(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2bed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2bed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a58XM", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $757152ee82640ba0$export$ffb0004e005737fa; }, function (v) { return $757152ee82640ba0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $757152ee82640ba0$export$34b9dba7ce09269b; }, function (v) { return $757152ee82640ba0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $757152ee82640ba0$export$25062201e9e25d76; }, function (v) { return $757152ee82640ba0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $757152ee82640ba0$export$ffb0004e005737fa;
var $757152ee82640ba0$export$34b9dba7ce09269b;
var $757152ee82640ba0$export$25062201e9e25d76;
"use strict";

var $6cds3 = parcelRequire("6cds3");
var $757152ee82640ba0$var$k = Symbol.for("react.element"), $757152ee82640ba0$var$l = Symbol.for("react.fragment"), $757152ee82640ba0$var$m = Object.prototype.hasOwnProperty, $757152ee82640ba0$var$n = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $757152ee82640ba0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $757152ee82640ba0$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$757152ee82640ba0$var$m.call(a, b) && !$757152ee82640ba0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $757152ee82640ba0$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $757152ee82640ba0$var$n.current
    };
}
$757152ee82640ba0$export$ffb0004e005737fa = $757152ee82640ba0$var$l;
$757152ee82640ba0$export$34b9dba7ce09269b = $757152ee82640ba0$var$q;
$757152ee82640ba0$export$25062201e9e25d76 = $757152ee82640ba0$var$q;

});
parcelRegister("6cds3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gx6CV"));

});
parcelRegister("gx6CV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c094de5bd35107a3$export$dca3b0875bd9a954; }, function (v) { return $c094de5bd35107a3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c094de5bd35107a3$export$16fa2f45be04daa8; }, function (v) { return $c094de5bd35107a3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c094de5bd35107a3$export$ffb0004e005737fa; }, function (v) { return $c094de5bd35107a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c094de5bd35107a3$export$e2c29f18771995cb; }, function (v) { return $c094de5bd35107a3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c094de5bd35107a3$export$221d75b3f55bb0bd; }, function (v) { return $c094de5bd35107a3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c094de5bd35107a3$export$5f8d39834fd61797; }, function (v) { return $c094de5bd35107a3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c094de5bd35107a3$export$74bf444e3cd11ea5; }, function (v) { return $c094de5bd35107a3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c094de5bd35107a3$export$ae55be85d98224ed; }, function (v) { return $c094de5bd35107a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c094de5bd35107a3$export$e530037191fcd5d7; }, function (v) { return $c094de5bd35107a3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c094de5bd35107a3$export$fd42f52fd3ae1109; }, function (v) { return $c094de5bd35107a3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c094de5bd35107a3$export$c8a8987d4410bf2d; }, function (v) { return $c094de5bd35107a3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c094de5bd35107a3$export$d38cd72104c1f0e9; }, function (v) { return $c094de5bd35107a3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c094de5bd35107a3$export$7d1e3a5e95ceca43; }, function (v) { return $c094de5bd35107a3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c094de5bd35107a3$export$257a8862b851cb5b; }, function (v) { return $c094de5bd35107a3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c094de5bd35107a3$export$a8257692ac88316c; }, function (v) { return $c094de5bd35107a3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c094de5bd35107a3$export$488013bae63b21da; }, function (v) { return $c094de5bd35107a3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c094de5bd35107a3$export$7c73462e0d25e514; }, function (v) { return $c094de5bd35107a3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c094de5bd35107a3$export$7568632d0d33d16d; }, function (v) { return $c094de5bd35107a3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c094de5bd35107a3$export$88948ce120ea2619; }, function (v) { return $c094de5bd35107a3$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c094de5bd35107a3$export$35808ee640e87ca7; }, function (v) { return $c094de5bd35107a3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c094de5bd35107a3$export$fae74005e78b1a27; }, function (v) { return $c094de5bd35107a3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e; }, function (v) { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c094de5bd35107a3$export$6a7bc4e911dc01cf; }, function (v) { return $c094de5bd35107a3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c094de5bd35107a3$export$6d9c69b0de29b591; }, function (v) { return $c094de5bd35107a3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c094de5bd35107a3$export$f680877a34711e37; }, function (v) { return $c094de5bd35107a3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c094de5bd35107a3$export$d5a552a76deda3c2; }, function (v) { return $c094de5bd35107a3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c094de5bd35107a3$export$aaabe4eda9ed9969; }, function (v) { return $c094de5bd35107a3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c094de5bd35107a3$export$e5c5a5f917a5871c; }, function (v) { return $c094de5bd35107a3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c094de5bd35107a3$export$1538c33de8887b59; }, function (v) { return $c094de5bd35107a3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c094de5bd35107a3$export$13e3392192263954; }, function (v) { return $c094de5bd35107a3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c094de5bd35107a3$export$b8f5890fc79d6aca; }, function (v) { return $c094de5bd35107a3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c094de5bd35107a3$export$60241385465d0a34; }, function (v) { return $c094de5bd35107a3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c094de5bd35107a3$export$306c0aa65ff9ec16; }, function (v) { return $c094de5bd35107a3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c094de5bd35107a3$export$7b286972b8d8ccbf; }, function (v) { return $c094de5bd35107a3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c094de5bd35107a3$export$83d89fbfd8236492; }, function (v) { return $c094de5bd35107a3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c094de5bd35107a3$export$dca3b0875bd9a954;
var $c094de5bd35107a3$export$16fa2f45be04daa8;
var $c094de5bd35107a3$export$ffb0004e005737fa;
var $c094de5bd35107a3$export$e2c29f18771995cb;
var $c094de5bd35107a3$export$221d75b3f55bb0bd;
var $c094de5bd35107a3$export$5f8d39834fd61797;
var $c094de5bd35107a3$export$74bf444e3cd11ea5;
var $c094de5bd35107a3$export$ae55be85d98224ed;
var $c094de5bd35107a3$export$e530037191fcd5d7;
var $c094de5bd35107a3$export$fd42f52fd3ae1109;
var $c094de5bd35107a3$export$c8a8987d4410bf2d;
var $c094de5bd35107a3$export$d38cd72104c1f0e9;
var $c094de5bd35107a3$export$7d1e3a5e95ceca43;
var $c094de5bd35107a3$export$257a8862b851cb5b;
var $c094de5bd35107a3$export$a8257692ac88316c;
var $c094de5bd35107a3$export$488013bae63b21da;
var $c094de5bd35107a3$export$7c73462e0d25e514;
var $c094de5bd35107a3$export$7568632d0d33d16d;
var $c094de5bd35107a3$export$88948ce120ea2619;
var $c094de5bd35107a3$export$35808ee640e87ca7;
var $c094de5bd35107a3$export$fae74005e78b1a27;
var $c094de5bd35107a3$export$dc8fbce3eb94dc1e;
var $c094de5bd35107a3$export$6a7bc4e911dc01cf;
var $c094de5bd35107a3$export$6d9c69b0de29b591;
var $c094de5bd35107a3$export$f680877a34711e37;
var $c094de5bd35107a3$export$d5a552a76deda3c2;
var $c094de5bd35107a3$export$aaabe4eda9ed9969;
var $c094de5bd35107a3$export$e5c5a5f917a5871c;
var $c094de5bd35107a3$export$1538c33de8887b59;
var $c094de5bd35107a3$export$13e3392192263954;
var $c094de5bd35107a3$export$b8f5890fc79d6aca;
var $c094de5bd35107a3$export$60241385465d0a34;
var $c094de5bd35107a3$export$306c0aa65ff9ec16;
var $c094de5bd35107a3$export$7b286972b8d8ccbf;
var $c094de5bd35107a3$export$83d89fbfd8236492;
"use strict";
var $c094de5bd35107a3$var$l = Symbol.for("react.element"), $c094de5bd35107a3$var$n = Symbol.for("react.portal"), $c094de5bd35107a3$var$p = Symbol.for("react.fragment"), $c094de5bd35107a3$var$q = Symbol.for("react.strict_mode"), $c094de5bd35107a3$var$r = Symbol.for("react.profiler"), $c094de5bd35107a3$var$t = Symbol.for("react.provider"), $c094de5bd35107a3$var$u = Symbol.for("react.context"), $c094de5bd35107a3$var$v = Symbol.for("react.forward_ref"), $c094de5bd35107a3$var$w = Symbol.for("react.suspense"), $c094de5bd35107a3$var$x = Symbol.for("react.memo"), $c094de5bd35107a3$var$y = Symbol.for("react.lazy"), $c094de5bd35107a3$var$z = Symbol.iterator;
function $c094de5bd35107a3$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c094de5bd35107a3$var$z && a[$c094de5bd35107a3$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c094de5bd35107a3$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c094de5bd35107a3$var$C = Object.assign, $c094de5bd35107a3$var$D = {};
function $c094de5bd35107a3$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
$c094de5bd35107a3$var$E.prototype.isReactComponent = {};
$c094de5bd35107a3$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c094de5bd35107a3$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c094de5bd35107a3$var$F() {}
$c094de5bd35107a3$var$F.prototype = $c094de5bd35107a3$var$E.prototype;
function $c094de5bd35107a3$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
var $c094de5bd35107a3$var$H = $c094de5bd35107a3$var$G.prototype = new $c094de5bd35107a3$var$F;
$c094de5bd35107a3$var$H.constructor = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$var$C($c094de5bd35107a3$var$H, $c094de5bd35107a3$var$E.prototype);
$c094de5bd35107a3$var$H.isPureReactComponent = !0;
var $c094de5bd35107a3$var$I = Array.isArray, $c094de5bd35107a3$var$J = Object.prototype.hasOwnProperty, $c094de5bd35107a3$var$K = {
    current: null
}, $c094de5bd35107a3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c094de5bd35107a3$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c094de5bd35107a3$var$J.call(b, d) && !$c094de5bd35107a3$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c094de5bd35107a3$var$K.current
    };
}
function $c094de5bd35107a3$var$N(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c094de5bd35107a3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c094de5bd35107a3$var$l;
}
function $c094de5bd35107a3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c094de5bd35107a3$var$P = /\/+/g;
function $c094de5bd35107a3$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c094de5bd35107a3$var$escape("" + a.key) : b.toString(36);
}
function $c094de5bd35107a3$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c094de5bd35107a3$var$l:
                case $c094de5bd35107a3$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c094de5bd35107a3$var$Q(h, 0) : d, $c094de5bd35107a3$var$I(c) ? (e = "", null != a && (e = a.replace($c094de5bd35107a3$var$P, "$&/") + "/"), $c094de5bd35107a3$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c094de5bd35107a3$var$O(c) && (c = $c094de5bd35107a3$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c094de5bd35107a3$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c094de5bd35107a3$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c094de5bd35107a3$var$Q(k, g);
        h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    }
    else if (f = $c094de5bd35107a3$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c094de5bd35107a3$var$Q(k, g++), h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c094de5bd35107a3$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c094de5bd35107a3$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c094de5bd35107a3$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c094de5bd35107a3$var$U = {
    current: null
}, $c094de5bd35107a3$var$V = {
    transition: null
}, $c094de5bd35107a3$var$W = {
    ReactCurrentDispatcher: $c094de5bd35107a3$var$U,
    ReactCurrentBatchConfig: $c094de5bd35107a3$var$V,
    ReactCurrentOwner: $c094de5bd35107a3$var$K
};
$c094de5bd35107a3$export$dca3b0875bd9a954 = {
    map: $c094de5bd35107a3$var$S,
    forEach: function(a, b, e) {
        $c094de5bd35107a3$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c094de5bd35107a3$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c094de5bd35107a3$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c094de5bd35107a3$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c094de5bd35107a3$export$16fa2f45be04daa8 = $c094de5bd35107a3$var$E;
$c094de5bd35107a3$export$ffb0004e005737fa = $c094de5bd35107a3$var$p;
$c094de5bd35107a3$export$e2c29f18771995cb = $c094de5bd35107a3$var$r;
$c094de5bd35107a3$export$221d75b3f55bb0bd = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$export$5f8d39834fd61797 = $c094de5bd35107a3$var$q;
$c094de5bd35107a3$export$74bf444e3cd11ea5 = $c094de5bd35107a3$var$w;
$c094de5bd35107a3$export$ae55be85d98224ed = $c094de5bd35107a3$var$W;
$c094de5bd35107a3$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c094de5bd35107a3$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c094de5bd35107a3$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c094de5bd35107a3$var$J.call(b, f) && !$c094de5bd35107a3$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c094de5bd35107a3$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c094de5bd35107a3$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c094de5bd35107a3$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c094de5bd35107a3$export$c8a8987d4410bf2d = $c094de5bd35107a3$var$M;
$c094de5bd35107a3$export$d38cd72104c1f0e9 = function(a) {
    var b = $c094de5bd35107a3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c094de5bd35107a3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c094de5bd35107a3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$v,
        render: a
    };
};
$c094de5bd35107a3$export$a8257692ac88316c = $c094de5bd35107a3$var$O;
$c094de5bd35107a3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c094de5bd35107a3$var$T
    };
};
$c094de5bd35107a3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c094de5bd35107a3$export$7568632d0d33d16d = function(a) {
    var b = $c094de5bd35107a3$var$V.transition;
    $c094de5bd35107a3$var$V.transition = {};
    try {
        a();
    } finally{
        $c094de5bd35107a3$var$V.transition = b;
    }
};
$c094de5bd35107a3$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$c094de5bd35107a3$export$35808ee640e87ca7 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useCallback(a, b);
};
$c094de5bd35107a3$export$fae74005e78b1a27 = function(a) {
    return $c094de5bd35107a3$var$U.current.useContext(a);
};
$c094de5bd35107a3$export$dc8fbce3eb94dc1e = function() {};
$c094de5bd35107a3$export$6a7bc4e911dc01cf = function(a) {
    return $c094de5bd35107a3$var$U.current.useDeferredValue(a);
};
$c094de5bd35107a3$export$6d9c69b0de29b591 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useEffect(a, b);
};
$c094de5bd35107a3$export$f680877a34711e37 = function() {
    return $c094de5bd35107a3$var$U.current.useId();
};
$c094de5bd35107a3$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useImperativeHandle(a, b, e);
};
$c094de5bd35107a3$export$aaabe4eda9ed9969 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useInsertionEffect(a, b);
};
$c094de5bd35107a3$export$e5c5a5f917a5871c = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useLayoutEffect(a, b);
};
$c094de5bd35107a3$export$1538c33de8887b59 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useMemo(a, b);
};
$c094de5bd35107a3$export$13e3392192263954 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useReducer(a, b, e);
};
$c094de5bd35107a3$export$b8f5890fc79d6aca = function(a) {
    return $c094de5bd35107a3$var$U.current.useRef(a);
};
$c094de5bd35107a3$export$60241385465d0a34 = function(a) {
    return $c094de5bd35107a3$var$U.current.useState(a);
};
$c094de5bd35107a3$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useSyncExternalStore(a, b, e);
};
$c094de5bd35107a3$export$7b286972b8d8ccbf = function() {
    return $c094de5bd35107a3$var$U.current.useTransition();
};
$c094de5bd35107a3$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("jZA9I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed; }, function (v) { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389; }, function (v) { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e8dfc29dafb3bbd7$export$882461b6382ed46c; }, function (v) { return $e8dfc29dafb3bbd7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e8dfc29dafb3bbd7$export$466bfc07425424d5; }, function (v) { return $e8dfc29dafb3bbd7$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4; }, function (v) { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db; }, function (v) { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e; }, function (v) { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99; }, function (v) { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e8dfc29dafb3bbd7$export$502457920280e6be; }, function (v) { return $e8dfc29dafb3bbd7$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1; }, function (v) { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18; }, function (v) { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492; }, function (v) { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e8dfc29dafb3bbd7$export$ae55be85d98224ed;
var $e8dfc29dafb3bbd7$export$d39a5bbd09211389;
var $e8dfc29dafb3bbd7$export$882461b6382ed46c;
var $e8dfc29dafb3bbd7$export$466bfc07425424d5;
var $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4;
var $e8dfc29dafb3bbd7$export$fa8d919ba61d84db;
var $e8dfc29dafb3bbd7$export$757ceba2d55c277e;
var $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99;
var $e8dfc29dafb3bbd7$export$502457920280e6be;
var $e8dfc29dafb3bbd7$export$c78a37762a8d58e1;
var $e8dfc29dafb3bbd7$export$dc54d992c10e8a18;
var $e8dfc29dafb3bbd7$export$83d89fbfd8236492;
"use strict";

var $6cds3 = parcelRequire("6cds3");

var $1c9zD = parcelRequire("1c9zD");
function $e8dfc29dafb3bbd7$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e8dfc29dafb3bbd7$var$da = new Set, $e8dfc29dafb3bbd7$var$ea = {};
function $e8dfc29dafb3bbd7$var$fa(a, b) {
    $e8dfc29dafb3bbd7$var$ha(a, b);
    $e8dfc29dafb3bbd7$var$ha(a + "Capture", b);
}
function $e8dfc29dafb3bbd7$var$ha(a, b) {
    $e8dfc29dafb3bbd7$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$da.add(b[a]);
}
var $e8dfc29dafb3bbd7$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e8dfc29dafb3bbd7$var$ja = Object.prototype.hasOwnProperty, $e8dfc29dafb3bbd7$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e8dfc29dafb3bbd7$var$la = {}, $e8dfc29dafb3bbd7$var$ma = {};
function $e8dfc29dafb3bbd7$var$oa(a) {
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$ma, a)) return !0;
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$la, a)) return !1;
    if ($e8dfc29dafb3bbd7$var$ka.test(a)) return $e8dfc29dafb3bbd7$var$ma[a] = !0;
    $e8dfc29dafb3bbd7$var$la[a] = !0;
    return !1;
}
function $e8dfc29dafb3bbd7$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e8dfc29dafb3bbd7$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e8dfc29dafb3bbd7$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e8dfc29dafb3bbd7$var$ra = /[\-:]([a-z])/g;
function $e8dfc29dafb3bbd7$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e8dfc29dafb3bbd7$var$z.xlinkHref = new $e8dfc29dafb3bbd7$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e8dfc29dafb3bbd7$var$ta(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$z.hasOwnProperty(b) ? $e8dfc29dafb3bbd7$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e8dfc29dafb3bbd7$var$qa(b, c, e, d) && (c = null), d || null === e ? $e8dfc29dafb3bbd7$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e8dfc29dafb3bbd7$var$ua = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e8dfc29dafb3bbd7$var$va = Symbol.for("react.element"), $e8dfc29dafb3bbd7$var$wa = Symbol.for("react.portal"), $e8dfc29dafb3bbd7$var$ya = Symbol.for("react.fragment"), $e8dfc29dafb3bbd7$var$za = Symbol.for("react.strict_mode"), $e8dfc29dafb3bbd7$var$Aa = Symbol.for("react.profiler"), $e8dfc29dafb3bbd7$var$Ba = Symbol.for("react.provider"), $e8dfc29dafb3bbd7$var$Ca = Symbol.for("react.context"), $e8dfc29dafb3bbd7$var$Da = Symbol.for("react.forward_ref"), $e8dfc29dafb3bbd7$var$Ea = Symbol.for("react.suspense"), $e8dfc29dafb3bbd7$var$Fa = Symbol.for("react.suspense_list"), $e8dfc29dafb3bbd7$var$Ga = Symbol.for("react.memo"), $e8dfc29dafb3bbd7$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e8dfc29dafb3bbd7$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e8dfc29dafb3bbd7$var$Ja = Symbol.iterator;
function $e8dfc29dafb3bbd7$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8dfc29dafb3bbd7$var$Ja && a[$e8dfc29dafb3bbd7$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8dfc29dafb3bbd7$var$A = Object.assign, $e8dfc29dafb3bbd7$var$La;
function $e8dfc29dafb3bbd7$var$Ma(a) {
    if (void 0 === $e8dfc29dafb3bbd7$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e8dfc29dafb3bbd7$var$La = b && b[1] || "";
    }
    return "\n" + $e8dfc29dafb3bbd7$var$La + a;
}
var $e8dfc29dafb3bbd7$var$Na = !1;
function $e8dfc29dafb3bbd7$var$Oa(a, b) {
    if (!a || $e8dfc29dafb3bbd7$var$Na) return "";
    $e8dfc29dafb3bbd7$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e8dfc29dafb3bbd7$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e8dfc29dafb3bbd7$var$Ma(a) : "";
}
function $e8dfc29dafb3bbd7$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e8dfc29dafb3bbd7$var$Ma(a.type);
        case 16:
            return $e8dfc29dafb3bbd7$var$Ma("Lazy");
        case 13:
            return $e8dfc29dafb3bbd7$var$Ma("Suspense");
        case 19:
            return $e8dfc29dafb3bbd7$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !1), a;
        case 11:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return "Fragment";
        case $e8dfc29dafb3bbd7$var$wa:
            return "Portal";
        case $e8dfc29dafb3bbd7$var$Aa:
            return "Profiler";
        case $e8dfc29dafb3bbd7$var$za:
            return "StrictMode";
        case $e8dfc29dafb3bbd7$var$Ea:
            return "Suspense";
        case $e8dfc29dafb3bbd7$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e8dfc29dafb3bbd7$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e8dfc29dafb3bbd7$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e8dfc29dafb3bbd7$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e8dfc29dafb3bbd7$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e8dfc29dafb3bbd7$var$Qa(a.type) || "Memo";
        case $e8dfc29dafb3bbd7$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e8dfc29dafb3bbd7$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e8dfc29dafb3bbd7$var$Qa(b);
        case 8:
            return b === $e8dfc29dafb3bbd7$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e8dfc29dafb3bbd7$var$Ua(a) {
    var b = $e8dfc29dafb3bbd7$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e8dfc29dafb3bbd7$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e8dfc29dafb3bbd7$var$Ua(a));
}
function $e8dfc29dafb3bbd7$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e8dfc29dafb3bbd7$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e8dfc29dafb3bbd7$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e8dfc29dafb3bbd7$var$Ya(a, b) {
    var c = b.checked;
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e8dfc29dafb3bbd7$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e8dfc29dafb3bbd7$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e8dfc29dafb3bbd7$var$ab(a, b) {
    b = b.checked;
    null != b && $e8dfc29dafb3bbd7$var$ta(a, "checked", b, !1);
}
function $e8dfc29dafb3bbd7$var$bb(a, b) {
    $e8dfc29dafb3bbd7$var$ab(a, b);
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e8dfc29dafb3bbd7$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e8dfc29dafb3bbd7$var$cb(a, b.type, $e8dfc29dafb3bbd7$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e8dfc29dafb3bbd7$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e8dfc29dafb3bbd7$var$cb(a, b, c) {
    if ("number" !== b || $e8dfc29dafb3bbd7$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e8dfc29dafb3bbd7$var$eb = Array.isArray;
function $e8dfc29dafb3bbd7$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e8dfc29dafb3bbd7$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e8dfc29dafb3bbd7$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e8dfc29dafb3bbd7$var$p(91));
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e8dfc29dafb3bbd7$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e8dfc29dafb3bbd7$var$p(92));
            if ($e8dfc29dafb3bbd7$var$eb(c)) {
                if (1 < c.length) throw Error($e8dfc29dafb3bbd7$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e8dfc29dafb3bbd7$var$Sa(c)
    };
}
function $e8dfc29dafb3bbd7$var$ib(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = $e8dfc29dafb3bbd7$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e8dfc29dafb3bbd7$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e8dfc29dafb3bbd7$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e8dfc29dafb3bbd7$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e8dfc29dafb3bbd7$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e8dfc29dafb3bbd7$var$mb, $e8dfc29dafb3bbd7$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e8dfc29dafb3bbd7$var$mb = $e8dfc29dafb3bbd7$var$mb || document.createElement("div");
        $e8dfc29dafb3bbd7$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e8dfc29dafb3bbd7$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e8dfc29dafb3bbd7$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e8dfc29dafb3bbd7$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e8dfc29dafb3bbd7$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e8dfc29dafb3bbd7$var$pb).forEach(function(a) {
    $e8dfc29dafb3bbd7$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e8dfc29dafb3bbd7$var$pb[b] = $e8dfc29dafb3bbd7$var$pb[a];
    });
});
function $e8dfc29dafb3bbd7$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e8dfc29dafb3bbd7$var$pb.hasOwnProperty(a) && $e8dfc29dafb3bbd7$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e8dfc29dafb3bbd7$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e8dfc29dafb3bbd7$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e8dfc29dafb3bbd7$var$tb = $e8dfc29dafb3bbd7$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e8dfc29dafb3bbd7$var$ub(a, b) {
    if (b) {
        if ($e8dfc29dafb3bbd7$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e8dfc29dafb3bbd7$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e8dfc29dafb3bbd7$var$p(62));
    }
}
function $e8dfc29dafb3bbd7$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e8dfc29dafb3bbd7$var$wb = null;
function $e8dfc29dafb3bbd7$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e8dfc29dafb3bbd7$var$yb = null, $e8dfc29dafb3bbd7$var$zb = null, $e8dfc29dafb3bbd7$var$Ab = null;
function $e8dfc29dafb3bbd7$var$Bb(a) {
    if (a = $e8dfc29dafb3bbd7$var$Cb(a)) {
        if ("function" !== typeof $e8dfc29dafb3bbd7$var$yb) throw Error($e8dfc29dafb3bbd7$var$p(280));
        var b = a.stateNode;
        b && (b = $e8dfc29dafb3bbd7$var$Db(b), $e8dfc29dafb3bbd7$var$yb(a.stateNode, a.type, b));
    }
}
function $e8dfc29dafb3bbd7$var$Eb(a) {
    $e8dfc29dafb3bbd7$var$zb ? $e8dfc29dafb3bbd7$var$Ab ? $e8dfc29dafb3bbd7$var$Ab.push(a) : $e8dfc29dafb3bbd7$var$Ab = [
        a
    ] : $e8dfc29dafb3bbd7$var$zb = a;
}
function $e8dfc29dafb3bbd7$var$Fb() {
    if ($e8dfc29dafb3bbd7$var$zb) {
        var a = $e8dfc29dafb3bbd7$var$zb, b = $e8dfc29dafb3bbd7$var$Ab;
        $e8dfc29dafb3bbd7$var$Ab = $e8dfc29dafb3bbd7$var$zb = null;
        $e8dfc29dafb3bbd7$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$Bb(b[a]);
    }
}
function $e8dfc29dafb3bbd7$var$Gb(a, b) {
    return a(b);
}
function $e8dfc29dafb3bbd7$var$Hb() {}
var $e8dfc29dafb3bbd7$var$Ib = !1;
function $e8dfc29dafb3bbd7$var$Jb(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$Ib) return a(b, c);
    $e8dfc29dafb3bbd7$var$Ib = !0;
    try {
        return $e8dfc29dafb3bbd7$var$Gb(a, b, c);
    } finally{
        if ($e8dfc29dafb3bbd7$var$Ib = !1, null !== $e8dfc29dafb3bbd7$var$zb || null !== $e8dfc29dafb3bbd7$var$Ab) $e8dfc29dafb3bbd7$var$Hb(), $e8dfc29dafb3bbd7$var$Fb();
    }
}
function $e8dfc29dafb3bbd7$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e8dfc29dafb3bbd7$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e8dfc29dafb3bbd7$var$p(231, b, typeof c));
    return c;
}
var $e8dfc29dafb3bbd7$var$Lb = !1;
if ($e8dfc29dafb3bbd7$var$ia) try {
    var $e8dfc29dafb3bbd7$var$Mb = {};
    Object.defineProperty($e8dfc29dafb3bbd7$var$Mb, "passive", {
        get: function() {
            $e8dfc29dafb3bbd7$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
    window.removeEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
} catch (a) {
    $e8dfc29dafb3bbd7$var$Lb = !1;
}
function $e8dfc29dafb3bbd7$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e8dfc29dafb3bbd7$var$Ob = !1, $e8dfc29dafb3bbd7$var$Pb = null, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, $e8dfc29dafb3bbd7$var$Sb = {
    onError: function(a) {
        $e8dfc29dafb3bbd7$var$Ob = !0;
        $e8dfc29dafb3bbd7$var$Pb = a;
    }
};
function $e8dfc29dafb3bbd7$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Ob = !1;
    $e8dfc29dafb3bbd7$var$Pb = null;
    $e8dfc29dafb3bbd7$var$Nb.apply($e8dfc29dafb3bbd7$var$Sb, arguments);
}
function $e8dfc29dafb3bbd7$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Tb.apply(this, arguments);
    if ($e8dfc29dafb3bbd7$var$Ob) {
        if ($e8dfc29dafb3bbd7$var$Ob) {
            var l = $e8dfc29dafb3bbd7$var$Pb;
            $e8dfc29dafb3bbd7$var$Ob = !1;
            $e8dfc29dafb3bbd7$var$Pb = null;
        } else throw Error($e8dfc29dafb3bbd7$var$p(198));
        $e8dfc29dafb3bbd7$var$Qb || ($e8dfc29dafb3bbd7$var$Qb = !0, $e8dfc29dafb3bbd7$var$Rb = l);
    }
}
function $e8dfc29dafb3bbd7$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e8dfc29dafb3bbd7$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xb(a) {
    if ($e8dfc29dafb3bbd7$var$Vb(a) !== a) throw Error($e8dfc29dafb3bbd7$var$p(188));
}
function $e8dfc29dafb3bbd7$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e8dfc29dafb3bbd7$var$Vb(a);
        if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e8dfc29dafb3bbd7$var$Xb(e), a;
                if (f === d) return $e8dfc29dafb3bbd7$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e8dfc29dafb3bbd7$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e8dfc29dafb3bbd7$var$p(190));
    }
    if (3 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e8dfc29dafb3bbd7$var$Zb(a) {
    a = $e8dfc29dafb3bbd7$var$Yb(a);
    return null !== a ? $e8dfc29dafb3bbd7$var$$b(a) : null;
}
function $e8dfc29dafb3bbd7$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e8dfc29dafb3bbd7$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$ac = $1c9zD.unstable_scheduleCallback, $e8dfc29dafb3bbd7$var$bc = $1c9zD.unstable_cancelCallback, $e8dfc29dafb3bbd7$var$cc = $1c9zD.unstable_shouldYield, $e8dfc29dafb3bbd7$var$dc = $1c9zD.unstable_requestPaint, $e8dfc29dafb3bbd7$var$B = $1c9zD.unstable_now, $e8dfc29dafb3bbd7$var$ec = $1c9zD.unstable_getCurrentPriorityLevel, $e8dfc29dafb3bbd7$var$fc = $1c9zD.unstable_ImmediatePriority, $e8dfc29dafb3bbd7$var$gc = $1c9zD.unstable_UserBlockingPriority, $e8dfc29dafb3bbd7$var$hc = $1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$ic = $1c9zD.unstable_LowPriority, $e8dfc29dafb3bbd7$var$jc = $1c9zD.unstable_IdlePriority, $e8dfc29dafb3bbd7$var$kc = null, $e8dfc29dafb3bbd7$var$lc = null;
function $e8dfc29dafb3bbd7$var$mc(a) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e8dfc29dafb3bbd7$var$oc = Math.clz32 ? Math.clz32 : $e8dfc29dafb3bbd7$var$nc, $e8dfc29dafb3bbd7$var$pc = Math.log, $e8dfc29dafb3bbd7$var$qc = Math.LN2;
function $e8dfc29dafb3bbd7$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e8dfc29dafb3bbd7$var$pc(a) / $e8dfc29dafb3bbd7$var$qc | 0) | 0;
}
var $e8dfc29dafb3bbd7$var$rc = 64, $e8dfc29dafb3bbd7$var$sc = 4194304;
function $e8dfc29dafb3bbd7$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e8dfc29dafb3bbd7$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e8dfc29dafb3bbd7$var$tc(h) : (f &= g, 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e8dfc29dafb3bbd7$var$tc(g) : 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e8dfc29dafb3bbd7$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e8dfc29dafb3bbd7$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e8dfc29dafb3bbd7$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e8dfc29dafb3bbd7$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e8dfc29dafb3bbd7$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e8dfc29dafb3bbd7$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e8dfc29dafb3bbd7$var$yc() {
    var a = $e8dfc29dafb3bbd7$var$rc;
    $e8dfc29dafb3bbd7$var$rc <<= 1;
    0 === ($e8dfc29dafb3bbd7$var$rc & 4194240) && ($e8dfc29dafb3bbd7$var$rc = 64);
    return a;
}
function $e8dfc29dafb3bbd7$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e8dfc29dafb3bbd7$var$oc(b);
    a[b] = c;
}
function $e8dfc29dafb3bbd7$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e8dfc29dafb3bbd7$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e8dfc29dafb3bbd7$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e8dfc29dafb3bbd7$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e8dfc29dafb3bbd7$var$C = 0;
function $e8dfc29dafb3bbd7$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e8dfc29dafb3bbd7$var$Ec, $e8dfc29dafb3bbd7$var$Fc, $e8dfc29dafb3bbd7$var$Gc, $e8dfc29dafb3bbd7$var$Hc, $e8dfc29dafb3bbd7$var$Ic, $e8dfc29dafb3bbd7$var$Jc = !1, $e8dfc29dafb3bbd7$var$Kc = [], $e8dfc29dafb3bbd7$var$Lc = null, $e8dfc29dafb3bbd7$var$Mc = null, $e8dfc29dafb3bbd7$var$Nc = null, $e8dfc29dafb3bbd7$var$Oc = new Map, $e8dfc29dafb3bbd7$var$Pc = new Map, $e8dfc29dafb3bbd7$var$Qc = [], $e8dfc29dafb3bbd7$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e8dfc29dafb3bbd7$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e8dfc29dafb3bbd7$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e8dfc29dafb3bbd7$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e8dfc29dafb3bbd7$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e8dfc29dafb3bbd7$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e8dfc29dafb3bbd7$var$Pc.delete(b.pointerId);
    }
}
function $e8dfc29dafb3bbd7$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e8dfc29dafb3bbd7$var$Cb(b), null !== b && $e8dfc29dafb3bbd7$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e8dfc29dafb3bbd7$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e8dfc29dafb3bbd7$var$Lc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e8dfc29dafb3bbd7$var$Mc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e8dfc29dafb3bbd7$var$Nc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e8dfc29dafb3bbd7$var$Oc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e8dfc29dafb3bbd7$var$Pc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Vc(a) {
    var b = $e8dfc29dafb3bbd7$var$Wc(a.target);
    if (null !== b) {
        var c = $e8dfc29dafb3bbd7$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e8dfc29dafb3bbd7$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e8dfc29dafb3bbd7$var$Ic(a.priority, function() {
                        $e8dfc29dafb3bbd7$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e8dfc29dafb3bbd7$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e8dfc29dafb3bbd7$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e8dfc29dafb3bbd7$var$wb = d;
            c.target.dispatchEvent(d);
            $e8dfc29dafb3bbd7$var$wb = null;
        } else return b = $e8dfc29dafb3bbd7$var$Cb(c), null !== b && $e8dfc29dafb3bbd7$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Zc(a, b, c) {
    $e8dfc29dafb3bbd7$var$Xc(a) && c.delete(b);
}
function $e8dfc29dafb3bbd7$var$$c() {
    $e8dfc29dafb3bbd7$var$Jc = !1;
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Lc) && ($e8dfc29dafb3bbd7$var$Lc = null);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Mc) && ($e8dfc29dafb3bbd7$var$Mc = null);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Nc) && ($e8dfc29dafb3bbd7$var$Nc = null);
    $e8dfc29dafb3bbd7$var$Oc.forEach($e8dfc29dafb3bbd7$var$Zc);
    $e8dfc29dafb3bbd7$var$Pc.forEach($e8dfc29dafb3bbd7$var$Zc);
}
function $e8dfc29dafb3bbd7$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e8dfc29dafb3bbd7$var$Jc || ($e8dfc29dafb3bbd7$var$Jc = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$$c)));
}
function $e8dfc29dafb3bbd7$var$bd(a) {
    function b(b) {
        return $e8dfc29dafb3bbd7$var$ad(b, a);
    }
    if (0 < $e8dfc29dafb3bbd7$var$Kc.length) {
        $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Kc[0], a);
        for(var c = 1; c < $e8dfc29dafb3bbd7$var$Kc.length; c++){
            var d = $e8dfc29dafb3bbd7$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Lc, a);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Mc, a);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Nc, a);
    $e8dfc29dafb3bbd7$var$Oc.forEach(b);
    $e8dfc29dafb3bbd7$var$Pc.forEach(b);
    for(c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length; c++)d = $e8dfc29dafb3bbd7$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e8dfc29dafb3bbd7$var$Qc.length && (c = $e8dfc29dafb3bbd7$var$Qc[0], null === c.blockedOn);)$e8dfc29dafb3bbd7$var$Vc(c), null === c.blockedOn && $e8dfc29dafb3bbd7$var$Qc.shift();
}
var $e8dfc29dafb3bbd7$var$cd = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$dd = !0;
function $e8dfc29dafb3bbd7$var$ed(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$gd(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 4, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$fd(a, b, c, d) {
    if ($e8dfc29dafb3bbd7$var$dd) {
        var e = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
        if (null === e) $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c), $e8dfc29dafb3bbd7$var$Sc(a, d);
        else if ($e8dfc29dafb3bbd7$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e8dfc29dafb3bbd7$var$Sc(a, d), b & 4 && -1 < $e8dfc29dafb3bbd7$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e8dfc29dafb3bbd7$var$Cb(e);
                null !== f && $e8dfc29dafb3bbd7$var$Ec(f);
                f = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
                null === f && $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e8dfc29dafb3bbd7$var$hd(a, b, d, null, c);
    }
}
var $e8dfc29dafb3bbd7$var$id = null;
function $e8dfc29dafb3bbd7$var$Yc(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$id = null;
    a = $e8dfc29dafb3bbd7$var$xb(d);
    a = $e8dfc29dafb3bbd7$var$Wc(a);
    if (null !== a) {
        if (b = $e8dfc29dafb3bbd7$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e8dfc29dafb3bbd7$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e8dfc29dafb3bbd7$var$id = a;
    return null;
}
function $e8dfc29dafb3bbd7$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e8dfc29dafb3bbd7$var$ec()){
                case $e8dfc29dafb3bbd7$var$fc:
                    return 1;
                case $e8dfc29dafb3bbd7$var$gc:
                    return 4;
                case $e8dfc29dafb3bbd7$var$hc:
                case $e8dfc29dafb3bbd7$var$ic:
                    return 16;
                case $e8dfc29dafb3bbd7$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ld = null, $e8dfc29dafb3bbd7$var$md = null;
function $e8dfc29dafb3bbd7$var$nd() {
    if ($e8dfc29dafb3bbd7$var$md) return $e8dfc29dafb3bbd7$var$md;
    var a, b = $e8dfc29dafb3bbd7$var$ld, c = b.length, d, e = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e8dfc29dafb3bbd7$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e8dfc29dafb3bbd7$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e8dfc29dafb3bbd7$var$pd() {
    return !0;
}
function $e8dfc29dafb3bbd7$var$qd() {
    return !1;
}
function $e8dfc29dafb3bbd7$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e8dfc29dafb3bbd7$var$pd : $e8dfc29dafb3bbd7$var$qd;
        this.isPropagationStopped = $e8dfc29dafb3bbd7$var$qd;
        return this;
    }
    $e8dfc29dafb3bbd7$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e8dfc29dafb3bbd7$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e8dfc29dafb3bbd7$var$pd);
        },
        persist: function() {},
        isPersistent: $e8dfc29dafb3bbd7$var$pd
    });
    return b;
}
var $e8dfc29dafb3bbd7$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e8dfc29dafb3bbd7$var$td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$sd), $e8dfc29dafb3bbd7$var$ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    view: 0,
    detail: 0
}), $e8dfc29dafb3bbd7$var$vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$ud), $e8dfc29dafb3bbd7$var$wd, $e8dfc29dafb3bbd7$var$xd, $e8dfc29dafb3bbd7$var$yd, $e8dfc29dafb3bbd7$var$Ad = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e8dfc29dafb3bbd7$var$yd && ($e8dfc29dafb3bbd7$var$yd && "mousemove" === a.type ? ($e8dfc29dafb3bbd7$var$wd = a.screenX - $e8dfc29dafb3bbd7$var$yd.screenX, $e8dfc29dafb3bbd7$var$xd = a.screenY - $e8dfc29dafb3bbd7$var$yd.screenY) : $e8dfc29dafb3bbd7$var$xd = $e8dfc29dafb3bbd7$var$wd = 0, $e8dfc29dafb3bbd7$var$yd = a);
        return $e8dfc29dafb3bbd7$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e8dfc29dafb3bbd7$var$xd;
    }
}), $e8dfc29dafb3bbd7$var$Bd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ad), $e8dfc29dafb3bbd7$var$Cd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    dataTransfer: 0
}), $e8dfc29dafb3bbd7$var$Dd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Cd), $e8dfc29dafb3bbd7$var$Ed = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    relatedTarget: 0
}), $e8dfc29dafb3bbd7$var$Fd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ed), $e8dfc29dafb3bbd7$var$Gd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Hd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Gd), $e8dfc29dafb3bbd7$var$Id = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e8dfc29dafb3bbd7$var$Jd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Id), $e8dfc29dafb3bbd7$var$Kd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    data: 0
}), $e8dfc29dafb3bbd7$var$Ld = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Kd), $e8dfc29dafb3bbd7$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e8dfc29dafb3bbd7$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e8dfc29dafb3bbd7$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e8dfc29dafb3bbd7$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e8dfc29dafb3bbd7$var$Od[a]) ? !!b[a] : !1;
}
function $e8dfc29dafb3bbd7$var$zd() {
    return $e8dfc29dafb3bbd7$var$Pd;
}
var $e8dfc29dafb3bbd7$var$Qd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e8dfc29dafb3bbd7$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e8dfc29dafb3bbd7$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e8dfc29dafb3bbd7$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e8dfc29dafb3bbd7$var$Rd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Qd), $e8dfc29dafb3bbd7$var$Sd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e8dfc29dafb3bbd7$var$Td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Sd), $e8dfc29dafb3bbd7$var$Ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd
}), $e8dfc29dafb3bbd7$var$Vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ud), $e8dfc29dafb3bbd7$var$Wd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Xd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Wd), $e8dfc29dafb3bbd7$var$Yd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e8dfc29dafb3bbd7$var$Zd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Yd), $e8dfc29dafb3bbd7$var$$d = [
    9,
    13,
    27,
    32
], $e8dfc29dafb3bbd7$var$ae = $e8dfc29dafb3bbd7$var$ia && "CompositionEvent" in window, $e8dfc29dafb3bbd7$var$be = null;
$e8dfc29dafb3bbd7$var$ia && "documentMode" in document && ($e8dfc29dafb3bbd7$var$be = document.documentMode);
var $e8dfc29dafb3bbd7$var$ce = $e8dfc29dafb3bbd7$var$ia && "TextEvent" in window && !$e8dfc29dafb3bbd7$var$be, $e8dfc29dafb3bbd7$var$de = $e8dfc29dafb3bbd7$var$ia && (!$e8dfc29dafb3bbd7$var$ae || $e8dfc29dafb3bbd7$var$be && 8 < $e8dfc29dafb3bbd7$var$be && 11 >= $e8dfc29dafb3bbd7$var$be), $e8dfc29dafb3bbd7$var$ee = String.fromCharCode(32), $e8dfc29dafb3bbd7$var$fe = !1;
function $e8dfc29dafb3bbd7$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e8dfc29dafb3bbd7$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e8dfc29dafb3bbd7$var$ie = !1;
function $e8dfc29dafb3bbd7$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e8dfc29dafb3bbd7$var$fe = !0;
            return $e8dfc29dafb3bbd7$var$ee;
        case "textInput":
            return a = b.data, a === $e8dfc29dafb3bbd7$var$ee && $e8dfc29dafb3bbd7$var$fe ? null : a;
        default:
            return null;
    }
}
function $e8dfc29dafb3bbd7$var$ke(a, b) {
    if ($e8dfc29dafb3bbd7$var$ie) return "compositionend" === a || !$e8dfc29dafb3bbd7$var$ae && $e8dfc29dafb3bbd7$var$ge(a, b) ? (a = $e8dfc29dafb3bbd7$var$nd(), $e8dfc29dafb3bbd7$var$md = $e8dfc29dafb3bbd7$var$ld = $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e8dfc29dafb3bbd7$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e8dfc29dafb3bbd7$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e8dfc29dafb3bbd7$var$ne(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$Eb(d);
    b = $e8dfc29dafb3bbd7$var$oe(b, "onChange");
    0 < b.length && (c = new $e8dfc29dafb3bbd7$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e8dfc29dafb3bbd7$var$pe = null, $e8dfc29dafb3bbd7$var$qe = null;
function $e8dfc29dafb3bbd7$var$re(a) {
    $e8dfc29dafb3bbd7$var$se(a, 0);
}
function $e8dfc29dafb3bbd7$var$te(a) {
    var b = $e8dfc29dafb3bbd7$var$ue(a);
    if ($e8dfc29dafb3bbd7$var$Wa(b)) return a;
}
function $e8dfc29dafb3bbd7$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e8dfc29dafb3bbd7$var$we = !1;
if ($e8dfc29dafb3bbd7$var$ia) {
    var $e8dfc29dafb3bbd7$var$xe;
    if ($e8dfc29dafb3bbd7$var$ia) {
        var $e8dfc29dafb3bbd7$var$ye = "oninput" in document;
        if (!$e8dfc29dafb3bbd7$var$ye) {
            var $e8dfc29dafb3bbd7$var$ze = document.createElement("div");
            $e8dfc29dafb3bbd7$var$ze.setAttribute("oninput", "return;");
            $e8dfc29dafb3bbd7$var$ye = "function" === typeof $e8dfc29dafb3bbd7$var$ze.oninput;
        }
        $e8dfc29dafb3bbd7$var$xe = $e8dfc29dafb3bbd7$var$ye;
    } else $e8dfc29dafb3bbd7$var$xe = !1;
    $e8dfc29dafb3bbd7$var$we = $e8dfc29dafb3bbd7$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e8dfc29dafb3bbd7$var$Ae() {
    $e8dfc29dafb3bbd7$var$pe && ($e8dfc29dafb3bbd7$var$pe.detachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be), $e8dfc29dafb3bbd7$var$qe = $e8dfc29dafb3bbd7$var$pe = null);
}
function $e8dfc29dafb3bbd7$var$Be(a) {
    if ("value" === a.propertyName && $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe)) {
        var b = [];
        $e8dfc29dafb3bbd7$var$ne(b, $e8dfc29dafb3bbd7$var$qe, a, $e8dfc29dafb3bbd7$var$xb(a));
        $e8dfc29dafb3bbd7$var$Jb($e8dfc29dafb3bbd7$var$re, b);
    }
}
function $e8dfc29dafb3bbd7$var$Ce(a, b, c) {
    "focusin" === a ? ($e8dfc29dafb3bbd7$var$Ae(), $e8dfc29dafb3bbd7$var$pe = b, $e8dfc29dafb3bbd7$var$qe = c, $e8dfc29dafb3bbd7$var$pe.attachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be)) : "focusout" === a && $e8dfc29dafb3bbd7$var$Ae();
}
function $e8dfc29dafb3bbd7$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe);
}
function $e8dfc29dafb3bbd7$var$Ee(a, b) {
    if ("click" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e8dfc29dafb3bbd7$var$He = "function" === typeof Object.is ? Object.is : $e8dfc29dafb3bbd7$var$Ge;
function $e8dfc29dafb3bbd7$var$Ie(a, b) {
    if ($e8dfc29dafb3bbd7$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e8dfc29dafb3bbd7$var$ja.call(b, e) || !$e8dfc29dafb3bbd7$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e8dfc29dafb3bbd7$var$Ke(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e8dfc29dafb3bbd7$var$Je(c);
    }
}
function $e8dfc29dafb3bbd7$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e8dfc29dafb3bbd7$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e8dfc29dafb3bbd7$var$Me() {
    for(var a = window, b = $e8dfc29dafb3bbd7$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e8dfc29dafb3bbd7$var$Xa(a.document);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e8dfc29dafb3bbd7$var$Oe(a) {
    var b = $e8dfc29dafb3bbd7$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e8dfc29dafb3bbd7$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e8dfc29dafb3bbd7$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e8dfc29dafb3bbd7$var$Ke(c, f);
                var g = $e8dfc29dafb3bbd7$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e8dfc29dafb3bbd7$var$Pe = $e8dfc29dafb3bbd7$var$ia && "documentMode" in document && 11 >= document.documentMode, $e8dfc29dafb3bbd7$var$Qe = null, $e8dfc29dafb3bbd7$var$Re = null, $e8dfc29dafb3bbd7$var$Se = null, $e8dfc29dafb3bbd7$var$Te = !1;
function $e8dfc29dafb3bbd7$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e8dfc29dafb3bbd7$var$Te || null == $e8dfc29dafb3bbd7$var$Qe || $e8dfc29dafb3bbd7$var$Qe !== $e8dfc29dafb3bbd7$var$Xa(d) || (d = $e8dfc29dafb3bbd7$var$Qe, "selectionStart" in d && $e8dfc29dafb3bbd7$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e8dfc29dafb3bbd7$var$Se && $e8dfc29dafb3bbd7$var$Ie($e8dfc29dafb3bbd7$var$Se, d) || ($e8dfc29dafb3bbd7$var$Se = d, d = $e8dfc29dafb3bbd7$var$oe($e8dfc29dafb3bbd7$var$Re, "onSelect"), 0 < d.length && (b = new $e8dfc29dafb3bbd7$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e8dfc29dafb3bbd7$var$Qe)));
}
function $e8dfc29dafb3bbd7$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e8dfc29dafb3bbd7$var$We = {
    animationend: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationStart"),
    transitionend: $e8dfc29dafb3bbd7$var$Ve("Transition", "TransitionEnd")
}, $e8dfc29dafb3bbd7$var$Xe = {}, $e8dfc29dafb3bbd7$var$Ye = {};
$e8dfc29dafb3bbd7$var$ia && ($e8dfc29dafb3bbd7$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e8dfc29dafb3bbd7$var$We.animationend.animation, delete $e8dfc29dafb3bbd7$var$We.animationiteration.animation, delete $e8dfc29dafb3bbd7$var$We.animationstart.animation), "TransitionEvent" in window || delete $e8dfc29dafb3bbd7$var$We.transitionend.transition);
function $e8dfc29dafb3bbd7$var$Ze(a) {
    if ($e8dfc29dafb3bbd7$var$Xe[a]) return $e8dfc29dafb3bbd7$var$Xe[a];
    if (!$e8dfc29dafb3bbd7$var$We[a]) return a;
    var b = $e8dfc29dafb3bbd7$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e8dfc29dafb3bbd7$var$Ye) return $e8dfc29dafb3bbd7$var$Xe[a] = b[c];
    return a;
}
var $e8dfc29dafb3bbd7$var$$e = $e8dfc29dafb3bbd7$var$Ze("animationend"), $e8dfc29dafb3bbd7$var$af = $e8dfc29dafb3bbd7$var$Ze("animationiteration"), $e8dfc29dafb3bbd7$var$bf = $e8dfc29dafb3bbd7$var$Ze("animationstart"), $e8dfc29dafb3bbd7$var$cf = $e8dfc29dafb3bbd7$var$Ze("transitionend"), $e8dfc29dafb3bbd7$var$df = new Map, $e8dfc29dafb3bbd7$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e8dfc29dafb3bbd7$var$ff(a, b) {
    $e8dfc29dafb3bbd7$var$df.set(a, b);
    $e8dfc29dafb3bbd7$var$fa(b, [
        a
    ]);
}
for(var $e8dfc29dafb3bbd7$var$gf = 0; $e8dfc29dafb3bbd7$var$gf < $e8dfc29dafb3bbd7$var$ef.length; $e8dfc29dafb3bbd7$var$gf++){
    var $e8dfc29dafb3bbd7$var$hf = $e8dfc29dafb3bbd7$var$ef[$e8dfc29dafb3bbd7$var$gf], $e8dfc29dafb3bbd7$var$jf = $e8dfc29dafb3bbd7$var$hf.toLowerCase(), $e8dfc29dafb3bbd7$var$kf = $e8dfc29dafb3bbd7$var$hf[0].toUpperCase() + $e8dfc29dafb3bbd7$var$hf.slice(1);
    $e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$jf, "on" + $e8dfc29dafb3bbd7$var$kf);
}
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$$e, "onAnimationEnd");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$af, "onAnimationIteration");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$bf, "onAnimationStart");
$e8dfc29dafb3bbd7$var$ff("dblclick", "onDoubleClick");
$e8dfc29dafb3bbd7$var$ff("focusin", "onFocus");
$e8dfc29dafb3bbd7$var$ff("focusout", "onBlur");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$cf, "onTransitionEnd");
$e8dfc29dafb3bbd7$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e8dfc29dafb3bbd7$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e8dfc29dafb3bbd7$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e8dfc29dafb3bbd7$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e8dfc29dafb3bbd7$var$lf));
function $e8dfc29dafb3bbd7$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e8dfc29dafb3bbd7$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e8dfc29dafb3bbd7$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e8dfc29dafb3bbd7$var$Qb) throw a = $e8dfc29dafb3bbd7$var$Rb, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, a;
}
function $e8dfc29dafb3bbd7$var$D(a, b) {
    var c = b[$e8dfc29dafb3bbd7$var$of];
    void 0 === c && (c = b[$e8dfc29dafb3bbd7$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e8dfc29dafb3bbd7$var$pf(b, a, 2, !1), c.add(d));
}
function $e8dfc29dafb3bbd7$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e8dfc29dafb3bbd7$var$pf(c, a, d, b);
}
var $e8dfc29dafb3bbd7$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e8dfc29dafb3bbd7$var$sf(a) {
    if (!a[$e8dfc29dafb3bbd7$var$rf]) {
        a[$e8dfc29dafb3bbd7$var$rf] = !0;
        $e8dfc29dafb3bbd7$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e8dfc29dafb3bbd7$var$mf.has(b) || $e8dfc29dafb3bbd7$var$qf(b, !1, a), $e8dfc29dafb3bbd7$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e8dfc29dafb3bbd7$var$rf] || (b[$e8dfc29dafb3bbd7$var$rf] = !0, $e8dfc29dafb3bbd7$var$qf("selectionchange", !1, b));
    }
}
function $e8dfc29dafb3bbd7$var$pf(a, b, c, d) {
    switch($e8dfc29dafb3bbd7$var$jd(b)){
        case 1:
            var e = $e8dfc29dafb3bbd7$var$ed;
            break;
        case 4:
            e = $e8dfc29dafb3bbd7$var$gd;
            break;
        default:
            e = $e8dfc29dafb3bbd7$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e8dfc29dafb3bbd7$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e8dfc29dafb3bbd7$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e8dfc29dafb3bbd7$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e8dfc29dafb3bbd7$var$Jb(function() {
        var d = f, e = $e8dfc29dafb3bbd7$var$xb(c), g = [];
        a: {
            var h = $e8dfc29dafb3bbd7$var$df.get(a);
            if (void 0 !== h) {
                var k = $e8dfc29dafb3bbd7$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e8dfc29dafb3bbd7$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e8dfc29dafb3bbd7$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e8dfc29dafb3bbd7$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e8dfc29dafb3bbd7$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e8dfc29dafb3bbd7$var$Vd;
                        break;
                    case $e8dfc29dafb3bbd7$var$$e:
                    case $e8dfc29dafb3bbd7$var$af:
                    case $e8dfc29dafb3bbd7$var$bf:
                        k = $e8dfc29dafb3bbd7$var$Hd;
                        break;
                    case $e8dfc29dafb3bbd7$var$cf:
                        k = $e8dfc29dafb3bbd7$var$Xd;
                        break;
                    case "scroll":
                        k = $e8dfc29dafb3bbd7$var$vd;
                        break;
                    case "wheel":
                        k = $e8dfc29dafb3bbd7$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e8dfc29dafb3bbd7$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e8dfc29dafb3bbd7$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e8dfc29dafb3bbd7$var$Kb(w, x), null != F && t.push($e8dfc29dafb3bbd7$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e8dfc29dafb3bbd7$var$wb && (n = c.relatedTarget || c.fromElement) && ($e8dfc29dafb3bbd7$var$Wc(n) || n[$e8dfc29dafb3bbd7$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e8dfc29dafb3bbd7$var$Wc(n) : null, null !== n && (J = $e8dfc29dafb3bbd7$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e8dfc29dafb3bbd7$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e8dfc29dafb3bbd7$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e8dfc29dafb3bbd7$var$ue(k);
                        u = null == n ? h : $e8dfc29dafb3bbd7$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e8dfc29dafb3bbd7$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e8dfc29dafb3bbd7$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e8dfc29dafb3bbd7$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e8dfc29dafb3bbd7$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e8dfc29dafb3bbd7$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e8dfc29dafb3bbd7$var$vf(t);
                                x = $e8dfc29dafb3bbd7$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e8dfc29dafb3bbd7$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e8dfc29dafb3bbd7$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e8dfc29dafb3bbd7$var$ve;
                else if ($e8dfc29dafb3bbd7$var$me(h)) {
                    if ($e8dfc29dafb3bbd7$var$we) na = $e8dfc29dafb3bbd7$var$Fe;
                    else {
                        na = $e8dfc29dafb3bbd7$var$De;
                        var xa = $e8dfc29dafb3bbd7$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e8dfc29dafb3bbd7$var$Ee);
                if (na && (na = na(a, d))) {
                    $e8dfc29dafb3bbd7$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e8dfc29dafb3bbd7$var$cb(h, "number", h.value);
            }
            xa = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e8dfc29dafb3bbd7$var$me(xa) || "true" === xa.contentEditable) $e8dfc29dafb3bbd7$var$Qe = xa, $e8dfc29dafb3bbd7$var$Re = d, $e8dfc29dafb3bbd7$var$Se = null;
                    break;
                case "focusout":
                    $e8dfc29dafb3bbd7$var$Se = $e8dfc29dafb3bbd7$var$Re = $e8dfc29dafb3bbd7$var$Qe = null;
                    break;
                case "mousedown":
                    $e8dfc29dafb3bbd7$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e8dfc29dafb3bbd7$var$Te = !1;
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e8dfc29dafb3bbd7$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
            }
            var $a;
            if ($e8dfc29dafb3bbd7$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e8dfc29dafb3bbd7$var$ie ? $e8dfc29dafb3bbd7$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e8dfc29dafb3bbd7$var$de && "ko" !== c.locale && ($e8dfc29dafb3bbd7$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e8dfc29dafb3bbd7$var$ie && ($a = $e8dfc29dafb3bbd7$var$nd()) : ($e8dfc29dafb3bbd7$var$kd = e, $e8dfc29dafb3bbd7$var$ld = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, $e8dfc29dafb3bbd7$var$ie = !0)), xa = $e8dfc29dafb3bbd7$var$oe(d, ba), 0 < xa.length && (ba = new $e8dfc29dafb3bbd7$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e8dfc29dafb3bbd7$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e8dfc29dafb3bbd7$var$ce ? $e8dfc29dafb3bbd7$var$je(a, c) : $e8dfc29dafb3bbd7$var$ke(a, c)) d = $e8dfc29dafb3bbd7$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e8dfc29dafb3bbd7$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e8dfc29dafb3bbd7$var$se(g, b);
    });
}
function $e8dfc29dafb3bbd7$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e8dfc29dafb3bbd7$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e8dfc29dafb3bbd7$var$Kb(a, c), null != f && d.unshift($e8dfc29dafb3bbd7$var$tf(a, f, e)), f = $e8dfc29dafb3bbd7$var$Kb(a, b), null != f && d.push($e8dfc29dafb3bbd7$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e8dfc29dafb3bbd7$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e8dfc29dafb3bbd7$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.unshift($e8dfc29dafb3bbd7$var$tf(c, k, h))) : e || (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.push($e8dfc29dafb3bbd7$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e8dfc29dafb3bbd7$var$xf = /\r\n?/g, $e8dfc29dafb3bbd7$var$yf = /\u0000|\uFFFD/g;
function $e8dfc29dafb3bbd7$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e8dfc29dafb3bbd7$var$xf, "\n").replace($e8dfc29dafb3bbd7$var$yf, "");
}
function $e8dfc29dafb3bbd7$var$Af(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$zf(b);
    if ($e8dfc29dafb3bbd7$var$zf(a) !== b && c) throw Error($e8dfc29dafb3bbd7$var$p(425));
}
function $e8dfc29dafb3bbd7$var$Bf() {}
var $e8dfc29dafb3bbd7$var$Cf = null, $e8dfc29dafb3bbd7$var$Df = null;
function $e8dfc29dafb3bbd7$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e8dfc29dafb3bbd7$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e8dfc29dafb3bbd7$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e8dfc29dafb3bbd7$var$Hf = "function" === typeof Promise ? Promise : void 0, $e8dfc29dafb3bbd7$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e8dfc29dafb3bbd7$var$Hf ? function(a) {
    return $e8dfc29dafb3bbd7$var$Hf.resolve(null).then(a).catch($e8dfc29dafb3bbd7$var$If);
} : $e8dfc29dafb3bbd7$var$Ff;
function $e8dfc29dafb3bbd7$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e8dfc29dafb3bbd7$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e8dfc29dafb3bbd7$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e8dfc29dafb3bbd7$var$bd(b);
}
function $e8dfc29dafb3bbd7$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nf = Math.random().toString(36).slice(2), $e8dfc29dafb3bbd7$var$Of = "__reactFiber$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Pf = "__reactProps$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$uf = "__reactContainer$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$of = "__reactEvents$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Qf = "__reactListeners$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Rf = "__reactHandles$" + $e8dfc29dafb3bbd7$var$Nf;
function $e8dfc29dafb3bbd7$var$Wc(a) {
    var b = a[$e8dfc29dafb3bbd7$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e8dfc29dafb3bbd7$var$uf] || c[$e8dfc29dafb3bbd7$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e8dfc29dafb3bbd7$var$Mf(a); null !== a;){
                if (c = a[$e8dfc29dafb3bbd7$var$Of]) return c;
                a = $e8dfc29dafb3bbd7$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Cb(a) {
    a = a[$e8dfc29dafb3bbd7$var$Of] || a[$e8dfc29dafb3bbd7$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e8dfc29dafb3bbd7$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e8dfc29dafb3bbd7$var$p(33));
}
function $e8dfc29dafb3bbd7$var$Db(a) {
    return a[$e8dfc29dafb3bbd7$var$Pf] || null;
}
var $e8dfc29dafb3bbd7$var$Sf = [], $e8dfc29dafb3bbd7$var$Tf = -1;
function $e8dfc29dafb3bbd7$var$Uf(a) {
    return {
        current: a
    };
}
function $e8dfc29dafb3bbd7$var$E(a) {
    0 > $e8dfc29dafb3bbd7$var$Tf || (a.current = $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf], $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = null, $e8dfc29dafb3bbd7$var$Tf--);
}
function $e8dfc29dafb3bbd7$var$G(a, b) {
    $e8dfc29dafb3bbd7$var$Tf++;
    $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = a.current;
    a.current = b;
}
var $e8dfc29dafb3bbd7$var$Vf = {}, $e8dfc29dafb3bbd7$var$H = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Vf), $e8dfc29dafb3bbd7$var$Wf = $e8dfc29dafb3bbd7$var$Uf(!1), $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$Vf;
function $e8dfc29dafb3bbd7$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e8dfc29dafb3bbd7$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e8dfc29dafb3bbd7$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e8dfc29dafb3bbd7$var$$f() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
}
function $e8dfc29dafb3bbd7$var$ag(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$H.current !== $e8dfc29dafb3bbd7$var$Vf) throw Error($e8dfc29dafb3bbd7$var$p(168));
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
function $e8dfc29dafb3bbd7$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e8dfc29dafb3bbd7$var$p(108, $e8dfc29dafb3bbd7$var$Ra(a) || "Unknown", e));
    return $e8dfc29dafb3bbd7$var$A({}, c, d);
}
function $e8dfc29dafb3bbd7$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e8dfc29dafb3bbd7$var$Vf;
    $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$H.current;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, $e8dfc29dafb3bbd7$var$Wf.current);
    return !0;
}
function $e8dfc29dafb3bbd7$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e8dfc29dafb3bbd7$var$p(169));
    c ? (a = $e8dfc29dafb3bbd7$var$bg(a, b, $e8dfc29dafb3bbd7$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a)) : $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
var $e8dfc29dafb3bbd7$var$eg = null, $e8dfc29dafb3bbd7$var$fg = !1, $e8dfc29dafb3bbd7$var$gg = !1;
function $e8dfc29dafb3bbd7$var$hg(a) {
    null === $e8dfc29dafb3bbd7$var$eg ? $e8dfc29dafb3bbd7$var$eg = [
        a
    ] : $e8dfc29dafb3bbd7$var$eg.push(a);
}
function $e8dfc29dafb3bbd7$var$ig(a) {
    $e8dfc29dafb3bbd7$var$fg = !0;
    $e8dfc29dafb3bbd7$var$hg(a);
}
function $e8dfc29dafb3bbd7$var$jg() {
    if (!$e8dfc29dafb3bbd7$var$gg && null !== $e8dfc29dafb3bbd7$var$eg) {
        $e8dfc29dafb3bbd7$var$gg = !0;
        var a = 0, b = $e8dfc29dafb3bbd7$var$C;
        try {
            var c = $e8dfc29dafb3bbd7$var$eg;
            for($e8dfc29dafb3bbd7$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e8dfc29dafb3bbd7$var$eg = null;
            $e8dfc29dafb3bbd7$var$fg = !1;
        } catch (e) {
            throw null !== $e8dfc29dafb3bbd7$var$eg && ($e8dfc29dafb3bbd7$var$eg = $e8dfc29dafb3bbd7$var$eg.slice(a + 1)), $e8dfc29dafb3bbd7$var$ac($e8dfc29dafb3bbd7$var$fc, $e8dfc29dafb3bbd7$var$jg), e;
        } finally{
            $e8dfc29dafb3bbd7$var$C = b, $e8dfc29dafb3bbd7$var$gg = !1;
        }
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$kg = [], $e8dfc29dafb3bbd7$var$lg = 0, $e8dfc29dafb3bbd7$var$mg = null, $e8dfc29dafb3bbd7$var$ng = 0, $e8dfc29dafb3bbd7$var$og = [], $e8dfc29dafb3bbd7$var$pg = 0, $e8dfc29dafb3bbd7$var$qg = null, $e8dfc29dafb3bbd7$var$rg = 1, $e8dfc29dafb3bbd7$var$sg = "";
function $e8dfc29dafb3bbd7$var$tg(a, b) {
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$ng;
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$mg;
    $e8dfc29dafb3bbd7$var$mg = a;
    $e8dfc29dafb3bbd7$var$ng = b;
}
function $e8dfc29dafb3bbd7$var$ug(a, b, c) {
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg;
    $e8dfc29dafb3bbd7$var$qg = a;
    var d = $e8dfc29dafb3bbd7$var$rg;
    a = $e8dfc29dafb3bbd7$var$sg;
    var e = 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e8dfc29dafb3bbd7$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e8dfc29dafb3bbd7$var$rg = 1 << 32 - $e8dfc29dafb3bbd7$var$oc(b) + e | c << e | d;
        $e8dfc29dafb3bbd7$var$sg = f + a;
    } else $e8dfc29dafb3bbd7$var$rg = 1 << f | c << e | d, $e8dfc29dafb3bbd7$var$sg = a;
}
function $e8dfc29dafb3bbd7$var$vg(a) {
    null !== a.return && ($e8dfc29dafb3bbd7$var$tg(a, 1), $e8dfc29dafb3bbd7$var$ug(a, 1, 0));
}
function $e8dfc29dafb3bbd7$var$wg(a) {
    for(; a === $e8dfc29dafb3bbd7$var$mg;)$e8dfc29dafb3bbd7$var$mg = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null, $e8dfc29dafb3bbd7$var$ng = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null;
    for(; a === $e8dfc29dafb3bbd7$var$qg;)$e8dfc29dafb3bbd7$var$qg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$sg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$rg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null;
}
var $e8dfc29dafb3bbd7$var$xg = null, $e8dfc29dafb3bbd7$var$yg = null, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$zg = null;
function $e8dfc29dafb3bbd7$var$Ag(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e8dfc29dafb3bbd7$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e8dfc29dafb3bbd7$var$qg ? {
                id: $e8dfc29dafb3bbd7$var$rg,
                overflow: $e8dfc29dafb3bbd7$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e8dfc29dafb3bbd7$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e8dfc29dafb3bbd7$var$Eg(a) {
    if ($e8dfc29dafb3bbd7$var$I) {
        var b = $e8dfc29dafb3bbd7$var$yg;
        if (b) {
            var c = b;
            if (!$e8dfc29dafb3bbd7$var$Cg(a, b)) {
                if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
                b = $e8dfc29dafb3bbd7$var$Lf(c.nextSibling);
                var d = $e8dfc29dafb3bbd7$var$xg;
                b && $e8dfc29dafb3bbd7$var$Cg(a, b) ? $e8dfc29dafb3bbd7$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$xg = a);
            }
        } else {
            if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e8dfc29dafb3bbd7$var$I = !1;
            $e8dfc29dafb3bbd7$var$xg = a;
        }
    }
}
function $e8dfc29dafb3bbd7$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e8dfc29dafb3bbd7$var$xg = a;
}
function $e8dfc29dafb3bbd7$var$Gg(a) {
    if (a !== $e8dfc29dafb3bbd7$var$xg) return !1;
    if (!$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$Fg(a), $e8dfc29dafb3bbd7$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e8dfc29dafb3bbd7$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e8dfc29dafb3bbd7$var$yg)) {
        if ($e8dfc29dafb3bbd7$var$Dg(a)) throw $e8dfc29dafb3bbd7$var$Hg(), Error($e8dfc29dafb3bbd7$var$p(418));
        for(; b;)$e8dfc29dafb3bbd7$var$Ag(a, b), b = $e8dfc29dafb3bbd7$var$Lf(b.nextSibling);
    }
    $e8dfc29dafb3bbd7$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e8dfc29dafb3bbd7$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e8dfc29dafb3bbd7$var$yg = null;
        }
    } else $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg ? $e8dfc29dafb3bbd7$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Hg() {
    for(var a = $e8dfc29dafb3bbd7$var$yg; a;)a = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
}
function $e8dfc29dafb3bbd7$var$Ig() {
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg = null;
    $e8dfc29dafb3bbd7$var$I = !1;
}
function $e8dfc29dafb3bbd7$var$Jg(a) {
    null === $e8dfc29dafb3bbd7$var$zg ? $e8dfc29dafb3bbd7$var$zg = [
        a
    ] : $e8dfc29dafb3bbd7$var$zg.push(a);
}
var $e8dfc29dafb3bbd7$var$Kg = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig;
function $e8dfc29dafb3bbd7$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e8dfc29dafb3bbd7$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Mg = $e8dfc29dafb3bbd7$var$Uf(null), $e8dfc29dafb3bbd7$var$Ng = null, $e8dfc29dafb3bbd7$var$Og = null, $e8dfc29dafb3bbd7$var$Pg = null;
function $e8dfc29dafb3bbd7$var$Qg() {
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Ng = null;
}
function $e8dfc29dafb3bbd7$var$Rg(a) {
    var b = $e8dfc29dafb3bbd7$var$Mg.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Mg);
    a._currentValue = b;
}
function $e8dfc29dafb3bbd7$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e8dfc29dafb3bbd7$var$Tg(a, b) {
    $e8dfc29dafb3bbd7$var$Ng = a;
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e8dfc29dafb3bbd7$var$Ug = !0), a.firstContext = null);
}
function $e8dfc29dafb3bbd7$var$Vg(a) {
    var b = a._currentValue;
    if ($e8dfc29dafb3bbd7$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e8dfc29dafb3bbd7$var$Og) {
            if (null === $e8dfc29dafb3bbd7$var$Ng) throw Error($e8dfc29dafb3bbd7$var$p(308));
            $e8dfc29dafb3bbd7$var$Og = a;
            $e8dfc29dafb3bbd7$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Og.next = a;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Wg = null;
function $e8dfc29dafb3bbd7$var$Xg(a) {
    null === $e8dfc29dafb3bbd7$var$Wg ? $e8dfc29dafb3bbd7$var$Wg = [
        a
    ] : $e8dfc29dafb3bbd7$var$Wg.push(a);
}
function $e8dfc29dafb3bbd7$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e8dfc29dafb3bbd7$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e8dfc29dafb3bbd7$var$Zg(a, d);
}
function $e8dfc29dafb3bbd7$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e8dfc29dafb3bbd7$var$$g = !1;
function $e8dfc29dafb3bbd7$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e8dfc29dafb3bbd7$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e8dfc29dafb3bbd7$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e8dfc29dafb3bbd7$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e8dfc29dafb3bbd7$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e8dfc29dafb3bbd7$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e8dfc29dafb3bbd7$var$Zg(a, c);
}
function $e8dfc29dafb3bbd7$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
function $e8dfc29dafb3bbd7$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e8dfc29dafb3bbd7$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e8dfc29dafb3bbd7$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e8dfc29dafb3bbd7$var$A({}, q, r);
                            break a;
                        case 2:
                            $e8dfc29dafb3bbd7$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e8dfc29dafb3bbd7$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e8dfc29dafb3bbd7$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e8dfc29dafb3bbd7$var$p(191, e));
            e.call(d);
        }
    }
}
var $e8dfc29dafb3bbd7$var$jh = (new $6cds3.Component).refs;
function $e8dfc29dafb3bbd7$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e8dfc29dafb3bbd7$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e8dfc29dafb3bbd7$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e8dfc29dafb3bbd7$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e8dfc29dafb3bbd7$var$L(), d = $e8dfc29dafb3bbd7$var$lh(a), e = $e8dfc29dafb3bbd7$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e8dfc29dafb3bbd7$var$dh(a, e, d);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, d, c), $e8dfc29dafb3bbd7$var$eh(b, a, d));
    }
};
function $e8dfc29dafb3bbd7$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e8dfc29dafb3bbd7$var$Ie(c, d) || !$e8dfc29dafb3bbd7$var$Ie(e, f) : !0;
}
function $e8dfc29dafb3bbd7$var$ph(a, b, c) {
    var d = !1, e = $e8dfc29dafb3bbd7$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e8dfc29dafb3bbd7$var$Vg(f) : (e = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e8dfc29dafb3bbd7$var$Yf(a, e) : $e8dfc29dafb3bbd7$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e8dfc29dafb3bbd7$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e8dfc29dafb3bbd7$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e8dfc29dafb3bbd7$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e8dfc29dafb3bbd7$var$jh;
    $e8dfc29dafb3bbd7$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e8dfc29dafb3bbd7$var$Vg(f) : (f = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, e.context = $e8dfc29dafb3bbd7$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e8dfc29dafb3bbd7$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(e, e.state, null), $e8dfc29dafb3bbd7$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e8dfc29dafb3bbd7$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e8dfc29dafb3bbd7$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $e8dfc29dafb3bbd7$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e8dfc29dafb3bbd7$var$p(284));
        if (!c._owner) throw Error($e8dfc29dafb3bbd7$var$p(290, a));
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e8dfc29dafb3bbd7$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e8dfc29dafb3bbd7$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e8dfc29dafb3bbd7$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e8dfc29dafb3bbd7$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e8dfc29dafb3bbd7$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e8dfc29dafb3bbd7$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c), d.return = a, d;
        d = $e8dfc29dafb3bbd7$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e8dfc29dafb3bbd7$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e8dfc29dafb3bbd7$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c = $e8dfc29dafb3bbd7$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e8dfc29dafb3bbd7$var$sh(a, null, b), c.return = a, c;
                case $e8dfc29dafb3bbd7$var$wa:
                    return b = $e8dfc29dafb3bbd7$var$zh(b, a.mode, c), b.return = a, b;
                case $e8dfc29dafb3bbd7$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e8dfc29dafb3bbd7$var$eb(b) || $e8dfc29dafb3bbd7$var$Ka(b)) return b = $e8dfc29dafb3bbd7$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e8dfc29dafb3bbd7$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e8dfc29dafb3bbd7$var$eb(c) || $e8dfc29dafb3bbd7$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e8dfc29dafb3bbd7$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e8dfc29dafb3bbd7$var$eb(d) || $e8dfc29dafb3bbd7$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e8dfc29dafb3bbd7$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e8dfc29dafb3bbd7$var$Ka(h);
        if ("function" !== typeof l) throw Error($e8dfc29dafb3bbd7$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e8dfc29dafb3bbd7$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e8dfc29dafb3bbd7$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e8dfc29dafb3bbd7$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e8dfc29dafb3bbd7$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e8dfc29dafb3bbd7$var$ya ? (d = $e8dfc29dafb3bbd7$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e8dfc29dafb3bbd7$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e8dfc29dafb3bbd7$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e8dfc29dafb3bbd7$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e8dfc29dafb3bbd7$var$eb(f)) return n(a, d, f, h);
            if ($e8dfc29dafb3bbd7$var$Ka(f)) return t(a, d, f, h);
            $e8dfc29dafb3bbd7$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e8dfc29dafb3bbd7$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e8dfc29dafb3bbd7$var$Bh = $e8dfc29dafb3bbd7$var$vh(!0), $e8dfc29dafb3bbd7$var$Ch = $e8dfc29dafb3bbd7$var$vh(!1), $e8dfc29dafb3bbd7$var$Dh = {}, $e8dfc29dafb3bbd7$var$Eh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Fh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Gh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh);
function $e8dfc29dafb3bbd7$var$Hh(a) {
    if (a === $e8dfc29dafb3bbd7$var$Dh) throw Error($e8dfc29dafb3bbd7$var$p(174));
    return a;
}
function $e8dfc29dafb3bbd7$var$Ih(a, b) {
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Gh, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, $e8dfc29dafb3bbd7$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e8dfc29dafb3bbd7$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e8dfc29dafb3bbd7$var$lb(b, a);
    }
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, b);
}
function $e8dfc29dafb3bbd7$var$Jh() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Gh);
}
function $e8dfc29dafb3bbd7$var$Kh(a) {
    $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
    var b = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
    var c = $e8dfc29dafb3bbd7$var$lb(b, a.type);
    b !== c && ($e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, c));
}
function $e8dfc29dafb3bbd7$var$Lh(a) {
    $e8dfc29dafb3bbd7$var$Fh.current === a && ($e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh));
}
var $e8dfc29dafb3bbd7$var$M = $e8dfc29dafb3bbd7$var$Uf(0);
function $e8dfc29dafb3bbd7$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nh = [];
function $e8dfc29dafb3bbd7$var$Oh() {
    for(var a = 0; a < $e8dfc29dafb3bbd7$var$Nh.length; a++)$e8dfc29dafb3bbd7$var$Nh[a]._workInProgressVersionPrimary = null;
    $e8dfc29dafb3bbd7$var$Nh.length = 0;
}
var $e8dfc29dafb3bbd7$var$Ph = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$Qh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$Rh = 0, $e8dfc29dafb3bbd7$var$N = null, $e8dfc29dafb3bbd7$var$O = null, $e8dfc29dafb3bbd7$var$P = null, $e8dfc29dafb3bbd7$var$Sh = !1, $e8dfc29dafb3bbd7$var$Th = !1, $e8dfc29dafb3bbd7$var$Uh = 0, $e8dfc29dafb3bbd7$var$Vh = 0;
function $e8dfc29dafb3bbd7$var$Q() {
    throw Error($e8dfc29dafb3bbd7$var$p(321));
}
function $e8dfc29dafb3bbd7$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e8dfc29dafb3bbd7$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$Rh = f;
    $e8dfc29dafb3bbd7$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e8dfc29dafb3bbd7$var$Ph.current = null === a || null === a.memoizedState ? $e8dfc29dafb3bbd7$var$Yh : $e8dfc29dafb3bbd7$var$Zh;
    a = c(d, e);
    if ($e8dfc29dafb3bbd7$var$Th) {
        f = 0;
        do {
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            if (25 <= f) throw Error($e8dfc29dafb3bbd7$var$p(301));
            f += 1;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = null;
            b.updateQueue = null;
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$$h;
            a = c(d, e);
        }while ($e8dfc29dafb3bbd7$var$Th);
    }
    $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
    b = null !== $e8dfc29dafb3bbd7$var$O && null !== $e8dfc29dafb3bbd7$var$O.next;
    $e8dfc29dafb3bbd7$var$Rh = 0;
    $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
    $e8dfc29dafb3bbd7$var$Sh = !1;
    if (b) throw Error($e8dfc29dafb3bbd7$var$p(300));
    return a;
}
function $e8dfc29dafb3bbd7$var$bi() {
    var a = 0 !== $e8dfc29dafb3bbd7$var$Uh;
    $e8dfc29dafb3bbd7$var$Uh = 0;
    return a;
}
function $e8dfc29dafb3bbd7$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$di() {
    if (null === $e8dfc29dafb3bbd7$var$O) {
        var a = $e8dfc29dafb3bbd7$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e8dfc29dafb3bbd7$var$O.next;
    var b = null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState : $e8dfc29dafb3bbd7$var$P.next;
    if (null !== b) $e8dfc29dafb3bbd7$var$P = b, $e8dfc29dafb3bbd7$var$O = a;
    else {
        if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(310));
        $e8dfc29dafb3bbd7$var$O = a;
        a = {
            memoizedState: $e8dfc29dafb3bbd7$var$O.memoizedState,
            baseState: $e8dfc29dafb3bbd7$var$O.baseState,
            baseQueue: $e8dfc29dafb3bbd7$var$O.baseQueue,
            queue: $e8dfc29dafb3bbd7$var$O.queue,
            next: null
        };
        null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    }
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e8dfc29dafb3bbd7$var$fi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e8dfc29dafb3bbd7$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e8dfc29dafb3bbd7$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e8dfc29dafb3bbd7$var$N.lanes |= m;
                $e8dfc29dafb3bbd7$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e8dfc29dafb3bbd7$var$He(d, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e8dfc29dafb3bbd7$var$N.lanes |= f, $e8dfc29dafb3bbd7$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e8dfc29dafb3bbd7$var$gi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e8dfc29dafb3bbd7$var$He(f, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e8dfc29dafb3bbd7$var$hi() {}
function $e8dfc29dafb3bbd7$var$ii(a, b) {
    var c = $e8dfc29dafb3bbd7$var$N, d = $e8dfc29dafb3bbd7$var$di(), e = b(), f = !$e8dfc29dafb3bbd7$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e8dfc29dafb3bbd7$var$Ug = !0);
    d = d.queue;
    $e8dfc29dafb3bbd7$var$ji($e8dfc29dafb3bbd7$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e8dfc29dafb3bbd7$var$P && $e8dfc29dafb3bbd7$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
        0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(c, b, e);
    }
    return e;
}
function $e8dfc29dafb3bbd7$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e8dfc29dafb3bbd7$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
}
function $e8dfc29dafb3bbd7$var$ki(a, b, c) {
    return c(function() {
        $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
    });
}
function $e8dfc29dafb3bbd7$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e8dfc29dafb3bbd7$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e8dfc29dafb3bbd7$var$pi(a) {
    var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
    null !== b && $e8dfc29dafb3bbd7$var$mh(b, a, 1, -1);
}
function $e8dfc29dafb3bbd7$var$qi(a) {
    var b = $e8dfc29dafb3bbd7$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e8dfc29dafb3bbd7$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e8dfc29dafb3bbd7$var$ri.bind(null, $e8dfc29dafb3bbd7$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e8dfc29dafb3bbd7$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e8dfc29dafb3bbd7$var$si() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$ti(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$ci();
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e8dfc29dafb3bbd7$var$ui(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e8dfc29dafb3bbd7$var$O) {
        var g = $e8dfc29dafb3bbd7$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e8dfc29dafb3bbd7$var$Wh(d, g.deps)) {
            e.memoizedState = $e8dfc29dafb3bbd7$var$li(b, c, f, d);
            return;
        }
    }
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, f, d);
}
function $e8dfc29dafb3bbd7$var$vi(a, b) {
    return $e8dfc29dafb3bbd7$var$ti(8390656, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$ji(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(2048, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$wi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 2, a, b);
}
function $e8dfc29dafb3bbd7$var$xi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 4, a, b);
}
function $e8dfc29dafb3bbd7$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e8dfc29dafb3bbd7$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e8dfc29dafb3bbd7$var$ui(4, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
}
function $e8dfc29dafb3bbd7$var$Ai() {}
function $e8dfc29dafb3bbd7$var$Bi(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Ci(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Di(a, b, c) {
    if (0 === ($e8dfc29dafb3bbd7$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e8dfc29dafb3bbd7$var$Ug = !0), a.memoizedState = c;
    $e8dfc29dafb3bbd7$var$He(c, b) || (c = $e8dfc29dafb3bbd7$var$yc(), $e8dfc29dafb3bbd7$var$N.lanes |= c, $e8dfc29dafb3bbd7$var$hh |= c, a.baseState = !0);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ei(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    $e8dfc29dafb3bbd7$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e8dfc29dafb3bbd7$var$Qh.transition;
    $e8dfc29dafb3bbd7$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$Qh.transition = d;
    }
}
function $e8dfc29dafb3bbd7$var$Fi() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$Gi(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, c);
    else if (c = $e8dfc29dafb3bbd7$var$Yg(a, b, c, d), null !== c) {
        var e = $e8dfc29dafb3bbd7$var$L();
        $e8dfc29dafb3bbd7$var$mh(c, a, d, e);
        $e8dfc29dafb3bbd7$var$Ji(c, b, d);
    }
}
function $e8dfc29dafb3bbd7$var$ri(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e8dfc29dafb3bbd7$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e8dfc29dafb3bbd7$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e8dfc29dafb3bbd7$var$Yg(a, b, e, d);
        null !== c && (e = $e8dfc29dafb3bbd7$var$L(), $e8dfc29dafb3bbd7$var$mh(c, a, d, e), $e8dfc29dafb3bbd7$var$Ji(c, b, d));
    }
}
function $e8dfc29dafb3bbd7$var$Hi(a) {
    var b = a.alternate;
    return a === $e8dfc29dafb3bbd7$var$N || null !== b && b === $e8dfc29dafb3bbd7$var$N;
}
function $e8dfc29dafb3bbd7$var$Ii(a, b) {
    $e8dfc29dafb3bbd7$var$Th = $e8dfc29dafb3bbd7$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e8dfc29dafb3bbd7$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
var $e8dfc29dafb3bbd7$var$ai = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Q,
    useContext: $e8dfc29dafb3bbd7$var$Q,
    useEffect: $e8dfc29dafb3bbd7$var$Q,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$Q,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$Q,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$Q,
    useMemo: $e8dfc29dafb3bbd7$var$Q,
    useReducer: $e8dfc29dafb3bbd7$var$Q,
    useRef: $e8dfc29dafb3bbd7$var$Q,
    useState: $e8dfc29dafb3bbd7$var$Q,
    useDebugValue: $e8dfc29dafb3bbd7$var$Q,
    useDeferredValue: $e8dfc29dafb3bbd7$var$Q,
    useTransition: $e8dfc29dafb3bbd7$var$Q,
    useMutableSource: $e8dfc29dafb3bbd7$var$Q,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Q,
    useId: $e8dfc29dafb3bbd7$var$Q,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Yh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: function(a, b) {
        $e8dfc29dafb3bbd7$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e8dfc29dafb3bbd7$var$Gi.bind(null, $e8dfc29dafb3bbd7$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e8dfc29dafb3bbd7$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e8dfc29dafb3bbd7$var$qi,
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        return $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$qi(!1), b = a[0];
        a = $e8dfc29dafb3bbd7$var$Ei.bind(null, a[1]);
        $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$N, e = $e8dfc29dafb3bbd7$var$ci();
        if ($e8dfc29dafb3bbd7$var$I) {
            if (void 0 === c) throw Error($e8dfc29dafb3bbd7$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
            0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e8dfc29dafb3bbd7$var$vi($e8dfc29dafb3bbd7$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e8dfc29dafb3bbd7$var$ci(), b = $e8dfc29dafb3bbd7$var$R.identifierPrefix;
        if ($e8dfc29dafb3bbd7$var$I) {
            var c = $e8dfc29dafb3bbd7$var$sg;
            var d = $e8dfc29dafb3bbd7$var$rg;
            c = (d & ~(1 << 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e8dfc29dafb3bbd7$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e8dfc29dafb3bbd7$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Zh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$fi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$$h = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$gi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return null === $e8dfc29dafb3bbd7$var$O ? b.memoizedState = a : $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
};
function $e8dfc29dafb3bbd7$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e8dfc29dafb3bbd7$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e8dfc29dafb3bbd7$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e8dfc29dafb3bbd7$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e8dfc29dafb3bbd7$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e8dfc29dafb3bbd7$var$Oi(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e8dfc29dafb3bbd7$var$Pi || ($e8dfc29dafb3bbd7$var$Pi = !0, $e8dfc29dafb3bbd7$var$Qi = d);
        $e8dfc29dafb3bbd7$var$Mi(a, b);
    };
    return c;
}
function $e8dfc29dafb3bbd7$var$Ri(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e8dfc29dafb3bbd7$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e8dfc29dafb3bbd7$var$Mi(a, b);
        "function" !== typeof d && (null === $e8dfc29dafb3bbd7$var$Si ? $e8dfc29dafb3bbd7$var$Si = new Set([
            this
        ]) : $e8dfc29dafb3bbd7$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e8dfc29dafb3bbd7$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e8dfc29dafb3bbd7$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e8dfc29dafb3bbd7$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e8dfc29dafb3bbd7$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e8dfc29dafb3bbd7$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e8dfc29dafb3bbd7$var$ch(-1, 1), b.tag = 2, $e8dfc29dafb3bbd7$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e8dfc29dafb3bbd7$var$Xi = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$Ug = !1;
function $e8dfc29dafb3bbd7$var$Yi(a, b, c, d) {
    b.child = null === a ? $e8dfc29dafb3bbd7$var$Ch(b, null, c, d) : $e8dfc29dafb3bbd7$var$Bh(b, a.child, c, d);
}
function $e8dfc29dafb3bbd7$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    d = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    c = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && c && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e8dfc29dafb3bbd7$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e8dfc29dafb3bbd7$var$cj(a, b, f, d, e);
        a = $e8dfc29dafb3bbd7$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e8dfc29dafb3bbd7$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e8dfc29dafb3bbd7$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e8dfc29dafb3bbd7$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e8dfc29dafb3bbd7$var$Ie(f, d) && a.ref === b.ref) {
            if ($e8dfc29dafb3bbd7$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e8dfc29dafb3bbd7$var$Ug = !0);
            else return b.lanes = a.lanes, $e8dfc29dafb3bbd7$var$$i(a, b, e);
        }
    }
    return $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e);
}
function $e8dfc29dafb3bbd7$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj);
            $e8dfc29dafb3bbd7$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= d;
    $e8dfc29dafb3bbd7$var$Yi(a, b, e, c);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e) {
    var f = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current;
    f = $e8dfc29dafb3bbd7$var$Yf(b, f);
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    c = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    d = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && d && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$ij(a, b, c, d, e) {
    if ($e8dfc29dafb3bbd7$var$Zf(c)) {
        var f = !0;
        $e8dfc29dafb3bbd7$var$cg(b);
    } else f = !1;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    if (null === b.stateNode) $e8dfc29dafb3bbd7$var$jj(a, b), $e8dfc29dafb3bbd7$var$ph(b, c, d), $e8dfc29dafb3bbd7$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e8dfc29dafb3bbd7$var$Vg(l) : (l = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, l = $e8dfc29dafb3bbd7$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e8dfc29dafb3bbd7$var$qh(b, g, d, l);
        $e8dfc29dafb3bbd7$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof m && ($e8dfc29dafb3bbd7$var$kh(b, c, m, d), k = b.memoizedState), (h = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e8dfc29dafb3bbd7$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e8dfc29dafb3bbd7$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e8dfc29dafb3bbd7$var$Vg(k) : (k = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, k = $e8dfc29dafb3bbd7$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e8dfc29dafb3bbd7$var$qh(b, g, d, k);
        $e8dfc29dafb3bbd7$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof y && ($e8dfc29dafb3bbd7$var$kh(b, c, y, d), n = b.memoizedState), (l = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e8dfc29dafb3bbd7$var$kj(a, b, c, d, f, e);
}
function $e8dfc29dafb3bbd7$var$kj(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e8dfc29dafb3bbd7$var$dg(b, c, !1), $e8dfc29dafb3bbd7$var$$i(a, b, f);
    d = b.stateNode;
    $e8dfc29dafb3bbd7$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, f), b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, h, f)) : $e8dfc29dafb3bbd7$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e8dfc29dafb3bbd7$var$dg(b, c, !0);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e8dfc29dafb3bbd7$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e8dfc29dafb3bbd7$var$ag(a, b.context, !1);
    $e8dfc29dafb3bbd7$var$Ih(a, b.containerInfo);
}
function $e8dfc29dafb3bbd7$var$mj(a, b, c, d, e) {
    $e8dfc29dafb3bbd7$var$Ig();
    $e8dfc29dafb3bbd7$var$Jg(e);
    b.flags |= 256;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, d);
    return b.child;
}
var $e8dfc29dafb3bbd7$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e8dfc29dafb3bbd7$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e8dfc29dafb3bbd7$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e8dfc29dafb3bbd7$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, e & 1);
    if (null === a) {
        $e8dfc29dafb3bbd7$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e8dfc29dafb3bbd7$var$qj(g, d, 0, null), a = $e8dfc29dafb3bbd7$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(c), b.memoizedState = $e8dfc29dafb3bbd7$var$nj, a) : $e8dfc29dafb3bbd7$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e8dfc29dafb3bbd7$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e8dfc29dafb3bbd7$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e8dfc29dafb3bbd7$var$wh(h, f) : (f = $e8dfc29dafb3bbd7$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e8dfc29dafb3bbd7$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e8dfc29dafb3bbd7$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e8dfc29dafb3bbd7$var$rj(a, b) {
    b = $e8dfc29dafb3bbd7$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e8dfc29dafb3bbd7$var$tj(a, b, c, d) {
    null !== d && $e8dfc29dafb3bbd7$var$Jg(d);
    $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, c);
    a = $e8dfc29dafb3bbd7$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e8dfc29dafb3bbd7$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(422))), $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e8dfc29dafb3bbd7$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e8dfc29dafb3bbd7$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(g);
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e8dfc29dafb3bbd7$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e8dfc29dafb3bbd7$var$p(419));
        d = $e8dfc29dafb3bbd7$var$Li(f, d, void 0);
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e8dfc29dafb3bbd7$var$Ug || h) {
        d = $e8dfc29dafb3bbd7$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e8dfc29dafb3bbd7$var$Zg(a, e), $e8dfc29dafb3bbd7$var$mh(d, a, e, -1));
        }
        $e8dfc29dafb3bbd7$var$uj();
        d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(421)));
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e8dfc29dafb3bbd7$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(e.nextSibling);
    $e8dfc29dafb3bbd7$var$xg = b;
    $e8dfc29dafb3bbd7$var$I = !0;
    $e8dfc29dafb3bbd7$var$zg = null;
    null !== a && ($e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg, $e8dfc29dafb3bbd7$var$rg = a.id, $e8dfc29dafb3bbd7$var$sg = a.overflow, $e8dfc29dafb3bbd7$var$qg = b);
    b = $e8dfc29dafb3bbd7$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e8dfc29dafb3bbd7$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e8dfc29dafb3bbd7$var$Sg(a.return, b, c);
}
function $e8dfc29dafb3bbd7$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e8dfc29dafb3bbd7$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d.children, c);
    d = $e8dfc29dafb3bbd7$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (19 === a.tag) $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e8dfc29dafb3bbd7$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e8dfc29dafb3bbd7$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e8dfc29dafb3bbd7$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e8dfc29dafb3bbd7$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e8dfc29dafb3bbd7$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e8dfc29dafb3bbd7$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e8dfc29dafb3bbd7$var$lj(b);
            $e8dfc29dafb3bbd7$var$Ig();
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$Kh(b);
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$cg(b);
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e8dfc29dafb3bbd7$var$pj(a, b, c);
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
                a = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e8dfc29dafb3bbd7$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    return $e8dfc29dafb3bbd7$var$$i(a, b, c);
}
var $e8dfc29dafb3bbd7$var$Aj, $e8dfc29dafb3bbd7$var$Bj, $e8dfc29dafb3bbd7$var$Cj, $e8dfc29dafb3bbd7$var$Dj;
$e8dfc29dafb3bbd7$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e8dfc29dafb3bbd7$var$Bj = function() {};
$e8dfc29dafb3bbd7$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e8dfc29dafb3bbd7$var$Ya(a, e);
                d = $e8dfc29dafb3bbd7$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e8dfc29dafb3bbd7$var$A({}, e, {
                    value: void 0
                });
                d = $e8dfc29dafb3bbd7$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e8dfc29dafb3bbd7$var$gb(a, e);
                d = $e8dfc29dafb3bbd7$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
        }
        $e8dfc29dafb3bbd7$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e8dfc29dafb3bbd7$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e8dfc29dafb3bbd7$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e8dfc29dafb3bbd7$var$Ej(a, b) {
    if (!$e8dfc29dafb3bbd7$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e8dfc29dafb3bbd7$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e8dfc29dafb3bbd7$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e8dfc29dafb3bbd7$var$S(b), null;
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e8dfc29dafb3bbd7$var$Jh();
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
            $e8dfc29dafb3bbd7$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e8dfc29dafb3bbd7$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null));
            $e8dfc29dafb3bbd7$var$Bj(a, b);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 5:
            $e8dfc29dafb3bbd7$var$Lh(b);
            var e = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                    $e8dfc29dafb3bbd7$var$S(b);
                    return null;
                }
                a = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    d[$e8dfc29dafb3bbd7$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e8dfc29dafb3bbd7$var$D("cancel", d);
                            $e8dfc29dafb3bbd7$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], d);
                            break;
                        case "source":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "details":
                            $e8dfc29dafb3bbd7$var$D("toggle", d);
                            break;
                        case "input":
                            $e8dfc29dafb3bbd7$var$Za(d, f);
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$hb(d, f), $e8dfc29dafb3bbd7$var$D("invalid", d);
                    }
                    $e8dfc29dafb3bbd7$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e8dfc29dafb3bbd7$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e8dfc29dafb3bbd7$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e8dfc29dafb3bbd7$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e8dfc29dafb3bbd7$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e8dfc29dafb3bbd7$var$Of] = b;
                    a[$e8dfc29dafb3bbd7$var$Pf] = d;
                    $e8dfc29dafb3bbd7$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e8dfc29dafb3bbd7$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e8dfc29dafb3bbd7$var$D("cancel", a);
                                $e8dfc29dafb3bbd7$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e8dfc29dafb3bbd7$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e8dfc29dafb3bbd7$var$Za(a, d);
                                e = $e8dfc29dafb3bbd7$var$Ya(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e8dfc29dafb3bbd7$var$A({}, d, {
                                    value: void 0
                                });
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$hb(a, d);
                                e = $e8dfc29dafb3bbd7$var$gb(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e8dfc29dafb3bbd7$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e8dfc29dafb3bbd7$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e8dfc29dafb3bbd7$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e8dfc29dafb3bbd7$var$ob(a, k) : "number" === typeof k && $e8dfc29dafb3bbd7$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e8dfc29dafb3bbd7$var$D("scroll", a) : null != k && $e8dfc29dafb3bbd7$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e8dfc29dafb3bbd7$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                c = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
                $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e8dfc29dafb3bbd7$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e8dfc29dafb3bbd7$var$Of] = b, b.stateNode = d;
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e8dfc29dafb3bbd7$var$I && null !== $e8dfc29dafb3bbd7$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e8dfc29dafb3bbd7$var$Hg(), $e8dfc29dafb3bbd7$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e8dfc29dafb3bbd7$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(317));
                        f[$e8dfc29dafb3bbd7$var$Of] = b;
                    } else $e8dfc29dafb3bbd7$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e8dfc29dafb3bbd7$var$S(b);
                    f = !1;
                } else null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e8dfc29dafb3bbd7$var$M.current & 1) ? 0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 3) : $e8dfc29dafb3bbd7$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$Bj(a, b), null === a && $e8dfc29dafb3bbd7$var$sf(b.stateNode.containerInfo), $e8dfc29dafb3bbd7$var$S(b), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), $e8dfc29dafb3bbd7$var$S(b), null;
        case 17:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 19:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            f = b.memoizedState;
            if (null === f) return $e8dfc29dafb3bbd7$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e8dfc29dafb3bbd7$var$Ej(f, !1);
                else {
                    if (0 !== $e8dfc29dafb3bbd7$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e8dfc29dafb3bbd7$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e8dfc29dafb3bbd7$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e8dfc29dafb3bbd7$var$B() > $e8dfc29dafb3bbd7$var$Hj && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e8dfc29dafb3bbd7$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e8dfc29dafb3bbd7$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$S(b), null;
                    } else 2 * $e8dfc29dafb3bbd7$var$B() - f.renderingStartTime > $e8dfc29dafb3bbd7$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e8dfc29dafb3bbd7$var$B(), b.sibling = null, c = $e8dfc29dafb3bbd7$var$M.current, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d ? c & 1 | 2 : c & 1), b;
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e8dfc29dafb3bbd7$var$gj & 1073741824) && ($e8dfc29dafb3bbd7$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e8dfc29dafb3bbd7$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
}
function $e8dfc29dafb3bbd7$var$Jj(a, b) {
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e8dfc29dafb3bbd7$var$Lh(b), null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e8dfc29dafb3bbd7$var$p(340));
                $e8dfc29dafb3bbd7$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M), null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$Kj = !1, $e8dfc29dafb3bbd7$var$U = !1, $e8dfc29dafb3bbd7$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e8dfc29dafb3bbd7$var$V = null;
function $e8dfc29dafb3bbd7$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e8dfc29dafb3bbd7$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e8dfc29dafb3bbd7$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e8dfc29dafb3bbd7$var$W(a, b, d);
    }
}
var $e8dfc29dafb3bbd7$var$Oj = !1;
function $e8dfc29dafb3bbd7$var$Pj(a, b) {
    $e8dfc29dafb3bbd7$var$Cf = $e8dfc29dafb3bbd7$var$dd;
    a = $e8dfc29dafb3bbd7$var$Me();
    if ($e8dfc29dafb3bbd7$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e8dfc29dafb3bbd7$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e8dfc29dafb3bbd7$var$dd = !1;
    for($e8dfc29dafb3bbd7$var$V = b; null !== $e8dfc29dafb3bbd7$var$V;)if (b = $e8dfc29dafb3bbd7$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e8dfc29dafb3bbd7$var$V = a;
    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
        b = $e8dfc29dafb3bbd7$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e8dfc29dafb3bbd7$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(163));
            }
        } catch (F) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e8dfc29dafb3bbd7$var$V = a;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
    n = $e8dfc29dafb3bbd7$var$Oj;
    $e8dfc29dafb3bbd7$var$Oj = !1;
    return n;
}
function $e8dfc29dafb3bbd7$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e8dfc29dafb3bbd7$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e8dfc29dafb3bbd7$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e8dfc29dafb3bbd7$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e8dfc29dafb3bbd7$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e8dfc29dafb3bbd7$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e8dfc29dafb3bbd7$var$Of], delete b[$e8dfc29dafb3bbd7$var$Pf], delete b[$e8dfc29dafb3bbd7$var$of], delete b[$e8dfc29dafb3bbd7$var$Qf], delete b[$e8dfc29dafb3bbd7$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e8dfc29dafb3bbd7$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e8dfc29dafb3bbd7$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e8dfc29dafb3bbd7$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e8dfc29dafb3bbd7$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling;
}
function $e8dfc29dafb3bbd7$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling;
}
var $e8dfc29dafb3bbd7$var$X = null, $e8dfc29dafb3bbd7$var$Yj = !1;
function $e8dfc29dafb3bbd7$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e8dfc29dafb3bbd7$var$ak(a, b, c), c = c.sibling;
}
function $e8dfc29dafb3bbd7$var$ak(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount($e8dfc29dafb3bbd7$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Mj(c, b);
        case 6:
            var d = $e8dfc29dafb3bbd7$var$X, e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e8dfc29dafb3bbd7$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? $e8dfc29dafb3bbd7$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e8dfc29dafb3bbd7$var$Kf(a, c), $e8dfc29dafb3bbd7$var$bd(a)) : $e8dfc29dafb3bbd7$var$Kf($e8dfc29dafb3bbd7$var$X, c.stateNode));
            break;
        case 4:
            d = $e8dfc29dafb3bbd7$var$X;
            e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = c.stateNode.containerInfo;
            $e8dfc29dafb3bbd7$var$Yj = !0;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e8dfc29dafb3bbd7$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e8dfc29dafb3bbd7$var$Nj(c, b, g) : 0 !== (f & 4) && $e8dfc29dafb3bbd7$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e8dfc29dafb3bbd7$var$U && ($e8dfc29dafb3bbd7$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e8dfc29dafb3bbd7$var$W(c, b, h);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 21:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (d = $e8dfc29dafb3bbd7$var$U) || null !== c.memoizedState, $e8dfc29dafb3bbd7$var$Zj(a, b, c), $e8dfc29dafb3bbd7$var$U = d) : $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        default:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e8dfc29dafb3bbd7$var$Lj);
        b.forEach(function(b) {
            var d = $e8dfc29dafb3bbd7$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e8dfc29dafb3bbd7$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode;
                        $e8dfc29dafb3bbd7$var$Yj = !1;
                        break a;
                    case 3:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                    case 4:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e8dfc29dafb3bbd7$var$X) throw Error($e8dfc29dafb3bbd7$var$p(160));
            $e8dfc29dafb3bbd7$var$ak(f, g, e);
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e8dfc29dafb3bbd7$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e8dfc29dafb3bbd7$var$ek(b, a), b = b.sibling;
}
function $e8dfc29dafb3bbd7$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                try {
                    $e8dfc29dafb3bbd7$var$Qj(3, a, a.return), $e8dfc29dafb3bbd7$var$Rj(3, a);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
                try {
                    $e8dfc29dafb3bbd7$var$Qj(5, a, a.return);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e8dfc29dafb3bbd7$var$ob(e, "");
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e8dfc29dafb3bbd7$var$ab(e, f);
                    $e8dfc29dafb3bbd7$var$vb(h, g);
                    var l = $e8dfc29dafb3bbd7$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e8dfc29dafb3bbd7$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e8dfc29dafb3bbd7$var$nb(e, q) : "children" === m ? $e8dfc29dafb3bbd7$var$ob(e, q) : $e8dfc29dafb3bbd7$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e8dfc29dafb3bbd7$var$bb(e, f);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e8dfc29dafb3bbd7$var$Pf] = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e8dfc29dafb3bbd7$var$bd(b.containerInfo);
            } catch (t) {
                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e8dfc29dafb3bbd7$var$gk = $e8dfc29dafb3bbd7$var$B()));
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (l = $e8dfc29dafb3bbd7$var$U) || m, $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$U = l) : $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e8dfc29dafb3bbd7$var$V = a, m = a.child; null !== m;){
                    for(q = $e8dfc29dafb3bbd7$var$V = m; null !== $e8dfc29dafb3bbd7$var$V;){
                        r = $e8dfc29dafb3bbd7$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e8dfc29dafb3bbd7$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e8dfc29dafb3bbd7$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e8dfc29dafb3bbd7$var$V = y) : $e8dfc29dafb3bbd7$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e8dfc29dafb3bbd7$var$rb("display", g));
                            } catch (t) {
                                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$fk(a);
    }
}
function $e8dfc29dafb3bbd7$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e8dfc29dafb3bbd7$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e8dfc29dafb3bbd7$var$ob(e, ""), d.flags &= -33);
                    var f = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(161));
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e8dfc29dafb3bbd7$var$ik(a, b, c) {
    $e8dfc29dafb3bbd7$var$V = a;
    $e8dfc29dafb3bbd7$var$jk(a, b, c);
}
function $e8dfc29dafb3bbd7$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e8dfc29dafb3bbd7$var$V;){
        var e = $e8dfc29dafb3bbd7$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e8dfc29dafb3bbd7$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e8dfc29dafb3bbd7$var$U;
                h = $e8dfc29dafb3bbd7$var$Kj;
                var l = $e8dfc29dafb3bbd7$var$U;
                $e8dfc29dafb3bbd7$var$Kj = g;
                if (($e8dfc29dafb3bbd7$var$U = k) && !l) for($e8dfc29dafb3bbd7$var$V = e; null !== $e8dfc29dafb3bbd7$var$V;)g = $e8dfc29dafb3bbd7$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e8dfc29dafb3bbd7$var$kk(e) : null !== k ? (k.return = g, $e8dfc29dafb3bbd7$var$V = k) : $e8dfc29dafb3bbd7$var$kk(e);
                for(; null !== f;)$e8dfc29dafb3bbd7$var$V = f, $e8dfc29dafb3bbd7$var$jk(f, b, c), f = f.sibling;
                $e8dfc29dafb3bbd7$var$V = e;
                $e8dfc29dafb3bbd7$var$Kj = h;
                $e8dfc29dafb3bbd7$var$U = l;
            }
            $e8dfc29dafb3bbd7$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e8dfc29dafb3bbd7$var$V = f) : $e8dfc29dafb3bbd7$var$lk(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$lk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e8dfc29dafb3bbd7$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e8dfc29dafb3bbd7$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e8dfc29dafb3bbd7$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e8dfc29dafb3bbd7$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e8dfc29dafb3bbd7$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e8dfc29dafb3bbd7$var$p(163));
                }
                $e8dfc29dafb3bbd7$var$U || b.flags & 512 && $e8dfc29dafb3bbd7$var$Sj(b);
            } catch (r) {
                $e8dfc29dafb3bbd7$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$hk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$kk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(4, b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e8dfc29dafb3bbd7$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, k);
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e8dfc29dafb3bbd7$var$V = h;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
var $e8dfc29dafb3bbd7$var$mk = Math.ceil, $e8dfc29dafb3bbd7$var$nk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$ok = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$pk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$K = 0, $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Y = null, $e8dfc29dafb3bbd7$var$Z = 0, $e8dfc29dafb3bbd7$var$gj = 0, $e8dfc29dafb3bbd7$var$fj = $e8dfc29dafb3bbd7$var$Uf(0), $e8dfc29dafb3bbd7$var$T = 0, $e8dfc29dafb3bbd7$var$qk = null, $e8dfc29dafb3bbd7$var$hh = 0, $e8dfc29dafb3bbd7$var$rk = 0, $e8dfc29dafb3bbd7$var$sk = 0, $e8dfc29dafb3bbd7$var$tk = null, $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$gk = 0, $e8dfc29dafb3bbd7$var$Hj = Infinity, $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Pi = !1, $e8dfc29dafb3bbd7$var$Qi = null, $e8dfc29dafb3bbd7$var$Si = null, $e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = null, $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, $e8dfc29dafb3bbd7$var$Bk = -1, $e8dfc29dafb3bbd7$var$Ck = 0;
function $e8dfc29dafb3bbd7$var$L() {
    return 0 !== ($e8dfc29dafb3bbd7$var$K & 6) ? $e8dfc29dafb3bbd7$var$B() : -1 !== $e8dfc29dafb3bbd7$var$Bk ? $e8dfc29dafb3bbd7$var$Bk : $e8dfc29dafb3bbd7$var$Bk = $e8dfc29dafb3bbd7$var$B();
}
function $e8dfc29dafb3bbd7$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2) && 0 !== $e8dfc29dafb3bbd7$var$Z) return $e8dfc29dafb3bbd7$var$Z & -$e8dfc29dafb3bbd7$var$Z;
    if (null !== $e8dfc29dafb3bbd7$var$Kg.transition) return 0 === $e8dfc29dafb3bbd7$var$Ck && ($e8dfc29dafb3bbd7$var$Ck = $e8dfc29dafb3bbd7$var$yc()), $e8dfc29dafb3bbd7$var$Ck;
    a = $e8dfc29dafb3bbd7$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e8dfc29dafb3bbd7$var$jd(a.type);
    return a;
}
function $e8dfc29dafb3bbd7$var$mh(a, b, c, d) {
    if (50 < $e8dfc29dafb3bbd7$var$zk) throw $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, Error($e8dfc29dafb3bbd7$var$p(185));
    $e8dfc29dafb3bbd7$var$Ac(a, c, d);
    if (0 === ($e8dfc29dafb3bbd7$var$K & 2) || a !== $e8dfc29dafb3bbd7$var$R) a === $e8dfc29dafb3bbd7$var$R && (0 === ($e8dfc29dafb3bbd7$var$K & 2) && ($e8dfc29dafb3bbd7$var$rk |= c), 4 === $e8dfc29dafb3bbd7$var$T && $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$Z)), $e8dfc29dafb3bbd7$var$Ek(a, d), 1 === c && 0 === $e8dfc29dafb3bbd7$var$K && 0 === (b.mode & 1) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
}
function $e8dfc29dafb3bbd7$var$Ek(a, b) {
    var c = a.callbackNode;
    $e8dfc29dafb3bbd7$var$wc(a, b);
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) null !== c && $e8dfc29dafb3bbd7$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e8dfc29dafb3bbd7$var$bc(c);
        if (1 === b) 0 === a.tag ? $e8dfc29dafb3bbd7$var$ig($e8dfc29dafb3bbd7$var$Fk.bind(null, a)) : $e8dfc29dafb3bbd7$var$hg($e8dfc29dafb3bbd7$var$Fk.bind(null, a)), $e8dfc29dafb3bbd7$var$Jf(function() {
            0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
        }), c = null;
        else {
            switch($e8dfc29dafb3bbd7$var$Dc(d)){
                case 1:
                    c = $e8dfc29dafb3bbd7$var$fc;
                    break;
                case 4:
                    c = $e8dfc29dafb3bbd7$var$gc;
                    break;
                case 16:
                    c = $e8dfc29dafb3bbd7$var$hc;
                    break;
                case 536870912:
                    c = $e8dfc29dafb3bbd7$var$jc;
                    break;
                default:
                    c = $e8dfc29dafb3bbd7$var$hc;
            }
            c = $e8dfc29dafb3bbd7$var$Gk(c, $e8dfc29dafb3bbd7$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e8dfc29dafb3bbd7$var$Hk(a, b) {
    $e8dfc29dafb3bbd7$var$Bk = -1;
    $e8dfc29dafb3bbd7$var$Ck = 0;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    var c = a.callbackNode;
    if ($e8dfc29dafb3bbd7$var$Ik() && a.callbackNode !== c) return null;
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e8dfc29dafb3bbd7$var$Jk(a, d);
    else {
        b = d;
        var e = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 2;
        var f = $e8dfc29dafb3bbd7$var$Kk();
        if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$Lk(a, b);
        for(;;)try {
            $e8dfc29dafb3bbd7$var$Mk();
            break;
        } catch (h) {
            $e8dfc29dafb3bbd7$var$Nk(a, h);
        }
        $e8dfc29dafb3bbd7$var$Qg();
        $e8dfc29dafb3bbd7$var$nk.current = f;
        $e8dfc29dafb3bbd7$var$K = e;
        null !== $e8dfc29dafb3bbd7$var$Y ? b = 0 : ($e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0, b = $e8dfc29dafb3bbd7$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e8dfc29dafb3bbd7$var$xc(a), 0 !== e && (d = e, b = $e8dfc29dafb3bbd7$var$Ok(a, e)));
        if (1 === b) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
        if (6 === b) $e8dfc29dafb3bbd7$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e8dfc29dafb3bbd7$var$Pk(e) && (b = $e8dfc29dafb3bbd7$var$Jk(a, d), 2 === b && (f = $e8dfc29dafb3bbd7$var$xc(a), 0 !== f && (d = f, b = $e8dfc29dafb3bbd7$var$Ok(a, f))), 1 === b)) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e8dfc29dafb3bbd7$var$p(345));
                case 2:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 3:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e8dfc29dafb3bbd7$var$gk + 500 - $e8dfc29dafb3bbd7$var$B(), 10 < b)) {
                        if (0 !== $e8dfc29dafb3bbd7$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e8dfc29dafb3bbd7$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), b);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 4:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e8dfc29dafb3bbd7$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e8dfc29dafb3bbd7$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e8dfc29dafb3bbd7$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), d);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 5:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(329));
            }
        }
    }
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return a.callbackNode === c ? $e8dfc29dafb3bbd7$var$Hk.bind(null, a) : null;
}
function $e8dfc29dafb3bbd7$var$Ok(a, b) {
    var c = $e8dfc29dafb3bbd7$var$tk;
    a.current.memoizedState.isDehydrated && ($e8dfc29dafb3bbd7$var$Lk(a, b).flags |= 256);
    a = $e8dfc29dafb3bbd7$var$Jk(a, b);
    2 !== a && (b = $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$uk = c, null !== b && $e8dfc29dafb3bbd7$var$Gj(b));
    return a;
}
function $e8dfc29dafb3bbd7$var$Gj(a) {
    null === $e8dfc29dafb3bbd7$var$uk ? $e8dfc29dafb3bbd7$var$uk = a : $e8dfc29dafb3bbd7$var$uk.push.apply($e8dfc29dafb3bbd7$var$uk, a);
}
function $e8dfc29dafb3bbd7$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e8dfc29dafb3bbd7$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Dk(a, b) {
    b &= ~$e8dfc29dafb3bbd7$var$sk;
    b &= ~$e8dfc29dafb3bbd7$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e8dfc29dafb3bbd7$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e8dfc29dafb3bbd7$var$Fk(a) {
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$uc(a, 0);
    if (0 === (b & 1)) return $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), null;
    var c = $e8dfc29dafb3bbd7$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e8dfc29dafb3bbd7$var$xc(a);
        0 !== d && (b = d, c = $e8dfc29dafb3bbd7$var$Ok(a, d));
    }
    if (1 === c) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, b), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
    if (6 === c) throw Error($e8dfc29dafb3bbd7$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return null;
}
function $e8dfc29dafb3bbd7$var$Rk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e8dfc29dafb3bbd7$var$K = c, 0 === $e8dfc29dafb3bbd7$var$K && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
    }
}
function $e8dfc29dafb3bbd7$var$Sk(a) {
    null !== $e8dfc29dafb3bbd7$var$xk && 0 === $e8dfc29dafb3bbd7$var$xk.tag && 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    var c = $e8dfc29dafb3bbd7$var$pk.transition, d = $e8dfc29dafb3bbd7$var$C;
    try {
        if ($e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, a) return a();
    } finally{
        $e8dfc29dafb3bbd7$var$C = d, $e8dfc29dafb3bbd7$var$pk.transition = c, $e8dfc29dafb3bbd7$var$K = b, 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
    }
}
function $e8dfc29dafb3bbd7$var$Ij() {
    $e8dfc29dafb3bbd7$var$gj = $e8dfc29dafb3bbd7$var$fj.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$fj);
}
function $e8dfc29dafb3bbd7$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e8dfc29dafb3bbd7$var$Gf(c));
    if (null !== $e8dfc29dafb3bbd7$var$Y) for(c = $e8dfc29dafb3bbd7$var$Y.return; null !== c;){
        var d = c;
        $e8dfc29dafb3bbd7$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e8dfc29dafb3bbd7$var$$f();
                break;
            case 3:
                $e8dfc29dafb3bbd7$var$Jh();
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
                $e8dfc29dafb3bbd7$var$Oh();
                break;
            case 5:
                $e8dfc29dafb3bbd7$var$Lh(d);
                break;
            case 4:
                $e8dfc29dafb3bbd7$var$Jh();
                break;
            case 13:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 19:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 10:
                $e8dfc29dafb3bbd7$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e8dfc29dafb3bbd7$var$Ij();
        }
        c = c.return;
    }
    $e8dfc29dafb3bbd7$var$R = a;
    $e8dfc29dafb3bbd7$var$Y = a = $e8dfc29dafb3bbd7$var$wh(a.current, null);
    $e8dfc29dafb3bbd7$var$Z = $e8dfc29dafb3bbd7$var$gj = b;
    $e8dfc29dafb3bbd7$var$T = 0;
    $e8dfc29dafb3bbd7$var$qk = null;
    $e8dfc29dafb3bbd7$var$sk = $e8dfc29dafb3bbd7$var$rk = $e8dfc29dafb3bbd7$var$hh = 0;
    $e8dfc29dafb3bbd7$var$uk = $e8dfc29dafb3bbd7$var$tk = null;
    if (null !== $e8dfc29dafb3bbd7$var$Wg) {
        for(b = 0; b < $e8dfc29dafb3bbd7$var$Wg.length; b++)if (c = $e8dfc29dafb3bbd7$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e8dfc29dafb3bbd7$var$Wg = null;
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Nk(a, b) {
    do {
        var c = $e8dfc29dafb3bbd7$var$Y;
        try {
            $e8dfc29dafb3bbd7$var$Qg();
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
            if ($e8dfc29dafb3bbd7$var$Sh) {
                for(var d = $e8dfc29dafb3bbd7$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e8dfc29dafb3bbd7$var$Sh = !1;
            }
            $e8dfc29dafb3bbd7$var$Rh = 0;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            $e8dfc29dafb3bbd7$var$ok.current = null;
            if (null === c || null === c.return) {
                $e8dfc29dafb3bbd7$var$T = 1;
                $e8dfc29dafb3bbd7$var$qk = b;
                $e8dfc29dafb3bbd7$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e8dfc29dafb3bbd7$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e8dfc29dafb3bbd7$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                            $e8dfc29dafb3bbd7$var$uj();
                            break a;
                        }
                        k = Error($e8dfc29dafb3bbd7$var$p(426));
                    }
                } else if ($e8dfc29dafb3bbd7$var$I && h.mode & 1) {
                    var J = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e8dfc29dafb3bbd7$var$Wi(J, g, h, f, b);
                        $e8dfc29dafb3bbd7$var$Jg($e8dfc29dafb3bbd7$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e8dfc29dafb3bbd7$var$Ki(k, h);
                4 !== $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 2);
                null === $e8dfc29dafb3bbd7$var$tk ? $e8dfc29dafb3bbd7$var$tk = [
                    f
                ] : $e8dfc29dafb3bbd7$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e8dfc29dafb3bbd7$var$Oi(f, k, b);
                            $e8dfc29dafb3bbd7$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e8dfc29dafb3bbd7$var$Ri(f, h, b);
                                $e8dfc29dafb3bbd7$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e8dfc29dafb3bbd7$var$Tk(c);
        } catch (na) {
            b = na;
            $e8dfc29dafb3bbd7$var$Y === c && null !== c && ($e8dfc29dafb3bbd7$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e8dfc29dafb3bbd7$var$Kk() {
    var a = $e8dfc29dafb3bbd7$var$nk.current;
    $e8dfc29dafb3bbd7$var$nk.current = $e8dfc29dafb3bbd7$var$ai;
    return null === a ? $e8dfc29dafb3bbd7$var$ai : a;
}
function $e8dfc29dafb3bbd7$var$uj() {
    if (0 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T || 2 === $e8dfc29dafb3bbd7$var$T) $e8dfc29dafb3bbd7$var$T = 4;
    null === $e8dfc29dafb3bbd7$var$R || 0 === ($e8dfc29dafb3bbd7$var$hh & 268435455) && 0 === ($e8dfc29dafb3bbd7$var$rk & 268435455) || $e8dfc29dafb3bbd7$var$Dk($e8dfc29dafb3bbd7$var$R, $e8dfc29dafb3bbd7$var$Z);
}
function $e8dfc29dafb3bbd7$var$Jk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 2;
    var d = $e8dfc29dafb3bbd7$var$Kk();
    if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Lk(a, b);
    for(;;)try {
        $e8dfc29dafb3bbd7$var$Uk();
        break;
    } catch (e) {
        $e8dfc29dafb3bbd7$var$Nk(a, e);
    }
    $e8dfc29dafb3bbd7$var$Qg();
    $e8dfc29dafb3bbd7$var$K = c;
    $e8dfc29dafb3bbd7$var$nk.current = d;
    if (null !== $e8dfc29dafb3bbd7$var$Y) throw Error($e8dfc29dafb3bbd7$var$p(261));
    $e8dfc29dafb3bbd7$var$R = null;
    $e8dfc29dafb3bbd7$var$Z = 0;
    return $e8dfc29dafb3bbd7$var$T;
}
function $e8dfc29dafb3bbd7$var$Uk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y;)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Mk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y && !$e8dfc29dafb3bbd7$var$cc();)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Vk(a) {
    var b = $e8dfc29dafb3bbd7$var$Wk(a.alternate, a, $e8dfc29dafb3bbd7$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e8dfc29dafb3bbd7$var$Tk(a) : $e8dfc29dafb3bbd7$var$Y = b;
    $e8dfc29dafb3bbd7$var$ok.current = null;
}
function $e8dfc29dafb3bbd7$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e8dfc29dafb3bbd7$var$Fj(c, b, $e8dfc29dafb3bbd7$var$gj), null !== c) {
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
        } else {
            c = $e8dfc29dafb3bbd7$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e8dfc29dafb3bbd7$var$T = 6;
                $e8dfc29dafb3bbd7$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e8dfc29dafb3bbd7$var$Y = b;
            return;
        }
        $e8dfc29dafb3bbd7$var$Y = b = a;
    }while (null !== b);
    0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 5);
}
function $e8dfc29dafb3bbd7$var$Qk(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$C, e = $e8dfc29dafb3bbd7$var$pk.transition;
    try {
        $e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$Xk(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$pk.transition = e, $e8dfc29dafb3bbd7$var$C = d;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xk(a, b, c, d) {
    do $e8dfc29dafb3bbd7$var$Ik();
    while (null !== $e8dfc29dafb3bbd7$var$xk);
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e8dfc29dafb3bbd7$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e8dfc29dafb3bbd7$var$Bc(a, f);
    a === $e8dfc29dafb3bbd7$var$R && ($e8dfc29dafb3bbd7$var$Y = $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e8dfc29dafb3bbd7$var$wk || ($e8dfc29dafb3bbd7$var$wk = !0, $e8dfc29dafb3bbd7$var$Gk($e8dfc29dafb3bbd7$var$hc, function() {
        $e8dfc29dafb3bbd7$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e8dfc29dafb3bbd7$var$pk.transition;
        $e8dfc29dafb3bbd7$var$pk.transition = null;
        var g = $e8dfc29dafb3bbd7$var$C;
        $e8dfc29dafb3bbd7$var$C = 1;
        var h = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 4;
        $e8dfc29dafb3bbd7$var$ok.current = null;
        $e8dfc29dafb3bbd7$var$Pj(a, c);
        $e8dfc29dafb3bbd7$var$ek(c, a);
        $e8dfc29dafb3bbd7$var$Oe($e8dfc29dafb3bbd7$var$Df);
        $e8dfc29dafb3bbd7$var$dd = !!$e8dfc29dafb3bbd7$var$Cf;
        $e8dfc29dafb3bbd7$var$Df = $e8dfc29dafb3bbd7$var$Cf = null;
        a.current = c;
        $e8dfc29dafb3bbd7$var$ik(c, a, e);
        $e8dfc29dafb3bbd7$var$dc();
        $e8dfc29dafb3bbd7$var$K = h;
        $e8dfc29dafb3bbd7$var$C = g;
        $e8dfc29dafb3bbd7$var$pk.transition = f;
    } else a.current = c;
    $e8dfc29dafb3bbd7$var$wk && ($e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = a, $e8dfc29dafb3bbd7$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e8dfc29dafb3bbd7$var$Si = null);
    $e8dfc29dafb3bbd7$var$mc(c.stateNode, d);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e8dfc29dafb3bbd7$var$Pi) throw $e8dfc29dafb3bbd7$var$Pi = !1, a = $e8dfc29dafb3bbd7$var$Qi, $e8dfc29dafb3bbd7$var$Qi = null, a;
    0 !== ($e8dfc29dafb3bbd7$var$yk & 1) && 0 !== a.tag && $e8dfc29dafb3bbd7$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e8dfc29dafb3bbd7$var$Ak ? $e8dfc29dafb3bbd7$var$zk++ : ($e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = a) : $e8dfc29dafb3bbd7$var$zk = 0;
    $e8dfc29dafb3bbd7$var$jg();
    return null;
}
function $e8dfc29dafb3bbd7$var$Ik() {
    if (null !== $e8dfc29dafb3bbd7$var$xk) {
        var a = $e8dfc29dafb3bbd7$var$Dc($e8dfc29dafb3bbd7$var$yk), b = $e8dfc29dafb3bbd7$var$pk.transition, c = $e8dfc29dafb3bbd7$var$C;
        try {
            $e8dfc29dafb3bbd7$var$pk.transition = null;
            $e8dfc29dafb3bbd7$var$C = 16 > a ? 16 : a;
            if (null === $e8dfc29dafb3bbd7$var$xk) var d = !1;
            else {
                a = $e8dfc29dafb3bbd7$var$xk;
                $e8dfc29dafb3bbd7$var$xk = null;
                $e8dfc29dafb3bbd7$var$yk = 0;
                if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(331));
                var e = $e8dfc29dafb3bbd7$var$K;
                $e8dfc29dafb3bbd7$var$K |= 4;
                for($e8dfc29dafb3bbd7$var$V = a.current; null !== $e8dfc29dafb3bbd7$var$V;){
                    var f = $e8dfc29dafb3bbd7$var$V, g = f.child;
                    if (0 !== ($e8dfc29dafb3bbd7$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e8dfc29dafb3bbd7$var$V = l; null !== $e8dfc29dafb3bbd7$var$V;){
                                    var m = $e8dfc29dafb3bbd7$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e8dfc29dafb3bbd7$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e8dfc29dafb3bbd7$var$V = q;
                                    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
                                        m = $e8dfc29dafb3bbd7$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e8dfc29dafb3bbd7$var$Tj(m);
                                        if (m === l) {
                                            $e8dfc29dafb3bbd7$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e8dfc29dafb3bbd7$var$V = r;
                                            break;
                                        }
                                        $e8dfc29dafb3bbd7$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e8dfc29dafb3bbd7$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e8dfc29dafb3bbd7$var$V = g;
                    else b: for(; null !== $e8dfc29dafb3bbd7$var$V;){
                        f = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e8dfc29dafb3bbd7$var$V = x;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e8dfc29dafb3bbd7$var$V = w; null !== $e8dfc29dafb3bbd7$var$V;){
                    g = $e8dfc29dafb3bbd7$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e8dfc29dafb3bbd7$var$V = u;
                    else b: for(g = w; null !== $e8dfc29dafb3bbd7$var$V;){
                        h = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e8dfc29dafb3bbd7$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e8dfc29dafb3bbd7$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e8dfc29dafb3bbd7$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e8dfc29dafb3bbd7$var$V = F;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = h.return;
                    }
                }
                $e8dfc29dafb3bbd7$var$K = e;
                $e8dfc29dafb3bbd7$var$jg();
                if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot) try {
                    $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$pk.transition = b;
        }
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Yk(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Ki(c, b);
    b = $e8dfc29dafb3bbd7$var$Oi(a, b, 1);
    a = $e8dfc29dafb3bbd7$var$dh(a, b, 1);
    b = $e8dfc29dafb3bbd7$var$L();
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, 1, b), $e8dfc29dafb3bbd7$var$Ek(a, b));
}
function $e8dfc29dafb3bbd7$var$W(a, b, c) {
    if (3 === a.tag) $e8dfc29dafb3bbd7$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e8dfc29dafb3bbd7$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(d))) {
                a = $e8dfc29dafb3bbd7$var$Ki(c, a);
                a = $e8dfc29dafb3bbd7$var$Ri(b, a, 1);
                b = $e8dfc29dafb3bbd7$var$dh(b, a, 1);
                a = $e8dfc29dafb3bbd7$var$L();
                null !== b && ($e8dfc29dafb3bbd7$var$Ac(b, 1, a), $e8dfc29dafb3bbd7$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e8dfc29dafb3bbd7$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e8dfc29dafb3bbd7$var$R === a && ($e8dfc29dafb3bbd7$var$Z & c) === c && (4 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$Z & 130023424) === $e8dfc29dafb3bbd7$var$Z && 500 > $e8dfc29dafb3bbd7$var$B() - $e8dfc29dafb3bbd7$var$gk ? $e8dfc29dafb3bbd7$var$Lk(a, 0) : $e8dfc29dafb3bbd7$var$sk |= c);
    $e8dfc29dafb3bbd7$var$Ek(a, b);
}
function $e8dfc29dafb3bbd7$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e8dfc29dafb3bbd7$var$sc, $e8dfc29dafb3bbd7$var$sc <<= 1, 0 === ($e8dfc29dafb3bbd7$var$sc & 130023424) && ($e8dfc29dafb3bbd7$var$sc = 4194304)));
    var c = $e8dfc29dafb3bbd7$var$L();
    a = $e8dfc29dafb3bbd7$var$Zg(a, b);
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, b, c), $e8dfc29dafb3bbd7$var$Ek(a, c));
}
function $e8dfc29dafb3bbd7$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
function $e8dfc29dafb3bbd7$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e8dfc29dafb3bbd7$var$p(314));
    }
    null !== d && d.delete(b);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
var $e8dfc29dafb3bbd7$var$Wk;
$e8dfc29dafb3bbd7$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e8dfc29dafb3bbd7$var$Wf.current) $e8dfc29dafb3bbd7$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$zj(a, b, c);
            $e8dfc29dafb3bbd7$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$I && 0 !== (b.flags & 1048576) && $e8dfc29dafb3bbd7$var$ug(b, $e8dfc29dafb3bbd7$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e8dfc29dafb3bbd7$var$jj(a, b);
            a = b.pendingProps;
            var e = $e8dfc29dafb3bbd7$var$Yf(b, $e8dfc29dafb3bbd7$var$H.current);
            $e8dfc29dafb3bbd7$var$Tg(b, c);
            e = $e8dfc29dafb3bbd7$var$Xh(null, b, d, a, e, c);
            var f = $e8dfc29dafb3bbd7$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e8dfc29dafb3bbd7$var$Zf(d) ? (f = !0, $e8dfc29dafb3bbd7$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e8dfc29dafb3bbd7$var$ah(b), e.updater = $e8dfc29dafb3bbd7$var$nh, b.stateNode = e, e._reactInternals = b, $e8dfc29dafb3bbd7$var$rh(b, d, a, c), b = $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e8dfc29dafb3bbd7$var$I && f && $e8dfc29dafb3bbd7$var$vg(b), $e8dfc29dafb3bbd7$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e8dfc29dafb3bbd7$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e8dfc29dafb3bbd7$var$$k(d);
                a = $e8dfc29dafb3bbd7$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e8dfc29dafb3bbd7$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e8dfc29dafb3bbd7$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e8dfc29dafb3bbd7$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e8dfc29dafb3bbd7$var$aj(null, b, d, $e8dfc29dafb3bbd7$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e8dfc29dafb3bbd7$var$lj(b);
                if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e8dfc29dafb3bbd7$var$bh(a, b);
                $e8dfc29dafb3bbd7$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(423)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(424)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.stateNode.containerInfo.firstChild), $e8dfc29dafb3bbd7$var$xg = b, $e8dfc29dafb3bbd7$var$I = !0, $e8dfc29dafb3bbd7$var$zg = null, c = $e8dfc29dafb3bbd7$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e8dfc29dafb3bbd7$var$Ig();
                    if (d === e) {
                        b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                        break a;
                    }
                    $e8dfc29dafb3bbd7$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e8dfc29dafb3bbd7$var$Kh(b), null === a && $e8dfc29dafb3bbd7$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e8dfc29dafb3bbd7$var$Ef(d, e) ? g = null : null !== f && $e8dfc29dafb3bbd7$var$Ef(d, f) && (b.flags |= 32), $e8dfc29dafb3bbd7$var$hj(a, b), $e8dfc29dafb3bbd7$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e8dfc29dafb3bbd7$var$Eg(b), null;
        case 13:
            return $e8dfc29dafb3bbd7$var$pj(a, b, c);
        case 4:
            return $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, d, c) : $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$Zi(a, b, d, e, c);
        case 7:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e8dfc29dafb3bbd7$var$He(f.value, g)) {
                        if (f.children === e.children && !$e8dfc29dafb3bbd7$var$Wf.current) {
                            b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e8dfc29dafb3bbd7$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e8dfc29dafb3bbd7$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e8dfc29dafb3bbd7$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e8dfc29dafb3bbd7$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e8dfc29dafb3bbd7$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e8dfc29dafb3bbd7$var$Tg(b, c), e = $e8dfc29dafb3bbd7$var$Vg(e), d = d(e), b.flags |= 1, $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e8dfc29dafb3bbd7$var$Lg(d, b.pendingProps), e = $e8dfc29dafb3bbd7$var$Lg(d.type, e), $e8dfc29dafb3bbd7$var$aj(a, b, d, e, c);
        case 15:
            return $e8dfc29dafb3bbd7$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$jj(a, b), b.tag = 1, $e8dfc29dafb3bbd7$var$Zf(d) ? (a = !0, $e8dfc29dafb3bbd7$var$cg(b)) : a = !1, $e8dfc29dafb3bbd7$var$Tg(b, c), $e8dfc29dafb3bbd7$var$ph(b, d, e), $e8dfc29dafb3bbd7$var$rh(b, d, e, c), $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e8dfc29dafb3bbd7$var$yj(a, b, c);
        case 22:
            return $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
};
function $e8dfc29dafb3bbd7$var$Gk(a, b) {
    return $e8dfc29dafb3bbd7$var$ac(a, b);
}
function $e8dfc29dafb3bbd7$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e8dfc29dafb3bbd7$var$Bg(a, b, c, d) {
    return new $e8dfc29dafb3bbd7$var$al(a, b, c, d);
}
function $e8dfc29dafb3bbd7$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e8dfc29dafb3bbd7$var$$k(a) {
    if ("function" === typeof a) return $e8dfc29dafb3bbd7$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e8dfc29dafb3bbd7$var$Da) return 11;
        if (a === $e8dfc29dafb3bbd7$var$Ga) return 14;
    }
    return 2;
}
function $e8dfc29dafb3bbd7$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e8dfc29dafb3bbd7$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e8dfc29dafb3bbd7$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e8dfc29dafb3bbd7$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return $e8dfc29dafb3bbd7$var$Ah(c.children, e, f, b);
        case $e8dfc29dafb3bbd7$var$za:
            g = 8;
            e |= 8;
            break;
        case $e8dfc29dafb3bbd7$var$Aa:
            return a = $e8dfc29dafb3bbd7$var$Bg(12, c, b, e | 2), a.elementType = $e8dfc29dafb3bbd7$var$Aa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ea:
            return a = $e8dfc29dafb3bbd7$var$Bg(13, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Ea, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Fa:
            return a = $e8dfc29dafb3bbd7$var$Bg(19, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Fa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ia:
            return $e8dfc29dafb3bbd7$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e8dfc29dafb3bbd7$var$Ba:
                    g = 10;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ca:
                    g = 9;
                    break a;
                case $e8dfc29dafb3bbd7$var$Da:
                    g = 11;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ga:
                    g = 14;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e8dfc29dafb3bbd7$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e8dfc29dafb3bbd7$var$Ah(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$qj(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(22, a, d, b);
    a.elementType = $e8dfc29dafb3bbd7$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e8dfc29dafb3bbd7$var$xh(a, b, c) {
    a = $e8dfc29dafb3bbd7$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$zh(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e8dfc29dafb3bbd7$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e8dfc29dafb3bbd7$var$zc(0);
    this.expirationTimes = $e8dfc29dafb3bbd7$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e8dfc29dafb3bbd7$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e8dfc29dafb3bbd7$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e8dfc29dafb3bbd7$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e8dfc29dafb3bbd7$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e8dfc29dafb3bbd7$var$ah(f);
    return a;
}
function $e8dfc29dafb3bbd7$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e8dfc29dafb3bbd7$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e8dfc29dafb3bbd7$var$el(a) {
    if (!a) return $e8dfc29dafb3bbd7$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e8dfc29dafb3bbd7$var$Vb(a) !== a || 1 !== a.tag) throw Error($e8dfc29dafb3bbd7$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e8dfc29dafb3bbd7$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e8dfc29dafb3bbd7$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e8dfc29dafb3bbd7$var$Zf(c)) return $e8dfc29dafb3bbd7$var$bg(a, c, b);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e8dfc29dafb3bbd7$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e8dfc29dafb3bbd7$var$el(null);
    c = a.current;
    d = $e8dfc29dafb3bbd7$var$L();
    e = $e8dfc29dafb3bbd7$var$lh(c);
    f = $e8dfc29dafb3bbd7$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e8dfc29dafb3bbd7$var$dh(c, f, e);
    a.current.lanes = e;
    $e8dfc29dafb3bbd7$var$Ac(a, e, d);
    $e8dfc29dafb3bbd7$var$Ek(a, d);
    return a;
}
function $e8dfc29dafb3bbd7$var$gl(a, b, c, d) {
    var e = b.current, f = $e8dfc29dafb3bbd7$var$L(), g = $e8dfc29dafb3bbd7$var$lh(e);
    c = $e8dfc29dafb3bbd7$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e8dfc29dafb3bbd7$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e8dfc29dafb3bbd7$var$dh(e, b, g);
    null !== a && ($e8dfc29dafb3bbd7$var$mh(a, e, g, f), $e8dfc29dafb3bbd7$var$eh(a, e, g));
    return g;
}
function $e8dfc29dafb3bbd7$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e8dfc29dafb3bbd7$var$jl(a, b) {
    $e8dfc29dafb3bbd7$var$il(a, b);
    (a = a.alternate) && $e8dfc29dafb3bbd7$var$il(a, b);
}
function $e8dfc29dafb3bbd7$var$kl() {
    return null;
}
var $e8dfc29dafb3bbd7$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e8dfc29dafb3bbd7$var$ml(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.render = $e8dfc29dafb3bbd7$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(409));
    $e8dfc29dafb3bbd7$var$gl(a, b, null, null);
};
$e8dfc29dafb3bbd7$var$nl.prototype.unmount = $e8dfc29dafb3bbd7$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e8dfc29dafb3bbd7$var$Sk(function() {
            $e8dfc29dafb3bbd7$var$gl(null, a, null, null);
        });
        b[$e8dfc29dafb3bbd7$var$uf] = null;
    }
};
function $e8dfc29dafb3bbd7$var$nl(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e8dfc29dafb3bbd7$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length && 0 !== b && b < $e8dfc29dafb3bbd7$var$Qc[c].priority; c++);
        $e8dfc29dafb3bbd7$var$Qc.splice(c, 0, a);
        0 === c && $e8dfc29dafb3bbd7$var$Vc(a);
    }
};
function $e8dfc29dafb3bbd7$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e8dfc29dafb3bbd7$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e8dfc29dafb3bbd7$var$ql() {}
function $e8dfc29dafb3bbd7$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e8dfc29dafb3bbd7$var$hl(g);
                f.call(a);
            };
        }
        var g = $e8dfc29dafb3bbd7$var$fl(b, d, a, 0, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
        a._reactRootContainer = g;
        a[$e8dfc29dafb3bbd7$var$uf] = g.current;
        $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e8dfc29dafb3bbd7$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e8dfc29dafb3bbd7$var$hl(k);
            h.call(a);
        };
    }
    var k = $e8dfc29dafb3bbd7$var$cl(a, 0, !1, null, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
    a._reactRootContainer = k;
    a[$e8dfc29dafb3bbd7$var$uf] = k.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$gl(b, k, c, d);
    });
    return k;
}
function $e8dfc29dafb3bbd7$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e8dfc29dafb3bbd7$var$hl(g);
                h.call(a);
            };
        }
        $e8dfc29dafb3bbd7$var$gl(b, g, a, e);
    } else g = $e8dfc29dafb3bbd7$var$rl(c, b, a, e, d);
    return $e8dfc29dafb3bbd7$var$hl(g);
}
$e8dfc29dafb3bbd7$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e8dfc29dafb3bbd7$var$tc(b.pendingLanes);
                0 !== c && ($e8dfc29dafb3bbd7$var$Cc(b, c | 1), $e8dfc29dafb3bbd7$var$Ek(b, $e8dfc29dafb3bbd7$var$B()), 0 === ($e8dfc29dafb3bbd7$var$K & 6) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$jg()));
            }
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$Sk(function() {
                var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e8dfc29dafb3bbd7$var$L();
                    $e8dfc29dafb3bbd7$var$mh(b, a, 1, c);
                }
            }), $e8dfc29dafb3bbd7$var$jl(a, 1);
    }
};
$e8dfc29dafb3bbd7$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(b, a, 134217728, c);
        }
        $e8dfc29dafb3bbd7$var$jl(a, 134217728);
    }
};
$e8dfc29dafb3bbd7$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$lh(a), c = $e8dfc29dafb3bbd7$var$Zg(a, b);
        if (null !== c) {
            var d = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(c, a, b, d);
        }
        $e8dfc29dafb3bbd7$var$jl(a, b);
    }
};
$e8dfc29dafb3bbd7$var$Hc = function() {
    return $e8dfc29dafb3bbd7$var$C;
};
$e8dfc29dafb3bbd7$var$Ic = function(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    try {
        return $e8dfc29dafb3bbd7$var$C = a, b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c;
    }
};
$e8dfc29dafb3bbd7$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e8dfc29dafb3bbd7$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e8dfc29dafb3bbd7$var$Db(d);
                        if (!e) throw Error($e8dfc29dafb3bbd7$var$p(90));
                        $e8dfc29dafb3bbd7$var$Wa(d);
                        $e8dfc29dafb3bbd7$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e8dfc29dafb3bbd7$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e8dfc29dafb3bbd7$var$fb(a, !!c.multiple, b, !1);
    }
};
$e8dfc29dafb3bbd7$var$Gb = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$var$Hb = $e8dfc29dafb3bbd7$var$Sk;
var $e8dfc29dafb3bbd7$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e8dfc29dafb3bbd7$var$Cb,
        $e8dfc29dafb3bbd7$var$ue,
        $e8dfc29dafb3bbd7$var$Db,
        $e8dfc29dafb3bbd7$var$Eb,
        $e8dfc29dafb3bbd7$var$Fb,
        $e8dfc29dafb3bbd7$var$Rk
    ]
}, $e8dfc29dafb3bbd7$var$ul = {
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e8dfc29dafb3bbd7$var$vl = {
    bundleType: $e8dfc29dafb3bbd7$var$ul.bundleType,
    version: $e8dfc29dafb3bbd7$var$ul.version,
    rendererPackageName: $e8dfc29dafb3bbd7$var$ul.rendererPackageName,
    rendererConfig: $e8dfc29dafb3bbd7$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e8dfc29dafb3bbd7$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$ul.findFiberByHostInstance || $e8dfc29dafb3bbd7$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e8dfc29dafb3bbd7$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e8dfc29dafb3bbd7$var$wl.isDisabled && $e8dfc29dafb3bbd7$var$wl.supportsFiber) try {
        $e8dfc29dafb3bbd7$var$kc = $e8dfc29dafb3bbd7$var$wl.inject($e8dfc29dafb3bbd7$var$vl), $e8dfc29dafb3bbd7$var$lc = $e8dfc29dafb3bbd7$var$wl;
    } catch (a) {}
}
$e8dfc29dafb3bbd7$export$ae55be85d98224ed = $e8dfc29dafb3bbd7$var$tl;
$e8dfc29dafb3bbd7$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$dl(a, b, null, c);
};
$e8dfc29dafb3bbd7$export$882461b6382ed46c = function(a, b) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(299));
    var c = !1, d = "", e = $e8dfc29dafb3bbd7$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e8dfc29dafb3bbd7$var$ml(b);
};
$e8dfc29dafb3bbd7$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e8dfc29dafb3bbd7$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e8dfc29dafb3bbd7$var$p(268, a));
    }
    a = $e8dfc29dafb3bbd7$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = function(a) {
    return $e8dfc29dafb3bbd7$var$Sk(a);
};
$e8dfc29dafb3bbd7$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !0, c);
};
$e8dfc29dafb3bbd7$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e8dfc29dafb3bbd7$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e8dfc29dafb3bbd7$var$nl(b);
};
$e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !1, c);
};
$e8dfc29dafb3bbd7$export$502457920280e6be = function(a) {
    if (!$e8dfc29dafb3bbd7$var$pl(a)) throw Error($e8dfc29dafb3bbd7$var$p(40));
    return a._reactRootContainer ? ($e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e8dfc29dafb3bbd7$var$uf] = null;
        });
    }), !0) : !1;
};
$e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e8dfc29dafb3bbd7$var$pl(c)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e8dfc29dafb3bbd7$var$p(38));
    return $e8dfc29dafb3bbd7$var$sl(a, b, c, !1, d);
};
$e8dfc29dafb3bbd7$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("1c9zD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lffg4"));

});
parcelRegister("lffg4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f776d5a8b0cafef3$export$c4744153514ff05d; }, function (v) { return $f776d5a8b0cafef3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7; }, function (v) { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875; }, function (v) { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f776d5a8b0cafef3$export$502329bbf4b505b1; }, function (v) { return $f776d5a8b0cafef3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f776d5a8b0cafef3$export$6e3807111c4874c4; }, function (v) { return $f776d5a8b0cafef3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f776d5a8b0cafef3$export$c27134553091fb3a; }, function (v) { return $f776d5a8b0cafef3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2; }, function (v) { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f776d5a8b0cafef3$export$b00a404bbd5edef2; }, function (v) { return $f776d5a8b0cafef3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f776d5a8b0cafef3$export$8352ce38b91d0c62; }, function (v) { return $f776d5a8b0cafef3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b; }, function (v) { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555; }, function (v) { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f776d5a8b0cafef3$export$839f9183b0465a69; }, function (v) { return $f776d5a8b0cafef3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f776d5a8b0cafef3$export$72fdf0e06517287b; }, function (v) { return $f776d5a8b0cafef3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f776d5a8b0cafef3$export$4b844e58a3e414b4; }, function (v) { return $f776d5a8b0cafef3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f776d5a8b0cafef3$export$816d2913ae6b83b1; }, function (v) { return $f776d5a8b0cafef3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f776d5a8b0cafef3$export$61bcfe829111a1d0; }, function (v) { return $f776d5a8b0cafef3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f; }, function (v) { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f776d5a8b0cafef3$export$b5836b71941fa3ed; }, function (v) { return $f776d5a8b0cafef3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f776d5a8b0cafef3$export$cf845f2c119da08a; }, function (v) { return $f776d5a8b0cafef3$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f776d5a8b0cafef3$export$c4744153514ff05d;
var $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7;
var $f776d5a8b0cafef3$export$e26fe2ed2fa76875;
var $f776d5a8b0cafef3$export$502329bbf4b505b1;
var $f776d5a8b0cafef3$export$6e3807111c4874c4;
var $f776d5a8b0cafef3$export$c27134553091fb3a;
var $f776d5a8b0cafef3$export$33ee1acdc04fd2a2;
var $f776d5a8b0cafef3$export$b00a404bbd5edef2;
var $f776d5a8b0cafef3$export$8352ce38b91d0c62;
var $f776d5a8b0cafef3$export$d66a1c1c77bd778b;
var $f776d5a8b0cafef3$export$d3dfb8e4810cb555;
var $f776d5a8b0cafef3$export$839f9183b0465a69;
var $f776d5a8b0cafef3$export$72fdf0e06517287b;
var $f776d5a8b0cafef3$export$4b844e58a3e414b4;
var $f776d5a8b0cafef3$export$816d2913ae6b83b1;
var $f776d5a8b0cafef3$export$61bcfe829111a1d0;
var $f776d5a8b0cafef3$export$7ee8c9beb337bc3f;
var $f776d5a8b0cafef3$export$b5836b71941fa3ed;
var $f776d5a8b0cafef3$export$cf845f2c119da08a;
"use strict";
function $f776d5a8b0cafef3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f776d5a8b0cafef3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f776d5a8b0cafef3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f776d5a8b0cafef3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f776d5a8b0cafef3$var$g(C, c)) n < e && 0 > $f776d5a8b0cafef3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f776d5a8b0cafef3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f776d5a8b0cafef3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f776d5a8b0cafef3$var$l = performance;
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$l.now();
    };
} else {
    var $f776d5a8b0cafef3$var$p = Date, $f776d5a8b0cafef3$var$q = $f776d5a8b0cafef3$var$p.now();
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$p.now() - $f776d5a8b0cafef3$var$q;
    };
}
var $f776d5a8b0cafef3$var$r = [], $f776d5a8b0cafef3$var$t = [], $f776d5a8b0cafef3$var$u = 1, $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = 3, $f776d5a8b0cafef3$var$z = !1, $f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$D = "function" === typeof setTimeout ? setTimeout : null, $f776d5a8b0cafef3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f776d5a8b0cafef3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f776d5a8b0cafef3$var$G(a) {
    for(var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t); null !== b;){
        if (null === b.callback) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t);
        else if (b.startTime <= a) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t), b.sortIndex = b.expirationTime, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, b);
        else break;
        b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
    }
}
function $f776d5a8b0cafef3$var$H(a) {
    $f776d5a8b0cafef3$var$B = !1;
    $f776d5a8b0cafef3$var$G(a);
    if (!$f776d5a8b0cafef3$var$A) {
        if (null !== $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r)) $f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J);
        else {
            var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== b && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, b.startTime - a);
        }
    }
}
function $f776d5a8b0cafef3$var$J(a, b) {
    $f776d5a8b0cafef3$var$A = !1;
    $f776d5a8b0cafef3$var$B && ($f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1);
    $f776d5a8b0cafef3$var$z = !0;
    var c = $f776d5a8b0cafef3$var$y;
    try {
        $f776d5a8b0cafef3$var$G(b);
        for($f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r); null !== $f776d5a8b0cafef3$var$v && (!($f776d5a8b0cafef3$var$v.expirationTime > b) || a && !$f776d5a8b0cafef3$var$M());){
            var d = $f776d5a8b0cafef3$var$v.callback;
            if ("function" === typeof d) {
                $f776d5a8b0cafef3$var$v.callback = null;
                $f776d5a8b0cafef3$var$y = $f776d5a8b0cafef3$var$v.priorityLevel;
                var e = d($f776d5a8b0cafef3$var$v.expirationTime <= b);
                b = $f776d5a8b0cafef3$export$c4744153514ff05d();
                "function" === typeof e ? $f776d5a8b0cafef3$var$v.callback = e : $f776d5a8b0cafef3$var$v === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
                $f776d5a8b0cafef3$var$G(b);
            } else $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
            $f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
        }
        if (null !== $f776d5a8b0cafef3$var$v) var w = !0;
        else {
            var m = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== m && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = c, $f776d5a8b0cafef3$var$z = !1;
    }
}
var $f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$L = -1, $f776d5a8b0cafef3$var$P = 5, $f776d5a8b0cafef3$var$Q = -1;
function $f776d5a8b0cafef3$var$M() {
    return $f776d5a8b0cafef3$export$c4744153514ff05d() - $f776d5a8b0cafef3$var$Q < $f776d5a8b0cafef3$var$P ? !1 : !0;
}
function $f776d5a8b0cafef3$var$R() {
    if (null !== $f776d5a8b0cafef3$var$O) {
        var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
        $f776d5a8b0cafef3$var$Q = a;
        var b = !0;
        try {
            b = $f776d5a8b0cafef3$var$O(!0, a);
        } finally{
            b ? $f776d5a8b0cafef3$var$S() : ($f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null);
        }
    } else $f776d5a8b0cafef3$var$N = !1;
}
var $f776d5a8b0cafef3$var$S;
if ("function" === typeof $f776d5a8b0cafef3$var$F) $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$F($f776d5a8b0cafef3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f776d5a8b0cafef3$var$T = new MessageChannel, $f776d5a8b0cafef3$var$U = $f776d5a8b0cafef3$var$T.port2;
    $f776d5a8b0cafef3$var$T.port1.onmessage = $f776d5a8b0cafef3$var$R;
    $f776d5a8b0cafef3$var$S = function() {
        $f776d5a8b0cafef3$var$U.postMessage(null);
    };
} else $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$D($f776d5a8b0cafef3$var$R, 0);
};
function $f776d5a8b0cafef3$var$I(a) {
    $f776d5a8b0cafef3$var$O = a;
    $f776d5a8b0cafef3$var$N || ($f776d5a8b0cafef3$var$N = !0, $f776d5a8b0cafef3$var$S());
}
function $f776d5a8b0cafef3$var$K(a, b) {
    $f776d5a8b0cafef3$var$L = $f776d5a8b0cafef3$var$D(function() {
        a($f776d5a8b0cafef3$export$c4744153514ff05d());
    }, b);
}
$f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = 5;
$f776d5a8b0cafef3$export$e26fe2ed2fa76875 = 1;
$f776d5a8b0cafef3$export$502329bbf4b505b1 = 4;
$f776d5a8b0cafef3$export$6e3807111c4874c4 = 3;
$f776d5a8b0cafef3$export$c27134553091fb3a = null;
$f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = 2;
$f776d5a8b0cafef3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f776d5a8b0cafef3$export$8352ce38b91d0c62 = function() {
    $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J));
};
$f776d5a8b0cafef3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f776d5a8b0cafef3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f776d5a8b0cafef3$export$d3dfb8e4810cb555 = function() {
    return $f776d5a8b0cafef3$var$y;
};
$f776d5a8b0cafef3$export$839f9183b0465a69 = function() {
    return $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
};
$f776d5a8b0cafef3$export$72fdf0e06517287b = function(a) {
    switch($f776d5a8b0cafef3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f776d5a8b0cafef3$var$y;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = b;
    try {
        return a();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$4b844e58a3e414b4 = function() {};
$f776d5a8b0cafef3$export$816d2913ae6b83b1 = function() {};
$f776d5a8b0cafef3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = a;
    try {
        return b();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f776d5a8b0cafef3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f776d5a8b0cafef3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$t, a), null === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && a === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t) && ($f776d5a8b0cafef3$var$B ? ($f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1) : $f776d5a8b0cafef3$var$B = !0, $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, c - d))) : (a.sortIndex = e, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, a), $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J)));
    return a;
};
$f776d5a8b0cafef3$export$b5836b71941fa3ed = $f776d5a8b0cafef3$var$M;
$f776d5a8b0cafef3$export$cf845f2c119da08a = function(a) {
    var b = $f776d5a8b0cafef3$var$y;
    return function() {
        var c = $f776d5a8b0cafef3$var$y;
        $f776d5a8b0cafef3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f776d5a8b0cafef3$var$y = c;
        }
    };
};

});



parcelRegister("74Uv8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5274bc1af2cc942e$export$2e2bcd8739ae039; });

var $eUhG2 = parcelRequire("eUhG2");
var $5274bc1af2cc942e$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $5274bc1af2cc942e$var$index = (0, $eUhG2.default)(function(prop) {
    return $5274bc1af2cc942e$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $5274bc1af2cc942e$export$2e2bcd8739ae039 = $5274bc1af2cc942e$var$index;

});
parcelRegister("eUhG2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ada401f6d5f6be81$export$2e2bcd8739ae039; });
function $ada401f6d5f6be81$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $ada401f6d5f6be81$export$2e2bcd8739ae039 = $ada401f6d5f6be81$var$memoize;

});


parcelRegister("lrct3", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $aGGuH = parcelRequire("aGGuH");
function $f9b5ca6aeff231cf$var$emptyFunction() {}
function $f9b5ca6aeff231cf$var$emptyFunctionWithReset() {}
$f9b5ca6aeff231cf$var$emptyFunctionWithReset.resetWarningCache = $f9b5ca6aeff231cf$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aGGuH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f9b5ca6aeff231cf$var$emptyFunctionWithReset,
        resetWarningCache: $f9b5ca6aeff231cf$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aGGuH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $7c7eca1397927a3e$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $7c7eca1397927a3e$var$ReactPropTypesSecret;

});


parcelRegister("f288Y", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "idrvier_logo.8127b520.webp";

});

parcelRegister("90B6E", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "VoiceNotesCase.50a393e3.webp";

});

parcelRegister("dTXXY", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "planer.be13087b.webp";

});

parcelRegister("eu0M3", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "cryptomania.c0366f94.webp";

});

parcelRegister("eUqt2", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "starWarsProject.2ce1ebef.webp";

});

parcelRegister("d5NXK", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "loaderProject.f901e61f.gif";

});

parcelRegister("aR5as", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "swapi_rn.3b0f34c4.webp";

});

parcelRegister("hAyS5", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "idriver_home_screen.1fe5363d.webp";

});

parcelRegister("69Rxo", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "idriver_welcome_screen.88caf05d.webp";

});

parcelRegister("j46sV", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "voice_notes_clients.b8bb156f.webp";

});

parcelRegister("7cPtD", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "hero_voice_notes.1edb1635.webp";

});

parcelRegister("7iqCP", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "kloki_charts.60650e5e.webp";

});

parcelRegister("1IavV", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "kloki_todo_list.6bcb833b.webp";

});

// modules
var $fba0f23e9e6a11bb$exports = {};
"use strict";

$fba0f23e9e6a11bb$exports = (parcelRequire("a58XM"));



var $6cds3 = parcelRequire("6cds3");
var $64d0b1ebdd6bcffe$exports = {};

$parcel$export($64d0b1ebdd6bcffe$exports, "createRoot", function () { return $64d0b1ebdd6bcffe$export$882461b6382ed46c; }, function (v) { return $64d0b1ebdd6bcffe$export$882461b6382ed46c = v; });
$parcel$export($64d0b1ebdd6bcffe$exports, "hydrateRoot", function () { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e; }, function (v) { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e = v; });
var $64d0b1ebdd6bcffe$export$882461b6382ed46c;
var $64d0b1ebdd6bcffe$export$757ceba2d55c277e;
"use strict";
var $6d4849ee44552f5f$exports = {};
"use strict";
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

$6d4849ee44552f5f$exports = (parcelRequire("jZA9I"));


var $64d0b1ebdd6bcffe$var$i;
$64d0b1ebdd6bcffe$export$882461b6382ed46c = $6d4849ee44552f5f$exports.createRoot;
$64d0b1ebdd6bcffe$export$757ceba2d55c277e = $6d4849ee44552f5f$exports.hydrateRoot;


/**
 * React Router DOM v6.21.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6cds3 = parcelRequire("6cds3");

/**
 * @remix-run/router v1.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $96b280a33643b696$var$_extends() {
    $96b280a33643b696$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $96b280a33643b696$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $96b280a33643b696$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($96b280a33643b696$export$e19cd5f9376f8cee || ($96b280a33643b696$export$e19cd5f9376f8cee = {}));
const $96b280a33643b696$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $96b280a33643b696$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $96b280a33643b696$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $96b280a33643b696$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $96b280a33643b696$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $96b280a33643b696$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
    }
    return $96b280a33643b696$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $96b280a33643b696$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $96b280a33643b696$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $96b280a33643b696$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $96b280a33643b696$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $96b280a33643b696$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $96b280a33643b696$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $96b280a33643b696$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $96b280a33643b696$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $96b280a33643b696$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $96b280a33643b696$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $96b280a33643b696$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $96b280a33643b696$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $96b280a33643b696$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $96b280a33643b696$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $96b280a33643b696$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($96b280a33643b696$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        let location = $96b280a33643b696$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $96b280a33643b696$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        let location = $96b280a33643b696$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $96b280a33643b696$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
        $96b280a33643b696$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($96b280a33643b696$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($96b280a33643b696$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $96b280a33643b696$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($96b280a33643b696$var$ResultType || ($96b280a33643b696$var$ResultType = {}));
const $96b280a33643b696$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $96b280a33643b696$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $96b280a33643b696$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $96b280a33643b696$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $96b280a33643b696$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($96b280a33643b696$var$isIndexRoute(route)) {
            let indexRoute = $96b280a33643b696$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $96b280a33643b696$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $96b280a33643b696$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $96b280a33643b696$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $96b280a33643b696$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $96b280a33643b696$var$flattenRoutes(routes);
    $96b280a33643b696$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $96b280a33643b696$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $96b280a33643b696$var$safelyDecodeURI(pathname));
    return matches;
}
function $96b280a33643b696$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $96b280a33643b696$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $96b280a33643b696$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $96b280a33643b696$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $96b280a33643b696$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $96b280a33643b696$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $96b280a33643b696$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $96b280a33643b696$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $96b280a33643b696$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $96b280a33643b696$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $96b280a33643b696$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $96b280a33643b696$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $96b280a33643b696$var$paramRe = /^:\w+$/;
const $96b280a33643b696$var$dynamicSegmentValue = 3;
const $96b280a33643b696$var$indexRouteValue = 2;
const $96b280a33643b696$var$emptySegmentValue = 1;
const $96b280a33643b696$var$staticSegmentValue = 10;
const $96b280a33643b696$var$splatPenalty = -2;
const $96b280a33643b696$var$isSplat = (s)=>s === "*";
function $96b280a33643b696$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($96b280a33643b696$var$isSplat)) initialScore += $96b280a33643b696$var$splatPenalty;
    if (index) initialScore += $96b280a33643b696$var$indexRouteValue;
    return segments.filter((s)=>!$96b280a33643b696$var$isSplat(s)).reduce((score, segment)=>score + ($96b280a33643b696$var$paramRe.test(segment) ? $96b280a33643b696$var$dynamicSegmentValue : segment === "" ? $96b280a33643b696$var$emptySegmentValue : $96b280a33643b696$var$staticSegmentValue), initialScore);
}
function $96b280a33643b696$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $96b280a33643b696$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $96b280a33643b696$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $96b280a33643b696$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $96b280a33643b696$export$a5c6d149b50c1d86($96b280a33643b696$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $96b280a33643b696$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $96b280a33643b696$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $96b280a33643b696$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $96b280a33643b696$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $96b280a33643b696$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $96b280a33643b696$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $96b280a33643b696$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $96b280a33643b696$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $96b280a33643b696$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $96b280a33643b696$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $96b280a33643b696$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $96b280a33643b696$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $96b280a33643b696$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $96b280a33643b696$var$normalizeSearch(search),
        hash: $96b280a33643b696$var$normalizeHash(hash)
    };
}
function $96b280a33643b696$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $96b280a33643b696$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $96b280a33643b696$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $96b280a33643b696$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $96b280a33643b696$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $96b280a33643b696$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $96b280a33643b696$export$8ccf933b0513f8d0(toArg);
    else {
        to = $96b280a33643b696$var$_extends({}, toArg);
        $96b280a33643b696$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $96b280a33643b696$var$getInvalidPathError("?", "pathname", "search", to));
        $96b280a33643b696$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $96b280a33643b696$var$getInvalidPathError("#", "pathname", "hash", to));
        $96b280a33643b696$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $96b280a33643b696$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $96b280a33643b696$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $96b280a33643b696$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $96b280a33643b696$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $96b280a33643b696$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $96b280a33643b696$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $96b280a33643b696$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $96b280a33643b696$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $96b280a33643b696$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $96b280a33643b696$export$42a99a7a4bc0e76a extends Error {
}
class $96b280a33643b696$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $96b280a33643b696$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $96b280a33643b696$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $96b280a33643b696$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $96b280a33643b696$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $96b280a33643b696$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $96b280a33643b696$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $96b280a33643b696$var$unwrapTrackedPromise(value) {
    if (!$96b280a33643b696$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $96b280a33643b696$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $96b280a33643b696$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $96b280a33643b696$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $96b280a33643b696$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $96b280a33643b696$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $96b280a33643b696$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $96b280a33643b696$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $96b280a33643b696$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $96b280a33643b696$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $96b280a33643b696$var$validMutationMethods = new Set($96b280a33643b696$var$validMutationMethodsArr);
const $96b280a33643b696$var$validRequestMethodsArr = [
    "get",
    ...$96b280a33643b696$var$validMutationMethodsArr
];
const $96b280a33643b696$var$validRequestMethods = new Set($96b280a33643b696$var$validRequestMethodsArr);
const $96b280a33643b696$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $96b280a33643b696$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $96b280a33643b696$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $96b280a33643b696$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $96b280a33643b696$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $96b280a33643b696$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $96b280a33643b696$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $96b280a33643b696$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $96b280a33643b696$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $96b280a33643b696$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $96b280a33643b696$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $96b280a33643b696$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $96b280a33643b696$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $96b280a33643b696$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $96b280a33643b696$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $96b280a33643b696$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$96b280a33643b696$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($96b280a33643b696$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $96b280a33643b696$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $96b280a33643b696$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $96b280a33643b696$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $96b280a33643b696$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $96b280a33643b696$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($96b280a33643b696$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $96b280a33643b696$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $96b280a33643b696$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $96b280a33643b696$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $96b280a33643b696$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $96b280a33643b696$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $96b280a33643b696$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $96b280a33643b696$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $96b280a33643b696$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $96b280a33643b696$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $96b280a33643b696$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$96b280a33643b696$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $96b280a33643b696$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $96b280a33643b696$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $96b280a33643b696$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $96b280a33643b696$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $96b280a33643b696$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $96b280a33643b696$var$ResultType.error,
            error: $96b280a33643b696$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $96b280a33643b696$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($96b280a33643b696$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($96b280a33643b696$var$isDeferredResult(result)) throw $96b280a33643b696$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $96b280a33643b696$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $96b280a33643b696$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $96b280a33643b696$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $96b280a33643b696$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $96b280a33643b696$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($96b280a33643b696$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $96b280a33643b696$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $96b280a33643b696$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $96b280a33643b696$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $96b280a33643b696$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $96b280a33643b696$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $96b280a33643b696$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $96b280a33643b696$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $96b280a33643b696$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $96b280a33643b696$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $96b280a33643b696$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $96b280a33643b696$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($96b280a33643b696$var$isRedirectResult(actionResult) || $96b280a33643b696$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($96b280a33643b696$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $96b280a33643b696$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($96b280a33643b696$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($96b280a33643b696$var$isDeferredResult(actionResult)) throw $96b280a33643b696$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $96b280a33643b696$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $96b280a33643b696$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $96b280a33643b696$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $96b280a33643b696$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $96b280a33643b696$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $96b280a33643b696$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $96b280a33643b696$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $96b280a33643b696$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $96b280a33643b696$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $96b280a33643b696$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $96b280a33643b696$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $96b280a33643b696$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $96b280a33643b696$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $96b280a33643b696$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($96b280a33643b696$var$isDeferredResult(result)) result = await $96b280a33643b696$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($96b280a33643b696$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($96b280a33643b696$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $96b280a33643b696$export$3e9cee6b33872309(!$96b280a33643b696$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $96b280a33643b696$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $96b280a33643b696$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $96b280a33643b696$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $96b280a33643b696$export$e19cd5f9376f8cee.Replace : $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $96b280a33643b696$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($96b280a33643b696$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $96b280a33643b696$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $96b280a33643b696$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $96b280a33643b696$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$96b280a33643b696$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $96b280a33643b696$var$callLoaderOrAction("loader", $96b280a33643b696$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $96b280a33643b696$var$ResultType.error,
                        error: $96b280a33643b696$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $96b280a33643b696$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $96b280a33643b696$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $96b280a33643b696$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $96b280a33643b696$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $96b280a33643b696$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $96b280a33643b696$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $96b280a33643b696$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $96b280a33643b696$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $96b280a33643b696$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $96b280a33643b696$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $96b280a33643b696$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $96b280a33643b696$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$96b280a33643b696$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $96b280a33643b696$export$4d0306f8f6a4585b = Symbol("deferred");
function $96b280a33643b696$export$3336b097a6fbc59a(routes, opts) {
    $96b280a33643b696$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $96b280a33643b696$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $96b280a33643b696$var$_extends({
        v7_relativeSplatPath: false
    }, opts ? opts.future : null);
    let dataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $96b280a33643b696$var$createLocation("", $96b280a33643b696$export$fe53371bee54353d(url), null, "default");
        let matches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$96b280a33643b696$var$isValidMethod(method) && method !== "HEAD") {
            let error = $96b280a33643b696$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($96b280a33643b696$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $96b280a33643b696$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $96b280a33643b696$var$createLocation("", $96b280a33643b696$export$fe53371bee54353d(url), null, "default");
        let matches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$96b280a33643b696$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $96b280a33643b696$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $96b280a33643b696$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $96b280a33643b696$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($96b280a33643b696$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$96b280a33643b696$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $96b280a33643b696$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($96b280a33643b696$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $96b280a33643b696$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $96b280a33643b696$var$isResponse(result) ? result : $96b280a33643b696$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($96b280a33643b696$var$isQueryRouteResponse(e)) {
                if (e.type === $96b280a33643b696$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($96b280a33643b696$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $96b280a33643b696$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $96b280a33643b696$var$ResultType.error,
                error: error
            };
        } else {
            result = await $96b280a33643b696$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($96b280a33643b696$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($96b280a33643b696$var$isDeferredResult(result)) {
            let error = $96b280a33643b696$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $96b280a33643b696$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($96b280a33643b696$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $96b280a33643b696$var$_extends({}, context, {
                statusCode: $96b280a33643b696$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $96b280a33643b696$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $96b280a33643b696$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $96b280a33643b696$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $96b280a33643b696$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$96b280a33643b696$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $96b280a33643b696$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $96b280a33643b696$export$fec11da027c70692(routes, context, error) {
    let newContext = $96b280a33643b696$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $96b280a33643b696$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $96b280a33643b696$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $96b280a33643b696$export$cae722b0cc860f13(to ? to : ".", $96b280a33643b696$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $96b280a33643b696$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$96b280a33643b696$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $96b280a33643b696$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $96b280a33643b696$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $96b280a33643b696$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$96b280a33643b696$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$96b280a33643b696$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $96b280a33643b696$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $96b280a33643b696$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $96b280a33643b696$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$96b280a33643b696$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$96b280a33643b696$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $96b280a33643b696$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $96b280a33643b696$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $96b280a33643b696$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $96b280a33643b696$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $96b280a33643b696$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($96b280a33643b696$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $96b280a33643b696$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $96b280a33643b696$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $96b280a33643b696$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $96b280a33643b696$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($96b280a33643b696$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $96b280a33643b696$var$shouldRevalidateLoader(match, $96b280a33643b696$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $96b280a33643b696$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $96b280a33643b696$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $96b280a33643b696$var$shouldRevalidateLoader(fetcherMatch, $96b280a33643b696$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $96b280a33643b696$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $96b280a33643b696$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $96b280a33643b696$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $96b280a33643b696$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $96b280a33643b696$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $96b280a33643b696$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$96b280a33643b696$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $96b280a33643b696$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $96b280a33643b696$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $96b280a33643b696$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $96b280a33643b696$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $96b280a33643b696$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $96b280a33643b696$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $96b280a33643b696$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $96b280a33643b696$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($96b280a33643b696$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($96b280a33643b696$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $96b280a33643b696$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(location)) location = $96b280a33643b696$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $96b280a33643b696$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $96b280a33643b696$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $96b280a33643b696$var$ResultType.error ? $96b280a33643b696$var$ResultType.error : $96b280a33643b696$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
            else data = await result.text();
        } catch (e) {
            return {
                type: $96b280a33643b696$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $96b280a33643b696$var$ResultType.error) return {
            type: resultType,
            error: new $96b280a33643b696$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $96b280a33643b696$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $96b280a33643b696$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($96b280a33643b696$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $96b280a33643b696$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $96b280a33643b696$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $96b280a33643b696$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($96b280a33643b696$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $96b280a33643b696$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $96b280a33643b696$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $96b280a33643b696$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $96b280a33643b696$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $96b280a33643b696$export$3e9cee6b33872309(!$96b280a33643b696$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $96b280a33643b696$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($96b280a33643b696$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $96b280a33643b696$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $96b280a33643b696$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($96b280a33643b696$var$isErrorResult(result)) {
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $96b280a33643b696$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($96b280a33643b696$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $96b280a33643b696$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($96b280a33643b696$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $96b280a33643b696$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $96b280a33643b696$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $96b280a33643b696$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $96b280a33643b696$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $96b280a33643b696$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $96b280a33643b696$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $96b280a33643b696$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $96b280a33643b696$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $96b280a33643b696$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($96b280a33643b696$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $96b280a33643b696$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(path) : path;
    return $96b280a33643b696$export$fe53371bee54353d($96b280a33643b696$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $96b280a33643b696$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $96b280a33643b696$var$isDeferredResult(result) {
    return result.type === $96b280a33643b696$var$ResultType.deferred;
}
function $96b280a33643b696$var$isErrorResult(result) {
    return result.type === $96b280a33643b696$var$ResultType.error;
}
function $96b280a33643b696$var$isRedirectResult(result) {
    return (result && result.type) === $96b280a33643b696$var$ResultType.redirect;
}
function $96b280a33643b696$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $96b280a33643b696$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $96b280a33643b696$var$isRedirectResponse(result) {
    if (!$96b280a33643b696$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $96b280a33643b696$var$isQueryRouteResponse(obj) {
    return obj && $96b280a33643b696$var$isResponse(obj.response) && (obj.type === $96b280a33643b696$var$ResultType.data || obj.type === $96b280a33643b696$var$ResultType.error);
}
function $96b280a33643b696$var$isValidMethod(method) {
    return $96b280a33643b696$var$validRequestMethods.has(method.toLowerCase());
}
function $96b280a33643b696$var$isMutationMethod(method) {
    return $96b280a33643b696$var$validMutationMethods.has(method.toLowerCase());
}
async function $96b280a33643b696$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$96b280a33643b696$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($96b280a33643b696$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $96b280a33643b696$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $96b280a33643b696$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $96b280a33643b696$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $96b280a33643b696$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $96b280a33643b696$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $96b280a33643b696$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $96b280a33643b696$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $96b280a33643b696$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $96b280a33643b696$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $96b280a33643b696$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $96b280a33643b696$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $96b280a33643b696$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $96b280a33643b696$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $96b280a33643b696$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $96b280a33643b696$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $96b280a33643b696$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $96b280a33643b696$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($96b280a33643b696$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $96b280a33643b696$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($96b280a33643b696$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $96b280a33643b696$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.21.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6cds3 = parcelRequire("6cds3");

function $4a3e215446c0ed92$var$_extends() {
    $4a3e215446c0ed92$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4a3e215446c0ed92$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $4a3e215446c0ed92$export$3add0d5dce533e2e = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$export$145dfa71566a64dc = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$var$AwaitContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $4a3e215446c0ed92$export$26749e8557646306 = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$export$c7914228fb69b0f5 = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$export$9072aa6dd1f93057 = /*#__PURE__*/ $6cds3.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $4a3e215446c0ed92$var$RouteErrorContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $4a3e215446c0ed92$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $4a3e215446c0ed92$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $4a3e215446c0ed92$export$9c954a9d03d32f4a() {
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $4a3e215446c0ed92$export$45d76561a5302f2b() {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $4a3e215446c0ed92$export$1b3f31771c5d07c() {
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $4a3e215446c0ed92$export$6c330e8992e8a295(pattern) {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    return $6cds3.useMemo(()=>(0, $96b280a33643b696$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $4a3e215446c0ed92$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $6cds3.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $4a3e215446c0ed92$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $4a3e215446c0ed92$var$useNavigateStable() : $4a3e215446c0ed92$var$useNavigateUnstable();
}
function $4a3e215446c0ed92$var$useNavigateUnstable() {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let dataRouterContext = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $96b280a33643b696$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $6cds3.useRef(false);
    $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6cds3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $96b280a33643b696$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $4a3e215446c0ed92$var$OutletContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $4a3e215446c0ed92$export$4138103a3ae699cc() {
    return $6cds3.useContext($4a3e215446c0ed92$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $4a3e215446c0ed92$export$a3be3530d8e40d0b(context) {
    let outlet = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $4a3e215446c0ed92$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $4a3e215446c0ed92$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $96b280a33643b696$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $6cds3.useMemo(()=>(0, $96b280a33643b696$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $4a3e215446c0ed92$export$5d3fca4a98652595(routes, locationArg) {
    return $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: parentMatches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $96b280a33643b696$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $96b280a33643b696$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $4a3e215446c0ed92$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $96b280a33643b696$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $96b280a33643b696$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $4a3e215446c0ed92$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $96b280a33643b696$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $4a3e215446c0ed92$var$DefaultErrorComponent() {
    let error = $4a3e215446c0ed92$export$ed527bf60f6e05f2();
    let message = (0, $96b280a33643b696$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $6cds3.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $6cds3.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $4a3e215446c0ed92$var$defaultErrorElement = /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$DefaultErrorComponent, null);
class $4a3e215446c0ed92$var$RenderErrorBoundary extends $6cds3.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $4a3e215446c0ed92$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $4a3e215446c0ed92$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $4a3e215446c0ed92$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $4a3e215446c0ed92$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $6cds3.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $4a3e215446c0ed92$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($4a3e215446c0ed92$var$DataRouterHook || {});
var $4a3e215446c0ed92$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($4a3e215446c0ed92$var$DataRouterStateHook || {});
function $4a3e215446c0ed92$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $4a3e215446c0ed92$var$useDataRouterContext(hookName) {
    let ctx = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    !ctx && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return ctx;
}
function $4a3e215446c0ed92$var$useDataRouterState(hookName) {
    let state = $6cds3.useContext($4a3e215446c0ed92$export$145dfa71566a64dc);
    !state && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return state;
}
function $4a3e215446c0ed92$var$useRouteContext(hookName) {
    let route = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $4a3e215446c0ed92$var$useCurrentRouteId(hookName) {
    let route = $4a3e215446c0ed92$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $4a3e215446c0ed92$export$5fc8298006ad9e58() {
    return $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $4a3e215446c0ed92$export$d0fd4b7106de2769() {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $4a3e215446c0ed92$export$600dc272ed516c15() {
    let dataRouterContext = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseRevalidator);
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRevalidator);
    return $6cds3.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $4a3e215446c0ed92$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseMatches);
    return $6cds3.useMemo(()=>matches.map((m)=>(0, $96b280a33643b696$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $4a3e215446c0ed92$export$1448a5050d252c4d() {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    let routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $4a3e215446c0ed92$export$fd5d37484eab868d(routeId) {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $4a3e215446c0ed92$export$fdc00f3f26066d5e() {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseActionData);
    let routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $4a3e215446c0ed92$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $6cds3.useContext($4a3e215446c0ed92$var$RouteErrorContext);
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteError);
    let routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $4a3e215446c0ed92$export$78a72ddb39bdd145() {
    let value = $6cds3.useContext($4a3e215446c0ed92$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $4a3e215446c0ed92$export$17f53340677d5831() {
    let value = $6cds3.useContext($4a3e215446c0ed92$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $4a3e215446c0ed92$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $4a3e215446c0ed92$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseBlocker);
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $6cds3.useState("");
    let blockerFunction = $6cds3.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $4a3e215446c0ed92$var$_extends({}, currentLocation, {
                pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $4a3e215446c0ed92$var$_extends({}, nextLocation, {
                pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $6cds3.useEffect(()=>{
        let key = String(++$4a3e215446c0ed92$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $6cds3.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $96b280a33643b696$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $4a3e215446c0ed92$var$useNavigateStable() {
    let { router: router } = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseNavigateStable);
    let id = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $6cds3.useRef(false);
    $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6cds3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $4a3e215446c0ed92$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $4a3e215446c0ed92$var$alreadyWarned = {};
function $4a3e215446c0ed92$var$warningOnce(key, cond, message) {
    if (!cond && !$4a3e215446c0ed92$var$alreadyWarned[key]) $4a3e215446c0ed92$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $4a3e215446c0ed92$var$START_TRANSITION = "startTransition";
const $4a3e215446c0ed92$var$startTransitionImpl = $6cds3[$4a3e215446c0ed92$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $4a3e215446c0ed92$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6cds3.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        if (v7_startTransition && $4a3e215446c0ed92$var$startTransitionImpl) $4a3e215446c0ed92$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6cds3.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $6cds3.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6cds3.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6cds3.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $4a3e215446c0ed92$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $4a3e215446c0ed92$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $4a3e215446c0ed92$var$startTransitionImpl ? $4a3e215446c0ed92$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $4a3e215446c0ed92$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let navigate = $4a3e215446c0ed92$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $96b280a33643b696$export$cae722b0cc860f13)(to, (0, $96b280a33643b696$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $6cds3.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $4a3e215446c0ed92$export$910ae8079b2c2852(props) {
    return $4a3e215446c0ed92$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $4a3e215446c0ed92$export$e7b0ac011bb776c6(_props) {
    (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $4a3e215446c0ed92$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $96b280a33643b696$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $6cds3.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $4a3e215446c0ed92$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $96b280a33643b696$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $6cds3.useMemo(()=>{
        let trailingPathname = (0, $96b280a33643b696$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $4a3e215446c0ed92$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $4a3e215446c0ed92$export$5d3fca4a98652595($4a3e215446c0ed92$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $4a3e215446c0ed92$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$ResolveAwait, null, children));
}
var $4a3e215446c0ed92$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($4a3e215446c0ed92$var$AwaitRenderStatus || {});
const $4a3e215446c0ed92$var$neverSettledPromise = new Promise(()=>{});
class $4a3e215446c0ed92$var$AwaitErrorBoundary extends $6cds3.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $4a3e215446c0ed92$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $4a3e215446c0ed92$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $4a3e215446c0ed92$var$AwaitRenderStatus.error : promise._data !== undefined ? $4a3e215446c0ed92$var$AwaitRenderStatus.success : $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error && promise._error instanceof (0, $96b280a33643b696$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $4a3e215446c0ed92$var$neverSettledPromise;
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $4a3e215446c0ed92$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $4a3e215446c0ed92$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $4a3e215446c0ed92$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $6cds3.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $6cds3.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $6cds3.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $4a3e215446c0ed92$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $4a3e215446c0ed92$export$e7b0ac011bb776c6) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $4a3e215446c0ed92$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $4a3e215446c0ed92$export$daf73786167a7f72(matches) {
    return $4a3e215446c0ed92$var$_renderMatches(matches);
}
function $4a3e215446c0ed92$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $6cds3.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $6cds3.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $6cds3.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $4a3e215446c0ed92$export$f30f7e456d254e83(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $4a3e215446c0ed92$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $4a3e215446c0ed92$export$52b333d321859367
    }).initialize();
}



function $0e36e707c39d0f3a$var$_extends() {
    $0e36e707c39d0f3a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e36e707c39d0f3a$var$_extends.apply(this, arguments);
}
function $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0e36e707c39d0f3a$var$defaultMethod = "get";
const $0e36e707c39d0f3a$var$defaultEncType = "application/x-www-form-urlencoded";
function $0e36e707c39d0f3a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0e36e707c39d0f3a$var$isButtonElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0e36e707c39d0f3a$var$isFormElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0e36e707c39d0f3a$var$isInputElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0e36e707c39d0f3a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0e36e707c39d0f3a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0e36e707c39d0f3a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0e36e707c39d0f3a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = null;
function $0e36e707c39d0f3a$var$isFormDataSubmitterSupported() {
    if ($0e36e707c39d0f3a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = true;
    }
    return $0e36e707c39d0f3a$var$_formDataSupportsSubmitter;
}
const $0e36e707c39d0f3a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0e36e707c39d0f3a$var$getFormEncType(encType) {
    if (encType != null && !$0e36e707c39d0f3a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0e36e707c39d0f3a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $96b280a33643b696$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0e36e707c39d0f3a$var$defaultMethod;
        encType = $0e36e707c39d0f3a$var$getFormEncType(target.getAttribute("enctype")) || $0e36e707c39d0f3a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0e36e707c39d0f3a$var$isButtonElement(target) || $0e36e707c39d0f3a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $96b280a33643b696$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0e36e707c39d0f3a$var$defaultMethod;
        encType = $0e36e707c39d0f3a$var$getFormEncType(target.getAttribute("formenctype")) || $0e36e707c39d0f3a$var$getFormEncType(form.getAttribute("enctype")) || $0e36e707c39d0f3a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0e36e707c39d0f3a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0e36e707c39d0f3a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0e36e707c39d0f3a$var$defaultMethod;
        action = null;
        encType = $0e36e707c39d0f3a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0e36e707c39d0f3a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $0e36e707c39d0f3a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $0e36e707c39d0f3a$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $0e36e707c39d0f3a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e36e707c39d0f3a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0e36e707c39d0f3a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4a3e215446c0ed92$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0e36e707c39d0f3a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e36e707c39d0f3a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0e36e707c39d0f3a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4a3e215446c0ed92$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0e36e707c39d0f3a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0e36e707c39d0f3a$var$_extends({}, state, {
        errors: $0e36e707c39d0f3a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0e36e707c39d0f3a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $96b280a33643b696$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0e36e707c39d0f3a$export$7ad602f0e94e62d1 = /*#__PURE__*/ $6cds3.createContext({
    isTransitioning: false
});
const $0e36e707c39d0f3a$export$148fd98d095596d4 = /*#__PURE__*/ $6cds3.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0e36e707c39d0f3a$var$START_TRANSITION = "startTransition";
const $0e36e707c39d0f3a$var$startTransitionImpl = $6cds3[$0e36e707c39d0f3a$var$START_TRANSITION];
const $0e36e707c39d0f3a$var$FLUSH_SYNC = "flushSync";
const $0e36e707c39d0f3a$var$flushSyncImpl = $6d4849ee44552f5f$exports[$0e36e707c39d0f3a$var$FLUSH_SYNC];
function $0e36e707c39d0f3a$var$startTransitionSafe(cb) {
    if ($0e36e707c39d0f3a$var$startTransitionImpl) $0e36e707c39d0f3a$var$startTransitionImpl(cb);
    else cb();
}
function $0e36e707c39d0f3a$var$flushSyncSafe(cb) {
    if ($0e36e707c39d0f3a$var$flushSyncImpl) $0e36e707c39d0f3a$var$flushSyncImpl(cb);
    else cb();
}
class $0e36e707c39d0f3a$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0e36e707c39d0f3a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6cds3.useState(router.state);
    let [pendingState, setPendingState] = $6cds3.useState();
    let [vtContext, setVtContext] = $6cds3.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $6cds3.useState();
    let [transition, setTransition] = $6cds3.useState();
    let [interruption, setInterruption] = $6cds3.useState();
    let fetcherData = $6cds3.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $6cds3.useCallback((cb)=>{
        if (v7_startTransition) $0e36e707c39d0f3a$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $6cds3.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0e36e707c39d0f3a$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0e36e707c39d0f3a$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0e36e707c39d0f3a$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0e36e707c39d0f3a$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0e36e707c39d0f3a$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6cds3.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $6cds3.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0e36e707c39d0f3a$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $6cds3.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $6cds3.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $6cds3.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $6cds3.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6cds3.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6cds3.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $0e36e707c39d0f3a$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $4a3e215446c0ed92$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0e36e707c39d0f3a$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0e36e707c39d0f3a$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0e36e707c39d0f3a$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0e36e707c39d0f3a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0e36e707c39d0f3a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0e36e707c39d0f3a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $6cds3.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref7, $0e36e707c39d0f3a$var$_excluded);
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0e36e707c39d0f3a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0e36e707c39d0f3a$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $96b280a33643b696$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $4a3e215446c0ed92$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $0e36e707c39d0f3a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $6cds3.createElement("a", $0e36e707c39d0f3a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0e36e707c39d0f3a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $6cds3.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref8, $0e36e707c39d0f3a$var$_excluded2);
    let path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let routerState = $6cds3.useContext((0, $4a3e215446c0ed92$export$145dfa71566a64dc));
    let { navigator: navigator } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0e36e707c39d0f3a$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$a6c7ac8248d6e38a, $0e36e707c39d0f3a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0e36e707c39d0f3a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $6cds3.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0e36e707c39d0f3a$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref9, $0e36e707c39d0f3a$var$_excluded3);
    let submit = $0e36e707c39d0f3a$export$47c85c6e3a081d3();
    let formAction = $0e36e707c39d0f3a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $6cds3.createElement("form", $0e36e707c39d0f3a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0e36e707c39d0f3a$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0e36e707c39d0f3a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0e36e707c39d0f3a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0e36e707c39d0f3a$var$DataRouterHook || ($0e36e707c39d0f3a$var$DataRouterHook = {}));
var $0e36e707c39d0f3a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0e36e707c39d0f3a$var$DataRouterStateHook || ($0e36e707c39d0f3a$var$DataRouterStateHook = {}));
// Internal hooks
function $0e36e707c39d0f3a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0e36e707c39d0f3a$var$useDataRouterContext(hookName) {
    let ctx = $6cds3.useContext((0, $4a3e215446c0ed92$export$3add0d5dce533e2e));
    !ctx && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0e36e707c39d0f3a$var$useDataRouterState(hookName) {
    let state = $6cds3.useContext((0, $4a3e215446c0ed92$export$145dfa71566a64dc));
    !state && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0e36e707c39d0f3a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $6cds3.useCallback((event)=>{
        if ($0e36e707c39d0f3a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $96b280a33643b696$export$fe53371bee54353d)(location) === (0, $96b280a33643b696$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0e36e707c39d0f3a$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $6cds3.useRef($0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $6cds3.useRef(false);
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let searchParams = $6cds3.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0e36e707c39d0f3a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    let setSearchParams = $6cds3.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0e36e707c39d0f3a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0e36e707c39d0f3a$var$fetcherId = 0;
let $0e36e707c39d0f3a$var$getUniqueFetcherId = ()=>"__" + String(++$0e36e707c39d0f3a$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0e36e707c39d0f3a$export$47c85c6e3a081d3() {
    let { router: router } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let currentRouteId = (0, $4a3e215446c0ed92$export$5fc8298006ad9e58)();
    return $6cds3.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0e36e707c39d0f3a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0e36e707c39d0f3a$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0e36e707c39d0f3a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let routeContext = $6cds3.useContext((0, $4a3e215446c0ed92$export$9072aa6dd1f93057));
    !routeContext && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0e36e707c39d0f3a$var$_extends({}, (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $96b280a33643b696$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0e36e707c39d0f3a$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseFetcher);
    let state = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $6cds3.useContext($0e36e707c39d0f3a$export$148fd98d095596d4);
    let route = $6cds3.useContext((0, $4a3e215446c0ed92$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    let [fetcherKey, setFetcherKey] = $6cds3.useState(key || "");
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) setFetcherKey($0e36e707c39d0f3a$var$getUniqueFetcherId());
    // Registration/cleanup
    $6cds3.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $6cds3.useCallback((href, opts)=>{
        !routeId && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0e36e707c39d0f3a$export$47c85c6e3a081d3();
    let submit = $6cds3.useCallback((target, opts)=>{
        submitImpl(target, $0e36e707c39d0f3a$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $6cds3.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $6cds3.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$a7fed597f4b8afd8, $0e36e707c39d0f3a$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $96b280a33643b696$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $6cds3.useMemo(()=>$0e36e707c39d0f3a$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0e36e707c39d0f3a$export$fa996778a3a31087() {
    let state = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0e36e707c39d0f3a$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0e36e707c39d0f3a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0e36e707c39d0f3a$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let matches = (0, $4a3e215446c0ed92$export$2378eb7f5ff86053)();
    let navigation = (0, $4a3e215446c0ed92$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $6cds3.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0e36e707c39d0f3a$var$usePageHide($6cds3.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0e36e707c39d0f3a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0e36e707c39d0f3a$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0e36e707c39d0f3a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0e36e707c39d0f3a$var$_extends({}, location, {
                    pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0e36e707c39d0f3a$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0e36e707c39d0f3a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $6cds3.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0e36e707c39d0f3a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $6cds3.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0e36e707c39d0f3a$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $4a3e215446c0ed92$export$b273b3273281a049)(when);
    $6cds3.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $6cds3.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0e36e707c39d0f3a$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $6cds3.useContext($0e36e707c39d0f3a$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { basename: basename } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.useViewTransitionState);
    let path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $96b280a33643b696$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $96b280a33643b696$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $96b280a33643b696$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $96b280a33643b696$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



// modules

parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
const $5ddea511a1df74b4$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $b588e509ec7465c1$export$700979bc83e7db82 = (0, $5ddea511a1df74b4$export$4e09c449d6c407f7) ? (0, $6cds3.useLayoutEffect) : (0, $6cds3.useEffect);


function $3ada8cab384c9a26$export$80c2a3957bcb42ea() {
    const isMounted = (0, $6cds3.useRef)(false);
    (0, $b588e509ec7465c1$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


const $dcf17e8536d5fb4f$export$8793edee2d425525 = (any)=>any;


class $04326321df67f623$var$Queue {
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
}
function $04326321df67f623$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $04326321df67f623$var$Queue();
    let nextFrame = new $04326321df67f623$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $bc1a7c89d5fd79e5$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $bc1a7c89d5fd79e5$var$maxElapsed = 40;
function $bc1a7c89d5fd79e5$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $bc1a7c89d5fd79e5$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $04326321df67f623$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $bc1a7c89d5fd79e5$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $bc1a7c89d5fd79e5$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $bc1a7c89d5fd79e5$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$bc1a7c89d5fd79e5$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $abdd74f2cc691999$export$2cef06c20297c17d, cancel: $abdd74f2cc691999$export$ec99c0ef4978dccb, state: $abdd74f2cc691999$export$fff89137e9e818ce, steps: $abdd74f2cc691999$export$be3f796aed065412 } = (0, $bc1a7c89d5fd79e5$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $dcf17e8536d5fb4f$export$8793edee2d425525), true);


function $b290eb7c0f34fa74$export$91db9bc4f8ac944a() {
    const isMounted = (0, $3ada8cab384c9a26$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $6cds3.useState)(0);
    const forceRender = (0, $6cds3.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $6cds3.useCallback)(()=>(0, $abdd74f2cc691999$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
/**
 * @public
 */ const $e40c1c7ce208ba78$export$f224e4635b6f8ce2 = (0, $6cds3.createContext)(null);



var $6cds3 = parcelRequire("6cds3");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $491d0f9d7a26c5a8$export$fe4300aa8eebea86(init) {
    const ref = (0, $6cds3.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $6cds3 = parcelRequire("6cds3");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $4ca2d8047b4739e2$var$PopChildMeasure extends $6cds3.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $4ca2d8047b4739e2$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $6cds3.useId)();
    const ref = (0, $6cds3.useRef)(null);
    const size = (0, $6cds3.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $6cds3.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $6cds3.createElement($4ca2d8047b4739e2$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $6cds3.cloneElement(children, {
        ref: ref
    }));
}


const $ed269eff01268d92$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $491d0f9d7a26c5a8$export$fe4300aa8eebea86)($ed269eff01268d92$var$newChildrenMap);
    const id = (0, $6cds3.useId)();
    const context = (0, $6cds3.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $6cds3.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $6cds3.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $6cds3.createElement((0, $4ca2d8047b4739e2$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $6cds3.createElement((0, $e40c1c7ce208ba78$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $ed269eff01268d92$var$newChildrenMap() {
    return new Map();
}



var $6cds3 = parcelRequire("6cds3");
const $5f7d717553e210fe$export$a3579ca508007a95 = (0, $6cds3.createContext)({});




var $6cds3 = parcelRequire("6cds3");
function $1261c2c53e6b9f12$export$f3a192d0cbd30b96(callback) {
    return (0, $6cds3.useEffect)(()=>()=>callback(), []);
}



let $faee95b32f04793f$export$491112666e282270 = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
let $faee95b32f04793f$export$f5708dca728d7177 = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
var $faee95b32f04793f$var$check, $faee95b32f04793f$var$message, $faee95b32f04793f$var$check1, $faee95b32f04793f$var$message1;


const $35bf9e9aed03b88e$var$getChildKey = (child)=>child.key || "";
function $35bf9e9aed03b88e$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $35bf9e9aed03b88e$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $35bf9e9aed03b88e$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $6cds3.Children).forEach(children, (child)=>{
        if ((0, $6cds3.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $35bf9e9aed03b88e$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $faee95b32f04793f$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $6cds3.useContext)((0, $5f7d717553e210fe$export$a3579ca508007a95)).forceRender || (0, $b290eb7c0f34fa74$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $3ada8cab384c9a26$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $35bf9e9aed03b88e$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $6cds3.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $6cds3.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $6cds3.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $6cds3.useRef)(true);
    (0, $b588e509ec7465c1$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $35bf9e9aed03b88e$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $1261c2c53e6b9f12$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $6cds3.createElement($6cds3.Fragment, null, childrenToRender.map((child)=>$6cds3.createElement((0, $ed269eff01268d92$export$979daf65881a382a), {
            key: $35bf9e9aed03b88e$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($35bf9e9aed03b88e$var$getChildKey);
    const targetKeys = filteredChildren.map($35bf9e9aed03b88e$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                // clean up the exiting children map
                exitingChildren.delete(key);
                // compute the keys of children that were rendered once but are no longer present
                // this could happen in case of too many fast consequent renderings
                // @link https://github.com/framer/motion/issues/2023
                const leftOverKeys = Array.from(allChildren.keys()).filter((childKey)=>!targetKeys.includes(childKey));
                // clean up the all children map
                leftOverKeys.forEach((leftOverKey)=>allChildren.delete(leftOverKey));
                // make sure to render only the children that are actually visible
                presentChildren.current = filteredChildren.filter((presentChild)=>{
                    const presentChildKey = $35bf9e9aed03b88e$var$getChildKey(presentChild);
                    return(// filter out the node exiting
                    presentChildKey === key || // filter out the leftover children
                    leftOverKeys.includes(presentChildKey));
                });
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $6cds3.createElement((0, $ed269eff01268d92$export$979daf65881a382a), {
                key: $35bf9e9aed03b88e$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $6cds3.createElement((0, $ed269eff01268d92$export$979daf65881a382a), {
            key: $35bf9e9aed03b88e$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $6cds3.createElement($6cds3.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $6cds3.cloneElement)(child)));
};

function $9dcc00a39e7f7954$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $66a5668b38a29be4$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


function $a6876eae976b1234$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $c4006311849aa271$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $a6876eae976b1234$export$7a4a7e38737aceb4)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
/**
 * @public
 */ const $874d1c1409e5f81e$export$22a697fb29aac98d = (0, $6cds3.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $96d9d0f780f718ca$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $96d9d0f780f718ca$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || $96d9d0f780f718ca$var$validMotionProps.has(key);
}


let $46bf78dd23632642$var$shouldForward = (key)=>!(0, $96d9d0f780f718ca$export$2f9c46555243bf04)(key);
function $46bf78dd23632642$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $46bf78dd23632642$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $96d9d0f780f718ca$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $46bf78dd23632642$export$59d6962c470509a5((parcelRequire("74Uv8")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $46bf78dd23632642$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($46bf78dd23632642$var$shouldForward(key) || forwardMotionProps === true && (0, $96d9d0f780f718ca$export$2f9c46555243bf04)(key) || !isDom && !(0, $96d9d0f780f718ca$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}



/**
 * `MotionConfig` is used to set configuration options for all children `motion` components.
 *
 * ```jsx
 * import { motion, MotionConfig } from "framer-motion"
 *
 * export function App() {
 *   return (
 *     <MotionConfig transition={{ type: "spring" }}>
 *       <motion.div animate={{ x: 100 }} />
 *     </MotionConfig>
 *   )
 * }
 * ```
 *
 * @public
 */ function $97523485216ee353$export$caa69d61d2de10d9(_param) {
    var { children: children, isValidProp: isValidProp } = _param, config = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "children",
        "isValidProp"
    ]);
    isValidProp && (0, $46bf78dd23632642$export$59d6962c470509a5)(isValidProp);
    /**
     * Inherit props from any parent MotionConfig components
     */ config = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, (0, $6cds3.useContext)((0, $874d1c1409e5f81e$export$22a697fb29aac98d)), config);
    /**
     * Don't allow isStatic to change between renders as it affects how many hooks
     * motion components fire.
     */ config.isStatic = (0, $491d0f9d7a26c5a8$export$fe4300aa8eebea86)(()=>config.isStatic);
    /**
     * Creating a new config context object will re-render every `motion` component
     * every time it renders. So we only want to create a new one sparingly.
     */ const context = (0, $6cds3.useMemo)(()=>config, [
        JSON.stringify(config.transition),
        config.transformPagePoint,
        config.reducedMotion
    ]);
    return $6cds3.createElement((0, $874d1c1409e5f81e$export$22a697fb29aac98d).Provider, {
        value: context
    }, children);
}



// modules

function $64b790ae24ac5be1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $64b790ae24ac5be1$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $64b790ae24ac5be1$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}




var $6cds3 = parcelRequire("6cds3");
var $1d42a532dd4f25d5$exports = {};
"use strict";
Object.defineProperty($1d42a532dd4f25d5$exports, "__esModule", {
    value: true
});
$1d42a532dd4f25d5$exports.Helpers = $1d42a532dd4f25d5$exports.ScrollElement = $1d42a532dd4f25d5$exports.ScrollLink = $1d42a532dd4f25d5$exports.animateScroll = $1d42a532dd4f25d5$exports.scrollSpy = $1d42a532dd4f25d5$exports.Events = $1d42a532dd4f25d5$exports.scroller = $1d42a532dd4f25d5$exports.Element = $1d42a532dd4f25d5$exports.Button = $1d42a532dd4f25d5$exports.Link = undefined;
var $0a79ef4c65637ec3$exports = {};
"use strict";
Object.defineProperty($0a79ef4c65637ec3$exports, "__esModule", {
    value: true
});

var $6cds3 = parcelRequire("6cds3");
var $0a79ef4c65637ec3$var$_react2 = $0a79ef4c65637ec3$var$_interopRequireDefault($6cds3);
var $9d8ec76ce9beaacb$exports = {};
"use strict";
Object.defineProperty($9d8ec76ce9beaacb$exports, "__esModule", {
    value: true
});
var $9d8ec76ce9beaacb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9d8ec76ce9beaacb$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6cds3 = parcelRequire("6cds3");
var $9d8ec76ce9beaacb$var$_react2 = $9d8ec76ce9beaacb$var$_interopRequireDefault($6cds3);
var $f2da373044131ea3$exports = {};
"use strict";
Object.defineProperty($f2da373044131ea3$exports, "__esModule", {
    value: true
});
var $2d9b66c179efa911$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $2d9b66c179efa911$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $2d9b66c179efa911$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $2d9b66c179efa911$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $2d9b66c179efa911$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $2d9b66c179efa911$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $2d9b66c179efa911$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $2d9b66c179efa911$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $2d9b66c179efa911$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $2d9b66c179efa911$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $2d9b66c179efa911$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $2d9b66c179efa911$var$root = $2d9b66c179efa911$var$freeGlobal || $2d9b66c179efa911$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $2d9b66c179efa911$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2d9b66c179efa911$var$objectToString = $2d9b66c179efa911$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2d9b66c179efa911$var$nativeMax = Math.max, $2d9b66c179efa911$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $2d9b66c179efa911$var$now = function() {
    return $2d9b66c179efa911$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $2d9b66c179efa911$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($2d9b66c179efa911$var$FUNC_ERROR_TEXT);
    wait = $2d9b66c179efa911$var$toNumber(wait) || 0;
    if ($2d9b66c179efa911$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $2d9b66c179efa911$var$nativeMax($2d9b66c179efa911$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $2d9b66c179efa911$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $2d9b66c179efa911$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($2d9b66c179efa911$var$now());
    }
    function debounced() {
        var time = $2d9b66c179efa911$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $2d9b66c179efa911$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($2d9b66c179efa911$var$FUNC_ERROR_TEXT);
    if ($2d9b66c179efa911$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $2d9b66c179efa911$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $2d9b66c179efa911$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2d9b66c179efa911$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2d9b66c179efa911$var$isSymbol(value) {
    return typeof value == "symbol" || $2d9b66c179efa911$var$isObjectLike(value) && $2d9b66c179efa911$var$objectToString.call(value) == $2d9b66c179efa911$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $2d9b66c179efa911$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($2d9b66c179efa911$var$isSymbol(value)) return $2d9b66c179efa911$var$NAN;
    if ($2d9b66c179efa911$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $2d9b66c179efa911$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($2d9b66c179efa911$var$reTrim, "");
    var isBinary = $2d9b66c179efa911$var$reIsBinary.test(value);
    return isBinary || $2d9b66c179efa911$var$reIsOctal.test(value) ? $2d9b66c179efa911$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $2d9b66c179efa911$var$reIsBadHex.test(value) ? $2d9b66c179efa911$var$NAN : +value;
}
$2d9b66c179efa911$exports = $2d9b66c179efa911$var$throttle;


var $f2da373044131ea3$var$_lodash2 = $f2da373044131ea3$var$_interopRequireDefault($2d9b66c179efa911$exports);
var $47868a47c82ef94c$exports = {};
"use strict";
Object.defineProperty($47868a47c82ef94c$exports, "__esModule", {
    value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */ var $47868a47c82ef94c$var$addPassiveEventListener = $47868a47c82ef94c$exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
    var listenerName = listener.name;
    if (!listenerName) {
        listenerName = eventName;
        console.warn("Listener must be a named function.");
    }
    if (!$47868a47c82ef94c$var$attachedListeners.has(eventName)) $47868a47c82ef94c$var$attachedListeners.set(eventName, new Set());
    var listeners = $47868a47c82ef94c$var$attachedListeners.get(eventName);
    if (listeners.has(listenerName)) return;
    var supportsPassiveOption = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function get() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("test", null, opts);
        } catch (e) {}
        return supportsPassiveOption;
    }();
    target.addEventListener(eventName, listener, supportsPassiveOption ? {
        passive: true
    } : false);
    listeners.add(listenerName);
};
var $47868a47c82ef94c$var$removePassiveEventListener = $47868a47c82ef94c$exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
    target.removeEventListener(eventName, listener);
    $47868a47c82ef94c$var$attachedListeners.get(eventName).delete(listener.name || eventName);
};
var $47868a47c82ef94c$var$attachedListeners = new Map();


function $f2da373044131ea3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// The eventHandler will execute at a rate of 15fps by default
var $f2da373044131ea3$var$eventThrottler = function eventThrottler(eventHandler) {
    var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
    return (0, $f2da373044131ea3$var$_lodash2.default)(eventHandler, throttleAmount);
};
var $f2da373044131ea3$var$scrollSpy = {
    spyCallbacks: [],
    spySetState: [],
    scrollSpyContainers: [],
    mount: function mount(scrollSpyContainer, throttle) {
        if (scrollSpyContainer) {
            var eventHandler = $f2da373044131ea3$var$eventThrottler(function(event) {
                $f2da373044131ea3$var$scrollSpy.scrollHandler(scrollSpyContainer);
            }, throttle);
            $f2da373044131ea3$var$scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
            (0, $47868a47c82ef94c$exports.addPassiveEventListener)(scrollSpyContainer, "scroll", eventHandler);
        }
    },
    isMounted: function isMounted(scrollSpyContainer) {
        return $f2da373044131ea3$var$scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
    },
    currentPositionX: function currentPositionX(scrollSpyContainer) {
        if (scrollSpyContainer === document) {
            var supportPageOffset = window.pageYOffset !== undefined;
            var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
            return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
        } else return scrollSpyContainer.scrollLeft;
    },
    currentPositionY: function currentPositionY(scrollSpyContainer) {
        if (scrollSpyContainer === document) {
            var supportPageOffset = window.pageXOffset !== undefined;
            var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
            return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
        } else return scrollSpyContainer.scrollTop;
    },
    scrollHandler: function scrollHandler(scrollSpyContainer) {
        var callbacks = $f2da373044131ea3$var$scrollSpy.scrollSpyContainers[$f2da373044131ea3$var$scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
        callbacks.forEach(function(c) {
            return c($f2da373044131ea3$var$scrollSpy.currentPositionX(scrollSpyContainer), $f2da373044131ea3$var$scrollSpy.currentPositionY(scrollSpyContainer));
        });
    },
    addStateHandler: function addStateHandler(handler) {
        $f2da373044131ea3$var$scrollSpy.spySetState.push(handler);
    },
    addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
        var container = $f2da373044131ea3$var$scrollSpy.scrollSpyContainers[$f2da373044131ea3$var$scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];
        if (!container.spyCallbacks) container.spyCallbacks = [];
        container.spyCallbacks.push(handler);
        handler($f2da373044131ea3$var$scrollSpy.currentPositionX(scrollSpyContainer), $f2da373044131ea3$var$scrollSpy.currentPositionY(scrollSpyContainer));
    },
    updateStates: function updateStates() {
        $f2da373044131ea3$var$scrollSpy.spySetState.forEach(function(s) {
            return s();
        });
    },
    unmount: function unmount(stateHandler, spyHandler) {
        $f2da373044131ea3$var$scrollSpy.scrollSpyContainers.forEach(function(c) {
            return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
        });
        if ($f2da373044131ea3$var$scrollSpy.spySetState && $f2da373044131ea3$var$scrollSpy.spySetState.length && $f2da373044131ea3$var$scrollSpy.spySetState.indexOf(stateHandler) > -1) $f2da373044131ea3$var$scrollSpy.spySetState.splice($f2da373044131ea3$var$scrollSpy.spySetState.indexOf(stateHandler), 1);
        document.removeEventListener("scroll", $f2da373044131ea3$var$scrollSpy.scrollHandler);
    },
    update: function update() {
        return $f2da373044131ea3$var$scrollSpy.scrollSpyContainers.forEach(function(c) {
            return $f2da373044131ea3$var$scrollSpy.scrollHandler(c);
        });
    }
};
$f2da373044131ea3$exports.default = $f2da373044131ea3$var$scrollSpy;


var $9d8ec76ce9beaacb$var$_scrollSpy2 = $9d8ec76ce9beaacb$var$_interopRequireDefault($f2da373044131ea3$exports);
var $73e9743a0f529a61$exports = {};
"use strict";
Object.defineProperty($73e9743a0f529a61$exports, "__esModule", {
    value: true
});
var $73e9743a0f529a61$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $84c67f2c9a2d458c$exports = {};
"use strict";
Object.defineProperty($84c67f2c9a2d458c$exports, "__esModule", {
    value: true
});
var $84c67f2c9a2d458c$var$updateHash = function updateHash(hash, historyUpdate) {
    var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
    var hashToUpdate = hashVal ? "#" + hashVal : "";
    var curLoc = window && window.location;
    var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
    historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};
var $84c67f2c9a2d458c$var$getHash = function getHash() {
    return window.location.hash.replace(/^#/, "");
};
var $84c67f2c9a2d458c$var$filterElementInContainer = function filterElementInContainer(container) {
    return function(element) {
        return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
    };
};
var $84c67f2c9a2d458c$var$isPositioned = function isPositioned(element) {
    return getComputedStyle(element).position !== "static";
};
var $84c67f2c9a2d458c$var$getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
    var offsetTop = element.offsetTop;
    var currentOffsetParent = element.offsetParent;
    while(currentOffsetParent && !predicate(currentOffsetParent)){
        offsetTop += currentOffsetParent.offsetTop;
        currentOffsetParent = currentOffsetParent.offsetParent;
    }
    return {
        offsetTop: offsetTop,
        offsetParent: currentOffsetParent
    };
};
var $84c67f2c9a2d458c$var$scrollOffset = function scrollOffset(c, t, horizontal) {
    if (horizontal) return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
    else {
        if (c === document) return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
        // The offsetParent of an element, according to MDN, is its nearest positioned
        // (an element whose position is anything other than static) ancestor. The offsetTop
        // of an element is taken with respect to its offsetParent which may not neccessarily
        // be its parentElement except the parent itself is positioned.
        // So if containerElement is positioned, then it must be an offsetParent somewhere
        // If it happens that targetElement is a descendant of the containerElement, and there
        // is not intermediate positioned element between the two of them, i.e.
        // targetElement"s offsetParent is the same as the containerElement, then the
        // distance between the two will be the offsetTop of the targetElement.
        // If, on the other hand, there are intermediate positioned elements between the
        // two entities, the distance between the targetElement and the containerElement
        // will be the accumulation of the offsetTop of the element and that of its
        // subsequent offsetParent until the containerElement is reached, since it
        // will also be an offsetParent at some point due to the fact that it is positioned.
        // If the containerElement is not positioned, then it can"t be an offsetParent,
        // which means that the offsetTop of the targetElement would not be with respect to it.
        // However, if the two of them happen to have the same offsetParent, then
        // the distance between them will be the difference between their offsetTop
        // since they are both taken with respect to the same entity.
        // The last resort would be to accumulate their offsetTop until a common
        // offsetParent is reached (usually the document) and taking the difference
        // between the accumulated offsetTops
        if ($84c67f2c9a2d458c$var$isPositioned(c)) {
            if (t.offsetParent !== c) {
                var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
                    return e === c || e === document;
                };
                var _getElementOffsetInfo = $84c67f2c9a2d458c$var$getElementOffsetInfoUntil(t, isContainerElementOrDocument), offsetTop = _getElementOffsetInfo.offsetTop, offsetParent = _getElementOffsetInfo.offsetParent;
                if (offsetParent !== c) throw new Error("Seems containerElement is not an ancestor of the Element");
                return offsetTop;
            }
            return t.offsetTop;
        }
        if (t.offsetParent === c.offsetParent) return t.offsetTop - c.offsetTop;
        var isDocument = function isDocument(e) {
            return e === document;
        };
        return $84c67f2c9a2d458c$var$getElementOffsetInfoUntil(t, isDocument).offsetTop - $84c67f2c9a2d458c$var$getElementOffsetInfoUntil(c, isDocument).offsetTop;
    }
};
$84c67f2c9a2d458c$exports.default = {
    updateHash: $84c67f2c9a2d458c$var$updateHash,
    getHash: $84c67f2c9a2d458c$var$getHash,
    filterElementInContainer: $84c67f2c9a2d458c$var$filterElementInContainer,
    scrollOffset: $84c67f2c9a2d458c$var$scrollOffset
};


var $73e9743a0f529a61$var$_utils2 = $73e9743a0f529a61$var$_interopRequireDefault($84c67f2c9a2d458c$exports);
var $12c2e80b8c7b855a$exports = {};
"use strict";
Object.defineProperty($12c2e80b8c7b855a$exports, "__esModule", {
    value: true
});
var $12c2e80b8c7b855a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $12c2e80b8c7b855a$var$_utils2 = $12c2e80b8c7b855a$var$_interopRequireDefault($84c67f2c9a2d458c$exports);
var $08a93b0abc7d2706$exports = {};
"use strict";
Object.defineProperty($08a93b0abc7d2706$exports, "__esModule", {
    value: true
});
$08a93b0abc7d2706$exports.default = {
    /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */ defaultEasing: function defaultEasing(x) {
        if (x < 0.5) return Math.pow(x * 2, 2) / 2;
        return 1 - Math.pow((1 - x) * 2, 2) / 2;
    },
    /*
   * https://gist.github.com/gre/1650294
   */ // no easing, no acceleration
    linear: function linear(x) {
        return x;
    },
    // accelerating from zero velocity
    easeInQuad: function easeInQuad(x) {
        return x * x;
    },
    // decelerating to zero velocity
    easeOutQuad: function easeOutQuad(x) {
        return x * (2 - x);
    },
    // acceleration until halfway, then deceleration
    easeInOutQuad: function easeInOutQuad(x) {
        return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
    },
    // accelerating from zero velocity 
    easeInCubic: function easeInCubic(x) {
        return x * x * x;
    },
    // decelerating to zero velocity π
    easeOutCubic: function easeOutCubic(x) {
        return --x * x * x + 1;
    },
    // acceleration until halfway, then deceleration 
    easeInOutCubic: function easeInOutCubic(x) {
        return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
    },
    // accelerating from zero velocity 
    easeInQuart: function easeInQuart(x) {
        return x * x * x * x;
    },
    // decelerating to zero velocity 
    easeOutQuart: function easeOutQuart(x) {
        return 1 - --x * x * x * x;
    },
    // acceleration until halfway, then deceleration
    easeInOutQuart: function easeInOutQuart(x) {
        return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
    },
    // accelerating from zero velocity
    easeInQuint: function easeInQuint(x) {
        return x * x * x * x * x;
    },
    // decelerating to zero velocity
    easeOutQuint: function easeOutQuint(x) {
        return 1 + --x * x * x * x * x;
    },
    // acceleration until halfway, then deceleration 
    easeInOutQuint: function easeInOutQuint(x) {
        return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
    }
};


var $12c2e80b8c7b855a$var$_smooth2 = $12c2e80b8c7b855a$var$_interopRequireDefault($08a93b0abc7d2706$exports);
var $7175c23d059057e1$exports = {};
"use strict";
Object.defineProperty($7175c23d059057e1$exports, "__esModule", {
    value: true
});

var $7175c23d059057e1$var$events = [
    "mousedown",
    "mousewheel",
    "touchmove",
    "keydown"
];
$7175c23d059057e1$exports.default = {
    subscribe: function subscribe(cancelEvent) {
        return typeof document !== "undefined" && $7175c23d059057e1$var$events.forEach(function(event) {
            return (0, $47868a47c82ef94c$exports.addPassiveEventListener)(document, event, cancelEvent);
        });
    }
};


var $12c2e80b8c7b855a$var$_cancelEvents2 = $12c2e80b8c7b855a$var$_interopRequireDefault($7175c23d059057e1$exports);
var $bd481ea6295e4234$exports = {};
"use strict";
Object.defineProperty($bd481ea6295e4234$exports, "__esModule", {
    value: true
});
var $bd481ea6295e4234$var$Events = {
    registered: {},
    scrollEvent: {
        register: function register(evtName, callback) {
            $bd481ea6295e4234$var$Events.registered[evtName] = callback;
        },
        remove: function remove(evtName) {
            $bd481ea6295e4234$var$Events.registered[evtName] = null;
        }
    }
};
$bd481ea6295e4234$exports.default = $bd481ea6295e4234$var$Events;


var $12c2e80b8c7b855a$var$_scrollEvents2 = $12c2e80b8c7b855a$var$_interopRequireDefault($bd481ea6295e4234$exports);
function $12c2e80b8c7b855a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * Gets the easing type from the smooth prop within options.
 */ var $12c2e80b8c7b855a$var$getAnimationType = function getAnimationType(options) {
    return $12c2e80b8c7b855a$var$_smooth2.default[options.smooth] || $12c2e80b8c7b855a$var$_smooth2.default.defaultEasing;
};
/*
 * Function helper
 */ var $12c2e80b8c7b855a$var$functionWrapper = function functionWrapper(value) {
    return typeof value === "function" ? value : function() {
        return value;
    };
};
/*
 * Wraps window properties to allow server side rendering
 */ var $12c2e80b8c7b855a$var$currentWindowProperties = function currentWindowProperties() {
    if (typeof window !== "undefined") return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
};
/*
 * Helper function to never extend 60fps on the webpage.
 */ var $12c2e80b8c7b855a$var$requestAnimationFrameHelper = function() {
    return $12c2e80b8c7b855a$var$currentWindowProperties() || function(callback, element, delay) {
        window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
    };
}();
var $12c2e80b8c7b855a$var$makeData = function makeData() {
    return {
        currentPosition: 0,
        startPosition: 0,
        targetPosition: 0,
        progress: 0,
        duration: 0,
        cancel: false,
        target: null,
        containerElement: null,
        to: null,
        start: null,
        delta: null,
        percent: null,
        delayTimeout: null
    };
};
var $12c2e80b8c7b855a$var$currentPositionX = function currentPositionX(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollLeft;
    else {
        var supportPageOffset = window.pageXOffset !== undefined;
        var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
        return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    }
};
var $12c2e80b8c7b855a$var$currentPositionY = function currentPositionY(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollTop;
    else {
        var supportPageOffset = window.pageXOffset !== undefined;
        var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
        return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    }
};
var $12c2e80b8c7b855a$var$scrollContainerWidth = function scrollContainerWidth(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollWidth - containerElement.offsetWidth;
    else {
        var body = document.body;
        var html = document.documentElement;
        return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
    }
};
var $12c2e80b8c7b855a$var$scrollContainerHeight = function scrollContainerHeight(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollHeight - containerElement.offsetHeight;
    else {
        var body = document.body;
        var html = document.documentElement;
        return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    }
};
var $12c2e80b8c7b855a$var$animateScroll = function animateScroll(easing, options, timestamp) {
    var data = options.data;
    // Cancel on specific events
    if (!options.ignoreCancelEvents && data.cancel) {
        if ($12c2e80b8c7b855a$var$_scrollEvents2.default.registered["end"]) $12c2e80b8c7b855a$var$_scrollEvents2.default.registered["end"](data.to, data.target, data.currentPositionY);
        return;
    }
    data.delta = Math.round(data.targetPosition - data.startPosition);
    if (data.start === null) data.start = timestamp;
    data.progress = timestamp - data.start;
    data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);
    data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);
    if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
        if (options.horizontal) data.containerElement.scrollLeft = data.currentPosition;
        else data.containerElement.scrollTop = data.currentPosition;
    } else if (options.horizontal) window.scrollTo(data.currentPosition, 0);
    else window.scrollTo(0, data.currentPosition);
    if (data.percent < 1) {
        var easedAnimate = animateScroll.bind(null, easing, options);
        $12c2e80b8c7b855a$var$requestAnimationFrameHelper.call(window, easedAnimate);
        return;
    }
    if ($12c2e80b8c7b855a$var$_scrollEvents2.default.registered["end"]) $12c2e80b8c7b855a$var$_scrollEvents2.default.registered["end"](data.to, data.target, data.currentPosition);
};
var $12c2e80b8c7b855a$var$setContainer = function setContainer(options) {
    options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};
var $12c2e80b8c7b855a$var$animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
    options.data = options.data || $12c2e80b8c7b855a$var$makeData();
    window.clearTimeout(options.data.delayTimeout);
    var setCancel = function setCancel() {
        options.data.cancel = true;
    };
    $12c2e80b8c7b855a$var$_cancelEvents2.default.subscribe(setCancel);
    $12c2e80b8c7b855a$var$setContainer(options);
    options.data.start = null;
    options.data.cancel = false;
    options.data.startPosition = options.horizontal ? $12c2e80b8c7b855a$var$currentPositionX(options) : $12c2e80b8c7b855a$var$currentPositionY(options);
    options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;
    if (options.data.startPosition === options.data.targetPosition) {
        if ($12c2e80b8c7b855a$var$_scrollEvents2.default.registered["end"]) $12c2e80b8c7b855a$var$_scrollEvents2.default.registered["end"](options.data.to, options.data.target, options.data.currentPosition);
        return;
    }
    options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);
    options.data.duration = $12c2e80b8c7b855a$var$functionWrapper(options.duration)(options.data.delta);
    options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
    options.data.to = to;
    options.data.target = target;
    var easing = $12c2e80b8c7b855a$var$getAnimationType(options);
    var easedAnimate = $12c2e80b8c7b855a$var$animateScroll.bind(null, easing, options);
    if (options && options.delay > 0) {
        options.data.delayTimeout = window.setTimeout(function() {
            if ($12c2e80b8c7b855a$var$_scrollEvents2.default.registered["begin"]) $12c2e80b8c7b855a$var$_scrollEvents2.default.registered["begin"](options.data.to, options.data.target);
            $12c2e80b8c7b855a$var$requestAnimationFrameHelper.call(window, easedAnimate);
        }, options.delay);
        return;
    }
    if ($12c2e80b8c7b855a$var$_scrollEvents2.default.registered["begin"]) $12c2e80b8c7b855a$var$_scrollEvents2.default.registered["begin"](options.data.to, options.data.target);
    $12c2e80b8c7b855a$var$requestAnimationFrameHelper.call(window, easedAnimate);
};
var $12c2e80b8c7b855a$var$proceedOptions = function proceedOptions(options) {
    options = $12c2e80b8c7b855a$var$_extends({}, options);
    options.data = options.data || $12c2e80b8c7b855a$var$makeData();
    options.absolute = true;
    return options;
};
var $12c2e80b8c7b855a$var$scrollToTop = function scrollToTop(options) {
    $12c2e80b8c7b855a$var$animateTopScroll(0, $12c2e80b8c7b855a$var$proceedOptions(options));
};
var $12c2e80b8c7b855a$var$scrollTo = function scrollTo(toPosition, options) {
    $12c2e80b8c7b855a$var$animateTopScroll(toPosition, $12c2e80b8c7b855a$var$proceedOptions(options));
};
var $12c2e80b8c7b855a$var$scrollToBottom = function scrollToBottom(options) {
    options = $12c2e80b8c7b855a$var$proceedOptions(options);
    $12c2e80b8c7b855a$var$setContainer(options);
    $12c2e80b8c7b855a$var$animateTopScroll(options.horizontal ? $12c2e80b8c7b855a$var$scrollContainerWidth(options) : $12c2e80b8c7b855a$var$scrollContainerHeight(options), options);
};
var $12c2e80b8c7b855a$var$scrollMore = function scrollMore(toPosition, options) {
    options = $12c2e80b8c7b855a$var$proceedOptions(options);
    $12c2e80b8c7b855a$var$setContainer(options);
    var currentPosition = options.horizontal ? $12c2e80b8c7b855a$var$currentPositionX(options) : $12c2e80b8c7b855a$var$currentPositionY(options);
    $12c2e80b8c7b855a$var$animateTopScroll(toPosition + currentPosition, options);
};
$12c2e80b8c7b855a$exports.default = {
    animateTopScroll: $12c2e80b8c7b855a$var$animateTopScroll,
    getAnimationType: $12c2e80b8c7b855a$var$getAnimationType,
    scrollToTop: $12c2e80b8c7b855a$var$scrollToTop,
    scrollToBottom: $12c2e80b8c7b855a$var$scrollToBottom,
    scrollTo: $12c2e80b8c7b855a$var$scrollTo,
    scrollMore: $12c2e80b8c7b855a$var$scrollMore
};


var $73e9743a0f529a61$var$_animateScroll2 = $73e9743a0f529a61$var$_interopRequireDefault($12c2e80b8c7b855a$exports);

var $73e9743a0f529a61$var$_scrollEvents2 = $73e9743a0f529a61$var$_interopRequireDefault($bd481ea6295e4234$exports);
function $73e9743a0f529a61$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $73e9743a0f529a61$var$__mapped = {};
var $73e9743a0f529a61$var$__activeLink = void 0;
$73e9743a0f529a61$exports.default = {
    unmount: function unmount() {
        $73e9743a0f529a61$var$__mapped = {};
    },
    register: function register(name, element) {
        $73e9743a0f529a61$var$__mapped[name] = element;
    },
    unregister: function unregister(name) {
        delete $73e9743a0f529a61$var$__mapped[name];
    },
    get: function get(name) {
        return $73e9743a0f529a61$var$__mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
    },
    setActiveLink: function setActiveLink(link) {
        return $73e9743a0f529a61$var$__activeLink = link;
    },
    getActiveLink: function getActiveLink() {
        return $73e9743a0f529a61$var$__activeLink;
    },
    scrollTo: function scrollTo(to, props) {
        var target = this.get(to);
        if (!target) {
            console.warn("target Element not found");
            return;
        }
        props = $73e9743a0f529a61$var$_extends({}, props, {
            absolute: false
        });
        var containerId = props.containerId;
        var container = props.container;
        var containerElement = void 0;
        if (containerId) containerElement = document.getElementById(containerId);
        else if (container && container.nodeType) containerElement = container;
        else containerElement = document;
        props.absolute = true;
        var horizontal = props.horizontal;
        var scrollOffset = $73e9743a0f529a61$var$_utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);
        /*
     * if animate is not provided just scroll into the view
     */ if (!props.smooth) {
            if ($73e9743a0f529a61$var$_scrollEvents2.default.registered["begin"]) $73e9743a0f529a61$var$_scrollEvents2.default.registered["begin"](to, target);
            if (containerElement === document) {
                if (props.horizontal) window.scrollTo(scrollOffset, 0);
                else window.scrollTo(0, scrollOffset);
            } else containerElement.scrollTop = scrollOffset;
            if ($73e9743a0f529a61$var$_scrollEvents2.default.registered["end"]) $73e9743a0f529a61$var$_scrollEvents2.default.registered["end"](to, target);
            return;
        }
        /*
     * Animate scrolling
     */ $73e9743a0f529a61$var$_animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
    }
};


var $9d8ec76ce9beaacb$var$_scroller2 = $9d8ec76ce9beaacb$var$_interopRequireDefault($73e9743a0f529a61$exports);
var $7da1d47045483a0e$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7da1d47045483a0e$var$ReactIs, $7da1d47045483a0e$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$7da1d47045483a0e$exports = (parcelRequire("lrct3"))();


var $9d8ec76ce9beaacb$var$_propTypes2 = $9d8ec76ce9beaacb$var$_interopRequireDefault($7da1d47045483a0e$exports);
var $e04d2545facd2b60$exports = {};
"use strict";
Object.defineProperty($e04d2545facd2b60$exports, "__esModule", {
    value: true
});


var $e04d2545facd2b60$var$_utils2 = $e04d2545facd2b60$var$_interopRequireDefault($84c67f2c9a2d458c$exports);
function $e04d2545facd2b60$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e04d2545facd2b60$var$scrollHash = {
    mountFlag: false,
    initialized: false,
    scroller: null,
    containers: {},
    mount: function mount(scroller) {
        this.scroller = scroller;
        this.handleHashChange = this.handleHashChange.bind(this);
        window.addEventListener("hashchange", this.handleHashChange);
        this.initStateFromHash();
        this.mountFlag = true;
    },
    mapContainer: function mapContainer(to, container) {
        this.containers[to] = container;
    },
    isMounted: function isMounted() {
        return this.mountFlag;
    },
    isInitialized: function isInitialized() {
        return this.initialized;
    },
    initStateFromHash: function initStateFromHash() {
        var _this = this;
        var hash = this.getHash();
        if (hash) window.setTimeout(function() {
            _this.scrollTo(hash, true);
            _this.initialized = true;
        }, 10);
        else this.initialized = true;
    },
    scrollTo: function scrollTo(to, isInit) {
        var scroller = this.scroller;
        var element = scroller.get(to);
        if (element && (isInit || to !== scroller.getActiveLink())) {
            var container = this.containers[to] || document;
            scroller.scrollTo(to, {
                container: container
            });
        }
    },
    getHash: function getHash() {
        return $e04d2545facd2b60$var$_utils2.default.getHash();
    },
    changeHash: function changeHash(to, saveHashHistory) {
        if (this.isInitialized() && $e04d2545facd2b60$var$_utils2.default.getHash() !== to) $e04d2545facd2b60$var$_utils2.default.updateHash(to, saveHashHistory);
    },
    handleHashChange: function handleHashChange() {
        this.scrollTo(this.getHash());
    },
    unmount: function unmount() {
        this.scroller = null;
        this.containers = null;
        window.removeEventListener("hashchange", this.handleHashChange);
    }
};
$e04d2545facd2b60$exports.default = $e04d2545facd2b60$var$scrollHash;


var $9d8ec76ce9beaacb$var$_scrollHash2 = $9d8ec76ce9beaacb$var$_interopRequireDefault($e04d2545facd2b60$exports);
function $9d8ec76ce9beaacb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9d8ec76ce9beaacb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9d8ec76ce9beaacb$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9d8ec76ce9beaacb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9d8ec76ce9beaacb$var$protoTypes = {
    to: $9d8ec76ce9beaacb$var$_propTypes2.default.string.isRequired,
    containerId: $9d8ec76ce9beaacb$var$_propTypes2.default.string,
    container: $9d8ec76ce9beaacb$var$_propTypes2.default.object,
    activeClass: $9d8ec76ce9beaacb$var$_propTypes2.default.string,
    activeStyle: $9d8ec76ce9beaacb$var$_propTypes2.default.object,
    spy: $9d8ec76ce9beaacb$var$_propTypes2.default.bool,
    horizontal: $9d8ec76ce9beaacb$var$_propTypes2.default.bool,
    smooth: $9d8ec76ce9beaacb$var$_propTypes2.default.oneOfType([
        $9d8ec76ce9beaacb$var$_propTypes2.default.bool,
        $9d8ec76ce9beaacb$var$_propTypes2.default.string
    ]),
    offset: $9d8ec76ce9beaacb$var$_propTypes2.default.number,
    delay: $9d8ec76ce9beaacb$var$_propTypes2.default.number,
    isDynamic: $9d8ec76ce9beaacb$var$_propTypes2.default.bool,
    onClick: $9d8ec76ce9beaacb$var$_propTypes2.default.func,
    duration: $9d8ec76ce9beaacb$var$_propTypes2.default.oneOfType([
        $9d8ec76ce9beaacb$var$_propTypes2.default.number,
        $9d8ec76ce9beaacb$var$_propTypes2.default.func
    ]),
    absolute: $9d8ec76ce9beaacb$var$_propTypes2.default.bool,
    onSetActive: $9d8ec76ce9beaacb$var$_propTypes2.default.func,
    onSetInactive: $9d8ec76ce9beaacb$var$_propTypes2.default.func,
    ignoreCancelEvents: $9d8ec76ce9beaacb$var$_propTypes2.default.bool,
    hashSpy: $9d8ec76ce9beaacb$var$_propTypes2.default.bool,
    saveHashHistory: $9d8ec76ce9beaacb$var$_propTypes2.default.bool,
    spyThrottle: $9d8ec76ce9beaacb$var$_propTypes2.default.number
};
$9d8ec76ce9beaacb$exports.default = function(Component, customScroller) {
    var scroller = customScroller || $9d8ec76ce9beaacb$var$_scroller2.default;
    var Link = function(_React$PureComponent) {
        $9d8ec76ce9beaacb$var$_inherits(Link, _React$PureComponent);
        function Link(props) {
            $9d8ec76ce9beaacb$var$_classCallCheck(this, Link);
            var _this = $9d8ec76ce9beaacb$var$_possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));
            _initialiseProps.call(_this);
            _this.state = {
                active: false
            };
            return _this;
        }
        $9d8ec76ce9beaacb$var$_createClass(Link, [
            {
                key: "getScrollSpyContainer",
                value: function getScrollSpyContainer() {
                    var containerId = this.props.containerId;
                    var container = this.props.container;
                    if (containerId && !container) return document.getElementById(containerId);
                    if (container && container.nodeType) return container;
                    return document;
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (this.props.spy || this.props.hashSpy) {
                        var scrollSpyContainer = this.getScrollSpyContainer();
                        if (!$9d8ec76ce9beaacb$var$_scrollSpy2.default.isMounted(scrollSpyContainer)) $9d8ec76ce9beaacb$var$_scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
                        if (this.props.hashSpy) {
                            if (!$9d8ec76ce9beaacb$var$_scrollHash2.default.isMounted()) $9d8ec76ce9beaacb$var$_scrollHash2.default.mount(scroller);
                            $9d8ec76ce9beaacb$var$_scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
                        }
                        $9d8ec76ce9beaacb$var$_scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);
                        this.setState({
                            container: scrollSpyContainer
                        });
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    $9d8ec76ce9beaacb$var$_scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
                }
            },
            {
                key: "render",
                value: function render() {
                    var className = "";
                    if (this.state && this.state.active) className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
                    else className = this.props.className;
                    var style = {};
                    if (this.state && this.state.active) style = $9d8ec76ce9beaacb$var$_extends({}, this.props.style, this.props.activeStyle);
                    else style = $9d8ec76ce9beaacb$var$_extends({}, this.props.style);
                    var props = $9d8ec76ce9beaacb$var$_extends({}, this.props);
                    for(var prop in $9d8ec76ce9beaacb$var$protoTypes)if (props.hasOwnProperty(prop)) delete props[prop];
                    props.className = className;
                    props.style = style;
                    props.onClick = this.handleClick;
                    return $9d8ec76ce9beaacb$var$_react2.default.createElement(Component, props);
                }
            }
        ]);
        return Link;
    }($9d8ec76ce9beaacb$var$_react2.default.PureComponent);
    var _initialiseProps = function _initialiseProps() {
        var _this2 = this;
        this.scrollTo = function(to, props) {
            scroller.scrollTo(to, $9d8ec76ce9beaacb$var$_extends({}, _this2.state, props));
        };
        this.handleClick = function(event) {
            /*
       * give the posibility to override onClick
       */ if (_this2.props.onClick) _this2.props.onClick(event);
            /*
       * dont bubble the navigation
       */ if (event.stopPropagation) event.stopPropagation();
            if (event.preventDefault) event.preventDefault();
            /*
       * do the magic!
       */ _this2.scrollTo(_this2.props.to, _this2.props);
        };
        this.spyHandler = function(x, y) {
            var scrollSpyContainer = _this2.getScrollSpyContainer();
            if ($9d8ec76ce9beaacb$var$_scrollHash2.default.isMounted() && !$9d8ec76ce9beaacb$var$_scrollHash2.default.isInitialized()) return;
            var horizontal = _this2.props.horizontal;
            var to = _this2.props.to;
            var element = null;
            var isInside = void 0;
            var isOutside = void 0;
            if (horizontal) {
                var elemLeftBound = 0;
                var elemRightBound = 0;
                var containerLeft = 0;
                if (scrollSpyContainer.getBoundingClientRect) {
                    var containerCords = scrollSpyContainer.getBoundingClientRect();
                    containerLeft = containerCords.left;
                }
                if (!element || _this2.props.isDynamic) {
                    element = scroller.get(to);
                    if (!element) return;
                    var cords = element.getBoundingClientRect();
                    elemLeftBound = cords.left - containerLeft + x;
                    elemRightBound = elemLeftBound + cords.width;
                }
                var offsetX = x - _this2.props.offset;
                isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
                isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
            } else {
                var elemTopBound = 0;
                var elemBottomBound = 0;
                var containerTop = 0;
                if (scrollSpyContainer.getBoundingClientRect) {
                    var _containerCords = scrollSpyContainer.getBoundingClientRect();
                    containerTop = _containerCords.top;
                }
                if (!element || _this2.props.isDynamic) {
                    element = scroller.get(to);
                    if (!element) return;
                    var _cords = element.getBoundingClientRect();
                    elemTopBound = _cords.top - containerTop + y;
                    elemBottomBound = elemTopBound + _cords.height;
                }
                var offsetY = y - _this2.props.offset;
                isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
                isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
            }
            var activeLink = scroller.getActiveLink();
            if (isOutside) {
                if (to === activeLink) scroller.setActiveLink(void 0);
                if (_this2.props.hashSpy && $9d8ec76ce9beaacb$var$_scrollHash2.default.getHash() === to) {
                    var _props$saveHashHistor = _this2.props.saveHashHistory, saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;
                    $9d8ec76ce9beaacb$var$_scrollHash2.default.changeHash("", saveHashHistory);
                }
                if (_this2.props.spy && _this2.state.active) {
                    _this2.setState({
                        active: false
                    });
                    _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
                }
            }
            if (isInside && (activeLink !== to || _this2.state.active === false)) {
                scroller.setActiveLink(to);
                var _props$saveHashHistor2 = _this2.props.saveHashHistory, _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;
                _this2.props.hashSpy && $9d8ec76ce9beaacb$var$_scrollHash2.default.changeHash(to, _saveHashHistory);
                if (_this2.props.spy) {
                    _this2.setState({
                        active: true
                    });
                    _this2.props.onSetActive && _this2.props.onSetActive(to, element);
                }
            }
        };
    };
    Link.propTypes = $9d8ec76ce9beaacb$var$protoTypes;
    Link.defaultProps = {
        offset: 0
    };
    return Link;
};


var $0a79ef4c65637ec3$var$_scrollLink2 = $0a79ef4c65637ec3$var$_interopRequireDefault($9d8ec76ce9beaacb$exports);
function $0a79ef4c65637ec3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0a79ef4c65637ec3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0a79ef4c65637ec3$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0a79ef4c65637ec3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $0a79ef4c65637ec3$var$LinkElement = function(_React$Component) {
    $0a79ef4c65637ec3$var$_inherits(LinkElement, _React$Component);
    function LinkElement() {
        var _ref;
        var _temp, _this, _ret;
        $0a79ef4c65637ec3$var$_classCallCheck(this, LinkElement);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $0a79ef4c65637ec3$var$_possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.render = function() {
            return $0a79ef4c65637ec3$var$_react2.default.createElement("a", _this.props, _this.props.children);
        }, _temp), $0a79ef4c65637ec3$var$_possibleConstructorReturn(_this, _ret);
    }
    return LinkElement;
}($0a79ef4c65637ec3$var$_react2.default.Component);
$0a79ef4c65637ec3$exports.default = (0, $0a79ef4c65637ec3$var$_scrollLink2.default)($0a79ef4c65637ec3$var$LinkElement);


var $1d42a532dd4f25d5$var$_Link2 = $1d42a532dd4f25d5$var$_interopRequireDefault($0a79ef4c65637ec3$exports);
var $a0c2a6a454c17db5$exports = {};
"use strict";
Object.defineProperty($a0c2a6a454c17db5$exports, "__esModule", {
    value: true
});
var $a0c2a6a454c17db5$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6cds3 = parcelRequire("6cds3");
var $a0c2a6a454c17db5$var$_react2 = $a0c2a6a454c17db5$var$_interopRequireDefault($6cds3);

var $a0c2a6a454c17db5$var$_scrollLink2 = $a0c2a6a454c17db5$var$_interopRequireDefault($9d8ec76ce9beaacb$exports);
function $a0c2a6a454c17db5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a0c2a6a454c17db5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a0c2a6a454c17db5$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a0c2a6a454c17db5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a0c2a6a454c17db5$var$ButtonElement = function(_React$Component) {
    $a0c2a6a454c17db5$var$_inherits(ButtonElement, _React$Component);
    function ButtonElement() {
        $a0c2a6a454c17db5$var$_classCallCheck(this, ButtonElement);
        return $a0c2a6a454c17db5$var$_possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
    }
    $a0c2a6a454c17db5$var$_createClass(ButtonElement, [
        {
            key: "render",
            value: function render() {
                return $a0c2a6a454c17db5$var$_react2.default.createElement("button", this.props, this.props.children);
            }
        }
    ]);
    return ButtonElement;
}($a0c2a6a454c17db5$var$_react2.default.Component);
$a0c2a6a454c17db5$exports.default = (0, $a0c2a6a454c17db5$var$_scrollLink2.default)($a0c2a6a454c17db5$var$ButtonElement);


var $1d42a532dd4f25d5$var$_Button2 = $1d42a532dd4f25d5$var$_interopRequireDefault($a0c2a6a454c17db5$exports);
var $9bdc64791f7314b8$exports = {};
"use strict";
Object.defineProperty($9bdc64791f7314b8$exports, "__esModule", {
    value: true
});
var $9bdc64791f7314b8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9bdc64791f7314b8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6cds3 = parcelRequire("6cds3");
var $9bdc64791f7314b8$var$_react2 = $9bdc64791f7314b8$var$_interopRequireDefault($6cds3);
var $43efe93b05d56ab8$exports = {};
"use strict";
Object.defineProperty($43efe93b05d56ab8$exports, "__esModule", {
    value: true
});
var $43efe93b05d56ab8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $43efe93b05d56ab8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6cds3 = parcelRequire("6cds3");
var $43efe93b05d56ab8$var$_react2 = $43efe93b05d56ab8$var$_interopRequireDefault($6cds3);

var $43efe93b05d56ab8$var$_reactDom2 = $43efe93b05d56ab8$var$_interopRequireDefault($6d4849ee44552f5f$exports);

var $43efe93b05d56ab8$var$_scroller2 = $43efe93b05d56ab8$var$_interopRequireDefault($73e9743a0f529a61$exports);

var $43efe93b05d56ab8$var$_propTypes2 = $43efe93b05d56ab8$var$_interopRequireDefault($7da1d47045483a0e$exports);
function $43efe93b05d56ab8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $43efe93b05d56ab8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $43efe93b05d56ab8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $43efe93b05d56ab8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
$43efe93b05d56ab8$exports.default = function(Component) {
    var Element = function(_React$Component) {
        $43efe93b05d56ab8$var$_inherits(Element, _React$Component);
        function Element(props) {
            $43efe93b05d56ab8$var$_classCallCheck(this, Element);
            var _this = $43efe93b05d56ab8$var$_possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));
            _this.childBindings = {
                domNode: null
            };
            return _this;
        }
        $43efe93b05d56ab8$var$_createClass(Element, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (typeof window === "undefined") return false;
                    this.registerElems(this.props.name);
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.name !== prevProps.name) this.registerElems(this.props.name);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (typeof window === "undefined") return false;
                    $43efe93b05d56ab8$var$_scroller2.default.unregister(this.props.name);
                }
            },
            {
                key: "registerElems",
                value: function registerElems(name) {
                    $43efe93b05d56ab8$var$_scroller2.default.register(name, this.childBindings.domNode);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $43efe93b05d56ab8$var$_react2.default.createElement(Component, $43efe93b05d56ab8$var$_extends({}, this.props, {
                        parentBindings: this.childBindings
                    }));
                }
            }
        ]);
        return Element;
    }($43efe93b05d56ab8$var$_react2.default.Component);
    Element.propTypes = {
        name: $43efe93b05d56ab8$var$_propTypes2.default.string,
        id: $43efe93b05d56ab8$var$_propTypes2.default.string
    };
    return Element;
};


var $9bdc64791f7314b8$var$_scrollElement2 = $9bdc64791f7314b8$var$_interopRequireDefault($43efe93b05d56ab8$exports);

var $9bdc64791f7314b8$var$_propTypes2 = $9bdc64791f7314b8$var$_interopRequireDefault($7da1d47045483a0e$exports);
function $9bdc64791f7314b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9bdc64791f7314b8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9bdc64791f7314b8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9bdc64791f7314b8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9bdc64791f7314b8$var$ElementWrapper = function(_React$Component) {
    $9bdc64791f7314b8$var$_inherits(ElementWrapper, _React$Component);
    function ElementWrapper() {
        $9bdc64791f7314b8$var$_classCallCheck(this, ElementWrapper);
        return $9bdc64791f7314b8$var$_possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
    }
    $9bdc64791f7314b8$var$_createClass(ElementWrapper, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                // Remove `parentBindings` and `name` from props
                var newProps = $9bdc64791f7314b8$var$_extends({}, this.props);
                delete newProps.name;
                if (newProps.parentBindings) delete newProps.parentBindings;
                return $9bdc64791f7314b8$var$_react2.default.createElement("div", $9bdc64791f7314b8$var$_extends({}, newProps, {
                    ref: function ref(el) {
                        _this2.props.parentBindings.domNode = el;
                    }
                }), this.props.children);
            }
        }
    ]);
    return ElementWrapper;
}($9bdc64791f7314b8$var$_react2.default.Component);
$9bdc64791f7314b8$var$ElementWrapper.propTypes = {
    name: $9bdc64791f7314b8$var$_propTypes2.default.string,
    id: $9bdc64791f7314b8$var$_propTypes2.default.string
};
$9bdc64791f7314b8$exports.default = (0, $9bdc64791f7314b8$var$_scrollElement2.default)($9bdc64791f7314b8$var$ElementWrapper);


var $1d42a532dd4f25d5$var$_Element2 = $1d42a532dd4f25d5$var$_interopRequireDefault($9bdc64791f7314b8$exports);

var $1d42a532dd4f25d5$var$_scroller2 = $1d42a532dd4f25d5$var$_interopRequireDefault($73e9743a0f529a61$exports);

var $1d42a532dd4f25d5$var$_scrollEvents2 = $1d42a532dd4f25d5$var$_interopRequireDefault($bd481ea6295e4234$exports);

var $1d42a532dd4f25d5$var$_scrollSpy2 = $1d42a532dd4f25d5$var$_interopRequireDefault($f2da373044131ea3$exports);

var $1d42a532dd4f25d5$var$_animateScroll2 = $1d42a532dd4f25d5$var$_interopRequireDefault($12c2e80b8c7b855a$exports);

var $1d42a532dd4f25d5$var$_scrollLink2 = $1d42a532dd4f25d5$var$_interopRequireDefault($9d8ec76ce9beaacb$exports);

var $1d42a532dd4f25d5$var$_scrollElement2 = $1d42a532dd4f25d5$var$_interopRequireDefault($43efe93b05d56ab8$exports);
var $ef227e5c2d40ad8a$exports = {};
"use strict";
/* DEPRECATED */ var $ef227e5c2d40ad8a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ef227e5c2d40ad8a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $ef227e5c2d40ad8a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ef227e5c2d40ad8a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ef227e5c2d40ad8a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $6cds3 = parcelRequire("6cds3");






var $ef227e5c2d40ad8a$var$protoTypes = {
    to: $7da1d47045483a0e$exports.string.isRequired,
    containerId: $7da1d47045483a0e$exports.string,
    container: $7da1d47045483a0e$exports.object,
    activeClass: $7da1d47045483a0e$exports.string,
    spy: $7da1d47045483a0e$exports.bool,
    smooth: $7da1d47045483a0e$exports.oneOfType([
        $7da1d47045483a0e$exports.bool,
        $7da1d47045483a0e$exports.string
    ]),
    offset: $7da1d47045483a0e$exports.number,
    delay: $7da1d47045483a0e$exports.number,
    isDynamic: $7da1d47045483a0e$exports.bool,
    onClick: $7da1d47045483a0e$exports.func,
    duration: $7da1d47045483a0e$exports.oneOfType([
        $7da1d47045483a0e$exports.number,
        $7da1d47045483a0e$exports.func
    ]),
    absolute: $7da1d47045483a0e$exports.bool,
    onSetActive: $7da1d47045483a0e$exports.func,
    onSetInactive: $7da1d47045483a0e$exports.func,
    ignoreCancelEvents: $7da1d47045483a0e$exports.bool,
    hashSpy: $7da1d47045483a0e$exports.bool,
    spyThrottle: $7da1d47045483a0e$exports.number
};
var $ef227e5c2d40ad8a$var$Helpers = {
    Scroll: function Scroll(Component, customScroller) {
        console.warn("Helpers.Scroll is deprecated since v1.7.0");
        var scroller = customScroller || $73e9743a0f529a61$exports;
        var Scroll = function(_React$Component) {
            $ef227e5c2d40ad8a$var$_inherits(Scroll, _React$Component);
            function Scroll(props) {
                $ef227e5c2d40ad8a$var$_classCallCheck(this, Scroll);
                var _this = $ef227e5c2d40ad8a$var$_possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));
                _initialiseProps.call(_this);
                _this.state = {
                    active: false
                };
                return _this;
            }
            $ef227e5c2d40ad8a$var$_createClass(Scroll, [
                {
                    key: "getScrollSpyContainer",
                    value: function getScrollSpyContainer() {
                        var containerId = this.props.containerId;
                        var container = this.props.container;
                        if (containerId) return document.getElementById(containerId);
                        if (container && container.nodeType) return container;
                        return document;
                    }
                },
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        if (this.props.spy || this.props.hashSpy) {
                            var scrollSpyContainer = this.getScrollSpyContainer();
                            if (!$f2da373044131ea3$exports.isMounted(scrollSpyContainer)) $f2da373044131ea3$exports.mount(scrollSpyContainer, this.props.spyThrottle);
                            if (this.props.hashSpy) {
                                if (!$e04d2545facd2b60$exports.isMounted()) $e04d2545facd2b60$exports.mount(scroller);
                                $e04d2545facd2b60$exports.mapContainer(this.props.to, scrollSpyContainer);
                            }
                            if (this.props.spy) $f2da373044131ea3$exports.addStateHandler(this.stateHandler);
                            $f2da373044131ea3$exports.addSpyHandler(this.spyHandler, scrollSpyContainer);
                            this.setState({
                                container: scrollSpyContainer
                            });
                        }
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        $f2da373044131ea3$exports.unmount(this.stateHandler, this.spyHandler);
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var className = "";
                        if (this.state && this.state.active) className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
                        else className = this.props.className;
                        var props = $ef227e5c2d40ad8a$var$_extends({}, this.props);
                        for(var prop in $ef227e5c2d40ad8a$var$protoTypes)if (props.hasOwnProperty(prop)) delete props[prop];
                        props.className = className;
                        props.onClick = this.handleClick;
                        return $6cds3.createElement(Component, props);
                    }
                }
            ]);
            return Scroll;
        }($6cds3.Component);
        var _initialiseProps = function _initialiseProps() {
            var _this2 = this;
            this.scrollTo = function(to, props) {
                scroller.scrollTo(to, $ef227e5c2d40ad8a$var$_extends({}, _this2.state, props));
            };
            this.handleClick = function(event) {
                /*
         * give the posibility to override onClick
         */ if (_this2.props.onClick) _this2.props.onClick(event);
                /*
         * dont bubble the navigation
         */ if (event.stopPropagation) event.stopPropagation();
                if (event.preventDefault) event.preventDefault();
                /*
         * do the magic!
         */ _this2.scrollTo(_this2.props.to, _this2.props);
            };
            this.stateHandler = function() {
                if (scroller.getActiveLink() !== _this2.props.to) {
                    if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) _this2.props.onSetInactive();
                    _this2.setState({
                        active: false
                    });
                }
            };
            this.spyHandler = function(y) {
                var scrollSpyContainer = _this2.getScrollSpyContainer();
                if ($e04d2545facd2b60$exports.isMounted() && !$e04d2545facd2b60$exports.isInitialized()) return;
                var to = _this2.props.to;
                var element = null;
                var elemTopBound = 0;
                var elemBottomBound = 0;
                var containerTop = 0;
                if (scrollSpyContainer.getBoundingClientRect) {
                    var containerCords = scrollSpyContainer.getBoundingClientRect();
                    containerTop = containerCords.top;
                }
                if (!element || _this2.props.isDynamic) {
                    element = scroller.get(to);
                    if (!element) return;
                    var cords = element.getBoundingClientRect();
                    elemTopBound = cords.top - containerTop + y;
                    elemBottomBound = elemTopBound + cords.height;
                }
                var offsetY = y - _this2.props.offset;
                var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
                var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
                var activeLink = scroller.getActiveLink();
                if (isOutside) {
                    if (to === activeLink) scroller.setActiveLink(void 0);
                    if (_this2.props.hashSpy && $e04d2545facd2b60$exports.getHash() === to) $e04d2545facd2b60$exports.changeHash();
                    if (_this2.props.spy && _this2.state.active) {
                        _this2.setState({
                            active: false
                        });
                        _this2.props.onSetInactive && _this2.props.onSetInactive();
                    }
                    return $f2da373044131ea3$exports.updateStates();
                }
                if (isInside && activeLink !== to) {
                    scroller.setActiveLink(to);
                    _this2.props.hashSpy && $e04d2545facd2b60$exports.changeHash(to);
                    if (_this2.props.spy) {
                        _this2.setState({
                            active: true
                        });
                        _this2.props.onSetActive && _this2.props.onSetActive(to);
                    }
                    return $f2da373044131ea3$exports.updateStates();
                }
            };
        };
        Scroll.propTypes = $ef227e5c2d40ad8a$var$protoTypes;
        Scroll.defaultProps = {
            offset: 0
        };
        return Scroll;
    },
    Element: function Element(Component) {
        console.warn("Helpers.Element is deprecated since v1.7.0");
        var Element = function(_React$Component2) {
            $ef227e5c2d40ad8a$var$_inherits(Element, _React$Component2);
            function Element(props) {
                $ef227e5c2d40ad8a$var$_classCallCheck(this, Element);
                var _this3 = $ef227e5c2d40ad8a$var$_possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));
                _this3.childBindings = {
                    domNode: null
                };
                return _this3;
            }
            $ef227e5c2d40ad8a$var$_createClass(Element, [
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        if (typeof window === "undefined") return false;
                        this.registerElems(this.props.name);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function componentDidUpdate(prevProps) {
                        if (this.props.name !== prevProps.name) this.registerElems(this.props.name);
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        if (typeof window === "undefined") return false;
                        $73e9743a0f529a61$exports.unregister(this.props.name);
                    }
                },
                {
                    key: "registerElems",
                    value: function registerElems(name) {
                        $73e9743a0f529a61$exports.register(name, this.childBindings.domNode);
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        return $6cds3.createElement(Component, $ef227e5c2d40ad8a$var$_extends({}, this.props, {
                            parentBindings: this.childBindings
                        }));
                    }
                }
            ]);
            return Element;
        }($6cds3.Component);
        Element.propTypes = {
            name: $7da1d47045483a0e$exports.string,
            id: $7da1d47045483a0e$exports.string
        };
        return Element;
    }
};
$ef227e5c2d40ad8a$exports = $ef227e5c2d40ad8a$var$Helpers;


var $1d42a532dd4f25d5$var$_Helpers2 = $1d42a532dd4f25d5$var$_interopRequireDefault($ef227e5c2d40ad8a$exports);
function $1d42a532dd4f25d5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$1d42a532dd4f25d5$exports.Link = $1d42a532dd4f25d5$var$_Link2.default;
$1d42a532dd4f25d5$exports.Button = $1d42a532dd4f25d5$var$_Button2.default;
$1d42a532dd4f25d5$exports.Element = $1d42a532dd4f25d5$var$_Element2.default;
$1d42a532dd4f25d5$exports.scroller = $1d42a532dd4f25d5$var$_scroller2.default;
$1d42a532dd4f25d5$exports.Events = $1d42a532dd4f25d5$var$_scrollEvents2.default;
$1d42a532dd4f25d5$exports.scrollSpy = $1d42a532dd4f25d5$var$_scrollSpy2.default;
$1d42a532dd4f25d5$exports.animateScroll = $1d42a532dd4f25d5$var$_animateScroll2.default;
$1d42a532dd4f25d5$exports.ScrollLink = $1d42a532dd4f25d5$var$_scrollLink2.default;
$1d42a532dd4f25d5$exports.ScrollElement = $1d42a532dd4f25d5$var$_scrollElement2.default;
$1d42a532dd4f25d5$exports.Helpers = $1d42a532dd4f25d5$var$_Helpers2.default;
$1d42a532dd4f25d5$exports.default = {
    Link: $1d42a532dd4f25d5$var$_Link2.default,
    Button: $1d42a532dd4f25d5$var$_Button2.default,
    Element: $1d42a532dd4f25d5$var$_Element2.default,
    scroller: $1d42a532dd4f25d5$var$_scroller2.default,
    Events: $1d42a532dd4f25d5$var$_scrollEvents2.default,
    scrollSpy: $1d42a532dd4f25d5$var$_scrollSpy2.default,
    animateScroll: $1d42a532dd4f25d5$var$_animateScroll2.default,
    ScrollLink: $1d42a532dd4f25d5$var$_scrollLink2.default,
    ScrollElement: $1d42a532dd4f25d5$var$_scrollElement2.default,
    Helpers: $1d42a532dd4f25d5$var$_Helpers2.default
};


function $20454ac70e4792f5$var$clamp(v, min, max) {
    return Math.max(min, Math.min(v, max));
}
const $20454ac70e4792f5$export$e7c866399fa523f5 = {
    toVector (v, fallback) {
        if (v === undefined) v = fallback;
        return Array.isArray(v) ? v : [
            v,
            v
        ];
    },
    add (v1, v2) {
        return [
            v1[0] + v2[0],
            v1[1] + v2[1]
        ];
    },
    sub (v1, v2) {
        return [
            v1[0] - v2[0],
            v1[1] - v2[1]
        ];
    },
    addTo (v1, v2) {
        v1[0] += v2[0];
        v1[1] += v2[1];
    },
    subTo (v1, v2) {
        v1[0] -= v2[0];
        v1[1] -= v2[1];
    }
};
function $20454ac70e4792f5$var$rubberband(distance, dimension, constant) {
    if (dimension === 0 || Math.abs(dimension) === Infinity) return Math.pow(distance, constant * 5);
    return distance * dimension * constant / (dimension + constant * distance);
}
function $20454ac70e4792f5$export$43caf9889c228507(position, min, max, constant = 0.15) {
    if (constant === 0) return $20454ac70e4792f5$var$clamp(position, min, max);
    if (position < min) return -$20454ac70e4792f5$var$rubberband(min - position, max - min, constant) + min;
    if (position > max) return +$20454ac70e4792f5$var$rubberband(position - max, max - min, constant) + max;
    return position;
}
function $20454ac70e4792f5$export$db3b6bfb95261072(bounds, [Vx, Vy], [Rx, Ry]) {
    const [[X0, X1], [Y0, Y1]] = bounds;
    return [
        $20454ac70e4792f5$export$43caf9889c228507(Vx, X0, X1, Rx),
        $20454ac70e4792f5$export$43caf9889c228507(Vy, Y0, Y1, Ry)
    ];
}


function $451a082378f3fc88$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $451a082378f3fc88$var$_toPropertyKey(arg) {
    var key = $451a082378f3fc88$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $451a082378f3fc88$export$407448d2b89b1813(obj, key, value) {
    key = $451a082378f3fc88$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $451a082378f3fc88$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $451a082378f3fc88$export$71511d61b312f219(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $451a082378f3fc88$var$ownKeys(Object(t), !0).forEach(function(r) {
            $451a082378f3fc88$export$407448d2b89b1813(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $451a082378f3fc88$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $451a082378f3fc88$var$EVENT_TYPE_MAP = {
    pointer: {
        start: "down",
        change: "move",
        end: "up"
    },
    mouse: {
        start: "down",
        change: "move",
        end: "up"
    },
    touch: {
        start: "start",
        change: "move",
        end: "end"
    },
    gesture: {
        start: "start",
        change: "change",
        end: "end"
    }
};
function $451a082378f3fc88$var$capitalize(string) {
    if (!string) return "";
    return string[0].toUpperCase() + string.slice(1);
}
const $451a082378f3fc88$var$actionsWithoutCaptureSupported = [
    "enter",
    "leave"
];
function $451a082378f3fc88$var$hasCapture(capture = false, actionKey) {
    return capture && !$451a082378f3fc88$var$actionsWithoutCaptureSupported.includes(actionKey);
}
function $451a082378f3fc88$export$4368d992c4eafac0(device, action = "", capture = false) {
    const deviceProps = $451a082378f3fc88$var$EVENT_TYPE_MAP[device];
    const actionKey = deviceProps ? deviceProps[action] || action : action;
    return "on" + $451a082378f3fc88$var$capitalize(device) + $451a082378f3fc88$var$capitalize(actionKey) + ($451a082378f3fc88$var$hasCapture(capture, actionKey) ? "Capture" : "");
}
const $451a082378f3fc88$var$pointerCaptureEvents = [
    "gotpointercapture",
    "lostpointercapture"
];
function $451a082378f3fc88$export$ffb5f4729a158638(prop) {
    let eventKey = prop.substring(2).toLowerCase();
    const passive = !!~eventKey.indexOf("passive");
    if (passive) eventKey = eventKey.replace("passive", "");
    const captureKey = $451a082378f3fc88$var$pointerCaptureEvents.includes(eventKey) ? "capturecapture" : "capture";
    const capture = !!~eventKey.indexOf(captureKey);
    if (capture) eventKey = eventKey.replace("capture", "");
    return {
        device: eventKey,
        capture: capture,
        passive: passive
    };
}
function $451a082378f3fc88$export$625550452a3fa3ec(device, action = "") {
    const deviceProps = $451a082378f3fc88$var$EVENT_TYPE_MAP[device];
    const actionKey = deviceProps ? deviceProps[action] || action : action;
    return device + actionKey;
}
function $451a082378f3fc88$export$23f2a1d2818174ef(event) {
    return "touches" in event;
}
function $451a082378f3fc88$var$getPointerType(event) {
    if ($451a082378f3fc88$export$23f2a1d2818174ef(event)) return "touch";
    if ("pointerType" in event) return event.pointerType;
    return "mouse";
}
function $451a082378f3fc88$var$getCurrentTargetTouchList(event) {
    return Array.from(event.touches).filter((e)=>{
        var _event$currentTarget, _event$currentTarget$;
        return e.target === event.currentTarget || ((_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || (_event$currentTarget$ = _event$currentTarget.contains) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.call(_event$currentTarget, e.target));
    });
}
function $451a082378f3fc88$var$getTouchList(event) {
    return event.type === "touchend" || event.type === "touchcancel" ? event.changedTouches : event.targetTouches;
}
function $451a082378f3fc88$var$getValueEvent(event) {
    return $451a082378f3fc88$export$23f2a1d2818174ef(event) ? $451a082378f3fc88$var$getTouchList(event)[0] : event;
}
function $451a082378f3fc88$var$distanceAngle(P1, P2) {
    try {
        const dx = P2.clientX - P1.clientX;
        const dy = P2.clientY - P1.clientY;
        const cx = (P2.clientX + P1.clientX) / 2;
        const cy = (P2.clientY + P1.clientY) / 2;
        const distance = Math.hypot(dx, dy);
        const angle = -(Math.atan2(dx, dy) * 180) / Math.PI;
        const origin = [
            cx,
            cy
        ];
        return {
            angle: angle,
            distance: distance,
            origin: origin
        };
    } catch (_unused) {}
    return null;
}
function $451a082378f3fc88$export$8b22cf2602fb60ce(event) {
    return $451a082378f3fc88$var$getCurrentTargetTouchList(event).map((touch)=>touch.identifier);
}
function $451a082378f3fc88$var$touchDistanceAngle(event, ids) {
    const [P1, P2] = Array.from(event.touches).filter((touch)=>ids.includes(touch.identifier));
    return $451a082378f3fc88$var$distanceAngle(P1, P2);
}
function $451a082378f3fc88$var$pointerId(event) {
    const valueEvent = $451a082378f3fc88$var$getValueEvent(event);
    return $451a082378f3fc88$export$23f2a1d2818174ef(event) ? valueEvent.identifier : valueEvent.pointerId;
}
function $451a082378f3fc88$var$pointerValues(event) {
    const valueEvent = $451a082378f3fc88$var$getValueEvent(event);
    return [
        valueEvent.clientX,
        valueEvent.clientY
    ];
}
const $451a082378f3fc88$var$LINE_HEIGHT = 40;
const $451a082378f3fc88$var$PAGE_HEIGHT = 800;
function $451a082378f3fc88$var$wheelValues(event) {
    let { deltaX: deltaX, deltaY: deltaY, deltaMode: deltaMode } = event;
    if (deltaMode === 1) {
        deltaX *= $451a082378f3fc88$var$LINE_HEIGHT;
        deltaY *= $451a082378f3fc88$var$LINE_HEIGHT;
    } else if (deltaMode === 2) {
        deltaX *= $451a082378f3fc88$var$PAGE_HEIGHT;
        deltaY *= $451a082378f3fc88$var$PAGE_HEIGHT;
    }
    return [
        deltaX,
        deltaY
    ];
}
function $451a082378f3fc88$var$scrollValues(event) {
    var _ref, _ref2;
    const { scrollX: scrollX, scrollY: scrollY, scrollLeft: scrollLeft, scrollTop: scrollTop } = event.currentTarget;
    return [
        (_ref = scrollX !== null && scrollX !== void 0 ? scrollX : scrollLeft) !== null && _ref !== void 0 ? _ref : 0,
        (_ref2 = scrollY !== null && scrollY !== void 0 ? scrollY : scrollTop) !== null && _ref2 !== void 0 ? _ref2 : 0
    ];
}
function $451a082378f3fc88$var$getEventDetails(event) {
    const payload = {};
    if ("buttons" in event) payload.buttons = event.buttons;
    if ("shiftKey" in event) {
        const { shiftKey: shiftKey, altKey: altKey, metaKey: metaKey, ctrlKey: ctrlKey } = event;
        Object.assign(payload, {
            shiftKey: shiftKey,
            altKey: altKey,
            metaKey: metaKey,
            ctrlKey: ctrlKey
        });
    }
    return payload;
}
function $451a082378f3fc88$var$call(v, ...args) {
    if (typeof v === "function") return v(...args);
    else return v;
}
function $451a082378f3fc88$var$noop() {}
function $451a082378f3fc88$export$db3b6bfb95261072(...fns) {
    if (fns.length === 0) return $451a082378f3fc88$var$noop;
    if (fns.length === 1) return fns[0];
    return function() {
        let result;
        for (const fn of fns)result = fn.apply(this, arguments) || result;
        return result;
    };
}
function $451a082378f3fc88$var$assignDefault(value, fallback) {
    return Object.assign({}, fallback, value || {});
}
const $451a082378f3fc88$var$BEFORE_LAST_KINEMATICS_DELAY = 32;
class $451a082378f3fc88$var$Engine {
    get state() {
        return this.ctrl.state[this.key];
    }
    set state(state) {
        this.ctrl.state[this.key] = state;
    }
    get shared() {
        return this.ctrl.state.shared;
    }
    get eventStore() {
        return this.ctrl.gestureEventStores[this.key];
    }
    get timeoutStore() {
        return this.ctrl.gestureTimeoutStores[this.key];
    }
    get config() {
        return this.ctrl.config[this.key];
    }
    get sharedConfig() {
        return this.ctrl.config.shared;
    }
    get handler() {
        return this.ctrl.handlers[this.key];
    }
    reset() {
        const { state: state, shared: shared, ingKey: ingKey, args: args } = this;
        shared[ingKey] = state._active = state.active = state._blocked = state._force = false;
        state._step = [
            false,
            false
        ];
        state.intentional = false;
        state._movement = [
            0,
            0
        ];
        state._distance = [
            0,
            0
        ];
        state._direction = [
            0,
            0
        ];
        state._delta = [
            0,
            0
        ];
        state._bounds = [
            [
                -Infinity,
                Infinity
            ],
            [
                -Infinity,
                Infinity
            ]
        ];
        state.args = args;
        state.axis = undefined;
        state.memo = undefined;
        state.elapsedTime = state.timeDelta = 0;
        state.direction = [
            0,
            0
        ];
        state.distance = [
            0,
            0
        ];
        state.overflow = [
            0,
            0
        ];
        state._movementBound = [
            false,
            false
        ];
        state.velocity = [
            0,
            0
        ];
        state.movement = [
            0,
            0
        ];
        state.delta = [
            0,
            0
        ];
        state.timeStamp = 0;
    }
    start(event) {
        const state = this.state;
        const config = this.config;
        if (!state._active) {
            this.reset();
            this.computeInitial();
            state._active = true;
            state.target = event.target;
            state.currentTarget = event.currentTarget;
            state.lastOffset = config.from ? $451a082378f3fc88$var$call(config.from, state) : state.offset;
            state.offset = state.lastOffset;
            state.startTime = state.timeStamp = event.timeStamp;
        }
    }
    computeValues(values) {
        const state = this.state;
        state._values = values;
        state.values = this.config.transform(values);
    }
    computeInitial() {
        const state = this.state;
        state._initial = state._values;
        state.initial = state.values;
    }
    compute(event) {
        const { state: state, config: config, shared: shared } = this;
        state.args = this.args;
        let dt = 0;
        if (event) {
            state.event = event;
            if (config.preventDefault && event.cancelable) state.event.preventDefault();
            state.type = event.type;
            shared.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size;
            shared.locked = !!document.pointerLockElement;
            Object.assign(shared, $451a082378f3fc88$var$getEventDetails(event));
            shared.down = shared.pressed = shared.buttons % 2 === 1 || shared.touches > 0;
            dt = event.timeStamp - state.timeStamp;
            state.timeStamp = event.timeStamp;
            state.elapsedTime = state.timeStamp - state.startTime;
        }
        if (state._active) {
            const _absoluteDelta = state._delta.map(Math.abs);
            (0, $20454ac70e4792f5$export$e7c866399fa523f5).addTo(state._distance, _absoluteDelta);
        }
        if (this.axisIntent) this.axisIntent(event);
        const [_m0, _m1] = state._movement;
        const [t0, t1] = config.threshold;
        const { _step: _step, values: values } = state;
        if (config.hasCustomTransform) {
            if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && values[0];
            if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && values[1];
        } else {
            if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && Math.sign(_m0) * t0;
            if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && Math.sign(_m1) * t1;
        }
        state.intentional = _step[0] !== false || _step[1] !== false;
        if (!state.intentional) return;
        const movement = [
            0,
            0
        ];
        if (config.hasCustomTransform) {
            const [v0, v1] = values;
            movement[0] = _step[0] !== false ? v0 - _step[0] : 0;
            movement[1] = _step[1] !== false ? v1 - _step[1] : 0;
        } else {
            movement[0] = _step[0] !== false ? _m0 - _step[0] : 0;
            movement[1] = _step[1] !== false ? _m1 - _step[1] : 0;
        }
        if (this.restrictToAxis && !state._blocked) this.restrictToAxis(movement);
        const previousOffset = state.offset;
        const gestureIsActive = state._active && !state._blocked || state.active;
        if (gestureIsActive) {
            state.first = state._active && !state.active;
            state.last = !state._active && state.active;
            state.active = shared[this.ingKey] = state._active;
            if (event) {
                if (state.first) {
                    if ("bounds" in config) state._bounds = $451a082378f3fc88$var$call(config.bounds, state);
                    if (this.setup) this.setup();
                }
                state.movement = movement;
                this.computeOffset();
            }
        }
        const [ox, oy] = state.offset;
        const [[x0, x1], [y0, y1]] = state._bounds;
        state.overflow = [
            ox < x0 ? -1 : ox > x1 ? 1 : 0,
            oy < y0 ? -1 : oy > y1 ? 1 : 0
        ];
        state._movementBound[0] = state.overflow[0] ? state._movementBound[0] === false ? state._movement[0] : state._movementBound[0] : false;
        state._movementBound[1] = state.overflow[1] ? state._movementBound[1] === false ? state._movement[1] : state._movementBound[1] : false;
        const rubberband = state._active ? config.rubberband || [
            0,
            0
        ] : [
            0,
            0
        ];
        state.offset = (0, $20454ac70e4792f5$export$db3b6bfb95261072)(state._bounds, state.offset, rubberband);
        state.delta = (0, $20454ac70e4792f5$export$e7c866399fa523f5).sub(state.offset, previousOffset);
        this.computeMovement();
        if (gestureIsActive && (!state.last || dt > $451a082378f3fc88$var$BEFORE_LAST_KINEMATICS_DELAY)) {
            state.delta = (0, $20454ac70e4792f5$export$e7c866399fa523f5).sub(state.offset, previousOffset);
            const absoluteDelta = state.delta.map(Math.abs);
            (0, $20454ac70e4792f5$export$e7c866399fa523f5).addTo(state.distance, absoluteDelta);
            state.direction = state.delta.map(Math.sign);
            state._direction = state._delta.map(Math.sign);
            if (!state.first && dt > 0) {
                state.velocity = [
                    absoluteDelta[0] / dt,
                    absoluteDelta[1] / dt
                ];
                state.timeDelta = dt;
            }
        }
    }
    emit() {
        const state = this.state;
        const shared = this.shared;
        const config = this.config;
        if (!state._active) this.clean();
        if ((state._blocked || !state.intentional) && !state._force && !config.triggerAllEvents) return;
        const memo = this.handler($451a082378f3fc88$export$71511d61b312f219($451a082378f3fc88$export$71511d61b312f219($451a082378f3fc88$export$71511d61b312f219({}, shared), state), {}, {
            [this.aliasKey]: state.values
        }));
        if (memo !== undefined) state.memo = memo;
    }
    clean() {
        this.eventStore.clean();
        this.timeoutStore.clean();
    }
    constructor(ctrl, args, key){
        this.ctrl = ctrl;
        this.args = args;
        this.key = key;
        if (!this.state) {
            this.state = {};
            this.computeValues([
                0,
                0
            ]);
            this.computeInitial();
            if (this.init) this.init();
            this.reset();
        }
    }
}
function $451a082378f3fc88$var$selectAxis([dx, dy], threshold) {
    const absDx = Math.abs(dx);
    const absDy = Math.abs(dy);
    if (absDx > absDy && absDx > threshold) return "x";
    if (absDy > absDx && absDy > threshold) return "y";
    return undefined;
}
class $451a082378f3fc88$var$CoordinatesEngine extends $451a082378f3fc88$var$Engine {
    reset() {
        super.reset();
        this.state.axis = undefined;
    }
    init() {
        this.state.offset = [
            0,
            0
        ];
        this.state.lastOffset = [
            0,
            0
        ];
    }
    computeOffset() {
        this.state.offset = (0, $20454ac70e4792f5$export$e7c866399fa523f5).add(this.state.lastOffset, this.state.movement);
    }
    computeMovement() {
        this.state.movement = (0, $20454ac70e4792f5$export$e7c866399fa523f5).sub(this.state.offset, this.state.lastOffset);
    }
    axisIntent(event) {
        const state = this.state;
        const config = this.config;
        if (!state.axis && event) {
            const threshold = typeof config.axisThreshold === "object" ? config.axisThreshold[$451a082378f3fc88$var$getPointerType(event)] : config.axisThreshold;
            state.axis = $451a082378f3fc88$var$selectAxis(state._movement, threshold);
        }
        state._blocked = (config.lockDirection || !!config.axis) && !state.axis || !!config.axis && config.axis !== state.axis;
    }
    restrictToAxis(v) {
        if (this.config.axis || this.config.lockDirection) switch(this.state.axis){
            case "x":
                v[1] = 0;
                break;
            case "y":
                v[0] = 0;
                break;
        }
    }
    constructor(...args){
        super(...args);
        $451a082378f3fc88$export$407448d2b89b1813(this, "aliasKey", "xy");
    }
}
const $451a082378f3fc88$var$identity = (v)=>v;
const $451a082378f3fc88$var$DEFAULT_RUBBERBAND = 0.15;
const $451a082378f3fc88$var$commonConfigResolver = {
    enabled (value = true) {
        return value;
    },
    eventOptions (value, _k, config) {
        return $451a082378f3fc88$export$71511d61b312f219($451a082378f3fc88$export$71511d61b312f219({}, config.shared.eventOptions), value);
    },
    preventDefault (value = false) {
        return value;
    },
    triggerAllEvents (value = false) {
        return value;
    },
    rubberband (value = 0) {
        switch(value){
            case true:
                return [
                    $451a082378f3fc88$var$DEFAULT_RUBBERBAND,
                    $451a082378f3fc88$var$DEFAULT_RUBBERBAND
                ];
            case false:
                return [
                    0,
                    0
                ];
            default:
                return (0, $20454ac70e4792f5$export$e7c866399fa523f5).toVector(value);
        }
    },
    from (value) {
        if (typeof value === "function") return value;
        if (value != null) return (0, $20454ac70e4792f5$export$e7c866399fa523f5).toVector(value);
    },
    transform (value, _k, config) {
        const transform = value || config.shared.transform;
        this.hasCustomTransform = !!transform;
        var v;
        return transform || $451a082378f3fc88$var$identity;
    },
    threshold (value) {
        return (0, $20454ac70e4792f5$export$e7c866399fa523f5).toVector(value, 0);
    }
};
var $451a082378f3fc88$var$value, $451a082378f3fc88$var$value1, $451a082378f3fc88$var$value2;
const $451a082378f3fc88$var$DEFAULT_AXIS_THRESHOLD = 0;
const $451a082378f3fc88$var$coordinatesConfigResolver = $451a082378f3fc88$export$71511d61b312f219($451a082378f3fc88$export$71511d61b312f219({}, $451a082378f3fc88$var$commonConfigResolver), {}, {
    axis (_v, _k, { axis: axis }) {
        this.lockDirection = axis === "lock";
        if (!this.lockDirection) return axis;
    },
    axisThreshold (value = $451a082378f3fc88$var$DEFAULT_AXIS_THRESHOLD) {
        return value;
    },
    bounds (value = {}) {
        if (typeof value === "function") return (state)=>$451a082378f3fc88$var$coordinatesConfigResolver.bounds(value(state));
        if ("current" in value) return ()=>value.current;
        if (typeof HTMLElement === "function" && value instanceof HTMLElement) return value;
        const { left: left = -Infinity, right: right = Infinity, top: top = -Infinity, bottom: bottom = Infinity } = value;
        return [
            [
                left,
                right
            ],
            [
                top,
                bottom
            ]
        ];
    }
});
const $451a082378f3fc88$var$KEYS_DELTA_MAP = {
    ArrowRight: (displacement, factor = 1)=>[
            displacement * factor,
            0
        ],
    ArrowLeft: (displacement, factor = 1)=>[
            -1 * displacement * factor,
            0
        ],
    ArrowUp: (displacement, factor = 1)=>[
            0,
            -1 * displacement * factor
        ],
    ArrowDown: (displacement, factor = 1)=>[
            0,
            displacement * factor
        ]
};
class $451a082378f3fc88$var$DragEngine extends $451a082378f3fc88$var$CoordinatesEngine {
    reset() {
        super.reset();
        const state = this.state;
        state._pointerId = undefined;
        state._pointerActive = false;
        state._keyboardActive = false;
        state._preventScroll = false;
        state._delayed = false;
        state.swipe = [
            0,
            0
        ];
        state.tap = false;
        state.canceled = false;
        state.cancel = this.cancel.bind(this);
    }
    setup() {
        const state = this.state;
        if (state._bounds instanceof HTMLElement) {
            const boundRect = state._bounds.getBoundingClientRect();
            const targetRect = state.currentTarget.getBoundingClientRect();
            const _bounds = {
                left: boundRect.left - targetRect.left + state.offset[0],
                right: boundRect.right - targetRect.right + state.offset[0],
                top: boundRect.top - targetRect.top + state.offset[1],
                bottom: boundRect.bottom - targetRect.bottom + state.offset[1]
            };
            state._bounds = $451a082378f3fc88$var$coordinatesConfigResolver.bounds(_bounds);
        }
    }
    cancel() {
        const state = this.state;
        if (state.canceled) return;
        state.canceled = true;
        state._active = false;
        setTimeout(()=>{
            this.compute();
            this.emit();
        }, 0);
    }
    setActive() {
        this.state._active = this.state._pointerActive || this.state._keyboardActive;
    }
    clean() {
        this.pointerClean();
        this.state._pointerActive = false;
        this.state._keyboardActive = false;
        super.clean();
    }
    pointerDown(event) {
        const config = this.config;
        const state = this.state;
        if (event.buttons != null && (Array.isArray(config.pointerButtons) ? !config.pointerButtons.includes(event.buttons) : config.pointerButtons !== -1 && config.pointerButtons !== event.buttons)) return;
        const ctrlIds = this.ctrl.setEventIds(event);
        if (config.pointerCapture) event.target.setPointerCapture(event.pointerId);
        if (ctrlIds && ctrlIds.size > 1 && state._pointerActive) return;
        this.start(event);
        this.setupPointer(event);
        state._pointerId = $451a082378f3fc88$var$pointerId(event);
        state._pointerActive = true;
        this.computeValues($451a082378f3fc88$var$pointerValues(event));
        this.computeInitial();
        if (config.preventScrollAxis && $451a082378f3fc88$var$getPointerType(event) !== "mouse") {
            state._active = false;
            this.setupScrollPrevention(event);
        } else if (config.delay > 0) {
            this.setupDelayTrigger(event);
            if (config.triggerAllEvents) {
                this.compute(event);
                this.emit();
            }
        } else this.startPointerDrag(event);
    }
    startPointerDrag(event) {
        const state = this.state;
        state._active = true;
        state._preventScroll = true;
        state._delayed = false;
        this.compute(event);
        this.emit();
    }
    pointerMove(event) {
        const state = this.state;
        const config = this.config;
        if (!state._pointerActive) return;
        const id = $451a082378f3fc88$var$pointerId(event);
        if (state._pointerId !== undefined && id !== state._pointerId) return;
        const _values = $451a082378f3fc88$var$pointerValues(event);
        if (document.pointerLockElement === event.target) state._delta = [
            event.movementX,
            event.movementY
        ];
        else {
            state._delta = (0, $20454ac70e4792f5$export$e7c866399fa523f5).sub(_values, state._values);
            this.computeValues(_values);
        }
        (0, $20454ac70e4792f5$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.compute(event);
        if (state._delayed && state.intentional) {
            this.timeoutStore.remove("dragDelay");
            state.active = false;
            this.startPointerDrag(event);
            return;
        }
        if (config.preventScrollAxis && !state._preventScroll) {
            if (state.axis) {
                if (state.axis === config.preventScrollAxis || config.preventScrollAxis === "xy") {
                    state._active = false;
                    this.clean();
                    return;
                } else {
                    this.timeoutStore.remove("startPointerDrag");
                    this.startPointerDrag(event);
                    return;
                }
            } else return;
        }
        this.emit();
    }
    pointerUp(event) {
        this.ctrl.setEventIds(event);
        try {
            if (this.config.pointerCapture && event.target.hasPointerCapture(event.pointerId)) event.target.releasePointerCapture(event.pointerId);
        } catch (_unused) {}
        const state = this.state;
        const config = this.config;
        if (!state._active || !state._pointerActive) return;
        const id = $451a082378f3fc88$var$pointerId(event);
        if (state._pointerId !== undefined && id !== state._pointerId) return;
        this.state._pointerActive = false;
        this.setActive();
        this.compute(event);
        const [dx, dy] = state._distance;
        state.tap = dx <= config.tapsThreshold && dy <= config.tapsThreshold;
        if (state.tap && config.filterTaps) state._force = true;
        else {
            const [_dx, _dy] = state._delta;
            const [_mx, _my] = state._movement;
            const [svx, svy] = config.swipe.velocity;
            const [sx, sy] = config.swipe.distance;
            const sdt = config.swipe.duration;
            if (state.elapsedTime < sdt) {
                const _vx = Math.abs(_dx / state.timeDelta);
                const _vy = Math.abs(_dy / state.timeDelta);
                if (_vx > svx && Math.abs(_mx) > sx) state.swipe[0] = Math.sign(_dx);
                if (_vy > svy && Math.abs(_my) > sy) state.swipe[1] = Math.sign(_dy);
            }
        }
        this.emit();
    }
    pointerClick(event) {
        if (!this.state.tap && event.detail > 0) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    setupPointer(event) {
        const config = this.config;
        const device = config.device;
        var _unused2;
        if (config.pointerLock) event.currentTarget.requestPointerLock();
        if (!config.pointerCapture) {
            this.eventStore.add(this.sharedConfig.window, device, "change", this.pointerMove.bind(this));
            this.eventStore.add(this.sharedConfig.window, device, "end", this.pointerUp.bind(this));
            this.eventStore.add(this.sharedConfig.window, device, "cancel", this.pointerUp.bind(this));
        }
    }
    pointerClean() {
        if (this.config.pointerLock && document.pointerLockElement === this.state.currentTarget) document.exitPointerLock();
    }
    preventScroll(event) {
        if (this.state._preventScroll && event.cancelable) event.preventDefault();
    }
    setupScrollPrevention(event) {
        this.state._preventScroll = false;
        $451a082378f3fc88$var$persistEvent(event);
        const remove = this.eventStore.add(this.sharedConfig.window, "touch", "change", this.preventScroll.bind(this), {
            passive: false
        });
        this.eventStore.add(this.sharedConfig.window, "touch", "end", remove);
        this.eventStore.add(this.sharedConfig.window, "touch", "cancel", remove);
        this.timeoutStore.add("startPointerDrag", this.startPointerDrag.bind(this), this.config.preventScrollDelay, event);
    }
    setupDelayTrigger(event) {
        this.state._delayed = true;
        this.timeoutStore.add("dragDelay", ()=>{
            this.state._step = [
                0,
                0
            ];
            this.startPointerDrag(event);
        }, this.config.delay);
    }
    keyDown(event) {
        const deltaFn = $451a082378f3fc88$var$KEYS_DELTA_MAP[event.key];
        if (deltaFn) {
            const state = this.state;
            const factor = event.shiftKey ? 10 : event.altKey ? 0.1 : 1;
            this.start(event);
            state._delta = deltaFn(this.config.keyboardDisplacement, factor);
            state._keyboardActive = true;
            (0, $20454ac70e4792f5$export$e7c866399fa523f5).addTo(state._movement, state._delta);
            this.compute(event);
            this.emit();
        }
    }
    keyUp(event) {
        if (!(event.key in $451a082378f3fc88$var$KEYS_DELTA_MAP)) return;
        this.state._keyboardActive = false;
        this.setActive();
        this.compute(event);
        this.emit();
    }
    bind(bindFunction) {
        const device = this.config.device;
        bindFunction(device, "start", this.pointerDown.bind(this));
        if (this.config.pointerCapture) {
            bindFunction(device, "change", this.pointerMove.bind(this));
            bindFunction(device, "end", this.pointerUp.bind(this));
            bindFunction(device, "cancel", this.pointerUp.bind(this));
            bindFunction("lostPointerCapture", "", this.pointerUp.bind(this));
        }
        if (this.config.keys) {
            bindFunction("key", "down", this.keyDown.bind(this));
            bindFunction("key", "up", this.keyUp.bind(this));
        }
        if (this.config.filterTaps) bindFunction("click", "", this.pointerClick.bind(this), {
            capture: true,
            passive: false
        });
    }
    constructor(...args){
        super(...args);
        $451a082378f3fc88$export$407448d2b89b1813(this, "ingKey", "dragging");
    }
}
function $451a082378f3fc88$var$persistEvent(event) {
    "persist" in event && typeof event.persist === "function" && event.persist();
}
const $451a082378f3fc88$var$isBrowser = typeof window !== "undefined" && window.document && window.document.createElement;
function $451a082378f3fc88$var$supportsTouchEvents() {
    return $451a082378f3fc88$var$isBrowser && "ontouchstart" in window;
}
function $451a082378f3fc88$var$isTouchScreen() {
    return $451a082378f3fc88$var$supportsTouchEvents() || $451a082378f3fc88$var$isBrowser && window.navigator.maxTouchPoints > 1;
}
function $451a082378f3fc88$var$supportsPointerEvents() {
    return $451a082378f3fc88$var$isBrowser && "onpointerdown" in window;
}
function $451a082378f3fc88$var$supportsPointerLock() {
    return $451a082378f3fc88$var$isBrowser && "exitPointerLock" in window.document;
}
function $451a082378f3fc88$var$supportsGestureEvents() {
    try {
        return "constructor" in GestureEvent;
    } catch (e) {
        return false;
    }
}
const $451a082378f3fc88$export$25ce5a424b770e84 = {
    isBrowser: $451a082378f3fc88$var$isBrowser,
    gesture: $451a082378f3fc88$var$supportsGestureEvents(),
    touch: $451a082378f3fc88$var$supportsTouchEvents(),
    touchscreen: $451a082378f3fc88$var$isTouchScreen(),
    pointer: $451a082378f3fc88$var$supportsPointerEvents(),
    pointerLock: $451a082378f3fc88$var$supportsPointerLock()
};
const $451a082378f3fc88$var$DEFAULT_PREVENT_SCROLL_DELAY = 250;
const $451a082378f3fc88$var$DEFAULT_DRAG_DELAY = 180;
const $451a082378f3fc88$var$DEFAULT_SWIPE_VELOCITY = 0.5;
const $451a082378f3fc88$var$DEFAULT_SWIPE_DISTANCE = 50;
const $451a082378f3fc88$var$DEFAULT_SWIPE_DURATION = 250;
const $451a082378f3fc88$var$DEFAULT_KEYBOARD_DISPLACEMENT = 10;
const $451a082378f3fc88$var$DEFAULT_DRAG_AXIS_THRESHOLD = {
    mouse: 0,
    touch: 0,
    pen: 8
};
const $451a082378f3fc88$var$dragConfigResolver = $451a082378f3fc88$export$71511d61b312f219($451a082378f3fc88$export$71511d61b312f219({}, $451a082378f3fc88$var$coordinatesConfigResolver), {}, {
    device (_v, _k, { pointer: { touch: touch = false, lock: lock = false, mouse: mouse = false } = {} }) {
        this.pointerLock = lock && $451a082378f3fc88$export$25ce5a424b770e84.pointerLock;
        if ($451a082378f3fc88$export$25ce5a424b770e84.touch && touch) return "touch";
        if (this.pointerLock) return "mouse";
        if ($451a082378f3fc88$export$25ce5a424b770e84.pointer && !mouse) return "pointer";
        if ($451a082378f3fc88$export$25ce5a424b770e84.touch) return "touch";
        return "mouse";
    },
    preventScrollAxis (value, _k, { preventScroll: preventScroll }) {
        this.preventScrollDelay = typeof preventScroll === "number" ? preventScroll : preventScroll || preventScroll === undefined && value ? $451a082378f3fc88$var$DEFAULT_PREVENT_SCROLL_DELAY : undefined;
        if (!$451a082378f3fc88$export$25ce5a424b770e84.touchscreen || preventScroll === false) return undefined;
        return value ? value : preventScroll !== undefined ? "y" : undefined;
    },
    pointerCapture (_v, _k, { pointer: { capture: capture = true, buttons: buttons = 1, keys: keys = true } = {} }) {
        this.pointerButtons = buttons;
        this.keys = keys;
        return !this.pointerLock && this.device === "pointer" && capture;
    },
    threshold (value, _k, { filterTaps: filterTaps = false, tapsThreshold: tapsThreshold = 3, axis: axis }) {
        const threshold = (0, $20454ac70e4792f5$export$e7c866399fa523f5).toVector(value, filterTaps ? tapsThreshold : axis ? 1 : 0);
        this.filterTaps = filterTaps;
        this.tapsThreshold = tapsThreshold;
        return threshold;
    },
    swipe ({ velocity: velocity = $451a082378f3fc88$var$DEFAULT_SWIPE_VELOCITY, distance: distance = $451a082378f3fc88$var$DEFAULT_SWIPE_DISTANCE, duration: duration = $451a082378f3fc88$var$DEFAULT_SWIPE_DURATION } = {}) {
        return {
            velocity: this.transform((0, $20454ac70e4792f5$export$e7c866399fa523f5).toVector(velocity)),
            distance: this.transform((0, $20454ac70e4792f5$export$e7c866399fa523f5).toVector(distance)),
            duration: duration
        };
    },
    delay (value = 0) {
        switch(value){
            case true:
                return $451a082378f3fc88$var$DEFAULT_DRAG_DELAY;
            case false:
                return 0;
            default:
                return value;
        }
    },
    axisThreshold (value) {
        if (!value) return $451a082378f3fc88$var$DEFAULT_DRAG_AXIS_THRESHOLD;
        return $451a082378f3fc88$export$71511d61b312f219($451a082378f3fc88$export$71511d61b312f219({}, $451a082378f3fc88$var$DEFAULT_DRAG_AXIS_THRESHOLD), value);
    },
    keyboardDisplacement (value = $451a082378f3fc88$var$DEFAULT_KEYBOARD_DISPLACEMENT) {
        return value;
    }
});
var $451a082378f3fc88$var$value3, $451a082378f3fc88$var$value4, $451a082378f3fc88$var$value5, $451a082378f3fc88$var$value6, $451a082378f3fc88$var$value7;
function $451a082378f3fc88$var$clampStateInternalMovementToBounds(state) {
    const [ox, oy] = state.overflow;
    const [dx, dy] = state._delta;
    const [dirx, diry] = state._direction;
    if (ox < 0 && dx > 0 && dirx < 0 || ox > 0 && dx < 0 && dirx > 0) state._movement[0] = state._movementBound[0];
    if (oy < 0 && dy > 0 && diry < 0 || oy > 0 && dy < 0 && diry > 0) state._movement[1] = state._movementBound[1];
}
const $451a082378f3fc88$var$SCALE_ANGLE_RATIO_INTENT_DEG = 30;
const $451a082378f3fc88$var$PINCH_WHEEL_RATIO = 100;
class $451a082378f3fc88$var$PinchEngine extends $451a082378f3fc88$var$Engine {
    init() {
        this.state.offset = [
            1,
            0
        ];
        this.state.lastOffset = [
            1,
            0
        ];
        this.state._pointerEvents = new Map();
    }
    reset() {
        super.reset();
        const state = this.state;
        state._touchIds = [];
        state.canceled = false;
        state.cancel = this.cancel.bind(this);
        state.turns = 0;
    }
    computeOffset() {
        const { type: type, movement: movement, lastOffset: lastOffset } = this.state;
        if (type === "wheel") this.state.offset = (0, $20454ac70e4792f5$export$e7c866399fa523f5).add(movement, lastOffset);
        else this.state.offset = [
            (1 + movement[0]) * lastOffset[0],
            movement[1] + lastOffset[1]
        ];
    }
    computeMovement() {
        const { offset: offset, lastOffset: lastOffset } = this.state;
        this.state.movement = [
            offset[0] / lastOffset[0],
            offset[1] - lastOffset[1]
        ];
    }
    axisIntent() {
        const state = this.state;
        const [_m0, _m1] = state._movement;
        if (!state.axis) {
            const axisMovementDifference = Math.abs(_m0) * $451a082378f3fc88$var$SCALE_ANGLE_RATIO_INTENT_DEG - Math.abs(_m1);
            if (axisMovementDifference < 0) state.axis = "angle";
            else if (axisMovementDifference > 0) state.axis = "scale";
        }
    }
    restrictToAxis(v) {
        if (this.config.lockDirection) {
            if (this.state.axis === "scale") v[1] = 0;
            else if (this.state.axis === "angle") v[0] = 0;
        }
    }
    cancel() {
        const state = this.state;
        if (state.canceled) return;
        setTimeout(()=>{
            state.canceled = true;
            state._active = false;
            this.compute();
            this.emit();
        }, 0);
    }
    touchStart(event) {
        this.ctrl.setEventIds(event);
        const state = this.state;
        const ctrlTouchIds = this.ctrl.touchIds;
        if (state._active) {
            if (state._touchIds.every((id)=>ctrlTouchIds.has(id))) return;
        }
        if (ctrlTouchIds.size < 2) return;
        this.start(event);
        state._touchIds = Array.from(ctrlTouchIds).slice(0, 2);
        const payload = $451a082378f3fc88$var$touchDistanceAngle(event, state._touchIds);
        if (!payload) return;
        this.pinchStart(event, payload);
    }
    pointerStart(event) {
        if (event.buttons != null && event.buttons % 2 !== 1) return;
        this.ctrl.setEventIds(event);
        event.target.setPointerCapture(event.pointerId);
        const state = this.state;
        const _pointerEvents = state._pointerEvents;
        const ctrlPointerIds = this.ctrl.pointerIds;
        if (state._active) {
            if (Array.from(_pointerEvents.keys()).every((id)=>ctrlPointerIds.has(id))) return;
        }
        if (_pointerEvents.size < 2) _pointerEvents.set(event.pointerId, event);
        if (state._pointerEvents.size < 2) return;
        this.start(event);
        const payload = $451a082378f3fc88$var$distanceAngle(...Array.from(_pointerEvents.values()));
        if (!payload) return;
        this.pinchStart(event, payload);
    }
    pinchStart(event, payload) {
        const state = this.state;
        state.origin = payload.origin;
        this.computeValues([
            payload.distance,
            payload.angle
        ]);
        this.computeInitial();
        this.compute(event);
        this.emit();
    }
    touchMove(event) {
        if (!this.state._active) return;
        const payload = $451a082378f3fc88$var$touchDistanceAngle(event, this.state._touchIds);
        if (!payload) return;
        this.pinchMove(event, payload);
    }
    pointerMove(event) {
        const _pointerEvents = this.state._pointerEvents;
        if (_pointerEvents.has(event.pointerId)) _pointerEvents.set(event.pointerId, event);
        if (!this.state._active) return;
        const payload = $451a082378f3fc88$var$distanceAngle(...Array.from(_pointerEvents.values()));
        if (!payload) return;
        this.pinchMove(event, payload);
    }
    pinchMove(event, payload) {
        const state = this.state;
        const prev_a = state._values[1];
        const delta_a = payload.angle - prev_a;
        let delta_turns = 0;
        if (Math.abs(delta_a) > 270) delta_turns += Math.sign(delta_a);
        this.computeValues([
            payload.distance,
            payload.angle - 360 * delta_turns
        ]);
        state.origin = payload.origin;
        state.turns = delta_turns;
        state._movement = [
            state._values[0] / state._initial[0] - 1,
            state._values[1] - state._initial[1]
        ];
        this.compute(event);
        this.emit();
    }
    touchEnd(event) {
        this.ctrl.setEventIds(event);
        if (!this.state._active) return;
        if (this.state._touchIds.some((id)=>!this.ctrl.touchIds.has(id))) {
            this.state._active = false;
            this.compute(event);
            this.emit();
        }
    }
    pointerEnd(event) {
        const state = this.state;
        this.ctrl.setEventIds(event);
        try {
            event.target.releasePointerCapture(event.pointerId);
        } catch (_unused) {}
        if (state._pointerEvents.has(event.pointerId)) state._pointerEvents.delete(event.pointerId);
        if (!state._active) return;
        if (state._pointerEvents.size < 2) {
            state._active = false;
            this.compute(event);
            this.emit();
        }
    }
    gestureStart(event) {
        if (event.cancelable) event.preventDefault();
        const state = this.state;
        if (state._active) return;
        this.start(event);
        this.computeValues([
            event.scale,
            event.rotation
        ]);
        state.origin = [
            event.clientX,
            event.clientY
        ];
        this.compute(event);
        this.emit();
    }
    gestureMove(event) {
        if (event.cancelable) event.preventDefault();
        if (!this.state._active) return;
        const state = this.state;
        this.computeValues([
            event.scale,
            event.rotation
        ]);
        state.origin = [
            event.clientX,
            event.clientY
        ];
        const _previousMovement = state._movement;
        state._movement = [
            event.scale - 1,
            event.rotation
        ];
        state._delta = (0, $20454ac70e4792f5$export$e7c866399fa523f5).sub(state._movement, _previousMovement);
        this.compute(event);
        this.emit();
    }
    gestureEnd(event) {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute(event);
        this.emit();
    }
    wheel(event) {
        const modifierKey = this.config.modifierKey;
        if (modifierKey && (Array.isArray(modifierKey) ? !modifierKey.find((k)=>event[k]) : !event[modifierKey])) return;
        if (!this.state._active) this.wheelStart(event);
        else this.wheelChange(event);
        this.timeoutStore.add("wheelEnd", this.wheelEnd.bind(this));
    }
    wheelStart(event) {
        this.start(event);
        this.wheelChange(event);
    }
    wheelChange(event) {
        const isR3f = "uv" in event;
        if (!isR3f) {
            if (event.cancelable) event.preventDefault();
        }
        const state = this.state;
        state._delta = [
            -$451a082378f3fc88$var$wheelValues(event)[1] / $451a082378f3fc88$var$PINCH_WHEEL_RATIO * state.offset[0],
            0
        ];
        (0, $20454ac70e4792f5$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        $451a082378f3fc88$var$clampStateInternalMovementToBounds(state);
        this.state.origin = [
            event.clientX,
            event.clientY
        ];
        this.compute(event);
        this.emit();
    }
    wheelEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        const device = this.config.device;
        if (!!device) {
            bindFunction(device, "start", this[device + "Start"].bind(this));
            bindFunction(device, "change", this[device + "Move"].bind(this));
            bindFunction(device, "end", this[device + "End"].bind(this));
            bindFunction(device, "cancel", this[device + "End"].bind(this));
            bindFunction("lostPointerCapture", "", this[device + "End"].bind(this));
        }
        if (this.config.pinchOnWheel) bindFunction("wheel", "", this.wheel.bind(this), {
            passive: false
        });
    }
    constructor(...args){
        super(...args);
        $451a082378f3fc88$export$407448d2b89b1813(this, "ingKey", "pinching");
        $451a082378f3fc88$export$407448d2b89b1813(this, "aliasKey", "da");
    }
}
const $451a082378f3fc88$var$pinchConfigResolver = $451a082378f3fc88$export$71511d61b312f219($451a082378f3fc88$export$71511d61b312f219({}, $451a082378f3fc88$var$commonConfigResolver), {}, {
    device (_v, _k, { shared: shared, pointer: { touch: touch = false } = {} }) {
        const sharedConfig = shared;
        if (sharedConfig.target && !$451a082378f3fc88$export$25ce5a424b770e84.touch && $451a082378f3fc88$export$25ce5a424b770e84.gesture) return "gesture";
        if ($451a082378f3fc88$export$25ce5a424b770e84.touch && touch) return "touch";
        if ($451a082378f3fc88$export$25ce5a424b770e84.touchscreen) {
            if ($451a082378f3fc88$export$25ce5a424b770e84.pointer) return "pointer";
            if ($451a082378f3fc88$export$25ce5a424b770e84.touch) return "touch";
        }
    },
    bounds (_v, _k, { scaleBounds: scaleBounds = {}, angleBounds: angleBounds = {} }) {
        const _scaleBounds = (state)=>{
            const D = $451a082378f3fc88$var$assignDefault($451a082378f3fc88$var$call(scaleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                D.min,
                D.max
            ];
        };
        const _angleBounds = (state)=>{
            const A = $451a082378f3fc88$var$assignDefault($451a082378f3fc88$var$call(angleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                A.min,
                A.max
            ];
        };
        if (typeof scaleBounds !== "function" && typeof angleBounds !== "function") return [
            _scaleBounds(),
            _angleBounds()
        ];
        return (state)=>[
                _scaleBounds(state),
                _angleBounds(state)
            ];
    },
    threshold (value, _k, config) {
        this.lockDirection = config.axis === "lock";
        const threshold = (0, $20454ac70e4792f5$export$e7c866399fa523f5).toVector(value, this.lockDirection ? [
            0.1,
            3
        ] : 0);
        return threshold;
    },
    modifierKey (value) {
        if (value === undefined) return "ctrlKey";
        return value;
    },
    pinchOnWheel (value = true) {
        return value;
    }
});
class $451a082378f3fc88$var$MoveEngine extends $451a082378f3fc88$var$CoordinatesEngine {
    move(event) {
        if (this.config.mouseOnly && event.pointerType !== "mouse") return;
        if (!this.state._active) this.moveStart(event);
        else this.moveChange(event);
        this.timeoutStore.add("moveEnd", this.moveEnd.bind(this));
    }
    moveStart(event) {
        this.start(event);
        this.computeValues($451a082378f3fc88$var$pointerValues(event));
        this.compute(event);
        this.computeInitial();
        this.emit();
    }
    moveChange(event) {
        if (!this.state._active) return;
        const values = $451a082378f3fc88$var$pointerValues(event);
        const state = this.state;
        state._delta = (0, $20454ac70e4792f5$export$e7c866399fa523f5).sub(values, state._values);
        (0, $20454ac70e4792f5$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.computeValues(values);
        this.compute(event);
        this.emit();
    }
    moveEnd(event) {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute(event);
        this.emit();
    }
    bind(bindFunction) {
        bindFunction("pointer", "change", this.move.bind(this));
        bindFunction("pointer", "leave", this.moveEnd.bind(this));
    }
    constructor(...args){
        super(...args);
        $451a082378f3fc88$export$407448d2b89b1813(this, "ingKey", "moving");
    }
}
const $451a082378f3fc88$var$moveConfigResolver = $451a082378f3fc88$export$71511d61b312f219($451a082378f3fc88$export$71511d61b312f219({}, $451a082378f3fc88$var$coordinatesConfigResolver), {}, {
    mouseOnly: (value = true)=>value
});
class $451a082378f3fc88$var$ScrollEngine extends $451a082378f3fc88$var$CoordinatesEngine {
    scroll(event) {
        if (!this.state._active) this.start(event);
        this.scrollChange(event);
        this.timeoutStore.add("scrollEnd", this.scrollEnd.bind(this));
    }
    scrollChange(event) {
        if (event.cancelable) event.preventDefault();
        const state = this.state;
        const values = $451a082378f3fc88$var$scrollValues(event);
        state._delta = (0, $20454ac70e4792f5$export$e7c866399fa523f5).sub(values, state._values);
        (0, $20454ac70e4792f5$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.computeValues(values);
        this.compute(event);
        this.emit();
    }
    scrollEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        bindFunction("scroll", "", this.scroll.bind(this));
    }
    constructor(...args){
        super(...args);
        $451a082378f3fc88$export$407448d2b89b1813(this, "ingKey", "scrolling");
    }
}
const $451a082378f3fc88$var$scrollConfigResolver = $451a082378f3fc88$var$coordinatesConfigResolver;
class $451a082378f3fc88$var$WheelEngine extends $451a082378f3fc88$var$CoordinatesEngine {
    wheel(event) {
        if (!this.state._active) this.start(event);
        this.wheelChange(event);
        this.timeoutStore.add("wheelEnd", this.wheelEnd.bind(this));
    }
    wheelChange(event) {
        const state = this.state;
        state._delta = $451a082378f3fc88$var$wheelValues(event);
        (0, $20454ac70e4792f5$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        $451a082378f3fc88$var$clampStateInternalMovementToBounds(state);
        this.compute(event);
        this.emit();
    }
    wheelEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        bindFunction("wheel", "", this.wheel.bind(this));
    }
    constructor(...args){
        super(...args);
        $451a082378f3fc88$export$407448d2b89b1813(this, "ingKey", "wheeling");
    }
}
const $451a082378f3fc88$var$wheelConfigResolver = $451a082378f3fc88$var$coordinatesConfigResolver;
class $451a082378f3fc88$var$HoverEngine extends $451a082378f3fc88$var$CoordinatesEngine {
    enter(event) {
        if (this.config.mouseOnly && event.pointerType !== "mouse") return;
        this.start(event);
        this.computeValues($451a082378f3fc88$var$pointerValues(event));
        this.compute(event);
        this.emit();
    }
    leave(event) {
        if (this.config.mouseOnly && event.pointerType !== "mouse") return;
        const state = this.state;
        if (!state._active) return;
        state._active = false;
        const values = $451a082378f3fc88$var$pointerValues(event);
        state._movement = state._delta = (0, $20454ac70e4792f5$export$e7c866399fa523f5).sub(values, state._values);
        this.computeValues(values);
        this.compute(event);
        state.delta = state.movement;
        this.emit();
    }
    bind(bindFunction) {
        bindFunction("pointer", "enter", this.enter.bind(this));
        bindFunction("pointer", "leave", this.leave.bind(this));
    }
    constructor(...args){
        super(...args);
        $451a082378f3fc88$export$407448d2b89b1813(this, "ingKey", "hovering");
    }
}
const $451a082378f3fc88$var$hoverConfigResolver = $451a082378f3fc88$export$71511d61b312f219($451a082378f3fc88$export$71511d61b312f219({}, $451a082378f3fc88$var$coordinatesConfigResolver), {}, {
    mouseOnly: (value = true)=>value
});
const $451a082378f3fc88$export$a9c23c6ac3fc3eca = new Map();
const $451a082378f3fc88$export$e7094788287c5e9b = new Map();
function $451a082378f3fc88$export$43caf9889c228507(action) {
    $451a082378f3fc88$export$a9c23c6ac3fc3eca.set(action.key, action.engine);
    $451a082378f3fc88$export$e7094788287c5e9b.set(action.key, action.resolver);
}
const $451a082378f3fc88$export$f1e1789686576879 = {
    key: "drag",
    engine: $451a082378f3fc88$var$DragEngine,
    resolver: $451a082378f3fc88$var$dragConfigResolver
};
const $451a082378f3fc88$export$dda1d9f60106f0e9 = {
    key: "hover",
    engine: $451a082378f3fc88$var$HoverEngine,
    resolver: $451a082378f3fc88$var$hoverConfigResolver
};
const $451a082378f3fc88$export$953cecd6e717a553 = {
    key: "move",
    engine: $451a082378f3fc88$var$MoveEngine,
    resolver: $451a082378f3fc88$var$moveConfigResolver
};
const $451a082378f3fc88$export$2d1720544b23b823 = {
    key: "pinch",
    engine: $451a082378f3fc88$var$PinchEngine,
    resolver: $451a082378f3fc88$var$pinchConfigResolver
};
const $451a082378f3fc88$export$2408f22a0fab9ae5 = {
    key: "scroll",
    engine: $451a082378f3fc88$var$ScrollEngine,
    resolver: $451a082378f3fc88$var$scrollConfigResolver
};
const $451a082378f3fc88$export$efccba1c4a2ef57b = {
    key: "wheel",
    engine: $451a082378f3fc88$var$WheelEngine,
    resolver: $451a082378f3fc88$var$wheelConfigResolver
};






var $6cds3 = parcelRequire("6cds3");


function $5f1c0a9b6c89f419$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5f1c0a9b6c89f419$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5f1c0a9b6c89f419$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
const $5f1c0a9b6c89f419$var$sharedConfigResolver = {
    target (value) {
        if (value) return ()=>"current" in value ? value.current : value;
        return undefined;
    },
    enabled (value = true) {
        return value;
    },
    window (value = (0, $451a082378f3fc88$export$25ce5a424b770e84).isBrowser ? window : undefined) {
        return value;
    },
    eventOptions ({ passive: passive = true, capture: capture = false } = {}) {
        return {
            passive: passive,
            capture: capture
        };
    },
    transform (value) {
        return value;
    }
};
const $5f1c0a9b6c89f419$var$_excluded = [
    "target",
    "eventOptions",
    "window",
    "enabled",
    "transform"
];
function $5f1c0a9b6c89f419$var$resolveWith(config = {}, resolvers) {
    const result = {};
    for (const [key, resolver] of Object.entries(resolvers))switch(typeof resolver){
        case "function":
            result[key] = resolver.call(result, config[key], key, config);
            break;
        case "object":
            result[key] = $5f1c0a9b6c89f419$var$resolveWith(config[key], resolver);
            break;
        case "boolean":
            if (resolver) result[key] = config[key];
            break;
    }
    return result;
}
function $5f1c0a9b6c89f419$var$parse(newConfig, gestureKey, _config = {}) {
    const _ref = newConfig, { target: target, eventOptions: eventOptions, window: window1, enabled: enabled, transform: transform } = _ref, rest = $5f1c0a9b6c89f419$var$_objectWithoutProperties(_ref, $5f1c0a9b6c89f419$var$_excluded);
    _config.shared = $5f1c0a9b6c89f419$var$resolveWith({
        target: target,
        eventOptions: eventOptions,
        window: window1,
        enabled: enabled,
        transform: transform
    }, $5f1c0a9b6c89f419$var$sharedConfigResolver);
    if (gestureKey) {
        const resolver = (0, $451a082378f3fc88$export$e7094788287c5e9b).get(gestureKey);
        _config[gestureKey] = $5f1c0a9b6c89f419$var$resolveWith((0, $451a082378f3fc88$export$71511d61b312f219)({
            shared: _config.shared
        }, rest), resolver);
    } else for(const key in rest){
        const resolver = (0, $451a082378f3fc88$export$e7094788287c5e9b).get(key);
        if (resolver) _config[key] = $5f1c0a9b6c89f419$var$resolveWith((0, $451a082378f3fc88$export$71511d61b312f219)({
            shared: _config.shared
        }, rest[key]), resolver);
    }
    return _config;
}
class $5f1c0a9b6c89f419$var$EventStore {
    add(element, device, action, handler, options) {
        const listeners = this._listeners;
        const type = (0, $451a082378f3fc88$export$625550452a3fa3ec)(device, action);
        const _options = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {};
        const eventOptions = (0, $451a082378f3fc88$export$71511d61b312f219)((0, $451a082378f3fc88$export$71511d61b312f219)({}, _options), options);
        element.addEventListener(type, handler, eventOptions);
        const remove = ()=>{
            element.removeEventListener(type, handler, eventOptions);
            listeners.delete(remove);
        };
        listeners.add(remove);
        return remove;
    }
    clean() {
        this._listeners.forEach((remove)=>remove());
        this._listeners.clear();
    }
    constructor(ctrl, gestureKey){
        (0, $451a082378f3fc88$export$407448d2b89b1813)(this, "_listeners", new Set());
        this._ctrl = ctrl;
        this._gestureKey = gestureKey;
    }
}
class $5f1c0a9b6c89f419$var$TimeoutStore {
    add(key, callback, ms = 140, ...args) {
        this.remove(key);
        this._timeouts.set(key, window.setTimeout(callback, ms, ...args));
    }
    remove(key) {
        const timeout = this._timeouts.get(key);
        if (timeout) window.clearTimeout(timeout);
    }
    clean() {
        this._timeouts.forEach((timeout)=>void window.clearTimeout(timeout));
        this._timeouts.clear();
    }
    constructor(){
        (0, $451a082378f3fc88$export$407448d2b89b1813)(this, "_timeouts", new Map());
    }
}
class $5f1c0a9b6c89f419$export$bd0bf19f25da8474 {
    setEventIds(event) {
        if ((0, $451a082378f3fc88$export$23f2a1d2818174ef)(event)) {
            this.touchIds = new Set((0, $451a082378f3fc88$export$8b22cf2602fb60ce)(event));
            return this.touchIds;
        } else if ("pointerId" in event) {
            if (event.type === "pointerup" || event.type === "pointercancel") this.pointerIds.delete(event.pointerId);
            else if (event.type === "pointerdown") this.pointerIds.add(event.pointerId);
            return this.pointerIds;
        }
    }
    applyHandlers(handlers, nativeHandlers) {
        this.handlers = handlers;
        this.nativeHandlers = nativeHandlers;
    }
    applyConfig(config, gestureKey) {
        this.config = $5f1c0a9b6c89f419$var$parse(config, gestureKey, this.config);
    }
    clean() {
        this._targetEventStore.clean();
        for (const key of this.gestures){
            this.gestureEventStores[key].clean();
            this.gestureTimeoutStores[key].clean();
        }
    }
    effect() {
        if (this.config.shared.target) this.bind();
        return ()=>this._targetEventStore.clean();
    }
    bind(...args) {
        const sharedConfig = this.config.shared;
        const props = {};
        let target;
        if (sharedConfig.target) {
            target = sharedConfig.target();
            if (!target) return;
        }
        if (sharedConfig.enabled) {
            for (const gestureKey of this.gestures){
                const gestureConfig = this.config[gestureKey];
                const bindFunction = $5f1c0a9b6c89f419$var$bindToProps(props, gestureConfig.eventOptions, !!target);
                if (gestureConfig.enabled) {
                    const Engine = (0, $451a082378f3fc88$export$a9c23c6ac3fc3eca).get(gestureKey);
                    new Engine(this, args, gestureKey).bind(bindFunction);
                }
            }
            const nativeBindFunction = $5f1c0a9b6c89f419$var$bindToProps(props, sharedConfig.eventOptions, !!target);
            for(const eventKey in this.nativeHandlers)nativeBindFunction(eventKey, "", (event)=>this.nativeHandlers[eventKey]((0, $451a082378f3fc88$export$71511d61b312f219)((0, $451a082378f3fc88$export$71511d61b312f219)({}, this.state.shared), {}, {
                    event: event,
                    args: args
                })), undefined, true);
        }
        for(const handlerProp in props)props[handlerProp] = (0, $451a082378f3fc88$export$db3b6bfb95261072)(...props[handlerProp]);
        if (!target) return props;
        for(const handlerProp in props){
            const { device: device, capture: capture, passive: passive } = (0, $451a082378f3fc88$export$ffb5f4729a158638)(handlerProp);
            this._targetEventStore.add(target, device, "", props[handlerProp], {
                capture: capture,
                passive: passive
            });
        }
    }
    constructor(handlers){
        (0, $451a082378f3fc88$export$407448d2b89b1813)(this, "gestures", new Set());
        (0, $451a082378f3fc88$export$407448d2b89b1813)(this, "_targetEventStore", new $5f1c0a9b6c89f419$var$EventStore(this));
        (0, $451a082378f3fc88$export$407448d2b89b1813)(this, "gestureEventStores", {});
        (0, $451a082378f3fc88$export$407448d2b89b1813)(this, "gestureTimeoutStores", {});
        (0, $451a082378f3fc88$export$407448d2b89b1813)(this, "handlers", {});
        (0, $451a082378f3fc88$export$407448d2b89b1813)(this, "config", {});
        (0, $451a082378f3fc88$export$407448d2b89b1813)(this, "pointerIds", new Set());
        (0, $451a082378f3fc88$export$407448d2b89b1813)(this, "touchIds", new Set());
        (0, $451a082378f3fc88$export$407448d2b89b1813)(this, "state", {
            shared: {
                shiftKey: false,
                metaKey: false,
                ctrlKey: false,
                altKey: false
            }
        });
        $5f1c0a9b6c89f419$var$resolveGestures(this, handlers);
    }
}
function $5f1c0a9b6c89f419$var$setupGesture(ctrl, gestureKey) {
    ctrl.gestures.add(gestureKey);
    ctrl.gestureEventStores[gestureKey] = new $5f1c0a9b6c89f419$var$EventStore(ctrl, gestureKey);
    ctrl.gestureTimeoutStores[gestureKey] = new $5f1c0a9b6c89f419$var$TimeoutStore();
}
function $5f1c0a9b6c89f419$var$resolveGestures(ctrl, internalHandlers) {
    if (internalHandlers.drag) $5f1c0a9b6c89f419$var$setupGesture(ctrl, "drag");
    if (internalHandlers.wheel) $5f1c0a9b6c89f419$var$setupGesture(ctrl, "wheel");
    if (internalHandlers.scroll) $5f1c0a9b6c89f419$var$setupGesture(ctrl, "scroll");
    if (internalHandlers.move) $5f1c0a9b6c89f419$var$setupGesture(ctrl, "move");
    if (internalHandlers.pinch) $5f1c0a9b6c89f419$var$setupGesture(ctrl, "pinch");
    if (internalHandlers.hover) $5f1c0a9b6c89f419$var$setupGesture(ctrl, "hover");
}
const $5f1c0a9b6c89f419$var$bindToProps = (props, eventOptions, withPassiveOption)=>(device, action, handler, options = {}, isNative = false)=>{
        var _options$capture, _options$passive;
        const capture = (_options$capture = options.capture) !== null && _options$capture !== void 0 ? _options$capture : eventOptions.capture;
        const passive = (_options$passive = options.passive) !== null && _options$passive !== void 0 ? _options$passive : eventOptions.passive;
        let handlerProp = isNative ? device : (0, $451a082378f3fc88$export$4368d992c4eafac0)(device, action, capture);
        if (withPassiveOption && passive) handlerProp += "Passive";
        props[handlerProp] = props[handlerProp] || [];
        props[handlerProp].push(handler);
    };
const $5f1c0a9b6c89f419$var$RE_NOT_NATIVE = /^on(Drag|Wheel|Scroll|Move|Pinch|Hover)/;
function $5f1c0a9b6c89f419$var$sortHandlers(_handlers) {
    const native = {};
    const handlers = {};
    const actions = new Set();
    for(let key in _handlers)if ($5f1c0a9b6c89f419$var$RE_NOT_NATIVE.test(key)) {
        actions.add(RegExp.lastMatch);
        handlers[key] = _handlers[key];
    } else native[key] = _handlers[key];
    return [
        handlers,
        native,
        actions
    ];
}
function $5f1c0a9b6c89f419$var$registerGesture(actions, handlers, handlerKey, key, internalHandlers, config) {
    if (!actions.has(handlerKey)) return;
    if (!(0, $451a082378f3fc88$export$a9c23c6ac3fc3eca).has(key)) return;
    const startKey = handlerKey + "Start";
    const endKey = handlerKey + "End";
    const fn = (state)=>{
        let memo = undefined;
        if (state.first && startKey in handlers) handlers[startKey](state);
        if (handlerKey in handlers) memo = handlers[handlerKey](state);
        if (state.last && endKey in handlers) handlers[endKey](state);
        return memo;
    };
    internalHandlers[key] = fn;
    config[key] = config[key] || {};
}
function $5f1c0a9b6c89f419$export$c14d3c7045c4485d(mergedHandlers, mergedConfig) {
    const [handlers, nativeHandlers, actions] = $5f1c0a9b6c89f419$var$sortHandlers(mergedHandlers);
    const internalHandlers = {};
    $5f1c0a9b6c89f419$var$registerGesture(actions, handlers, "onDrag", "drag", internalHandlers, mergedConfig);
    $5f1c0a9b6c89f419$var$registerGesture(actions, handlers, "onWheel", "wheel", internalHandlers, mergedConfig);
    $5f1c0a9b6c89f419$var$registerGesture(actions, handlers, "onScroll", "scroll", internalHandlers, mergedConfig);
    $5f1c0a9b6c89f419$var$registerGesture(actions, handlers, "onPinch", "pinch", internalHandlers, mergedConfig);
    $5f1c0a9b6c89f419$var$registerGesture(actions, handlers, "onMove", "move", internalHandlers, mergedConfig);
    $5f1c0a9b6c89f419$var$registerGesture(actions, handlers, "onHover", "hover", internalHandlers, mergedConfig);
    return {
        handlers: internalHandlers,
        config: mergedConfig,
        nativeHandlers: nativeHandlers
    };
}







function $160140048d0d318d$var$useRecognizers(handlers, config = {}, gestureKey, nativeHandlers) {
    const ctrl = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useMemo(()=>new (0, $5f1c0a9b6c89f419$export$bd0bf19f25da8474)(handlers), []);
    ctrl.applyHandlers(handlers, nativeHandlers);
    ctrl.applyConfig(config, gestureKey);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(ctrl.effect.bind(ctrl));
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        return ctrl.clean.bind(ctrl);
    }, []);
    if (config.target === undefined) return ctrl.bind.bind(ctrl);
    return undefined;
}
function $160140048d0d318d$export$7941f8aafa4b6021(handler, config) {
    (0, $451a082378f3fc88$export$43caf9889c228507)((0, $451a082378f3fc88$export$f1e1789686576879));
    return $160140048d0d318d$var$useRecognizers({
        drag: handler
    }, config || {}, "drag");
}
function $160140048d0d318d$export$ccc26886ea7dba8f(handler, config) {
    (0, $451a082378f3fc88$export$43caf9889c228507)((0, $451a082378f3fc88$export$2d1720544b23b823));
    return $160140048d0d318d$var$useRecognizers({
        pinch: handler
    }, config || {}, "pinch");
}
function $160140048d0d318d$export$43260e1b277d5f62(handler, config) {
    (0, $451a082378f3fc88$export$43caf9889c228507)((0, $451a082378f3fc88$export$efccba1c4a2ef57b));
    return $160140048d0d318d$var$useRecognizers({
        wheel: handler
    }, config || {}, "wheel");
}
function $160140048d0d318d$export$d928051c8cd740b(handler, config) {
    (0, $451a082378f3fc88$export$43caf9889c228507)((0, $451a082378f3fc88$export$2408f22a0fab9ae5));
    return $160140048d0d318d$var$useRecognizers({
        scroll: handler
    }, config || {}, "scroll");
}
function $160140048d0d318d$export$36da96379f79f245(handler, config) {
    (0, $451a082378f3fc88$export$43caf9889c228507)((0, $451a082378f3fc88$export$953cecd6e717a553));
    return $160140048d0d318d$var$useRecognizers({
        move: handler
    }, config || {}, "move");
}
function $160140048d0d318d$export$ae780daf29e6d456(handler, config) {
    (0, $451a082378f3fc88$export$43caf9889c228507)((0, $451a082378f3fc88$export$dda1d9f60106f0e9));
    return $160140048d0d318d$var$useRecognizers({
        hover: handler
    }, config || {}, "hover");
}
function $160140048d0d318d$export$ee99e1f7df2b9180(actions) {
    actions.forEach((0, $451a082378f3fc88$export$43caf9889c228507));
    return function useGesture(_handlers, _config) {
        const { handlers: handlers, nativeHandlers: nativeHandlers, config: config } = (0, $5f1c0a9b6c89f419$export$c14d3c7045c4485d)(_handlers, _config || {});
        return $160140048d0d318d$var$useRecognizers(handlers, config, undefined, nativeHandlers);
    };
}
function $160140048d0d318d$export$ece84446a783717(handlers, config) {
    const hook = $160140048d0d318d$export$ee99e1f7df2b9180([
        (0, $451a082378f3fc88$export$f1e1789686576879),
        (0, $451a082378f3fc88$export$2d1720544b23b823),
        (0, $451a082378f3fc88$export$2408f22a0fab9ae5),
        (0, $451a082378f3fc88$export$efccba1c4a2ef57b),
        (0, $451a082378f3fc88$export$953cecd6e717a553),
        (0, $451a082378f3fc88$export$dda1d9f60106f0e9)
    ]);
    return hook(handlers, config || {});
}


var $6d85277821bd819c$exports = {};

$parcel$export($6d85277821bd819c$exports, "aboutButton", function () { return $6d85277821bd819c$export$4e1cad6b92b3bf0c; }, function (v) { return $6d85277821bd819c$export$4e1cad6b92b3bf0c = v; });
$parcel$export($6d85277821bd819c$exports, "buttonContainer", function () { return $6d85277821bd819c$export$dc57ddd528b7443f; }, function (v) { return $6d85277821bd819c$export$dc57ddd528b7443f = v; });
$parcel$export($6d85277821bd819c$exports, "container", function () { return $6d85277821bd819c$export$34e0f9847d4c02dd; }, function (v) { return $6d85277821bd819c$export$34e0f9847d4c02dd = v; });
$parcel$export($6d85277821bd819c$exports, "contentContainer", function () { return $6d85277821bd819c$export$8f981dffec84ba52; }, function (v) { return $6d85277821bd819c$export$8f981dffec84ba52 = v; });
$parcel$export($6d85277821bd819c$exports, "cvLink", function () { return $6d85277821bd819c$export$dbdc478824424900; }, function (v) { return $6d85277821bd819c$export$dbdc478824424900 = v; });
$parcel$export($6d85277821bd819c$exports, "decorIcons", function () { return $6d85277821bd819c$export$2407fcea42672f87; }, function (v) { return $6d85277821bd819c$export$2407fcea42672f87 = v; });
$parcel$export($6d85277821bd819c$exports, "description", function () { return $6d85277821bd819c$export$6d59db4903f20f7d; }, function (v) { return $6d85277821bd819c$export$6d59db4903f20f7d = v; });
$parcel$export($6d85277821bd819c$exports, "headerContainer", function () { return $6d85277821bd819c$export$e052384d4071fee2; }, function (v) { return $6d85277821bd819c$export$e052384d4071fee2 = v; });
$parcel$export($6d85277821bd819c$exports, "hiddenElement", function () { return $6d85277821bd819c$export$83c59592758c984d; }, function (v) { return $6d85277821bd819c$export$83c59592758c984d = v; });
$parcel$export($6d85277821bd819c$exports, "hiddenHeader", function () { return $6d85277821bd819c$export$a1b4d186c73cbe25; }, function (v) { return $6d85277821bd819c$export$a1b4d186c73cbe25 = v; });
$parcel$export($6d85277821bd819c$exports, "icon", function () { return $6d85277821bd819c$export$1ca1ec8b29a4ce27; }, function (v) { return $6d85277821bd819c$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($6d85277821bd819c$exports, "iconContainer", function () { return $6d85277821bd819c$export$acf4eaf431084f78; }, function (v) { return $6d85277821bd819c$export$acf4eaf431084f78 = v; });
$parcel$export($6d85277821bd819c$exports, "logoContainer", function () { return $6d85277821bd819c$export$a1fe6a2d7788354f; }, function (v) { return $6d85277821bd819c$export$a1fe6a2d7788354f = v; });
$parcel$export($6d85277821bd819c$exports, "name", function () { return $6d85277821bd819c$export$a8ff84c12d48cfa6; }, function (v) { return $6d85277821bd819c$export$a8ff84c12d48cfa6 = v; });
$parcel$export($6d85277821bd819c$exports, "nameContainer", function () { return $6d85277821bd819c$export$3b9d909fcd39d8ae; }, function (v) { return $6d85277821bd819c$export$3b9d909fcd39d8ae = v; });
$parcel$export($6d85277821bd819c$exports, "socialLink", function () { return $6d85277821bd819c$export$73c6ff44a127ab67; }, function (v) { return $6d85277821bd819c$export$73c6ff44a127ab67 = v; });
$parcel$export($6d85277821bd819c$exports, "textBlock", function () { return $6d85277821bd819c$export$ba7ca0e7f111fc0b; }, function (v) { return $6d85277821bd819c$export$ba7ca0e7f111fc0b = v; });
$parcel$export($6d85277821bd819c$exports, "works", function () { return $6d85277821bd819c$export$523f2c8870ae8f82; }, function (v) { return $6d85277821bd819c$export$523f2c8870ae8f82 = v; });
$parcel$export($6d85277821bd819c$exports, "worksContainer", function () { return $6d85277821bd819c$export$4f32aac682c6a61b; }, function (v) { return $6d85277821bd819c$export$4f32aac682c6a61b = v; });
var $6d85277821bd819c$export$4e1cad6b92b3bf0c;
var $6d85277821bd819c$export$dc57ddd528b7443f;
var $6d85277821bd819c$export$34e0f9847d4c02dd;
var $6d85277821bd819c$export$8f981dffec84ba52;
var $6d85277821bd819c$export$dbdc478824424900;
var $6d85277821bd819c$export$2407fcea42672f87;
var $6d85277821bd819c$export$6d59db4903f20f7d;
var $6d85277821bd819c$export$e052384d4071fee2;
var $6d85277821bd819c$export$83c59592758c984d;
var $6d85277821bd819c$export$a1b4d186c73cbe25;
var $6d85277821bd819c$export$1ca1ec8b29a4ce27;
var $6d85277821bd819c$export$acf4eaf431084f78;
var $6d85277821bd819c$export$a1fe6a2d7788354f;
var $6d85277821bd819c$export$a8ff84c12d48cfa6;
var $6d85277821bd819c$export$3b9d909fcd39d8ae;
var $6d85277821bd819c$export$73c6ff44a127ab67;
var $6d85277821bd819c$export$ba7ca0e7f111fc0b;
var $6d85277821bd819c$export$523f2c8870ae8f82;
var $6d85277821bd819c$export$4f32aac682c6a61b;
$6d85277821bd819c$export$4e1cad6b92b3bf0c = `P30aKa_aboutButton`;
$6d85277821bd819c$export$dc57ddd528b7443f = `P30aKa_buttonContainer`;
$6d85277821bd819c$export$34e0f9847d4c02dd = `P30aKa_container`;
$6d85277821bd819c$export$8f981dffec84ba52 = `P30aKa_contentContainer`;
$6d85277821bd819c$export$dbdc478824424900 = `P30aKa_cvLink`;
$6d85277821bd819c$export$2407fcea42672f87 = `P30aKa_decorIcons`;
$6d85277821bd819c$export$6d59db4903f20f7d = `P30aKa_description`;
$6d85277821bd819c$export$e052384d4071fee2 = `P30aKa_headerContainer`;
$6d85277821bd819c$export$83c59592758c984d = `P30aKa_hiddenElement`;
$6d85277821bd819c$export$a1b4d186c73cbe25 = `P30aKa_hiddenHeader`;
$6d85277821bd819c$export$1ca1ec8b29a4ce27 = `P30aKa_icon`;
$6d85277821bd819c$export$acf4eaf431084f78 = `P30aKa_iconContainer`;
$6d85277821bd819c$export$a1fe6a2d7788354f = `P30aKa_logoContainer`;
$6d85277821bd819c$export$a8ff84c12d48cfa6 = `P30aKa_name`;
$6d85277821bd819c$export$3b9d909fcd39d8ae = `P30aKa_nameContainer`;
$6d85277821bd819c$export$73c6ff44a127ab67 = `P30aKa_socialLink`;
$6d85277821bd819c$export$ba7ca0e7f111fc0b = `P30aKa_textBlock`;
$6d85277821bd819c$export$523f2c8870ae8f82 = `P30aKa_works`;
$6d85277821bd819c$export$4f32aac682c6a61b = `P30aKa_worksContainer`;


// modules

parcelRequire("6cds3");
// social
// modules

parcelRequire("6cds3");
const $e59883fe3c0830cf$var$LinkedIn = (props)=>{
    const { width: width, height: height, color: color, className: className, onCLick: onCLick } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        onClick: onCLick,
        viewBox: "0 0 56 54",
        className: className,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            fill: color,
            d: "M55.61 32.944v20.334H43.822V34.306c0-4.766-1.705-8.019-5.972-8.019-3.258 0-5.196 2.192-6.049 4.313-.31.758-.391 1.813-.391 2.874v19.804H19.618s.159-32.132 0-35.462H31.41v5.027c-.024.038-.055.078-.077.114h.077v-.114c1.567-2.413 4.365-5.86 10.627-5.86 7.758 0 13.574 5.069 13.574 15.96v.001zM7.283.722C3.249.722.61 3.368.61 6.848c0 3.404 2.562 6.13 6.516 6.13h.079c4.112 0 6.67-2.726 6.67-6.13-.078-3.48-2.558-6.126-6.592-6.126zM1.31 53.278h11.788V17.816H1.31v35.462z"
        })
    });
};
var $e59883fe3c0830cf$export$2e2bcd8739ae039 = $e59883fe3c0830cf$var$LinkedIn;
$e59883fe3c0830cf$var$LinkedIn.defaultProps = {
    width: 58,
    height: 56,
    color: "#B0B2C3"
};


// modules

parcelRequire("6cds3");
const $83c7069cb3e05d16$var$GitHub = (props)=>{
    const { width: width, height: height, className: className } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 56 56",
        className: className,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                clipPath: "url(#clip0_8_72)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    fill: "#B0B2C3",
                    d: "M51.92 14.869c-2.458-4.213-5.794-7.55-10.007-10.008-4.214-2.459-8.814-3.688-13.804-3.688-4.989 0-9.59 1.23-13.803 3.688-4.213 2.459-7.549 5.795-10.008 10.008C1.84 19.082.61 23.683.61 28.672c0 5.992 1.748 11.38 5.246 16.166 3.497 4.786 8.014 8.098 13.552 9.936.645.12 1.122.036 1.432-.25a1.4 1.4 0 00.466-1.074l-.018-1.933c-.013-1.218-.018-2.28-.018-3.187l-.824.143c-.525.096-1.188.137-1.987.125-.8-.01-1.63-.095-2.489-.25a5.558 5.558 0 01-2.399-1.074 4.543 4.543 0 01-1.575-2.202l-.358-.824c-.239-.548-.615-1.157-1.128-1.825-.513-.669-1.032-1.122-1.558-1.36l-.25-.18a2.634 2.634 0 01-.465-.43 1.963 1.963 0 01-.323-.502c-.071-.167-.012-.304.18-.412.19-.108.536-.16 1.038-.16l.716.107c.477.096 1.068.381 1.772.859a5.78 5.78 0 011.737 1.861c.549.98 1.21 1.725 1.987 2.239.775.513 1.558.77 2.345.77.788 0 1.468-.06 2.041-.18a7.112 7.112 0 001.611-.536c.215-1.6.8-2.83 1.755-3.689-1.36-.143-2.584-.358-3.67-.644-1.086-.287-2.208-.752-3.366-1.397s-2.119-1.445-2.883-2.4c-.763-.954-1.39-2.208-1.88-3.76-.488-1.55-.733-3.341-.733-5.37 0-2.889.943-5.347 2.829-7.376-.884-2.172-.8-4.607.25-7.304.693-.216 1.72-.054 3.08.483s2.357.997 2.99 1.379c.632.38 1.14.704 1.521.966 2.221-.62 4.512-.93 6.876-.93 2.363 0 4.654.31 6.875.93l1.36-.859c.931-.573 2.03-1.098 3.294-1.575 1.266-.478 2.233-.61 2.902-.394 1.073 2.697 1.17 5.132.286 7.304 1.885 2.03 2.829 4.488 2.829 7.376 0 2.03-.246 3.825-.734 5.389-.49 1.564-1.122 2.816-1.897 3.76-.777.943-1.743 1.737-2.901 2.38-1.158.645-2.28 1.11-3.366 1.397-1.087.287-2.31.502-3.67.646 1.24 1.074 1.861 2.769 1.861 5.084v7.554c0 .43.15.788.448 1.074.299.286.77.37 1.414.25 5.539-1.837 10.056-5.15 13.553-9.936 3.497-4.785 5.246-10.174 5.246-16.166-.001-4.988-1.231-9.589-3.689-13.802z"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                    id: "clip0_8_72",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H55V55H0z",
                        transform: "translate(.61 .5)"
                    })
                })
            })
        ]
    });
};
var $83c7069cb3e05d16$export$2e2bcd8739ae039 = $83c7069cb3e05d16$var$GitHub;
$83c7069cb3e05d16$var$GitHub.defaultProps = {
    width: 58,
    height: 58
};


// modules

parcelRequire("6cds3");
const $12772571040e4136$var$GitLab = (props)=>{
    const { width: width, height: height, className: className, color: color } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 1024 1024",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            fill: color,
            d: "M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z"
        })
    });
};
var $12772571040e4136$export$2e2bcd8739ae039 = $12772571040e4136$var$GitLab;
$12772571040e4136$var$GitLab.defaultProps = {
    width: 60,
    height: 60,
    color: "#B0B2C3"
};


// modules

parcelRequire("6cds3");
const $dd858a5e38ab6616$var$Telegram = (props)=>{
    const { width: width, height: height, className: className, color: color } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        className: className,
        version: "1.1",
        viewBox: "0 0 189.473 189.473",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            fill: color,
            d: "M152.531 179.476c-1.48 0-2.95-.438-4.211-1.293l-47.641-32.316-25.552 18.386a7.502 7.502 0 01-11.633-4.174l-12.83-48.622L4.821 93.928a7.501 7.501 0 01-.094-13.975l174.312-69.36a7.503 7.503 0 0110.282 8.408L159.898 173.38a7.499 7.499 0 01-7.367 6.096zm-47.669-48.897l42.437 28.785L170.193 39.24l-82.687 79.566 17.156 11.638c.069.043.135.089.2.135zm-35.327-6.401l5.682 21.53 12.242-8.809-16.03-10.874a7.478 7.478 0 01-1.894-1.847zM28.136 86.782l31.478 12.035a7.5 7.5 0 014.573 5.092l3.992 15.129a7.504 7.504 0 012.259-4.624L149.227 38.6 28.136 86.782z"
        })
    });
};
var $dd858a5e38ab6616$export$2e2bcd8739ae039 = $dd858a5e38ab6616$var$Telegram;
$dd858a5e38ab6616$var$Telegram.defaultProps = {
    width: 50,
    height: 50,
    color: "#B0B2C3"
};


// modules

parcelRequire("6cds3");
const $8ff8432e5adf1d5e$var$Gmail = (props)=>{
    const { width: width, height: height, className: className, color: color, onClick: onClick } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        className: className,
        version: "1.1",
        viewBox: "0 0 21.51 21.51",
        xmlSpace: "preserve",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            fill: color,
            d: "M0 2.963v15.584h21.51V2.963H0zm15.722.548l-4.969 4.966-5.547-4.966h10.516zM2.912 5.993l5.992 5.19-5.992 4.589V5.993zm15.685 12.04H2.912v-1.41l6.403-4.926 1.438 1.438 1.507-1.438 6.337 4.926v1.41zm0-2.261l-5.822-4.725 5.822-5.755v10.48z"
        })
    });
};
var $8ff8432e5adf1d5e$export$2e2bcd8739ae039 = $8ff8432e5adf1d5e$var$Gmail;
$8ff8432e5adf1d5e$var$Gmail.defaultProps = {
    width: 60,
    height: 60,
    color: "#B0B2C3"
};


// modules

parcelRequire("6cds3");
const $b072f8ca25588567$var$JsIcon = (props)=>{
    const { width: width, height: height, color: color, className: className } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        className: className,
        height: height,
        viewBox: "0 0 48 48",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: color,
                d: "M6 42V6h36v36H6z"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: "white",
                d: "M29.538 32.947c.692 1.124 1.444 2.201 3.037 2.201 1.338 0 2.04-.665 2.04-1.585 0-1.101-.726-1.492-2.198-2.133l-.807-.344c-2.329-.988-3.878-2.226-3.878-4.841 0-2.41 1.845-4.244 4.728-4.244 2.053 0 3.528.711 4.592 2.573l-2.514 1.607c-.553-.988-1.151-1.377-2.078-1.377-.946 0-1.545.597-1.545 1.377 0 .964.6 1.354 1.985 1.951l.807.344C36.452 29.645 38 30.839 38 33.523 38 36.415 35.716 38 32.65 38c-2.999 0-4.702-1.505-5.65-3.368l2.538-1.685zm-11.586.082c.506.906 1.275 1.603 2.381 1.603 1.058 0 1.667-.418 1.667-2.043V22h3.333v11.101c0 3.367-1.953 4.899-4.805 4.899-2.577 0-4.437-1.746-5.195-3.368l2.619-1.603z"
            })
        ]
    });
};
var $b072f8ca25588567$export$2e2bcd8739ae039 = $b072f8ca25588567$var$JsIcon;
$b072f8ca25588567$var$JsIcon.defaultProps = {
    width: 64,
    height: 64,
    color: "#ffd600"
};


// modules

parcelRequire("6cds3");
const $4f90229c6fd0f911$var$TsIcon = (props)=>{
    const { width: width, height: height, className: className, color: color } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 48 48",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: color,
                d: "M6 6H42V42H6z"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: "#fff",
                d: "M27.49 22L14.227 22 14.227 25.264 18.984 25.264 18.984 40 22.753 40 22.753 25.264 27.49 25.264z"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: "#fff",
                d: "M39.194 26.084s-1.787-1.192-3.807-1.192-2.747.96-2.747 1.986c0 2.648 7.381 2.383 7.381 7.712 0 8.209-11.254 4.568-11.254 4.568V35.22s2.152 1.622 4.733 1.622 2.483-1.688 2.483-1.92c0-2.449-7.315-2.449-7.315-7.878 0-7.381 10.658-4.469 10.658-4.469l-.132 3.509z"
            })
        ]
    });
};
var $4f90229c6fd0f911$export$2e2bcd8739ae039 = $4f90229c6fd0f911$var$TsIcon;
$4f90229c6fd0f911$var$TsIcon.defaultProps = {
    width: 64,
    height: 64,
    color: "#1976d2"
};


// modules

parcelRequire("6cds3");
const $0c1061e411609f9e$var$ReactIcon = (props)=>{
    const { width: width, height: height, className: className, color: color } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 80 80",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: color,
                d: "M46.5 40c0 3.593-2.907 6.5-6.5 6.5s-6.5-2.907-6.5-6.5 2.907-6.5 6.5-6.5 6.5 2.907 6.5 6.5z"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: color,
                d: "M40 47c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7zm0-13c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6z"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: color,
                d: "M24.474 75.503c-1.711 0-3.269-.392-4.632-1.164-2.28-1.293-3.856-3.521-4.686-6.62-.965-3.607-.85-8.398.332-13.878C5.956 50.562.5 45.531.5 40c0-5.532 5.455-10.562 14.987-13.84-1.182-5.481-1.298-10.272-.333-13.879.83-3.1 2.406-5.328 4.685-6.62 1.362-.772 2.921-1.164 4.632-1.164 4.388 0 9.891 2.73 15.531 7.698 5.64-4.963 11.141-7.691 15.524-7.691 1.711 0 3.269.392 4.632 1.164 2.277 1.291 3.854 3.515 4.684 6.611.966 3.606.85 8.398-.333 13.88C74.043 29.437 79.5 34.468 79.5 40s-5.457 10.563-14.991 13.842c1.182 5.481 1.298 10.272.332 13.878-.83 3.097-2.405 5.321-4.68 6.612-1.364.772-2.923 1.164-4.633 1.164-4.386 0-9.889-2.728-15.527-7.689-5.64 4.967-11.142 7.696-15.527 7.696zm-5.137-20.497c-.991 4.717-1.102 8.747-.316 11.679.542 2.026 1.481 3.431 2.794 4.175.753.427 1.648.644 2.659.644 3.394 0 7.862-2.282 12.621-6.437-2.385-2.402-4.713-5.121-6.928-8.091-3.831-.416-7.471-1.078-10.83-1.97zm23.569 10.059c4.758 4.151 9.227 6.431 12.621 6.432 1.011 0 1.906-.217 2.661-.644 1.309-.742 2.246-2.144 2.787-4.167.786-2.934.676-6.963-.315-11.679-3.362.892-7.003 1.554-10.833 1.97-2.214 2.97-4.539 5.688-6.921 8.088zm-7.34-7.672A69.158 69.158 0 0040 62.333a69.42 69.42 0 004.43-4.94A93.401 93.401 0 0140 57.5a93.6 93.6 0 01-4.434-.107zm-3.217-4.214A90.32 90.32 0 0040 53.5c2.585 0 5.155-.108 7.646-.32a88.988 88.988 0 004.214-6.495 86.718 86.718 0 003.547-6.686 86.61 86.61 0 00-3.546-6.684 88.83 88.83 0 00-4.215-6.495A90.446 90.446 0 0040 26.5c-2.588 0-5.159.108-7.647.321a86.61 86.61 0 00-7.765 13.181 86.991 86.991 0 007.761 13.177zm25.142-8.4a91.579 91.579 0 01-4.571 7.77 65.033 65.033 0 006.771-1.4 68.338 68.338 0 00-2.2-6.37zm-37.187 6.369a65.451 65.451 0 006.768 1.4 92.582 92.582 0 01-2.386-3.835 91.92 91.92 0 01-2.183-3.931 68.787 68.787 0 00-2.199 6.366zM59.816 40c1.528 3.391 2.773 6.743 3.708 9.977C70.926 47.373 75.5 43.574 75.5 40s-4.574-7.373-11.976-9.977c-.933 3.234-2.179 6.586-3.708 9.977zm-43.344-9.975C9.073 32.628 4.5 36.427 4.5 40c0 3.574 4.573 7.373 11.974 9.976.934-3.235 2.179-6.587 3.705-9.974-1.527-3.388-2.772-6.74-3.707-9.977zm3.831-1.173a69.255 69.255 0 002.2 6.368 91.131 91.131 0 014.572-7.768 64.901 64.901 0 00-6.772 1.4zm32.619-1.401a91.976 91.976 0 014.571 7.769 68.683 68.683 0 002.201-6.369 65.117 65.117 0 00-6.772-1.4zM24.471 8.497c-1.011 0-1.905.216-2.657.644-1.312.744-2.252 2.149-2.795 4.175-.785 2.935-.675 6.964.317 11.679 3.36-.892 7.002-1.555 10.834-1.971 2.217-2.971 4.545-5.688 6.927-8.088-4.76-4.157-9.231-6.439-12.626-6.439zm25.357 14.526c3.83.416 7.471 1.078 10.833 1.97.992-4.716 1.103-8.746.316-11.68-.542-2.022-1.48-3.424-2.79-4.166-.754-.427-1.649-.644-2.661-.644-3.393 0-7.86 2.281-12.619 6.433 2.38 2.399 4.706 5.117 6.921 8.087zM40 22.5c1.454 0 2.939.036 4.431.107a69.982 69.982 0 00-4.429-4.938 69.905 69.905 0 00-4.432 4.938A93.401 93.401 0 0140 22.5z"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: color,
                d: "M24.471 4.997c4.494 0 9.996 2.91 15.532 7.867 5.535-4.953 11.034-7.86 15.524-7.86 1.623 0 3.099.37 4.386 1.099 2.156 1.222 3.652 3.343 4.446 6.306 1.077 3.917.851 8.74-.434 14.08C73.147 29.57 79 34.431 79 40s-5.853 10.43-15.076 13.512c1.341 5.773 1.566 10.726.434 14.079-.794 2.962-2.289 5.084-4.443 6.306-1.289.73-2.46 1.103-4.082 1.103h-.417c-4.492 0-9.882-2.91-15.416-7.861-5.535 4.956-11.035 7.864-15.527 7.864-1.623 0-3.099-.37-4.386-1.099-2.158-1.225-3.655-3.349-4.448-6.314-1.19-3.717-.95-8.603.434-14.079C6.852 50.429 1 45.569 1 40c0-5.568 5.852-10.429 15.072-13.511-.687-3.059-1.126-5.899-1.141-8.489a21.247 21.247 0 01.707-5.59c.794-2.966 2.29-5.09 4.448-6.314 1.286-.73 2.762-1.099 4.385-1.099m-5.513 20.617c3.477-.955 7.338-1.677 11.483-2.117 2.382-3.21 4.875-6.096 7.386-8.584-4.872-4.346-9.616-6.917-13.356-6.917-1.099 0-2.075.238-2.904.709-1.433.813-2.452 2.32-3.031 4.481-.858 3.202-.663 7.53.422 12.428m42.081-.001c1.085-4.898 1.28-9.227.422-12.429-.578-2.157-1.597-3.661-3.027-4.472-.83-.471-1.809-.709-2.907-.709-3.737 0-8.478 2.568-13.349 6.91 2.51 2.488 5 5.374 7.38 8.583 4.143.44 8.004 1.162 11.481 2.117m-26.562-2.447c1.802-.107 3.609-.2 5.488-.2 1.879 0 3.755.094 5.557.2a70.437 70.437 0 00-5.521-6.204 70.776 70.776 0 00-5.524 6.204M40 54c2.761 0 5.404-.121 7.918-.342a88.394 88.394 0 004.372-6.719A86.927 86.927 0 0055.96 40a87.031 87.031 0 00-3.669-6.937 88.203 88.203 0 00-4.373-6.719C45.405 26.121 42.762 26 40 26s-5.406.121-7.92.343a87.238 87.238 0 00-8.045 13.658 87.016 87.016 0 003.668 6.937 88.409 88.409 0 004.374 6.719c2.515.222 5.16.343 7.923.343m17.546-17.587c1.125-2.709 2.056-5.369 2.766-7.913-2.553-.702-5.373-1.282-8.428-1.707a91.97 91.97 0 015.662 9.62m-35.097.001a92.563 92.563 0 012.668-4.873 91.97 91.97 0 012.995-4.747c-3.055.424-5.875 1.005-8.428 1.707.71 2.544 1.641 5.203 2.765 7.913m40.739 14.208C71.264 47.886 76 43.866 76 40s-4.736-7.886-12.812-10.622c-.953 3.405-2.269 6.983-3.92 10.621 1.651 3.639 2.967 7.217 3.92 10.623m-46.378-.001c.952-3.404 2.267-6.982 3.918-10.619-1.651-3.638-2.967-7.217-3.919-10.622C8.734 32.116 4 36.135 4 40c0 3.866 4.735 7.885 12.81 10.621m35.074 2.586c3.055-.424 5.875-1.004 8.428-1.707-.711-2.544-1.642-5.204-2.766-7.914a91.97 91.97 0 01-5.662 9.621m-23.775-.001a93.04 93.04 0 01-2.993-4.746 92.464 92.464 0 01-2.667-4.87c-1.124 2.708-2.054 5.367-2.764 7.91 2.552.701 5.371 1.281 8.424 1.706m-3.635 18.797c3.739 0 8.481-2.57 13.352-6.914-2.513-2.489-5.005-5.376-7.388-8.587-4.143-.439-8.002-1.161-11.478-2.116-1.084 4.898-1.279 9.226-.422 12.428.578 2.16 1.598 3.667 3.03 4.48.828.471 1.807.709 2.906.709m31.053-.006c1.099 0 2.076-.238 2.907-.709 1.43-.811 2.447-2.315 3.024-4.473.858-3.203.663-7.531-.421-12.428-3.477.955-7.337 1.677-11.481 2.116-2.38 3.21-4.871 6.096-7.381 8.585 4.871 4.34 9.613 6.908 13.352 6.909M40 63.04a70.783 70.783 0 005.522-6.206c-1.801.107-3.559.333-5.439.333-1.881 0-3.807-.226-5.609-.333A70.517 70.517 0 0040 63.04M24.116 4.072c-1.799 0-3.085.338-4.523 1.153-2.399 1.361-4.055 3.691-4.921 6.926-.96 3.587-.877 8.302.236 13.681C5.419 29.189 0 34.325 0 40c0 5.676 5.42 10.811 14.909 14.168-1.113 5.379-1.196 10.094-.235 13.681.865 3.233 2.52 5.563 4.921 6.926 1.44.816 3.17 1.163 4.968 1.163 4.487 0 9.753-2.535 15.438-7.466 5.684 4.926 11.039 7.524 15.525 7.525 1.799 0 3.441-.413 4.881-1.229 2.397-1.359 4.051-3.686 4.916-6.917.961-3.588.878-8.303-.235-13.681C74.579 50.812 80 45.676 80 40s-5.42-10.812-14.911-14.169c1.114-5.38 1.196-10.095.235-13.682-.866-3.231-2.521-5.558-4.919-6.917-1.439-.815-3.081-1.229-4.879-1.229-4.485 0-9.839 2.599-15.524 7.527-5.686-4.932-11.066-7.461-15.554-7.461l-.332.003zM19.72 24.377c-.462-2.324-.772-4.502-.789-6.412-.015-1.72.221-3.217.57-4.521.507-1.892 1.368-3.194 2.559-3.87a4.895 4.895 0 012.423-.644c3.181 0 7.367 2.178 11.883 6.034-2.221 2.273-4.392 4.819-6.466 7.585-3.585.4-7.003 1.013-10.18 1.828zm23.918-9.411c4.515-3.853 8.711-5.963 11.888-5.963.924 0 1.737.195 2.414.579 1.189.674 2.049 1.973 2.555 3.861.874 2.818.761 6.564-.218 10.933-3.177-.814-6.594-1.428-10.178-1.826-2.073-2.765-4.242-5.311-6.461-7.584zm-6.965 7.094a68.902 68.902 0 013.328-3.678 68.455 68.455 0 013.326 3.678 93.3 93.3 0 00-6.654 0zm-4.048 5.24c2.405-.199 4.883-.341 7.375-.341 2.491 0 4.969.142 7.373.341a87.795 87.795 0 014.056 6.269 86.348 86.348 0 013.423 6.43 86.576 86.576 0 01-7.48 12.701c-2.403.199-4.881.466-7.372.466-2.493 0-4.972-.268-7.378-.467a87.371 87.371 0 01-4.058-6.269A85.944 85.944 0 0125.142 40a86.194 86.194 0 017.483-12.7zm24.797 6.724a92.547 92.547 0 00-3.468-5.899c1.774.302 3.485.663 5.114 1.08a67.473 67.473 0 01-1.646 4.819zm-36.494-4.819a63.923 63.923 0 015.114-1.08 91.83 91.83 0 00-1.786 2.908 94.03 94.03 0 00-1.683 2.99 66.926 66.926 0 01-1.645-4.818zm39.437 10.794c1.415-3.162 2.587-6.292 3.49-9.326C70.758 33.192 75 36.721 75 40s-4.242 6.808-11.145 9.327c-.904-3.035-2.075-6.166-3.49-9.328zm-44.223 9.327C9.241 46.807 5 43.278 5 40s4.241-6.807 11.141-9.326c.903 3.035 2.074 6.165 3.489 9.327-1.414 3.161-2.585 6.291-3.488 9.325zm37.811 2.55a92.174 92.174 0 003.469-5.9 67.845 67.845 0 011.646 4.821 64.94 64.94 0 01-5.115 1.079zm-33.024-1.081a67.527 67.527 0 011.644-4.816 91.986 91.986 0 003.467 5.896 64.733 64.733 0 01-5.111-1.08zm3.545 20.208c-.924 0-1.736-.195-2.413-.579-1.19-.676-2.051-1.977-2.557-3.869-.831-2.845-.737-6.592.218-10.933 3.176.814 6.592 1.428 10.175 1.826 2.075 2.766 4.246 5.313 6.468 7.588-4.515 3.857-8.712 5.968-11.891 5.967zM50.098 57.45c3.584-.399 7.001-1.012 10.178-1.826 1.105 4.74 1.192 8.518.217 10.932-.505 1.889-1.364 3.188-2.552 3.861-.678.384-1.49.579-2.413.579v1l-.001-1c-3.18 0-7.377-2.11-11.891-5.961 2.22-2.273 4.389-4.819 6.462-7.585zM40 61.62a68.17 68.17 0 01-3.33-3.68 93.467 93.467 0 006.657 0A68.14 68.14 0 0140 61.62z"
            })
        ]
    });
};
var $0c1061e411609f9e$export$2e2bcd8739ae039 = $0c1061e411609f9e$var$ReactIcon;
$0c1061e411609f9e$var$ReactIcon.defaultProps = {
    width: 64,
    height: 64,
    color: "#8bb7f0"
};


// modules

parcelRequire("6cds3");
const $eb4bb93bbb19c6c9$var$CssIcon = (props)=>{
    const { width: width, height: height, className: className, color: color } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        className: className,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            fill: color,
            d: "M16.017 21.044zM4.743 3.519L6.792 26.5l9.194 2.552 9.22-2.556 2.051-22.977H4.743zM23 8.775l-.693 7.767-.48 5.359-.042.476-5.781 1.603-5.773-1.603-.395-4.426h2.829l.201 2.248 3.142.847.008-.002h.002l3.134-.846.329-3.655h-6.579l-.056-.633-.129-1.429-.067-.756h7.081l.258-2.886H9.203l-.056-.634-.129-1.429-.067-.756h14.118l-.068.756z"
        })
    });
};
var $eb4bb93bbb19c6c9$export$2e2bcd8739ae039 = $eb4bb93bbb19c6c9$var$CssIcon;
$eb4bb93bbb19c6c9$var$CssIcon.defaultProps = {
    width: 64,
    height: 64,
    color: "#444"
};


// modules

parcelRequire("6cds3");
const $e9d28615c616988b$var$DoubleWave = (props)=>{
    const { className: className, color: color, width: width, height: height } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        className: className,
        viewBox: "0 0 36 37",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                clipPath: "url(#clip0_8_30)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    clipPath: "url(#clip1_8_30)",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                        stroke: color,
                        strokeMiterlimit: "10",
                        strokeWidth: "3",
                        d: "M9.945 35.024S1.46 31.79 1.5 24.33c.04-7.46 11.73-4.797 11.73-4.797S3.82 17.118 4.18 9.18c.36-7.938 12.784-7.255 12.784-7.255"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                        id: "clip0_8_30",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H36V36H0z",
                            transform: "translate(0 .41)"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                        id: "clip1_8_30",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H36V36H0z",
                            transform: "translate(0 .41)"
                        })
                    })
                ]
            })
        ]
    });
};
var $e9d28615c616988b$export$2e2bcd8739ae039 = $e9d28615c616988b$var$DoubleWave;
$e9d28615c616988b$var$DoubleWave.defaultProps = {
    color: "#CF4981",
    width: 36,
    height: 37
};


// modules

parcelRequire("6cds3");
const $7d7a71f72705788c$var$Wave = (props)=>{
    const { className: className, color: color, width: width, height: height } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        className: className,
        fill: "none",
        viewBox: "0 0 28 29",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                clipPath: "url(#clip0_8_42)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    clipPath: "url(#clip1_8_42)",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                        stroke: color,
                        strokeMiterlimit: "10",
                        strokeWidth: "3",
                        d: "M26.5 14.044c0 7.206-5.84 13.046-13.047 13.046C6.248 27.09.407 21.25.407 14.044"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                        id: "clip0_8_42",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H28V28H0z",
                            transform: "rotate(180 14 14.295)"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                        id: "clip1_8_42",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H28V28H0z",
                            transform: "rotate(180 14 14.295)"
                        })
                    })
                ]
            })
        ]
    });
};
var $7d7a71f72705788c$export$2e2bcd8739ae039 = $7d7a71f72705788c$var$Wave;
$7d7a71f72705788c$var$Wave.defaultProps = {
    color: "#CF4981",
    width: 28,
    height: 29
};


// modules

parcelRequire("6cds3");
const $759e05d64aee4aab$var$Triangle = (props)=>{
    const { className: className, color: color, width: width, height: height } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        className: className,
        viewBox: "0 0 25 25",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                clipPath: "url(#clip0_8_9)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    clipPath: "url(#clip1_8_9)",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                        clipPath: "url(#clip2_8_9)",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            stroke: color,
                            strokeMiterlimit: "10",
                            strokeWidth: "3",
                            d: "M12.163 22l-5.12-8.868-5.12-8.868h20.48l-5.12 8.868L12.163 22z"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                        id: "clip0_8_9",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H25V25H0z",
                            transform: "rotate(180 12.5 12.5)"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                        id: "clip1_8_9",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H25V25H0z",
                            transform: "rotate(180 12.5 12.5)"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                        id: "clip2_8_9",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H25.675V22.236H0z",
                            transform: "rotate(180 12.5 12.5)"
                        })
                    })
                ]
            })
        ]
    });
};
var $759e05d64aee4aab$export$2e2bcd8739ae039 = $759e05d64aee4aab$var$Triangle;
$759e05d64aee4aab$var$Triangle.defaultProps = {
    color: "#CF4981",
    width: 25,
    height: 25
};


// modules

parcelRequire("6cds3");
const $d31ee9019390861b$var$Line = (props)=>{
    const { className: className, color: color, width: width, height: height } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        className: className,
        viewBox: "0 0 24 25",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                clipPath: "url(#clip0_8_39)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    clipPath: "url(#clip1_8_39)",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                        stroke: color,
                        strokeMiterlimit: "10",
                        strokeWidth: "3",
                        d: "M19.924 5.61L4.43 24.075"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                        id: "clip0_8_39",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H22V22H0z",
                            transform: "rotate(85 10.733 12.25)"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                        id: "clip1_8_39",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H22V22H0z",
                            transform: "rotate(85 10.733 12.25)"
                        })
                    })
                ]
            })
        ]
    });
};
var $d31ee9019390861b$export$2e2bcd8739ae039 = $d31ee9019390861b$var$Line;
$d31ee9019390861b$var$Line.defaultProps = {
    color: "#CF4981",
    width: 24,
    height: 25
};


// modules

parcelRequire("6cds3");
const $67294a4786d574bf$var$SemiCircle = (props)=>{
    const { className: className, color: color, width: width, height: height } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        className: className,
        viewBox: "0 0 40 40",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                clipPath: "url(#clip0_8_25)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    stroke: color,
                    strokeMiterlimit: "10",
                    strokeWidth: "3",
                    d: "M10.775 11.546c5.095-5.095 13.354-5.095 18.45.001 5.095 5.095 5.096 13.354 0 18.45"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                    id: "clip0_8_25",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H28V28H0z",
                        transform: "rotate(45 9.759 24.242)"
                    })
                })
            })
        ]
    });
};
var $67294a4786d574bf$export$2e2bcd8739ae039 = $67294a4786d574bf$var$SemiCircle;
$67294a4786d574bf$var$SemiCircle.defaultProps = {
    color: "#CF4981",
    width: 40,
    height: 40
};


// modules

parcelRequire("6cds3");
const $fe8768734706f750$var$Logo = (props)=>{
    const { width: width, height: height, className: className, color: color } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        className: className,
        version: "1",
        viewBox: "0 0 369 342",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: color,
                d: "M461 2778c30-57 1021-1772 1028-1780 3-3 165 269 358 605l353 612-238 3c-220 2-238 1-252-16-8-10-60-96-114-190-54-95-101-172-105-172-3 1-130 216-281 480l-275 479-243 1H449l12-22z",
                transform: "matrix(.1 0 0 -.1 0 342)"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: color,
                d: "M1932 2593l-120-208 334-3c184-1 334-4 334-6 0-3-201-352-446-777-337-584-444-776-437-789 22-46 229-400 233-400 3 0 170 287 372 638 202 350 505 876 674 1167 168 292 312 542 320 558l15 27H2052l-120-207z",
                transform: "matrix(.1 0 0 -.1 0 342)"
            })
        ]
    });
};
var $fe8768734706f750$export$2e2bcd8739ae039 = $fe8768734706f750$var$Logo;
$fe8768734706f750$var$Logo.defaultProps = {
    width: 69,
    height: 62,
    color: "white"
};


// modules


var $6cds3 = parcelRequire("6cds3");




var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");
const $ebdd93538295fd0b$export$2285bbca2c666415 = (0, $6cds3.createContext)({});



var $6cds3 = parcelRequire("6cds3");




var $6cds3 = parcelRequire("6cds3");
const $027323c169da8fa9$export$40f10139ecf1f171 = (0, $6cds3.createContext)({
    strict: false
});



/**
 * Convert camelCase to dash-case properties.
 */ const $3bc74152d744365d$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


const $acf7e02863b7c6a2$export$ed7b8fa9dbf0105d = "framerAppearId";
const $acf7e02863b7c6a2$export$8592e1c077c890a6 = "data-" + (0, $3bc74152d744365d$export$9fd24a634729c672)($acf7e02863b7c6a2$export$ed7b8fa9dbf0105d);


function $40a69983ea87a7ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $6cds3.useContext)((0, $ebdd93538295fd0b$export$2285bbca2c666415));
    const lazyContext = (0, $6cds3.useContext)((0, $027323c169da8fa9$export$40f10139ecf1f171));
    const presenceContext = (0, $6cds3.useContext)((0, $e40c1c7ce208ba78$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $6cds3.useContext)((0, $874d1c1409e5f81e$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $6cds3.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $6cds3.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $6cds3.useRef)(Boolean(props[0, $acf7e02863b7c6a2$export$8592e1c077c890a6]));
    (0, $b588e509ec7465c1$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.render();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $6cds3.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        /**
         * Once we've handed animations off, we can delete the global reference.
         */ if (wantsHandoff.current) {
            window.HandoffAppearAnimations = false;
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}



var $6cds3 = parcelRequire("6cds3");
function $1c79ac3705c6b6d1$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $90806267369c30cf$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $6cds3.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $1c79ac3705c6b6d1$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $6cds3 = parcelRequire("6cds3");

/**
 * Decides if the supplied variable is variant label
 */ function $23e2b8e45e65dfac$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $cba7aa384b255de7$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}



const $20855a5d0b260125$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $20855a5d0b260125$export$1405a65085f40b9 = [
    "initial",
    ...$20855a5d0b260125$export$16e45afcc206d3a8
];


function $9b5ea444b3556797$export$4b3c3bd8d910d78d(props) {
    return (0, $cba7aa384b255de7$export$aa71198ceeaf53ce)(props.animate) || (0, $20855a5d0b260125$export$1405a65085f40b9).some((name)=>(0, $23e2b8e45e65dfac$export$720b90e312cea233)(props[name]));
}
function $9b5ea444b3556797$export$ce46fa4165cdec40(props) {
    return Boolean($9b5ea444b3556797$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $3f04b40ab69fc8fb$export$12fc32fc096a04a3(props, context) {
    if ((0, $9b5ea444b3556797$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $23e2b8e45e65dfac$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $23e2b8e45e65dfac$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $520ddbac949d6fdc$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $3f04b40ab69fc8fb$export$12fc32fc096a04a3)(props, (0, $6cds3.useContext)((0, $ebdd93538295fd0b$export$2285bbca2c666415)));
    return (0, $6cds3.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $520ddbac949d6fdc$var$variantLabelsAsDependency(initial),
        $520ddbac949d6fdc$var$variantLabelsAsDependency(animate)
    ]);
}
function $520ddbac949d6fdc$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}



const $a953b6ada2f72db5$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $a953b6ada2f72db5$export$65570e08d843624d = {};
for(const key in $a953b6ada2f72db5$var$featureProps)$a953b6ada2f72db5$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$a953b6ada2f72db5$var$featureProps[key].some((name)=>!!props[name])
};


function $aca4ab24ef876987$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $a953b6ada2f72db5$export$65570e08d843624d)[key] = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, (0, $a953b6ada2f72db5$export$65570e08d843624d)[key], features[key]);
}






var $6cds3 = parcelRequire("6cds3");
/**
 * Internal, exported only for usage in Framer
 */ const $80cd083093aee758$export$da5f7b802957459a = (0, $6cds3.createContext)({});


const $3b011ee003f444b4$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $60bdad86d4074aed$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $aca4ab24ef876987$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, (0, $6cds3.useContext)((0, $874d1c1409e5f81e$export$22a697fb29aac98d)), props), {
            layoutId: $60bdad86d4074aed$var$useLayoutId(props)
        });
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $520ddbac949d6fdc$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $5ddea511a1df74b4$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $40a69983ea87a7ad$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $6cds3.useContext)((0, $80cd083093aee758$export$da5f7b802957459a));
            const isStrict = (0, $6cds3.useContext)((0, $027323c169da8fa9$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $6cds3.createElement((0, $ebdd93538295fd0b$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $6cds3.createElement(MeasureLayout, (0, $66a5668b38a29be4$export$581ff339ea0ba762)({
            visualElement: context.visualElement
        }, configAndProps)) : null, useRender(Component, props, (0, $90806267369c30cf$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $6cds3.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $3b011ee003f444b4$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $60bdad86d4074aed$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $6cds3.useContext)((0, $5f7d717553e210fe$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $31c6675f74aec206$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $60bdad86d4074aed$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}




/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $2692c437a8fd9588$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $13b7dd579aa6d2ca$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $2692c437a8fd9588$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}





var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
const $f4236abcb41ce1af$export$91ddd985b97788d1 = {};
function $f4236abcb41ce1af$export$de9e7791c71225fd(correctors) {
    Object.assign($f4236abcb41ce1af$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $d1c315412dc4e663$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $d1c315412dc4e663$export$7b42a0094fb00b6e = new Set($d1c315412dc4e663$export$280dc01950909d86);


function $c7c26ba3aa2ea131$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $f4236abcb41ce1af$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $251f7d673c9c86a3$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $bd773126b9f243d5$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $bd773126b9f243d5$var$numTransforms = (0, $d1c315412dc4e663$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $bd773126b9f243d5$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $bd773126b9f243d5$var$numTransforms; i++){
        const key = (0, $d1c315412dc4e663$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $bd773126b9f243d5$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $58159485ea5b9511$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $58159485ea5b9511$export$9de1236619d9e756 = $58159485ea5b9511$var$checkStringStartsWith("--");
const $58159485ea5b9511$export$31f9caa2600b5723 = $58159485ea5b9511$var$checkStringStartsWith("var(--");
const $58159485ea5b9511$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $f97b248c59f08e79$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};




const $fa84546edb6e889a$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $9ad8a8be30ce5844$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $9ad8a8be30ce5844$export$58f0f39f63f3cf42 = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, $9ad8a8be30ce5844$export$98e628dec113755e), {
    transform: (v)=>(0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)(0, 1, v)
});
const $9ad8a8be30ce5844$export$dcdf75081b88279d = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, $9ad8a8be30ce5844$export$98e628dec113755e), {
    default: 1
});




/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $338f435df31a3d26$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $338f435df31a3d26$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $338f435df31a3d26$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $338f435df31a3d26$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $338f435df31a3d26$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $d414efec423ce291$var$createUnitType = (unit)=>({
        test: (v)=>(0, $338f435df31a3d26$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $d414efec423ce291$export$41fc368e1a942b97 = $d414efec423ce291$var$createUnitType("deg");
const $d414efec423ce291$export$626336c2cd4b14de = $d414efec423ce291$var$createUnitType("%");
const $d414efec423ce291$export$91c0eda1d06bf008 = $d414efec423ce291$var$createUnitType("px");
const $d414efec423ce291$export$f91e8c45a95a32f2 = $d414efec423ce291$var$createUnitType("vh");
const $d414efec423ce291$export$aed3d7b7d206c196 = $d414efec423ce291$var$createUnitType("vw");
const $d414efec423ce291$export$44e2e1705876d7ed = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, $d414efec423ce291$export$626336c2cd4b14de), {
    parse: (v)=>$d414efec423ce291$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$d414efec423ce291$export$626336c2cd4b14de.transform(v * 100)
});





const $c36e63324803d105$export$7d260a2a5f8bc19e = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, (0, $9ad8a8be30ce5844$export$98e628dec113755e)), {
    transform: Math.round
});


const $5cd21c5d2c5b7cec$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderTopWidth: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderRightWidth: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderRadius: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    radius: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    maxWidth: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    height: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    maxHeight: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    size: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    top: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    right: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    bottom: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    left: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    paddingTop: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    paddingRight: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    paddingBottom: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    paddingLeft: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    margin: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    marginTop: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    marginRight: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    marginBottom: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    marginLeft: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $d414efec423ce291$export$41fc368e1a942b97),
    rotateX: (0, $d414efec423ce291$export$41fc368e1a942b97),
    rotateY: (0, $d414efec423ce291$export$41fc368e1a942b97),
    rotateZ: (0, $d414efec423ce291$export$41fc368e1a942b97),
    scale: $9ad8a8be30ce5844$export$dcdf75081b88279d,
    scaleX: (0, $9ad8a8be30ce5844$export$dcdf75081b88279d),
    scaleY: (0, $9ad8a8be30ce5844$export$dcdf75081b88279d),
    scaleZ: (0, $9ad8a8be30ce5844$export$dcdf75081b88279d),
    skew: (0, $d414efec423ce291$export$41fc368e1a942b97),
    skewX: (0, $d414efec423ce291$export$41fc368e1a942b97),
    skewY: (0, $d414efec423ce291$export$41fc368e1a942b97),
    distance: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    translateX: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    translateY: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    translateZ: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    x: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    y: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    z: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    perspective: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    transformPerspective: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    opacity: (0, $9ad8a8be30ce5844$export$58f0f39f63f3cf42),
    originX: (0, $d414efec423ce291$export$44e2e1705876d7ed),
    originY: (0, $d414efec423ce291$export$44e2e1705876d7ed),
    originZ: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $c36e63324803d105$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $9ad8a8be30ce5844$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $9ad8a8be30ce5844$export$58f0f39f63f3cf42),
    numOctaves: (0, $c36e63324803d105$export$7d260a2a5f8bc19e)
};


function $371459a1640f998f$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $58159485ea5b9511$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $5cd21c5d2c5b7cec$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $f97b248c59f08e79$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $bd773126b9f243d5$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $ccea98651e8f869c$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $d67c8c7c4130cfba$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $251f7d673c9c86a3$export$605d60a2578142d3)(source[key]) && !(0, $c7c26ba3aa2ea131$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $d67c8c7c4130cfba$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $6cds3.useMemo)(()=>{
        const state = (0, $ccea98651e8f869c$export$8940b483cf52eeda)();
        (0, $371459a1640f998f$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $d67c8c7c4130cfba$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $d67c8c7c4130cfba$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $d67c8c7c4130cfba$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $d67c8c7c4130cfba$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $d67c8c7c4130cfba$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}







var $6cds3 = parcelRequire("6cds3");




function $b77b3238a5e2cf7d$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $d414efec423ce291$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $b77b3238a5e2cf7d$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $b77b3238a5e2cf7d$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $b77b3238a5e2cf7d$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $6b5e1ea882fb62b1$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $6b5e1ea882fb62b1$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $6b5e1ea882fb62b1$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $6b5e1ea882fb62b1$var$dashKeys : $6b5e1ea882fb62b1$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $d414efec423ce291$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $d414efec423ce291$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $d414efec423ce291$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $85a07f77d14903fc$export$5475d24f125d7053(state, _param, options, isSVGTag, transformTemplate) {
    var { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0 } = _param, latest = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "attrX",
        "attrY",
        "attrScale",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $371459a1640f998f$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $b77b3238a5e2cf7d$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $6b5e1ea882fb62b1$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}





const $75ca4a7bad37c3e8$export$41be8b43e1c4d4f9 = ()=>(0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, (0, $ccea98651e8f869c$export$8940b483cf52eeda)()), {
        attrs: {}
    });


const $7ee347ff6d81ac56$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $91d65fc990f1a95d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $6cds3.useMemo)(()=>{
        const state = (0, $75ca4a7bad37c3e8$export$41be8b43e1c4d4f9)();
        (0, $85a07f77d14903fc$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $7ee347ff6d81ac56$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, state.attrs), {
            style: (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $d67c8c7c4130cfba$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, rawStyles, visualProps.style);
    }
    return visualProps;
}



function $895c6e7acd0991b4$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $13b7dd579aa6d2ca$export$88f3fc2fd3766989)(Component) ? (0, $91d65fc990f1a95d$export$84309c4f53cb1bd5) : (0, $d67c8c7c4130cfba$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $46bf78dd23632642$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, filteredProps, visualProps), {
            ref: ref
        });
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $6cds3.useMemo)(()=>(0, $251f7d673c9c86a3$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $6cds3.createElement)(Component, (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, elementProps), {
            children: renderedChildren
        }));
    };
    return useRender;
}



function $9bc9ba6c7615124c$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $671a4e7e4df97a9a$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $afcd7ecf658716d9$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $9bc9ba6c7615124c$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $671a4e7e4df97a9a$export$28931db5d57958e5).has(key) ? (0, $3bc74152d744365d$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $a95906244a2d7e5e$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $251f7d673c9c86a3$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $251f7d673c9c86a3$export$605d60a2578142d3)(prevProps.style[key]) || (0, $c7c26ba3aa2ea131$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $79ce2b625ef60476$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $a95906244a2d7e5e$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $251f7d673c9c86a3$export$605d60a2578142d3)(props[key]) || (0, $251f7d673c9c86a3$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $d1c315412dc4e663$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}




var $6cds3 = parcelRequire("6cds3");


function $c0f30ec55cd531d9$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



const $cdfb45bee9c27be9$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $4d89fd6dc8b0f394$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $4d89fd6dc8b0f394$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $cdfb45bee9c27be9$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $acbc391d093466b3$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $251f7d673c9c86a3$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $4d89fd6dc8b0f394$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $464ec9c807f3e0b4$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $464ec9c807f3e0b4$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $464ec9c807f3e0b4$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $6cds3.useContext)((0, $ebdd93538295fd0b$export$2285bbca2c666415));
        const presenceContext = (0, $6cds3.useContext)((0, $e40c1c7ce208ba78$export$f224e4635b6f8ce2));
        const make = ()=>$464ec9c807f3e0b4$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $491d0f9d7a26c5a8$export$fe4300aa8eebea86)(make);
    };
function $464ec9c807f3e0b4$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $acbc391d093466b3$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $9b5ea444b3556797$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $9b5ea444b3556797$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $cba7aa384b255de7$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $c0f30ec55cd531d9$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition } = resolved, target = (0, $c4006311849aa271$export$69fdd232f62cde60)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}






const $287e28872a2d5f38$export$44dabd3fae512e85 = {
    useVisualState: (0, $464ec9c807f3e0b4$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $79ce2b625ef60476$export$16da615486abaa45),
        createRenderState: (0, $75ca4a7bad37c3e8$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $abdd74f2cc691999$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $abdd74f2cc691999$export$2cef06c20297c17d).render(()=>{
                (0, $85a07f77d14903fc$export$5475d24f125d7053)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $7ee347ff6d81ac56$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $afcd7ecf658716d9$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $f10027b5076f7c66$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $464ec9c807f3e0b4$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $a95906244a2d7e5e$export$16da615486abaa45,
        createRenderState: (0, $ccea98651e8f869c$export$8940b483cf52eeda)
    })
};


function $cb5f7861a7a27279$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $13b7dd579aa6d2ca$export$88f3fc2fd3766989)(Component) ? (0, $287e28872a2d5f38$export$44dabd3fae512e85) : (0, $f10027b5076f7c66$export$e13ea21d87ea57c8);
    return (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $895c6e7acd0991b4$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    });
}


function $3b9e8293424667bf$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $e686dca3072f0847$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $230784ee47833b0a$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $230784ee47833b0a$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $e686dca3072f0847$export$a4cf9c8a4b063a6e)(event) && handler(event, $230784ee47833b0a$export$12f84bb882d06e1a(event));
};


function $59727fd3e6cd9f0c$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(target, eventName, (0, $230784ee47833b0a$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $81c10aac384f5ba3$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $81c10aac384f5ba3$export$a4627e546088548d = (...transformers)=>transformers.reduce($81c10aac384f5ba3$var$combineFunctions);


function $6b9c534ca65d1916$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $6b9c534ca65d1916$var$globalHorizontalLock = $6b9c534ca65d1916$export$518c5fc2dcb7974b("dragHorizontal");
const $6b9c534ca65d1916$var$globalVerticalLock = $6b9c534ca65d1916$export$518c5fc2dcb7974b("dragVertical");
function $6b9c534ca65d1916$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $6b9c534ca65d1916$var$globalVerticalLock();
    else if (drag === "x") lock = $6b9c534ca65d1916$var$globalHorizontalLock();
    else {
        const openHorizontal = $6b9c534ca65d1916$var$globalHorizontalLock();
        const openVertical = $6b9c534ca65d1916$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $6b9c534ca65d1916$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $6b9c534ca65d1916$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $617d59ae1886b5b2$export$6e91cf7616333d5 {
    update() {}
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
}



function $c4db1434d52a9998$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.type === "touch" || (0, $6b9c534ca65d1916$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>props[callbackName](event, info));
    };
    return (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $c4db1434d52a9998$export$93a81ea037eac456 extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $81c10aac384f5ba3$export$a4627e546088548d)($c4db1434d52a9998$var$addHoverEvent(this.node, true), $c4db1434d52a9998$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $d2f509fd0b24572d$export$d4826db40d47595b extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $81c10aac384f5ba3$export$a4627e546088548d)((0, $3b9e8293424667bf$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $0c844bc4120cf1fc$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $0c844bc4120cf1fc$export$e841ada32ff745b(parent, child.parentElement);
};




function $5052b2c80097d882$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $230784ee47833b0a$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $5052b2c80097d882$export$f026abdbba7f0c9e extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $6b9c534ca65d1916$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $81c10aac384f5ba3$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
        this.removeEndListeners = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            this.removeEndListeners();
            if (this.isPressing) return;
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel } = this.node.getProps();
                (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !(0, $0c844bc4120cf1fc$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $81c10aac384f5ba3$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $5052b2c80097d882$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $5052b2c80097d882$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $5052b2c80097d882$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $81c10aac384f5ba3$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ 

const $59ac27f66aea5dfe$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $59ac27f66aea5dfe$var$observers = new WeakMap();
const $59ac27f66aea5dfe$var$fireObserverCallback = (entry)=>{
    const callback = $59ac27f66aea5dfe$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $59ac27f66aea5dfe$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($59ac27f66aea5dfe$var$fireObserverCallback);
};
function $59ac27f66aea5dfe$var$initIntersectionObserver(_param) {
    var { root: root } = _param, options = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "root"
    ]);
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$59ac27f66aea5dfe$var$observers.has(lookupRoot)) $59ac27f66aea5dfe$var$observers.set(lookupRoot, {});
    const rootObservers = $59ac27f66aea5dfe$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($59ac27f66aea5dfe$var$fireAllObserverCallbacks, (0, $66a5668b38a29be4$export$581ff339ea0ba762)({
        root: root
    }, options));
    return rootObservers[key];
}
function $59ac27f66aea5dfe$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $59ac27f66aea5dfe$var$initIntersectionObserver(options);
    $59ac27f66aea5dfe$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $59ac27f66aea5dfe$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $39c5bf68d6322b93$var$thresholdNames = {
    some: 0,
    all: 1
};
class $39c5bf68d6322b93$export$150851c8cc2f0c72 extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $39c5bf68d6322b93$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $59ac27f66aea5dfe$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($39c5bf68d6322b93$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
}
function $39c5bf68d6322b93$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $9f80faa8a4e07d80$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $39c5bf68d6322b93$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $5052b2c80097d882$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $d2f509fd0b24572d$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $c4db1434d52a9998$export$93a81ea037eac456)
    }
};







function $b72ed983341c6484$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $09bc9ca971307c1d$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $09bc9ca971307c1d$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $09bc9ca971307c1d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $c0f30ec55cd531d9$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $09bc9ca971307c1d$var$getCurrent(visualElement), $09bc9ca971307c1d$var$getVelocity(visualElement));
}











/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $a9e2d00978e30fa4$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $8fa4692997fef09a$export$888a3d84909f9e3d = {
    current: false
};





const $ccf562d41de2cfd9$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $098e26d9afc788ba$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $098e26d9afc788ba$export$2cf569f5e2221176[easing] || (0, $ccf562d41de2cfd9$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($098e26d9afc788ba$export$fcdd8f3f2160beda));
}
const $098e26d9afc788ba$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $098e26d9afc788ba$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $098e26d9afc788ba$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $098e26d9afc788ba$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $098e26d9afc788ba$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $098e26d9afc788ba$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $098e26d9afc788ba$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $ccf562d41de2cfd9$export$ff43f99925d7366b)(easing) ? $098e26d9afc788ba$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($098e26d9afc788ba$export$916ea73bcd3a6030) : $098e26d9afc788ba$export$2cf569f5e2221176[easing];
}


function $e6d1c43098e794ae$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $098e26d9afc788ba$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $71f528837f15cf2e$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}






/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $b68ec7dd50aa8255$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $b68ec7dd50aa8255$var$subdivisionPrecision = 0.0000001;
const $b68ec7dd50aa8255$var$subdivisionMaxIterations = 12;
function $b68ec7dd50aa8255$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $b68ec7dd50aa8255$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $b68ec7dd50aa8255$var$subdivisionPrecision && ++i < $b68ec7dd50aa8255$var$subdivisionMaxIterations);
    return currentT;
}
function $b68ec7dd50aa8255$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $dcf17e8536d5fb4f$export$8793edee2d425525;
    const getTForX = (aX)=>$b68ec7dd50aa8255$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $b68ec7dd50aa8255$var$calcBezier(getTForX(t), mY1, mY2);
}


const $4b2d8ea621676e4a$export$929e5a82286172a6 = (0, $b68ec7dd50aa8255$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $4b2d8ea621676e4a$export$57636bb43b1ccbb0 = (0, $b68ec7dd50aa8255$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $4b2d8ea621676e4a$export$c07234257a03d5e9 = (0, $b68ec7dd50aa8255$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $7d2532405ded3ea5$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $69035d8d09bc295c$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $819cd53771ed6265$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $d6fb562c03554c29$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $d6fb562c03554c29$export$c8d67a19199d1a50 = (0, $819cd53771ed6265$export$2c07eeff45156d4d)($d6fb562c03554c29$export$e444123e42d03385);
const $d6fb562c03554c29$export$30d3455eee55bed5 = (0, $69035d8d09bc295c$export$f946554fb8aeaf0d)($d6fb562c03554c29$export$c8d67a19199d1a50);





const $2ffe3caa5694044a$export$77edfce482316a60 = (0, $b68ec7dd50aa8255$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $2ffe3caa5694044a$export$b01116c84cdfe1a2 = (0, $819cd53771ed6265$export$2c07eeff45156d4d)($2ffe3caa5694044a$export$77edfce482316a60);
const $2ffe3caa5694044a$export$ddc5fd596f6c71b2 = (0, $69035d8d09bc295c$export$f946554fb8aeaf0d)($2ffe3caa5694044a$export$b01116c84cdfe1a2);



const $b671f13caff3e8c0$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $2ffe3caa5694044a$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $a4ee59a17d946ff8$var$easingLookup = {
    linear: (0, $dcf17e8536d5fb4f$export$8793edee2d425525),
    easeIn: $4b2d8ea621676e4a$export$929e5a82286172a6,
    easeInOut: $4b2d8ea621676e4a$export$c07234257a03d5e9,
    easeOut: $4b2d8ea621676e4a$export$57636bb43b1ccbb0,
    circIn: $d6fb562c03554c29$export$e444123e42d03385,
    circInOut: $d6fb562c03554c29$export$30d3455eee55bed5,
    circOut: $d6fb562c03554c29$export$c8d67a19199d1a50,
    backIn: $2ffe3caa5694044a$export$b01116c84cdfe1a2,
    backInOut: $2ffe3caa5694044a$export$ddc5fd596f6c71b2,
    backOut: $2ffe3caa5694044a$export$77edfce482316a60,
    anticipate: $b671f13caff3e8c0$export$6b0af63b873d419e
};
const $a4ee59a17d946ff8$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $faee95b32f04793f$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $b68ec7dd50aa8255$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $faee95b32f04793f$export$f5708dca728d7177)($a4ee59a17d946ff8$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $a4ee59a17d946ff8$var$easingLookup[definition];
    }
    return definition;
};










/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $dcbec077bb7f84f2$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $338f435df31a3d26$export$844ec244b1367d54)(v) && (0, $338f435df31a3d26$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $dcbec077bb7f84f2$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $338f435df31a3d26$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $338f435df31a3d26$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $7eb780a36d447b78$var$clampRgbUnit = (v)=>(0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)(0, 255, v);
const $7eb780a36d447b78$export$7a99c86b5b1f4c9e = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, (0, $9ad8a8be30ce5844$export$98e628dec113755e)), {
    transform: (v)=>Math.round($7eb780a36d447b78$var$clampRgbUnit(v))
});
const $7eb780a36d447b78$export$4e46ac54fc82cf3b = {
    test: (0, $dcbec077bb7f84f2$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $dcbec077bb7f84f2$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $7eb780a36d447b78$export$7a99c86b5b1f4c9e.transform(red) + ", " + $7eb780a36d447b78$export$7a99c86b5b1f4c9e.transform(green) + ", " + $7eb780a36d447b78$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $338f435df31a3d26$export$83d2e9e3e4ee39ed)((0, $9ad8a8be30ce5844$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $033e89ee5ceff2b5$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $033e89ee5ceff2b5$export$834dfc94dde4b3d8 = {
    test: (0, $dcbec077bb7f84f2$export$2c8400d58aca05e)("#"),
    parse: $033e89ee5ceff2b5$var$parseHex,
    transform: (0, $7eb780a36d447b78$export$4e46ac54fc82cf3b).transform
};






const $3430a9d7e3ad25df$export$810b04175080204c = {
    test: (0, $dcbec077bb7f84f2$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $dcbec077bb7f84f2$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $d414efec423ce291$export$626336c2cd4b14de).transform((0, $338f435df31a3d26$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $d414efec423ce291$export$626336c2cd4b14de).transform((0, $338f435df31a3d26$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $338f435df31a3d26$export$83d2e9e3e4ee39ed)((0, $9ad8a8be30ce5844$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $4dc0621296be153e$export$35e9368ef982300f = {
    test: (v)=>(0, $7eb780a36d447b78$export$4e46ac54fc82cf3b).test(v) || (0, $033e89ee5ceff2b5$export$834dfc94dde4b3d8).test(v) || (0, $3430a9d7e3ad25df$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $7eb780a36d447b78$export$4e46ac54fc82cf3b).test(v)) return (0, $7eb780a36d447b78$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $3430a9d7e3ad25df$export$810b04175080204c).test(v)) return (0, $3430a9d7e3ad25df$export$810b04175080204c).parse(v);
        else return (0, $033e89ee5ceff2b5$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $338f435df31a3d26$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $7eb780a36d447b78$export$4e46ac54fc82cf3b).transform(v) : (0, $3430a9d7e3ad25df$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $6547127f992c1078$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;





// Adapted from https://gist.github.com/mjackson/5311256
function $6d40377c43cb841e$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $6d40377c43cb841e$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $6d40377c43cb841e$var$hueToRgb(p, q, hue + 1 / 3);
        green = $6d40377c43cb841e$var$hueToRgb(p, q, hue);
        blue = $6d40377c43cb841e$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $e5a66d3fc8862ad9$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $e5a66d3fc8862ad9$var$colorTypes = [
    (0, $033e89ee5ceff2b5$export$834dfc94dde4b3d8),
    (0, $7eb780a36d447b78$export$4e46ac54fc82cf3b),
    (0, $3430a9d7e3ad25df$export$810b04175080204c)
];
const $e5a66d3fc8862ad9$var$getColorType = (v)=>$e5a66d3fc8862ad9$var$colorTypes.find((type)=>type.test(v));
function $e5a66d3fc8862ad9$var$asRGBA(color) {
    const type = $e5a66d3fc8862ad9$var$getColorType(color);
    (0, $faee95b32f04793f$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $3430a9d7e3ad25df$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $6d40377c43cb841e$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $e5a66d3fc8862ad9$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $e5a66d3fc8862ad9$var$asRGBA(from);
    const toRGBA = $e5a66d3fc8862ad9$var$asRGBA(to);
    const blended = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, fromRGBA);
    return (v)=>{
        blended.red = $e5a66d3fc8862ad9$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $e5a66d3fc8862ad9$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $e5a66d3fc8862ad9$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $7eb780a36d447b78$export$4e46ac54fc82cf3b).transform(blended);
    };
};













function $7c24e3fb3ccfb2d4$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $338f435df31a3d26$export$844ec244b1367d54)(v) && (((_a = v.match((0, $338f435df31a3d26$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $338f435df31a3d26$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $7c24e3fb3ccfb2d4$var$cssVarTokeniser = {
    regex: (0, $58159485ea5b9511$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $dcf17e8536d5fb4f$export$8793edee2d425525)
};
const $7c24e3fb3ccfb2d4$var$colorTokeniser = {
    regex: (0, $338f435df31a3d26$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $4dc0621296be153e$export$35e9368ef982300f).parse
};
const $7c24e3fb3ccfb2d4$var$numberTokeniser = {
    regex: (0, $338f435df31a3d26$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $9ad8a8be30ce5844$export$98e628dec113755e).parse
};
function $7c24e3fb3ccfb2d4$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $7c24e3fb3ccfb2d4$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $7c24e3fb3ccfb2d4$var$tokenise(info, $7c24e3fb3ccfb2d4$var$cssVarTokeniser);
    $7c24e3fb3ccfb2d4$var$tokenise(info, $7c24e3fb3ccfb2d4$var$colorTokeniser);
    $7c24e3fb3ccfb2d4$var$tokenise(info, $7c24e3fb3ccfb2d4$var$numberTokeniser);
    return info;
}
function $7c24e3fb3ccfb2d4$var$parseComplexValue(v) {
    return $7c24e3fb3ccfb2d4$export$b61fc7c44bf646d5(v).values;
}
function $7c24e3fb3ccfb2d4$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $7c24e3fb3ccfb2d4$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($7c24e3fb3ccfb2d4$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($7c24e3fb3ccfb2d4$var$colorTokeniser.token, (0, $4dc0621296be153e$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($7c24e3fb3ccfb2d4$var$numberTokeniser.token, (0, $338f435df31a3d26$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $7c24e3fb3ccfb2d4$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $7c24e3fb3ccfb2d4$var$getAnimatableNone(v) {
    const parsed = $7c24e3fb3ccfb2d4$var$parseComplexValue(v);
    const transformer = $7c24e3fb3ccfb2d4$var$createTransformer(v);
    return transformer(parsed.map($7c24e3fb3ccfb2d4$var$convertNumbersToZero));
}
const $7c24e3fb3ccfb2d4$export$83a0e34f1302825b = {
    test: $7c24e3fb3ccfb2d4$var$test,
    parse: $7c24e3fb3ccfb2d4$var$parseComplexValue,
    createTransformer: $7c24e3fb3ccfb2d4$var$createTransformer,
    getAnimatableNone: $7c24e3fb3ccfb2d4$var$getAnimatableNone
};


const $00da527ed9b21873$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $00da527ed9b21873$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $6547127f992c1078$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $4dc0621296be153e$export$35e9368ef982300f).test(origin)) return (0, $e5a66d3fc8862ad9$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $00da527ed9b21873$var$mixImmediate(origin, target) : $00da527ed9b21873$export$65516310a87d8205(origin, target);
}
const $00da527ed9b21873$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$00da527ed9b21873$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $00da527ed9b21873$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, origin, target);
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $00da527ed9b21873$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $00da527ed9b21873$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $7c24e3fb3ccfb2d4$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $7c24e3fb3ccfb2d4$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $81c10aac384f5ba3$export$a4627e546088548d)($00da527ed9b21873$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $faee95b32f04793f$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $00da527ed9b21873$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $6fc1d9b67c5d7cd4$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $cd3a4e99a88f1222$var$mixNumber = (from, to)=>(p)=>(0, $6547127f992c1078$export$2c9e8a9632a706b2)(from, to, p);
function $cd3a4e99a88f1222$var$detectMixerFactory(v) {
    if (typeof v === "number") return $cd3a4e99a88f1222$var$mixNumber;
    else if (typeof v === "string") return (0, $4dc0621296be153e$export$35e9368ef982300f).test(v) ? (0, $e5a66d3fc8862ad9$export$51e568cf5c039bac) : (0, $00da527ed9b21873$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $00da527ed9b21873$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $00da527ed9b21873$export$ebc23b6840c51ba1;
    return $cd3a4e99a88f1222$var$mixNumber;
}
function $cd3a4e99a88f1222$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $cd3a4e99a88f1222$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $dcf17e8536d5fb4f$export$8793edee2d425525) : ease;
            mixer = (0, $81c10aac384f5ba3$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $cd3a4e99a88f1222$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $faee95b32f04793f$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $cd3a4e99a88f1222$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $6fc1d9b67c5d7cd4$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $efee312df0ae1acd$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $6fc1d9b67c5d7cd4$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $6547127f992c1078$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $009cfdc0ed035ef1$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $efee312df0ae1acd$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $0f38857b669e010e$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $712034bcad0bd3f0$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $4b2d8ea621676e4a$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $712034bcad0bd3f0$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $7d2532405ded3ea5$export$216948827bbdc797)(ease) ? ease.map((0, $a4ee59a17d946ff8$export$ef97fe084f156ca4)) : (0, $a4ee59a17d946ff8$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $0f38857b669e010e$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $009cfdc0ed035ef1$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $cd3a4e99a88f1222$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $712034bcad0bd3f0$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}






/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $fc31a30583b4fe53$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $ffa64122c9b9a90f$var$velocitySampleDuration = 5; // ms
function $ffa64122c9b9a90f$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $ffa64122c9b9a90f$var$velocitySampleDuration, 0);
    return (0, $fc31a30583b4fe53$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $cab5cc8e79bc5280$var$safeMin = 0.001;
const $cab5cc8e79bc5280$export$a3cdb76e84ee608e = 0.01;
const $cab5cc8e79bc5280$export$1824b851fad8862b = 10.0;
const $cab5cc8e79bc5280$export$ff08f2d53484465 = 0.05;
const $cab5cc8e79bc5280$export$201ca48e54038115 = 1;
function $cab5cc8e79bc5280$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $faee95b32f04793f$export$491112666e282270)(duration <= (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)($cab5cc8e79bc5280$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)($cab5cc8e79bc5280$export$ff08f2d53484465, $cab5cc8e79bc5280$export$201ca48e54038115, dampingRatio);
    duration = (0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)($cab5cc8e79bc5280$export$a3cdb76e84ee608e, $cab5cc8e79bc5280$export$1824b851fad8862b, (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $cab5cc8e79bc5280$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $cab5cc8e79bc5280$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $cab5cc8e79bc5280$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $cab5cc8e79bc5280$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$cab5cc8e79bc5280$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $cab5cc8e79bc5280$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $cab5cc8e79bc5280$var$rootIterations = 12;
function $cab5cc8e79bc5280$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $cab5cc8e79bc5280$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $cab5cc8e79bc5280$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $d0316fb58456992f$var$durationKeys = [
    "duration",
    "bounce"
];
const $d0316fb58456992f$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $d0316fb58456992f$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $d0316fb58456992f$var$getSpringOptions(options) {
    let springOptions = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    // stiffness/damping/mass overrides duration/bounce
    if (!$d0316fb58456992f$var$isSpringType(options, $d0316fb58456992f$var$physicsKeys) && $d0316fb58456992f$var$isSpringType(options, $d0316fb58456992f$var$durationKeys)) {
        const derived = (0, $cab5cc8e79bc5280$export$b15f158dc6d6f458)(options);
        springOptions = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, springOptions, derived), {
            velocity: 0.0,
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $d0316fb58456992f$export$b36281d89752ae66(_param) {
    var { keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed } = _param, options = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "keyframes",
        "restDelta",
        "restSpeed"
    ]);
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $d0316fb58456992f$var$getSpringOptions(options);
    const initialVelocity = velocity ? -(0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(velocity) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $cab5cc8e79bc5280$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $ffa64122c9b9a90f$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $2ec82feee7e066a4$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $d0316fb58456992f$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $ffa64122c9b9a90f$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $cf5a1cd070499774$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $abdd74f2cc691999$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $abdd74f2cc691999$export$fff89137e9e818ce).isProcessing ? (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $3d7ae8dd746b979b$export$f4ff70a5b4808fd8 = 20000;
function $3d7ae8dd746b979b$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $3d7ae8dd746b979b$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $3d7ae8dd746b979b$export$f4ff70a5b4808fd8 ? Infinity : duration;
}


const $07b37c423959864d$var$types = {
    decay: (0, $2ec82feee7e066a4$export$ee3ff3a17106998),
    inertia: $2ec82feee7e066a4$export$ee3ff3a17106998,
    tween: (0, $712034bcad0bd3f0$export$d25ddfdf17c3ad3e),
    keyframes: (0, $712034bcad0bd3f0$export$d25ddfdf17c3ad3e),
    spring: $d0316fb58456992f$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $07b37c423959864d$export$ee9b76de7353d815(_param) {
    var { autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $cf5a1cd070499774$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate } = _param, options = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "autoplay",
        "delay",
        "driver",
        "keyframes",
        "type",
        "repeat",
        "repeatDelay",
        "repeatType",
        "onPlay",
        "onStop",
        "onComplete",
        "onUpdate"
    ]);
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $07b37c423959864d$var$types[type] || (0, $712034bcad0bd3f0$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     * TODO: Support velocity for units and complex value types/
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $712034bcad0bd3f0$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $cd3a4e99a88f1222$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory((0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, options), {
        keyframes: keyframes$1
    }));
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory((0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, options), {
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    }));
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $3d7ae8dd746b979b$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = currentTime / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = Boolean(currentIteration % 2);
            if (iterationIsOdd) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            let p = (0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress);
            if (currentTime > totalDuration) p = repeatType === "reverse" && iterationIsOdd ? 1 : 0;
            elapsed = p * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $3d7ae8dd746b979b$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}



function $03368a0fa40656d3$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}




const $f9975aca839c67fa$var$supportsWaapi = (0, $03368a0fa40656d3$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $f9975aca839c67fa$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $f9975aca839c67fa$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $f9975aca839c67fa$var$maxDuration = 20000;
const $f9975aca839c67fa$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $098e26d9afc788ba$export$fcdd8f3f2160beda)(options.ease);
function $f9975aca839c67fa$export$4d5d9557ab897126(value, valueName, _param) {
    var { onUpdate: onUpdate, onComplete: onComplete } = _param, options = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "onUpdate",
        "onComplete"
    ]);
    const canAccelerateAnimation = $f9975aca839c67fa$var$supportsWaapi() && $f9975aca839c67fa$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($f9975aca839c67fa$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $07b37c423959864d$export$ee9b76de7353d815)((0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, options), {
            repeat: 0,
            delay: 0
        }));
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $f9975aca839c67fa$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $f9975aca839c67fa$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $f9975aca839c67fa$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $e6d1c43098e794ae$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, options), {
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    }));
    /**
     * WAAPI animations don't resolve startTime synchronously. But a blocked
     * thread could delay the startTime resolution by a noticeable amount.
     * For synching handoff animations with the new Motion animation we want
     * to ensure startTime is synchronously set.
     */ if (options.syncStart) animation.startTime = (0, $abdd74f2cc691999$export$fff89137e9e818ce).isProcessing ? (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp : document.timeline ? document.timeline.currentTime : performance.now();
    const cancelAnimation = ()=>animation.cancel();
    const safeCancel = ()=>{
        (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        value.set((0, $71f528837f15cf2e$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $dcf17e8536d5fb4f$export$8793edee2d425525;
        },
        get time () {
            return (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $07b37c423959864d$export$ee9b76de7353d815)((0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, options), {
                    autoplay: false
                }));
                value.setWithVelocity(sampleAnimation.sample(currentTime - $f9975aca839c67fa$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $f9975aca839c67fa$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>animation.finish(),
        cancel: safeCancel
    };
    return controls;
}




function $3c69f9995b7d9d6c$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $dcf17e8536d5fb4f$export$8793edee2d425525),
            pause: (0, $dcf17e8536d5fb4f$export$8793edee2d425525),
            stop: (0, $dcf17e8536d5fb4f$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $dcf17e8536d5fb4f$export$8793edee2d425525),
            complete: (0, $dcf17e8536d5fb4f$export$8793edee2d425525)
        };
    };
    return delay ? (0, $07b37c423959864d$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $f3507eb24a522f61$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $f3507eb24a522f61$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $f3507eb24a522f61$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $f3507eb24a522f61$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $f3507eb24a522f61$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $f3507eb24a522f61$var$keyframesTransition;
    else if ((0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $f3507eb24a522f61$var$criticallyDampedSpring(keyframes[1]) : $f3507eb24a522f61$var$underDampedSpring;
    return $f3507eb24a522f61$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $3371f0ca4fc89c46$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};







/**
 * Properties that should default to 1 or 100%
 */ const $f5689d8b8e6d59f7$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $f5689d8b8e6d59f7$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $338f435df31a3d26$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $f5689d8b8e6d59f7$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $f5689d8b8e6d59f7$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $f5689d8b8e6d59f7$export$3dea766d36a8935f = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b)), {
    getAnimatableNone: (v)=>{
        const functions = v.match($f5689d8b8e6d59f7$var$functionRegex);
        return functions ? functions.map($f5689d8b8e6d59f7$var$applyDefaultFilter).join(" ") : v;
    }
});







/**
 * A map of default value types for common values
 */ const $0b53a6efb3642986$export$98cd7c72c5a731fb = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, (0, $5cd21c5d2c5b7cec$export$eec14432cd1cb67b)), {
    color: // Color props
    $4dc0621296be153e$export$35e9368ef982300f,
    backgroundColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    outlineColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    fill: (0, $4dc0621296be153e$export$35e9368ef982300f),
    stroke: (0, $4dc0621296be153e$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    borderTopColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    borderRightColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    borderBottomColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    borderLeftColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    filter: $f5689d8b8e6d59f7$export$3dea766d36a8935f,
    WebkitFilter: (0, $f5689d8b8e6d59f7$export$3dea766d36a8935f)
});
/**
 * Gets the default ValueType for the provided value key
 */ const $0b53a6efb3642986$export$67d1babe0338d23b = (key)=>$0b53a6efb3642986$export$98cd7c72c5a731fb[key];


function $52c5d0266b29e428$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $0b53a6efb3642986$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $f5689d8b8e6d59f7$export$3dea766d36a8935f)) defaultValueType = (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $96f381b193ee6086$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $63ed2da846c28a44$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $96f381b193ee6086$export$ade84c85e44a6cb1)(value);
}


function $701f1c7ab5ce4d4f$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $3371f0ca4fc89c46$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $63ed2da846c28a44$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $52c5d0266b29e428$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ 
function $6dd602398ed69a9c$export$ca8e47dc8ed5a9d7(_param) {
    var { when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed } = _param, transition = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from",
        "elapsed"
    ]);
    return !!Object.keys(transition).length;
}
function $6dd602398ed69a9c$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $9672f3cc4d35c47f$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $6dd602398ed69a9c$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $701f1c7ab5ce4d4f$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $3371f0ca4fc89c46$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $3371f0ca4fc89c46$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $faee95b32f04793f$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut"
        }, valueTransition), {
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        });
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $6dd602398ed69a9c$export$ca8e47dc8ed5a9d7)(valueTransition)) options = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, options, (0, $f3507eb24a522f61$export$262124b154b9f1c0)(valueName, options));
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $8fa4692997fef09a$export$888a3d84909f9e3d).current || valueTransition.type === false) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $3c69f9995b7d9d6c$export$6f34fc8ef6c42b70)((0, $8fa4692997fef09a$export$888a3d84909f9e3d).current ? (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, options), {
            delay: 0
        }) : options);
        /**
         * Animate via WAAPI if possible.
         */ if (value.owner && value.owner.current instanceof HTMLElement && !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $f9975aca839c67fa$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $07b37c423959864d$export$ee9b76de7353d815)(options);
    };
};



function $58059ad17277dd8f$export$98397f3adbf6259f(value) {
    return Boolean((0, $251f7d673c9c86a3$export$605d60a2578142d3)(value) && value.add);
}




/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $586a8c9354c052af$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);




function $c96f8df7c05c7795$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $c96f8df7c05c7795$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $c96f8df7c05c7795$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $4f660a66e171c06b$export$e7dff9482a5fd23c {
    add(handler) {
        (0, $c96f8df7c05c7795$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $c96f8df7c05c7795$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
    constructor(){
        this.subscriptions = [];
    }
}





const $79d69d565640708f$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $79d69d565640708f$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $79d69d565640708f$export$8cea36d14ee64562 {
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $4f660a66e171c06b$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $abdd74f2cc691999$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($79d69d565640708f$export$67fcd818a264039d.current) $79d69d565640708f$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $fc31a30583b4fe53$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.16.11";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $abdd74f2cc691999$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $abdd74f2cc691999$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $abdd74f2cc691999$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $79d69d565640708f$var$isFloat(this.current);
        this.owner = options.owner;
    }
}
function $79d69d565640708f$export$ce8bdc721e76545f(init, options) {
    return new $79d69d565640708f$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $e73715ad81b54c5b$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $d8af184010c14e94$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $f2ef0e515384c134$export$d176691c1998a1f5 = [
    (0, $9ad8a8be30ce5844$export$98e628dec113755e),
    (0, $d414efec423ce291$export$91c0eda1d06bf008),
    (0, $d414efec423ce291$export$626336c2cd4b14de),
    (0, $d414efec423ce291$export$41fc368e1a942b97),
    (0, $d414efec423ce291$export$aed3d7b7d206c196),
    (0, $d414efec423ce291$export$f91e8c45a95a32f2),
    (0, $d8af184010c14e94$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $f2ef0e515384c134$export$eefdd52e3ccae428 = (v)=>$f2ef0e515384c134$export$d176691c1998a1f5.find((0, $e73715ad81b54c5b$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $b2f7b57e3e0175ec$var$valueTypes = [
    ...(0, $f2ef0e515384c134$export$d176691c1998a1f5),
    (0, $4dc0621296be153e$export$35e9368ef982300f),
    (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $b2f7b57e3e0175ec$export$950e7e59ea1ffed7 = (v)=>$b2f7b57e3e0175ec$var$valueTypes.find((0, $e73715ad81b54c5b$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $284183dc41cada08$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $79d69d565640708f$export$ce8bdc721e76545f)(value));
}
function $284183dc41cada08$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $09bc9ca971307c1d$export$7b1b1c981f4f0558)(visualElement, definition);
    let _ref = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, { transitionEnd: transitionEnd = {}, transition: transition = {} } = _ref, target = (0, $c4006311849aa271$export$69fdd232f62cde60)(_ref, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, target, transitionEnd);
    for(const key in target){
        const value = (0, $4d89fd6dc8b0f394$export$5485128c47bd48bb)(target[key]);
        $284183dc41cada08$var$setMotionValue(visualElement, key, value);
    }
}
function $284183dc41cada08$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $284183dc41cada08$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $284183dc41cada08$var$setVariants(child, variantLabels);
        });
    });
}
function $284183dc41cada08$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $284183dc41cada08$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $284183dc41cada08$var$setVariants(visualElement, [
        definition
    ]);
    else $284183dc41cada08$export$1f61c53461aff4a5(visualElement, definition);
}
function $284183dc41cada08$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $586a8c9354c052af$export$65583ed5a868f2d9)(value) || (0, $96f381b193ee6086$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $b2f7b57e3e0175ec$export$950e7e59ea1ffed7)(value) && (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b).test(targetValue)) value = (0, $52c5d0266b29e428$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $79d69d565640708f$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $284183dc41cada08$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $284183dc41cada08$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $284183dc41cada08$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}




/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $cc3ad3de4cb35171$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $cc3ad3de4cb35171$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let _visualElement_makeTargetAnimatable = visualElement.makeTargetAnimatable(definition), { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd } = _visualElement_makeTargetAnimatable, target = (0, $c4006311849aa271$export$69fdd232f62cde60)(_visualElement_makeTargetAnimatable, [
        "transition",
        "transitionEnd"
    ]);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $cc3ad3de4cb35171$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({
            delay: delay,
            elapsed: 0
        }, (0, $6dd602398ed69a9c$export$7c1391340308742e)(transition || {}, key));
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let canSkipHandoff = true;
        if (window.HandoffAppearAnimations && !value.hasAnimated) {
            const appearId = visualElement.getProps()[0, $acf7e02863b7c6a2$export$8592e1c077c890a6];
            if (appearId) {
                canSkipHandoff = false;
                valueTransition.elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $abdd74f2cc691999$export$2cef06c20297c17d));
                valueTransition.syncStart = true;
            }
        }
        let canSkip = canSkipHandoff && valueTarget === value.get();
        if (valueTransition.type === "spring" && (value.getVelocity() || valueTransition.velocity)) canSkip = false;
        /**
         * Temporarily disable skipping animations if there's an animation in
         * progress. Better would be to track the current target of a value
         * and compare that against valueTarget.
         */ if (value.animation) canSkip = false;
        if (canSkip) continue;
        value.start((0, $9672f3cc4d35c47f$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $58059ad17277dd8f$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $284183dc41cada08$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}






function $76b8fd27e9a24a2a$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $09bc9ca971307c1d$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $cc3ad3de4cb35171$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $76b8fd27e9a24a2a$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $76b8fd27e9a24a2a$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($76b8fd27e9a24a2a$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($76b8fd27e9a24a2a$export$4709dc300705b2af(child, variant, (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $76b8fd27e9a24a2a$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $25633fa26ef1b230$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $76b8fd27e9a24a2a$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $76b8fd27e9a24a2a$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $09bc9ca971307c1d$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $cc3ad3de4cb35171$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}


const $dd83ae5ab182dd8d$var$reversePriorityOrder = [
    ...(0, $20855a5d0b260125$export$16e45afcc206d3a8)
].reverse();
const $dd83ae5ab182dd8d$var$numAnimationTypes = (0, $20855a5d0b260125$export$16e45afcc206d3a8).length;
function $dd83ae5ab182dd8d$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $25633fa26ef1b230$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $dd83ae5ab182dd8d$export$bb53502b7a672aa8(visualElement) {
    let animate = $dd83ae5ab182dd8d$var$animateList(visualElement);
    const state = $dd83ae5ab182dd8d$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $09bc9ca971307c1d$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd } = resolved, target = (0, $c4006311849aa271$export$69fdd232f62cde60)(resolved, [
                "transition",
                "transitionEnd"
            ]);
            acc = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, acc, target, transitionEnd);
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $dd83ae5ab182dd8d$var$numAnimationTypes; i++){
            const type = $dd83ae5ab182dd8d$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $23e2b8e45e65dfac$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $cba7aa384b255de7$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $dd83ae5ab182dd8d$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, prevResolvedValues, resolvedValues);
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $cdfb45bee9c27be9$export$9153ad4c4999f4a0)(next) && (0, $cdfb45bee9c27be9$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $b72ed983341c6484$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, encounteredKeys, resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: (0, $66a5668b38a29be4$export$581ff339ea0ba762)({
                        type: type
                    }, options)
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $dd83ae5ab182dd8d$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $b72ed983341c6484$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $dd83ae5ab182dd8d$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $dd83ae5ab182dd8d$var$createState() {
    return {
        animate: $dd83ae5ab182dd8d$var$createTypeState(true),
        whileInView: $dd83ae5ab182dd8d$var$createTypeState(),
        whileHover: $dd83ae5ab182dd8d$var$createTypeState(),
        whileTap: $dd83ae5ab182dd8d$var$createTypeState(),
        whileDrag: $dd83ae5ab182dd8d$var$createTypeState(),
        whileFocus: $dd83ae5ab182dd8d$var$createTypeState(),
        exit: $dd83ae5ab182dd8d$var$createTypeState()
    };
}



class $c25a4516189cca97$export$b45b3fe5caabdca extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $cba7aa384b255de7$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $dd83ae5ab182dd8d$export$bb53502b7a672aa8)(node));
    }
}



let $056087ff4c0a12f5$var$id = 0;
class $056087ff4c0a12f5$export$4989d1eb6104cc6c extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.id = $056087ff4c0a12f5$var$id++;
    }
}


const $1a6859e1b2177404$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $c25a4516189cca97$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $056087ff4c0a12f5$export$4989d1eb6104cc6c)
    }
};













const $ca59ff59f5b9b641$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $ca59ff59f5b9b641$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $ca59ff59f5b9b641$export$9f17032d917177de(a.x, b.x);
    const yDelta = $ca59ff59f5b9b641$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $0edc1aba4122b85c$export$d9c66232c9c4689c {
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(this.updatePoint);
    }
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $0edc1aba4122b85c$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $ca59ff59f5b9b641$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $abdd74f2cc691999$export$fff89137e9e818ce);
            this.history.push((0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, point), {
                timestamp: timestamp
            }));
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $0edc1aba4122b85c$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            const panInfo = $0edc1aba4122b85c$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $0edc1aba4122b85c$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $e686dca3072f0847$export$a4cf9c8a4b063a6e)(event)) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $230784ee47833b0a$export$12f84bb882d06e1a)(event);
        const initialInfo = $0edc1aba4122b85c$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $abdd74f2cc691999$export$fff89137e9e818ce);
        this.history = [
            (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, point), {
                timestamp: timestamp
            })
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $0edc1aba4122b85c$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $81c10aac384f5ba3$export$a4627e546088548d)((0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
}
function $0edc1aba4122b85c$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $0edc1aba4122b85c$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $0edc1aba4122b85c$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $0edc1aba4122b85c$var$subtractPoint(point, $0edc1aba4122b85c$var$lastDevicePoint(history)),
        offset: $0edc1aba4122b85c$var$subtractPoint(point, $0edc1aba4122b85c$var$startDevicePoint(history)),
        velocity: $0edc1aba4122b85c$var$getVelocity(history, 0.1)
    };
}
function $0edc1aba4122b85c$var$startDevicePoint(history) {
    return history[0];
}
function $0edc1aba4122b85c$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $0edc1aba4122b85c$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $0edc1aba4122b85c$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $981dbb7bd35e3220$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $981dbb7bd35e3220$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $981dbb7bd35e3220$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $981dbb7bd35e3220$export$c1c127004b72a37(target) / $981dbb7bd35e3220$export$c1c127004b72a37(source);
    if ($981dbb7bd35e3220$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($981dbb7bd35e3220$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $981dbb7bd35e3220$export$c0d25e96fc67d310(delta, source, target, origin) {
    $981dbb7bd35e3220$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $981dbb7bd35e3220$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $981dbb7bd35e3220$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $981dbb7bd35e3220$export$c1c127004b72a37(relative);
}
function $981dbb7bd35e3220$export$426154f9d100f99(target, relative, parent) {
    $981dbb7bd35e3220$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $981dbb7bd35e3220$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $981dbb7bd35e3220$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $981dbb7bd35e3220$export$c1c127004b72a37(layout);
}
function $981dbb7bd35e3220$export$2785bfcc929c5650(target, layout, parent) {
    $981dbb7bd35e3220$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $981dbb7bd35e3220$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $feceabd437ab568a$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $6547127f992c1078$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $6547127f992c1078$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $feceabd437ab568a$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $feceabd437ab568a$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $feceabd437ab568a$export$690c180aa5775042(layoutBox.x, left, right),
        y: $feceabd437ab568a$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $feceabd437ab568a$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $feceabd437ab568a$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $feceabd437ab568a$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $feceabd437ab568a$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $feceabd437ab568a$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(source);
    const targetLength = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $6fc1d9b67c5d7cd4$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $6fc1d9b67c5d7cd4$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $feceabd437ab568a$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $feceabd437ab568a$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $feceabd437ab568a$export$7c5eaef8f4723d22(dragElastic = $feceabd437ab568a$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $feceabd437ab568a$export$a3366d3bac43a742;
    return {
        x: $feceabd437ab568a$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $feceabd437ab568a$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $feceabd437ab568a$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $feceabd437ab568a$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $feceabd437ab568a$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $feceabd437ab568a$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $130a04a50c584572$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $130a04a50c584572$export$3d227df54007d73a = ()=>({
        x: $130a04a50c584572$export$ff25708b37f72782(),
        y: $130a04a50c584572$export$ff25708b37f72782()
    });
const $130a04a50c584572$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $130a04a50c584572$export$6459fc9e86be362e = ()=>({
        x: $130a04a50c584572$export$6db76765312617ac(),
        y: $130a04a50c584572$export$6db76765312617ac()
    });


function $561ecab7bc487cb5$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $6113e12a67eb6306$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $6113e12a67eb6306$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $6113e12a67eb6306$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $245b5e64e7ae0d35$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $245b5e64e7ae0d35$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$245b5e64e7ae0d35$var$isIdentityScale(scale) || !$245b5e64e7ae0d35$var$isIdentityScale(scaleX) || !$245b5e64e7ae0d35$var$isIdentityScale(scaleY);
}
function $245b5e64e7ae0d35$export$a545127cf1fbb600(values) {
    return $245b5e64e7ae0d35$export$bdf30dca883ea463(values) || $245b5e64e7ae0d35$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $245b5e64e7ae0d35$export$bf80f5f8f4dc327f(values) {
    return $245b5e64e7ae0d35$var$is2DTranslate(values.x) || $245b5e64e7ae0d35$var$is2DTranslate(values.y);
}
function $245b5e64e7ae0d35$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d7183edf0eab2b8a$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d7183edf0eab2b8a$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d7183edf0eab2b8a$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d7183edf0eab2b8a$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d7183edf0eab2b8a$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d7183edf0eab2b8a$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d7183edf0eab2b8a$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d7183edf0eab2b8a$export$d80074982803af5c(box, { x: x, y: y }) {
    $d7183edf0eab2b8a$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d7183edf0eab2b8a$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d7183edf0eab2b8a$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d7183edf0eab2b8a$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d7183edf0eab2b8a$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(node.latestValues)) $d7183edf0eab2b8a$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $d7183edf0eab2b8a$var$snapToDefault(treeScale.x);
    treeScale.y = $d7183edf0eab2b8a$var$snapToDefault(treeScale.y);
}
function $d7183edf0eab2b8a$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $d7183edf0eab2b8a$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d7183edf0eab2b8a$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d7183edf0eab2b8a$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $d7183edf0eab2b8a$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $d7183edf0eab2b8a$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d7183edf0eab2b8a$export$58b16271041fbfb(box, transform) {
    $d7183edf0eab2b8a$export$625f1dd140a2f5e7(box.x, transform, $d7183edf0eab2b8a$var$xKeys);
    $d7183edf0eab2b8a$export$625f1dd140a2f5e7(box.y, transform, $d7183edf0eab2b8a$var$yKeys);
}


function $251bbb6a3c87ae07$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $6113e12a67eb6306$export$d3955c6a8f65a36b)((0, $6113e12a67eb6306$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $251bbb6a3c87ae07$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $251bbb6a3c87ae07$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $ac41a0567f61a1d6$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};



const $af92ecd6ba1f7e78$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $af92ecd6ba1f7e78$export$86bff71f18910307 {
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $230784ee47833b0a$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $6b9c534ca65d1916$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $d414efec423ce291$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $af92ecd6ba1f7e78$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        this.panSession = new (0, $0edc1aba4122b85c$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            contextWindow: (0, $ac41a0567f61a1d6$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$af92ecd6ba1f7e78$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $feceabd437ab568a$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $1c79ac3705c6b6d1$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $feceabd437ab568a$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $feceabd437ab568a$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $feceabd437ab568a$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $1c79ac3705c6b6d1$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $faee95b32f04793f$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $251bbb6a3c87ae07$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $feceabd437ab568a$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $6113e12a67eb6306$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $6113e12a67eb6306$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            if (!$af92ecd6ba1f7e78$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition, transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $9672f3cc4d35c47f$export$90b3dfc33ff3548)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$af92ecd6ba1f7e78$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $6547127f992c1078$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $1c79ac3705c6b6d1$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $feceabd437ab568a$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            if (!$af92ecd6ba1f7e78$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $6547127f992c1078$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $af92ecd6ba1f7e78$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $1c79ac3705c6b6d1$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $feceabd437ab568a$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, props), {
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        });
    }
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $130a04a50c584572$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
}
function $af92ecd6ba1f7e78$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $af92ecd6ba1f7e78$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $d1975e8dea510822$export$5d97dc2872682820 extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
        this.removeListeners = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
        this.controls = new (0, $af92ecd6ba1f7e78$export$86bff71f18910307)(node);
    }
}








const $e22e1dd92051f0a0$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>handler(event, info));
    };
class $e22e1dd92051f0a0$export$b4f8f1ee75ce5859 extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $0edc1aba4122b85c$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $ac41a0567f61a1d6$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $e22e1dd92051f0a0$var$asyncHandler(onPanSessionStart),
            onStart: $e22e1dd92051f0a0$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
    }
}





var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $35c3ca91a4fc3062$export$2a8c16d82a0a0e26() {
    const context = (0, $6cds3.useContext)((0, $e40c1c7ce208ba78$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $6cds3.useId)();
    (0, $6cds3.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $35c3ca91a4fc3062$export$8249053f690ea39a() {
    return $35c3ca91a4fc3062$export$ee27c052bca048fb((0, $6cds3.useContext)((0, $e40c1c7ce208ba78$export$f224e4635b6f8ce2)));
}
function $35c3ca91a4fc3062$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $1ba477217000c17f$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $f033999f3b94341e$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $f033999f3b94341e$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $d414efec423ce291$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $f033999f3b94341e$export$fafff692be55225d(latest, node.target.x);
        const y = $f033999f3b94341e$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $5fbaf6db683a9111$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};




class $bf0011aeb54a8603$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $f4236abcb41ce1af$export$de9e7791c71225fd)($bf0011aeb54a8603$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions((0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, projection.options), {
                onExitComplete: ()=>this.safeToRemove()
            }));
        }
        (0, $1ba477217000c17f$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $abdd74f2cc691999$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $bf0011aeb54a8603$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $35c3ca91a4fc3062$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $6cds3.useContext)((0, $5f7d717553e210fe$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($bf0011aeb54a8603$var$MeasureLayoutWithContext, (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, props), {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $6cds3.useContext)((0, $80cd083093aee758$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}
const $bf0011aeb54a8603$var$defaultScaleCorrectors = {
    borderRadius: (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, (0, $f033999f3b94341e$export$5eafb6257a5844c)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, $f033999f3b94341e$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $f033999f3b94341e$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $f033999f3b94341e$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $f033999f3b94341e$export$5eafb6257a5844c),
    boxShadow: (0, $5fbaf6db683a9111$export$eb0bc629e74dcf8)
};










const $5b730dc57489e238$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $5b730dc57489e238$var$numBorders = $5b730dc57489e238$var$borders.length;
const $5b730dc57489e238$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $5b730dc57489e238$var$isPx = (value)=>typeof value === "number" || (0, $d414efec423ce291$export$91c0eda1d06bf008).test(value);
function $5b730dc57489e238$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $5b730dc57489e238$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $5b730dc57489e238$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $5b730dc57489e238$var$numBorders; i++){
        const borderLabel = `border${$5b730dc57489e238$var$borders[i]}Radius`;
        let followRadius = $5b730dc57489e238$var$getRadius(follow, borderLabel);
        let leadRadius = $5b730dc57489e238$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $5b730dc57489e238$var$isPx(followRadius) === $5b730dc57489e238$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $6547127f992c1078$export$2c9e8a9632a706b2)($5b730dc57489e238$var$asNumber(followRadius), $5b730dc57489e238$var$asNumber(leadRadius), progress), 0);
            if ((0, $d414efec423ce291$export$626336c2cd4b14de).test(leadRadius) || (0, $d414efec423ce291$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $5b730dc57489e238$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $5b730dc57489e238$var$easeCrossfadeIn = $5b730dc57489e238$var$compress(0, 0.5, (0, $d6fb562c03554c29$export$c8d67a19199d1a50));
const $5b730dc57489e238$var$easeCrossfadeOut = $5b730dc57489e238$var$compress(0.5, 0.95, (0, $dcf17e8536d5fb4f$export$8793edee2d425525));
function $5b730dc57489e238$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $6fc1d9b67c5d7cd4$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5f205044d0db3736$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5f205044d0db3736$export$c53fd88f45d77e4b(box, originBox) {
    $5f205044d0db3736$export$a0230ae482601ae8(box.x, originBox.x);
    $5f205044d0db3736$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $7ad777e49fa4a365$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d7183edf0eab2b8a$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d7183edf0eab2b8a$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $7ad777e49fa4a365$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $d414efec423ce291$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $7ad777e49fa4a365$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $7ad777e49fa4a365$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $7ad777e49fa4a365$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $7ad777e49fa4a365$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $7ad777e49fa4a365$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $7ad777e49fa4a365$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $7ad777e49fa4a365$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $7ad777e49fa4a365$export$42b76f1d0d16d5b(box.x, transforms, $7ad777e49fa4a365$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $7ad777e49fa4a365$export$42b76f1d0d16d5b(box.y, transforms, $7ad777e49fa4a365$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $9d2bb0d64b3cd7fc$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $9d2bb0d64b3cd7fc$export$a7ec7642fe550fb6(delta) {
    return $9d2bb0d64b3cd7fc$var$isAxisDeltaZero(delta.x) && $9d2bb0d64b3cd7fc$var$isAxisDeltaZero(delta.y);
}
function $9d2bb0d64b3cd7fc$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $9d2bb0d64b3cd7fc$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $9d2bb0d64b3cd7fc$export$c5706146bc63213(box) {
    return (0, $981dbb7bd35e3220$export$c1c127004b72a37)(box.x) / (0, $981dbb7bd35e3220$export$c1c127004b72a37)(box.y);
}



class $1a1417a9e50596e8$export$39be5b2d82fc9dc7 {
    add(node) {
        (0, $c96f8df7c05c7795$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $c96f8df7c05c7795$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
    constructor(){
        this.members = [];
    }
}



function $c7f5fc751b151e12$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $4e9dc7afe657b330$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $d5623a75f1f312b3$export$1465d17e3de78a96 {
    add(child) {
        (0, $c96f8df7c05c7795$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $c96f8df7c05c7795$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $4e9dc7afe657b330$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
}





/**
 * Timeout defined in ms
 */ function $aaecb8b12257cf1a$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $abdd74f2cc691999$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(checkElapsed);
}



function $f8a34acd939b8b40$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $a45afbf9cac8c0ab$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $cb991438c56936ca$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $251f7d673c9c86a3$export$605d60a2578142d3)(value) ? value : (0, $79d69d565640708f$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $9672f3cc4d35c47f$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}





const $172c8329ecf90fdd$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $172c8329ecf90fdd$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $172c8329ecf90fdd$var$animationTarget = 1000;
let $172c8329ecf90fdd$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $172c8329ecf90fdd$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $172c8329ecf90fdd$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $4f660a66e171c06b$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $a45afbf9cac8c0ab$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $aaecb8b12257cf1a$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $1ba477217000c17f$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $1ba477217000c17f$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($172c8329ecf90fdd$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $172c8329ecf90fdd$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $9d2bb0d64b3cd7fc$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, (0, $6dd602398ed69a9c$export$7c1391340308742e)(layoutTransition, "layout")), {
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    });
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $172c8329ecf90fdd$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($172c8329ecf90fdd$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($172c8329ecf90fdd$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($172c8329ecf90fdd$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($172c8329ecf90fdd$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($172c8329ecf90fdd$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($172c8329ecf90fdd$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, $abdd74f2cc691999$export$fff89137e9e818ce).delta = (0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp);
            (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp = now;
            (0, $abdd74f2cc691999$export$fff89137e9e818ce).isProcessing = true;
            (0, $abdd74f2cc691999$export$be3f796aed065412).update.process((0, $abdd74f2cc691999$export$fff89137e9e818ce));
            (0, $abdd74f2cc691999$export$be3f796aed065412).preRender.process((0, $abdd74f2cc691999$export$fff89137e9e818ce));
            (0, $abdd74f2cc691999$export$be3f796aed065412).render.process((0, $abdd74f2cc691999$export$fff89137e9e818ce));
            (0, $abdd74f2cc691999$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($172c8329ecf90fdd$var$clearSnapshot);
            this.sharedNodes.forEach($172c8329ecf90fdd$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $abdd74f2cc691999$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $abdd74f2cc691999$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $9d2bb0d64b3cd7fc$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $172c8329ecf90fdd$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $130a04a50c584572$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d7183edf0eab2b8a$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d7183edf0eab2b8a$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(this.latestValues)) (0, $d7183edf0eab2b8a$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $245b5e64e7ae0d35$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $7ad777e49fa4a365$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(this.latestValues)) (0, $7ad777e49fa4a365$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, this.options, options), {
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            });
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    (0, $981dbb7bd35e3220$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $981dbb7bd35e3220$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $d7183edf0eab2b8a$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    (0, $981dbb7bd35e3220$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $172c8329ecf90fdd$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $245b5e64e7ae0d35$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $245b5e64e7ae0d35$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d7183edf0eab2b8a$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $130a04a50c584572$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $130a04a50c584572$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $130a04a50c584572$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $981dbb7bd35e3220$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $c7f5fc751b151e12$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $172c8329ecf90fdd$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, this.latestValues);
            const targetDelta = (0, $130a04a50c584572$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($172c8329ecf90fdd$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $172c8329ecf90fdd$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $172c8329ecf90fdd$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $981dbb7bd35e3220$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $172c8329ecf90fdd$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $9d2bb0d64b3cd7fc$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $5b730dc57489e238$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>{
                (0, $1ba477217000c17f$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $cb991438c56936ca$export$335a17c977067b99)(0, $172c8329ecf90fdd$var$animationTarget, (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, options), {
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                }));
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($172c8329ecf90fdd$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $172c8329ecf90fdd$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $130a04a50c584572$export$6459fc9e86be362e)();
                const xLength = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d7183edf0eab2b8a$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $981dbb7bd35e3220$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $1a1417a9e50596e8$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $172c8329ecf90fdd$var$transformAxes.length; i++){
                const key = "rotate" + $172c8329ecf90fdd$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $172c8329ecf90fdd$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $acbc391d093466b3$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $acbc391d093466b3$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $c7f5fc751b151e12$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $f4236abcb41ce1af$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $f4236abcb41ce1af$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $acbc391d093466b3$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($172c8329ecf90fdd$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $172c8329ecf90fdd$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $172c8329ecf90fdd$var$projectionFrameData.totalNodes = $172c8329ecf90fdd$var$projectionFrameData.resolvedTargetDeltas = $172c8329ecf90fdd$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($172c8329ecf90fdd$export$131f2f0cc5fe9609);
                this.nodes.forEach($172c8329ecf90fdd$var$resolveTargetDelta);
                this.nodes.forEach($172c8329ecf90fdd$var$calcProjection);
                this.nodes.forEach($172c8329ecf90fdd$export$c2664f37bc951031);
                (0, $f8a34acd939b8b40$export$e5185e241753e543)($172c8329ecf90fdd$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $d5623a75f1f312b3$export$1465d17e3de78a96)();
        }
    };
}
function $172c8329ecf90fdd$var$updateLayout(node) {
    node.updateLayout();
}
function $172c8329ecf90fdd$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($172c8329ecf90fdd$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $130a04a50c584572$export$3d227df54007d73a)();
        (0, $981dbb7bd35e3220$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $130a04a50c584572$export$3d227df54007d73a)();
        if (isShared) (0, $981dbb7bd35e3220$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $981dbb7bd35e3220$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $9d2bb0d64b3cd7fc$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    (0, $981dbb7bd35e3220$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    (0, $981dbb7bd35e3220$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $9d2bb0d64b3cd7fc$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $172c8329ecf90fdd$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $172c8329ecf90fdd$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $172c8329ecf90fdd$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $172c8329ecf90fdd$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $172c8329ecf90fdd$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $172c8329ecf90fdd$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $172c8329ecf90fdd$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $172c8329ecf90fdd$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $172c8329ecf90fdd$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $172c8329ecf90fdd$var$calcProjection(node) {
    node.calcProjection();
}
function $172c8329ecf90fdd$var$resetRotation(node) {
    node.resetRotation();
}
function $172c8329ecf90fdd$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $172c8329ecf90fdd$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $172c8329ecf90fdd$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $6547127f992c1078$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $172c8329ecf90fdd$export$6ffd3e6ae339a132(output, from, to, p) {
    $172c8329ecf90fdd$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $172c8329ecf90fdd$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $172c8329ecf90fdd$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $172c8329ecf90fdd$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $172c8329ecf90fdd$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $172c8329ecf90fdd$var$roundPoint = $172c8329ecf90fdd$var$userAgentContains("applewebkit/") && !$172c8329ecf90fdd$var$userAgentContains("chrome/") ? Math.round : (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
function $172c8329ecf90fdd$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $172c8329ecf90fdd$var$roundPoint(axis.min);
    axis.max = $172c8329ecf90fdd$var$roundPoint(axis.max);
}
function $172c8329ecf90fdd$var$roundBox(box) {
    $172c8329ecf90fdd$var$roundAxis(box.x);
    $172c8329ecf90fdd$var$roundAxis(box.y);
}
function $172c8329ecf90fdd$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $981dbb7bd35e3220$export$28d0384c4b79bde2)((0, $9d2bb0d64b3cd7fc$export$c5706146bc63213)(snapshot), (0, $9d2bb0d64b3cd7fc$export$c5706146bc63213)(layout), 0.2);
}




const $720cddb211c53192$export$2d029a49a09b6177 = (0, $172c8329ecf90fdd$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $3b9e8293424667bf$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $553ab14d0d1abf3e$export$b91509fcf893b648 = {
    current: undefined
};
const $553ab14d0d1abf3e$export$b61a9eb3dbde8858 = (0, $172c8329ecf90fdd$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$553ab14d0d1abf3e$export$b91509fcf893b648.current) {
            const documentNode = new (0, $720cddb211c53192$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $553ab14d0d1abf3e$export$b91509fcf893b648.current = documentNode;
        }
        return $553ab14d0d1abf3e$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $20334d379c4993a0$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $e22e1dd92051f0a0$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $d1975e8dea510822$export$5d97dc2872682820),
        ProjectionNode: (0, $553ab14d0d1abf3e$export$b61a9eb3dbde8858),
        MeasureLayout: $bf0011aeb54a8603$export$779f5fb01ad751cd
    }
};












function $877ef6de280e80e7$export$c90d7ca213038c72() {
    $877ef6de280e80e7$export$c90d7ca213038c72 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $877ef6de280e80e7$export$c90d7ca213038c72.apply(this, arguments);
}


function $9c04611ef3cd7bb6$export$cffab43ebdf6037(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}






/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $17d46babbc343972$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $17d46babbc343972$export$b9f0c1f373aee2b0(current) {
    const match = $17d46babbc343972$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $17d46babbc343972$var$maxDepth = 4;
function $17d46babbc343972$var$getVariableValue(current, element, depth = 1) {
    (0, $faee95b32f04793f$export$f5708dca728d7177)(depth <= $17d46babbc343972$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $17d46babbc343972$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $586a8c9354c052af$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    } else if ((0, $58159485ea5b9511$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $17d46babbc343972$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $17d46babbc343972$export$669319b042b57350(visualElement, _param, transitionEnd) {
    var target = (0, $877ef6de280e80e7$export$c90d7ca213038c72)({}, (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(_param));
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, transitionEnd);
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $58159485ea5b9511$export$31f9caa2600b5723)(current)) return;
        const resolved = $17d46babbc343972$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $58159485ea5b9511$export$31f9caa2600b5723)(current)) continue;
        const resolved = $17d46babbc343972$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}










const $c124c5f5f2629442$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $c124c5f5f2629442$var$isPositionalKey = (key)=>$c124c5f5f2629442$var$positionalKeys.has(key);
const $c124c5f5f2629442$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($c124c5f5f2629442$var$isPositionalKey);
};
const $c124c5f5f2629442$var$isNumOrPxType = (v)=>v === (0, $9ad8a8be30ce5844$export$98e628dec113755e) || v === (0, $d414efec423ce291$export$91c0eda1d06bf008);
const $c124c5f5f2629442$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $c124c5f5f2629442$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $c124c5f5f2629442$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $c124c5f5f2629442$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $c124c5f5f2629442$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $c124c5f5f2629442$var$nonTranslationalTransformKeys = (0, $d1c315412dc4e663$export$280dc01950909d86).filter((key)=>!$c124c5f5f2629442$var$transformKeys.has(key));
function $c124c5f5f2629442$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $c124c5f5f2629442$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $c124c5f5f2629442$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $c124c5f5f2629442$var$getTranslateFromMatrix(4, 13),
    y: $c124c5f5f2629442$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$c124c5f5f2629442$export$781d46a8aa670d52.translateX = $c124c5f5f2629442$export$781d46a8aa670d52.x;
$c124c5f5f2629442$export$781d46a8aa670d52.translateY = $c124c5f5f2629442$export$781d46a8aa670d52.y;
const $c124c5f5f2629442$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $c124c5f5f2629442$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $c124c5f5f2629442$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $c124c5f5f2629442$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, target);
    transitionEnd = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, transitionEnd);
    const targetPositionalKeys = Object.keys(target).filter($c124c5f5f2629442$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $f2ef0e515384c134$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $cdfb45bee9c27be9$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $f2ef0e515384c134$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $f2ef0e515384c134$export$eefdd52e3ccae428)(to[i]);
                    (0, $faee95b32f04793f$export$f5708dca728d7177)(toType === fromType || $c124c5f5f2629442$var$isNumOrPxType(fromType) && $c124c5f5f2629442$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $faee95b32f04793f$export$f5708dca728d7177)((0, $f2ef0e515384c134$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $f2ef0e515384c134$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($c124c5f5f2629442$var$isNumOrPxType(fromType) && $c124c5f5f2629442$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $d414efec423ce291$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $c124c5f5f2629442$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $c124c5f5f2629442$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $5ddea511a1df74b4$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $c124c5f5f2629442$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $c124c5f5f2629442$var$hasPositionalKey(target) ? $c124c5f5f2629442$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $fe276f9616682996$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $17d46babbc343972$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $c124c5f5f2629442$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};








// Does this device prefer reduced motion? Returns `null` server-side.
const $3ff2c43741033fcf$export$ff7706047246b98b = {
    current: null
};
const $3ff2c43741033fcf$export$6476d16e2fd2d0db = {
    current: false
};


function $cc01182a0cb35a51$export$ca9f41fb23dded3d() {
    (0, $3ff2c43741033fcf$export$6476d16e2fd2d0db).current = true;
    if (!(0, $5ddea511a1df74b4$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $3ff2c43741033fcf$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $3ff2c43741033fcf$export$ff7706047246b98b).current = false;
}














function $f0581c7b281c0faf$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $251f7d673c9c86a3$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $58059ad17277dd8f$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $251f7d673c9c86a3$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $79d69d565640708f$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $58059ad17277dd8f$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $79d69d565640708f$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $a77b1e6783fc58b3$export$bc2a978a17abfdde = new WeakMap();



const $37894a1df55e8899$var$featureNames = Object.keys((0, $a953b6ada2f72db5$export$65570e08d843624d));
const $37894a1df55e8899$var$numFeatures = $37894a1df55e8899$var$featureNames.length;
const $37894a1df55e8899$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $37894a1df55e8899$var$numVariantProps = (0, $20855a5d0b260125$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $37894a1df55e8899$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $a77b1e6783fc58b3$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $3ff2c43741033fcf$export$6476d16e2fd2d0db).current) (0, $cc01182a0cb35a51$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $3ff2c43741033fcf$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $a77b1e6783fc58b3$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures(_param, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        var { children: children } = _param, renderedProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
            "children"
        ]);
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $37894a1df55e8899$var$numFeatures; i++){
            const name = $37894a1df55e8899$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $a953b6ada2f72db5$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $1c79ac3705c6b6d1$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $130a04a50c584572$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $37894a1df55e8899$var$propEventHandlers.length; i++){
            const key = $37894a1df55e8899$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $f0581c7b281c0faf$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $37894a1df55e8899$var$numVariantProps; i++){
            const name = (0, $20855a5d0b260125$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $23e2b8e45e65dfac$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $79d69d565640708f$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $c0f30ec55cd531d9$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $251f7d673c9c86a3$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $4f660a66e171c06b$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $abdd74f2cc691999$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, latestValues);
        this.initialValues = props.initial ? (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, latestValues) : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $9b5ea444b3556797$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $9b5ea444b3556797$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const _this_scrapeMotionValuesFromProps = this.scrapeMotionValuesFromProps(props, {}), { willChange: willChange } = _this_scrapeMotionValuesFromProps, initialMotionValues = (0, $c4006311849aa271$export$69fdd232f62cde60)(_this_scrapeMotionValuesFromProps, [
            "willChange"
        ]);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $251f7d673c9c86a3$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $58059ad17277dd8f$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
}


class $c1bbb76a693c1a23$export$e49735c2a366bdc7 extends (0, $37894a1df55e8899$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance(_param, _param1, isMounted) {
        var { transition: transition, transitionEnd: transitionEnd } = _param, target = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
            "transition",
            "transitionEnd"
        ]), { transformValues: transformValues } = _param1;
        let origin = (0, $284183dc41cada08$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $284183dc41cada08$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $fe276f9616682996$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return (0, $66a5668b38a29be4$export$581ff339ea0ba762)({
            transition: transition,
            transitionEnd: transitionEnd
        }, target);
    }
}



function $359688a01e55b9fb$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $359688a01e55b9fb$export$23fea75b03ac16b3 extends (0, $c1bbb76a693c1a23$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $0b53a6efb3642986$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $359688a01e55b9fb$export$3735103072e4a80(instance);
            const value = ((0, $58159485ea5b9511$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $251bbb6a3c87ae07$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $371459a1640f998f$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $a95906244a2d7e5e$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $251f7d673c9c86a3$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $9bc9ba6c7615124c$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $4ebd0c9a7e192544$export$86bcdffbaf733d84 extends (0, $c1bbb76a693c1a23$export$e49735c2a366bdc7) {
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $0b53a6efb3642986$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $671a4e7e4df97a9a$export$28931db5d57958e5).has(key) ? (0, $3bc74152d744365d$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $130a04a50c584572$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $79ce2b625ef60476$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $85a07f77d14903fc$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $afcd7ecf658716d9$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $7ee347ff6d81ac56$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
    constructor(){
        super(...arguments);
        this.isSVGTag = false;
    }
}



const $d2d301fdeaaca8eb$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $13b7dd579aa6d2ca$export$88f3fc2fd3766989)(Component) ? new (0, $4ebd0c9a7e192544$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $359688a01e55b9fb$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $21c81956e95d4088$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $553ab14d0d1abf3e$export$b61a9eb3dbde8858),
        MeasureLayout: $bf0011aeb54a8603$export$779f5fb01ad751cd
    }
};


const $9aca5855743a2e6f$var$preloadedFeatures = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, (0, $1a6859e1b2177404$export$7f9953c70dacfd7f), (0, $9f80faa8a4e07d80$export$e5b72898e5a201f1), (0, $20334d379c4993a0$export$d7d5d435647ed5a0), (0, $21c81956e95d4088$export$b3219800bda33a1f));
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $9aca5855743a2e6f$export$e25e478948902b8b = /*@__PURE__*/ (0, $31c6675f74aec206$export$a28d6df673050e18)((Component, config)=>(0, $cb5f7861a7a27279$export$732916c0e88175fb)(Component, config, $9aca5855743a2e6f$var$preloadedFeatures, (0, $d2d301fdeaaca8eb$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $9aca5855743a2e6f$export$546614c4a05701f9(key) {
    return (0, $60bdad86d4074aed$export$46b7e4b9dc6110c3)((0, $cb5f7861a7a27279$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $9aca5855743a2e6f$var$preloadedFeatures, (0, $d2d301fdeaaca8eb$export$56ba0183203348f5)));
}


const $a26f2e3d8304fc83$var$pathVariant = {
    hidden: {
        pathLength: 0,
        opacity: 0
    },
    visible: {
        pathLength: 1,
        opacity: 1,
        transition: {
            pathLength: {
                duration: 1
            },
            opacity: {
                duration: 0.1
            }
        }
    }
};
const $a26f2e3d8304fc83$var$AnimatedLogo = ()=>{
    const [fill, setFill] = (0, $6cds3.useState)("none");
    const handleAnimationComplete = ()=>{
        setFill("#2D2E83");
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $9aca5855743a2e6f$export$e25e478948902b8b).svg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "550",
        height: "550",
        version: "1",
        viewBox: "0 0 369 342",
        initial: "hidden",
        animate: "visible",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).path, {
                fill: fill,
                d: "M461 2778c30-57 1021-1772 1028-1780 3-3 165 269 358 605l353 612-238 3c-220 2-238 1-252-16-8-10-60-96-114-190-54-95-101-172-105-172-3 1-130 216-281 480l-275 479-243 1H449l12-22z",
                transform: "matrix(.1 0 0 -.1 0 342)",
                stroke: "#2D2E83",
                variants: $a26f2e3d8304fc83$var$pathVariant,
                strokeWidth: 40,
                onAnimationComplete: handleAnimationComplete
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).path, {
                fill: fill,
                d: "M1932 2593l-120-208 334-3c184-1 334-4 334-6 0-3-201-352-446-777-337-584-444-776-437-789 22-46 229-400 233-400 3 0 170 287 372 638 202 350 505 876 674 1167 168 292 312 542 320 558l15 27H2052l-120-207z",
                transform: "matrix(.1 0 0 -.1 0 342)",
                stroke: "#2D2E83",
                strokeWidth: 40,
                variants: $a26f2e3d8304fc83$var$pathVariant
            })
        ]
    });
};
var $a26f2e3d8304fc83$export$2e2bcd8739ae039 = $a26f2e3d8304fc83$var$AnimatedLogo;


// modules

parcelRequire("6cds3");
const $d7df85b6397975d1$var$ArrowIcon = (props)=>{
    const { width: width, height: height, className: className, color: color } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        className: className,
        fill: "none",
        viewBox: "0 0 36 35",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                clipPath: "url(#clip0_8_64)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    fill: color,
                    d: "M30.76 12.31l-1.558 1.56 2.527 2.528H.95v2.204h30.78l-2.528 2.528 1.559 1.56 5.189-5.19"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                    id: "clip0_8_64",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                        fill: color,
                        d: "M0 0H35V35H0z",
                        transform: "translate(.95)"
                    })
                })
            })
        ]
    });
};
var $d7df85b6397975d1$export$2e2bcd8739ae039 = $d7df85b6397975d1$var$ArrowIcon;
$d7df85b6397975d1$var$ArrowIcon.defaultProps = {
    width: 36,
    height: 35,
    color: "#fff"
};


// modules

parcelRequire("6cds3");

const $1990a6955aaedc91$var$pathVariant = {
    hidden: {
        pathLength: 0,
        opacity: 1
    },
    visible: {
        pathLength: 1,
        opacity: 1,
        transition: {
            delay: 0.5,
            pathLength: {
                duration: 1
            },
            opacity: {
                duration: 1
            }
        }
    }
};
const $1990a6955aaedc91$var$Okay = (props)=>{
    const { className: className } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "220",
        height: "220",
        fill: "none",
        className: className,
        viewBox: "0 0 220 220",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).circle, {
                variants: $1990a6955aaedc91$var$pathVariant,
                cx: "110",
                cy: "110",
                r: "107.5",
                fill: "none",
                fillOpacity: "0.3",
                stroke: "#1F2AD1",
                initial: "hidden",
                animate: "visible",
                strokeWidth: "5"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).path, {
                initial: {
                    opacity: 0,
                    pathLength: 0
                },
                animate: {
                    opacity: 1,
                    pathLength: 1
                },
                transition: {
                    delay: 0.5,
                    duration: 1
                },
                stroke: "#1F2AD1",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "21",
                d: "M56.281 102.513L91.83 164.04 168 62.96"
            })
        ]
    });
};
var $1990a6955aaedc91$export$2e2bcd8739ae039 = $1990a6955aaedc91$var$Okay;


// modules

parcelRequire("6cds3");
const $048e3729530822ee$var$Download = (props)=>{
    const { width: width, height: height, color: color, className: className } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            fill: color,
            d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
        })
    });
};
var $048e3729530822ee$export$2e2bcd8739ae039 = $048e3729530822ee$var$Download;
$048e3729530822ee$var$Download.defaultProps = {
    width: 24,
    height: 24,
    color: "black"
};




const $b5d47c2f6a1fbb71$export$d2cd89f2d124bed6 = [
    {
        id: 21,
        name: "Case Studies",
        path: "work"
    },
    {
        id: 22,
        name: "Experiments",
        path: "petProject"
    },
    {
        id: 23,
        name: "Contact",
        path: ""
    }
];
const $b5d47c2f6a1fbb71$export$1c6d320eca5f475 = [
    {
        id: 12,
        name: "Turn Back Home",
        path: "/"
    },
    {
        id: 13,
        name: "All Works",
        path: ""
    },
    {
        id: 14,
        name: "Contact",
        path: ""
    }
];


var $bf625c9f51d2a2ca$exports = {};

$parcel$export($bf625c9f51d2a2ca$exports, "container", function () { return $bf625c9f51d2a2ca$export$34e0f9847d4c02dd; }, function (v) { return $bf625c9f51d2a2ca$export$34e0f9847d4c02dd = v; });
$parcel$export($bf625c9f51d2a2ca$exports, "linkContainer", function () { return $bf625c9f51d2a2ca$export$51d4df9cfb8c2bf4; }, function (v) { return $bf625c9f51d2a2ca$export$51d4df9cfb8c2bf4 = v; });
$parcel$export($bf625c9f51d2a2ca$exports, "logo", function () { return $bf625c9f51d2a2ca$export$db3c28d99448dcff; }, function (v) { return $bf625c9f51d2a2ca$export$db3c28d99448dcff = v; });
var $bf625c9f51d2a2ca$export$34e0f9847d4c02dd;
var $bf625c9f51d2a2ca$export$51d4df9cfb8c2bf4;
var $bf625c9f51d2a2ca$export$db3c28d99448dcff;
$bf625c9f51d2a2ca$export$34e0f9847d4c02dd = `Qh3Vja_container`;
$bf625c9f51d2a2ca$export$51d4df9cfb8c2bf4 = `Qh3Vja_linkContainer`;
$bf625c9f51d2a2ca$export$db3c28d99448dcff = `Qh3Vja_logo`;


// modules





var $6cds3 = parcelRequire("6cds3");


var $3ba8d7bfbe467fd4$exports = {};

$parcel$export($3ba8d7bfbe467fd4$exports, "headerBtn", function () { return $3ba8d7bfbe467fd4$export$6b9abc300b631130; }, function (v) { return $3ba8d7bfbe467fd4$export$6b9abc300b631130 = v; });
$parcel$export($3ba8d7bfbe467fd4$exports, "slideRight", function () { return $3ba8d7bfbe467fd4$export$19b9a771608c4321; }, function (v) { return $3ba8d7bfbe467fd4$export$19b9a771608c4321 = v; });
$parcel$export($3ba8d7bfbe467fd4$exports, "slideRightReverse", function () { return $3ba8d7bfbe467fd4$export$f870dc62fd1b90dc; }, function (v) { return $3ba8d7bfbe467fd4$export$f870dc62fd1b90dc = v; });
var $3ba8d7bfbe467fd4$export$6b9abc300b631130;
var $3ba8d7bfbe467fd4$export$19b9a771608c4321;
var $3ba8d7bfbe467fd4$export$f870dc62fd1b90dc;
$3ba8d7bfbe467fd4$export$6b9abc300b631130 = `QTriiG_headerBtn`;
$3ba8d7bfbe467fd4$export$19b9a771608c4321 = `QTriiG_slideRight`;
$3ba8d7bfbe467fd4$export$19b9a771608c4321;
$3ba8d7bfbe467fd4$export$f870dc62fd1b90dc = `QTriiG_slideRightReverse`;
$3ba8d7bfbe467fd4$export$f870dc62fd1b90dc;


const $e93451a89777bdf5$var$AnimatedLinks = (props)=>{
    const { item: item, onClick: onClick } = props, scrollProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "item",
        "onClick"
    ]);
    // external link
    if (/^https?:\/\//.test(item.path)) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
        href: item.path,
        target: "_blank",
        rel: "noopener noreferrer",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3ba8d7bfbe467fd4$exports))).headerBtn,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
            children: item.name
        })
    });
    // route
    if (item.path.startsWith("/")) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
        to: item.path,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3ba8d7bfbe467fd4$exports))).headerBtn,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
            children: item.name
        })
    });
    // no target, only an action (opens a modal)
    if (!item.path) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3ba8d7bfbe467fd4$exports))).headerBtn,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
            children: item.name
        })
    });
    // anchor on the current page
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1d42a532dd4f25d5$exports.Link), (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, scrollProps), {
        onClick: onClick,
        to: item.path,
        href: `#${item.path}`,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3ba8d7bfbe467fd4$exports))).headerBtn,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
            children: item.name
        })
    }));
};
var $e93451a89777bdf5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $6cds3.memo)($e93451a89777bdf5$var$AnimatedLinks);


const $4eb7dc37af125249$var$Header = (props)=>{
    const { setModal: setModal, data: data = (0, $b5d47c2f6a1fbb71$export$d2cd89f2d124bed6), setWorkModal: setWorkModal } = props;
    const onLinkPress = (path, name)=>{
        if (!path && name !== "All Works") setModal(true);
        if (!path && name === "All Works" && setWorkModal) setWorkModal(true);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bf625c9f51d2a2ca$exports))).container,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bf625c9f51d2a2ca$exports))).logo,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fe8768734706f750$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bf625c9f51d2a2ca$exports))).linkContainer,
                children: data.map((item)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e93451a89777bdf5$export$2e2bcd8739ae039), {
                        onClick: ()=>onLinkPress(item.path, item.name),
                        smooth: true,
                        item: item
                    }, item.id))
            })
        ]
    });
};
var $4eb7dc37af125249$export$2e2bcd8739ae039 = $4eb7dc37af125249$var$Header;


// modules



parcelRequire("6cds3");
var $deb4736da6babac2$exports = {};

$parcel$export($deb4736da6babac2$exports, "btnText", function () { return $deb4736da6babac2$export$30b7d84b1e5fdac2; }, function (v) { return $deb4736da6babac2$export$30b7d84b1e5fdac2 = v; });
$parcel$export($deb4736da6babac2$exports, "button", function () { return $deb4736da6babac2$export$2ba01fb71ed41cb6; }, function (v) { return $deb4736da6babac2$export$2ba01fb71ed41cb6 = v; });
$parcel$export($deb4736da6babac2$exports, "buttonArrow", function () { return $deb4736da6babac2$export$44b0390115568323; }, function (v) { return $deb4736da6babac2$export$44b0390115568323 = v; });
$parcel$export($deb4736da6babac2$exports, "buttonMask", function () { return $deb4736da6babac2$export$2faaa835fe867c73; }, function (v) { return $deb4736da6babac2$export$2faaa835fe867c73 = v; });
$parcel$export($deb4736da6babac2$exports, "disabledText", function () { return $deb4736da6babac2$export$942b887770462c6a; }, function (v) { return $deb4736da6babac2$export$942b887770462c6a = v; });
var $deb4736da6babac2$export$30b7d84b1e5fdac2;
var $deb4736da6babac2$export$2ba01fb71ed41cb6;
var $deb4736da6babac2$export$44b0390115568323;
var $deb4736da6babac2$export$2faaa835fe867c73;
var $deb4736da6babac2$export$942b887770462c6a;
$deb4736da6babac2$export$30b7d84b1e5fdac2 = `Pyg6BW_btnText`;
$deb4736da6babac2$export$2ba01fb71ed41cb6 = `Pyg6BW_button`;
$deb4736da6babac2$export$44b0390115568323 = `Pyg6BW_buttonArrow`;
$deb4736da6babac2$export$2faaa835fe867c73 = `Pyg6BW_buttonMask`;
$deb4736da6babac2$export$942b887770462c6a = `Pyg6BW_disabledText`;



const $9307550ce52715a5$var$Button = (props)=>{
    const { text: text, widthArrow: widthArrow = true, onClick: onClick, disabled: disabled = false, className: className } = props;
    const handleButtonPress = ()=>{
        if (onClick && !disabled) onClick();
    };
    const handleKeyDown = (event)=>{
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleButtonPress();
        }
    };
    // without onClick the button is only a visual part of a link around it
    const buttonProps = onClick ? {
        role: "button",
        tabIndex: disabled ? -1 : 0,
        "aria-disabled": disabled,
        onKeyDown: handleKeyDown
    } : {};
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({
        style: {
            position: "relative",
            cursor: disabled ? "not-allowed" : "pointer"
        },
        onClick: handleButtonPress,
        className: className
    }, buttonProps), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($deb4736da6babac2$exports))).button,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                        className: disabled ? (0, (/*@__PURE__*/$parcel$interopDefault($deb4736da6babac2$exports))).disabledText : (0, (/*@__PURE__*/$parcel$interopDefault($deb4736da6babac2$exports))).btnText,
                        children: text
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($deb4736da6babac2$exports))).buttonMask
                    })
                ]
            }),
            widthArrow && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d7df85b6397975d1$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($deb4736da6babac2$exports))).buttonArrow
            })
        ]
    }));
};
var $9307550ce52715a5$export$2e2bcd8739ae039 = $9307550ce52715a5$var$Button;


// modules



var $6cds3 = parcelRequire("6cds3");
var $d92646279872c11a$exports = {};

$parcel$export($d92646279872c11a$exports, "iconAnimation", function () { return $d92646279872c11a$export$d671ce10b5818b97; }, function (v) { return $d92646279872c11a$export$d671ce10b5818b97 = v; });
var $d92646279872c11a$export$d671ce10b5818b97;
$d92646279872c11a$export$d671ce10b5818b97 = `dY6-Ra_iconAnimation`;


// modules

parcelRequire("6cds3");


const $e7c4d3e7d65f40e5$export$d123b529ac6b7b39 = (top, left, transX)=>{
    return {
        position: "absolute",
        top: top,
        left: left,
        transform: `translateX(${transX})`
    };
};


const $659a992bfe06fd0d$export$78a7c3e6a26a06a6 = [
    {
        id: 11,
        name: "LinkedIn",
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e59883fe3c0830cf$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).icon
        }),
        link: "https://www.linkedin.com/in/vlad-khrushchov-59a83b380/"
    },
    {
        id: 12,
        name: "GitHub",
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $83c7069cb3e05d16$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).icon
        }),
        link: "https://github.com/Vladoosik"
    },
    {
        id: 23,
        name: "GitLab",
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $12772571040e4136$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).icon
        }),
        link: "https://gitlab.com/Vladoosik"
    },
    {
        id: 32,
        name: "Telegram",
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dd858a5e38ab6616$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).icon
        }),
        link: "https://t.me/vladoosik1"
    },
    {
        id: 44,
        name: "Email",
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8ff8432e5adf1d5e$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).icon
        }),
        link: "mailto:x.vlad2101@gmail.com"
    }
];
const $659a992bfe06fd0d$export$24b8815879ec6da3 = [
    {
        id: 1,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7d7a71f72705788c$export$2e2bcd8739ae039), {
            color: "#CF4981"
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("25%", "90%", "50%"),
        invertedMove: false
    },
    {
        id: 2,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e9d28615c616988b$export$2e2bcd8739ae039), {
            color: "#CF4981"
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("50%", "70%", "50%"),
        invertedMove: true
    },
    {
        id: 3,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d31ee9019390861b$export$2e2bcd8739ae039), {
            color: "#CF4981"
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("12%", "50%", "50%"),
        invertedMove: false
    },
    {
        id: 4,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $759e05d64aee4aab$export$2e2bcd8739ae039), {
            color: "#0f6898"
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("80%", "10%", "10%"),
        invertedMove: true
    },
    {
        id: 5,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7d7a71f72705788c$export$2e2bcd8739ae039), {
            color: "yellow"
        }),
        color: "#CF4981",
        invertedMove: false
    },
    {
        id: 6,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $759e05d64aee4aab$export$2e2bcd8739ae039), {
            color: "#3a9a5c"
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("10%", "10%", "10%"),
        invertedMove: false
    },
    {
        id: 7,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $759e05d64aee4aab$export$2e2bcd8739ae039), {
            color: "#49cfb0"
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("10%", "80%", "50%"),
        invertedMove: true
    },
    {
        id: 8,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $67294a4786d574bf$export$2e2bcd8739ae039), {}),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("50%", "20%", "50%"),
        invertedMove: false
    },
    {
        id: 9,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $759e05d64aee4aab$export$2e2bcd8739ae039), {
            color: "#49cfb0"
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("70%", "90%", "50%"),
        invertedMove: true
    },
    {
        id: 12,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $759e05d64aee4aab$export$2e2bcd8739ae039), {
            color: "#49cfb0"
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("82%", "50%", "50%"),
        invertedMove: true
    },
    {
        id: 121,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d31ee9019390861b$export$2e2bcd8739ae039), {}),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("12%", "25%", "60%"),
        invertedMove: false
    }
];
const $659a992bfe06fd0d$export$5acc3e0471c10a8c = [
    {
        id: 121,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d31ee9019390861b$export$2e2bcd8739ae039), {
            width: 100,
            height: 100
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("12%", "5%", "60%")
    },
    {
        id: 123,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $759e05d64aee4aab$export$2e2bcd8739ae039), {
            color: "#49cfb0",
            width: 100,
            height: 100
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("32%", "18%", "60%")
    },
    {
        id: 124,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d31ee9019390861b$export$2e2bcd8739ae039), {
            width: 100,
            height: 100
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("52%", "3%", "60%")
    },
    {
        id: 125,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $67294a4786d574bf$export$2e2bcd8739ae039), {
            width: 100,
            height: 100,
            color: "orange"
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("82%", "20%", "60%")
    },
    {
        id: 126,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $759e05d64aee4aab$export$2e2bcd8739ae039), {
            width: 100,
            height: 100
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("12%", "80%", "60%")
    },
    {
        id: 127,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7d7a71f72705788c$export$2e2bcd8739ae039), {
            width: 100,
            height: 100,
            color: "orange"
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("32%", "90%", "60%")
    },
    {
        id: 128,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e9d28615c616988b$export$2e2bcd8739ae039), {
            width: 100,
            height: 100,
            color: "#49cfb0"
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("52%", "70%", "60%")
    },
    {
        id: 129,
        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7d7a71f72705788c$export$2e2bcd8739ae039), {
            width: 100,
            height: 100,
            color: "orange"
        }),
        style: (0, $e7c4d3e7d65f40e5$export$d123b529ac6b7b39)("82%", "90%", "60%")
    }
];


const $6e1f125894bc562c$var$AnimatedIcons = ({ cursorPosition: cursorPosition })=>{
    const iconRefs = (0, $6cds3.useRef)([]);
    const animationFrameRef = (0, $6cds3.useRef)();
    const lastPosition = (0, $6cds3.useRef)({
        x: 0,
        y: 0
    });
    const updateIconsPosition = ()=>{
        const current = cursorPosition.current;
        if (!current) return;
        const deltaX = current.x - lastPosition.current.x;
        const deltaY = current.y - lastPosition.current.y;
        // если движение минимально, пропускаем кадр
        if (Math.abs(deltaX) < 1 && Math.abs(deltaY) < 1) {
            animationFrameRef.current = requestAnimationFrame(updateIconsPosition);
            return;
        }
        iconRefs.current.forEach((iconRef, index)=>{
            if (iconRef) {
                const { invertedMove: invertedMove } = (0, $659a992bfe06fd0d$export$24b8815879ec6da3)[index];
                const x = invertedMove ? -current.x : current.x;
                const y = invertedMove ? -current.y : current.y;
                iconRef.style.transform = `translate(-50%, -50%) translate(${x * 0.08}px, ${y * 0.08}px)`;
            }
        });
        lastPosition.current = current;
        animationFrameRef.current = requestAnimationFrame(updateIconsPosition);
    };
    (0, $6cds3.useEffect)(()=>{
        var _window_matchMedia, _window;
        iconRefs.current = iconRefs.current.slice(0, (0, $659a992bfe06fd0d$export$24b8815879ec6da3).length);
        // the icons stay still for users who asked for less motion
        if ((_window_matchMedia = (_window = window).matchMedia) === null || _window_matchMedia === void 0 ? void 0 : _window_matchMedia.call(_window, "(prefers-reduced-motion: reduce)").matches) return;
        animationFrameRef.current = requestAnimationFrame(updateIconsPosition);
        return ()=>{
            if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: (0, $659a992bfe06fd0d$export$24b8815879ec6da3).map((item, index)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d92646279872c11a$exports))).iconAnimation,
                ref: (el)=>iconRefs.current[index] = el,
                style: (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, item.style),
                children: item.icon
            }, item.id))
    });
};
var $6e1f125894bc562c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $6cds3.memo)($6e1f125894bc562c$var$AnimatedIcons);


// modules



"use strict";
function $b4293b0eb4c07151$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $4457f145f4fd6a49$var$toString } = Object.prototype;
const { getPrototypeOf: $4457f145f4fd6a49$var$getPrototypeOf } = Object;
const $4457f145f4fd6a49$var$kindOf = ((cache)=>(thing)=>{
        const str = $4457f145f4fd6a49$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $4457f145f4fd6a49$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$4457f145f4fd6a49$var$kindOf(thing) === type;
};
const $4457f145f4fd6a49$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $4457f145f4fd6a49$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $4457f145f4fd6a49$var$isUndefined = $4457f145f4fd6a49$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4457f145f4fd6a49$var$isBuffer(val) {
    return val !== null && !$4457f145f4fd6a49$var$isUndefined(val) && val.constructor !== null && !$4457f145f4fd6a49$var$isUndefined(val.constructor) && $4457f145f4fd6a49$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $4457f145f4fd6a49$var$isArrayBuffer = $4457f145f4fd6a49$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4457f145f4fd6a49$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4457f145f4fd6a49$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $4457f145f4fd6a49$var$isString = $4457f145f4fd6a49$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $4457f145f4fd6a49$var$isFunction = $4457f145f4fd6a49$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $4457f145f4fd6a49$var$isNumber = $4457f145f4fd6a49$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $4457f145f4fd6a49$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $4457f145f4fd6a49$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $4457f145f4fd6a49$var$isPlainObject = (val)=>{
    if ($4457f145f4fd6a49$var$kindOf(val) !== "object") return false;
    const prototype = $4457f145f4fd6a49$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $4457f145f4fd6a49$var$isDate = $4457f145f4fd6a49$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFile = $4457f145f4fd6a49$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $4457f145f4fd6a49$var$isBlob = $4457f145f4fd6a49$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFileList = $4457f145f4fd6a49$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $4457f145f4fd6a49$var$isStream = (val)=>$4457f145f4fd6a49$var$isObject(val) && $4457f145f4fd6a49$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $4457f145f4fd6a49$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $4457f145f4fd6a49$var$isFunction(thing.append) && ((kind = $4457f145f4fd6a49$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $4457f145f4fd6a49$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $4457f145f4fd6a49$var$isURLSearchParams = $4457f145f4fd6a49$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $4457f145f4fd6a49$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $4457f145f4fd6a49$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4457f145f4fd6a49$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $4457f145f4fd6a49$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $4457f145f4fd6a49$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $4457f145f4fd6a49$var$isContextDefined = (context)=>!$4457f145f4fd6a49$var$isUndefined(context) && context !== $4457f145f4fd6a49$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4457f145f4fd6a49$var$merge() {
    const { caseless: caseless } = $4457f145f4fd6a49$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $4457f145f4fd6a49$var$findKey(result, key) || key;
        if ($4457f145f4fd6a49$var$isPlainObject(result[targetKey]) && $4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge(result[targetKey], val);
        else if ($4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge({}, val);
        else if ($4457f145f4fd6a49$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $4457f145f4fd6a49$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $4457f145f4fd6a49$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $4457f145f4fd6a49$var$forEach(b, (val, key)=>{
        if (thisArg && $4457f145f4fd6a49$var$isFunction(val)) a[key] = (0, $b4293b0eb4c07151$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $4457f145f4fd6a49$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $4457f145f4fd6a49$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4457f145f4fd6a49$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $4457f145f4fd6a49$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $4457f145f4fd6a49$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($4457f145f4fd6a49$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$4457f145f4fd6a49$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $4457f145f4fd6a49$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $4457f145f4fd6a49$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $4457f145f4fd6a49$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $4457f145f4fd6a49$var$isHTMLForm = $4457f145f4fd6a49$var$kindOfTest("HTMLFormElement");
const $4457f145f4fd6a49$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $4457f145f4fd6a49$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $4457f145f4fd6a49$var$isRegExp = $4457f145f4fd6a49$var$kindOfTest("RegExp");
const $4457f145f4fd6a49$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $4457f145f4fd6a49$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $4457f145f4fd6a49$var$freezeMethods = (obj)=>{
    $4457f145f4fd6a49$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($4457f145f4fd6a49$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$4457f145f4fd6a49$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $4457f145f4fd6a49$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $4457f145f4fd6a49$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $4457f145f4fd6a49$var$noop = ()=>{};
const $4457f145f4fd6a49$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $4457f145f4fd6a49$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $4457f145f4fd6a49$var$DIGIT = "0123456789";
const $4457f145f4fd6a49$var$ALPHABET = {
    DIGIT: $4457f145f4fd6a49$var$DIGIT,
    ALPHA: $4457f145f4fd6a49$var$ALPHA,
    ALPHA_DIGIT: $4457f145f4fd6a49$var$ALPHA + $4457f145f4fd6a49$var$ALPHA.toUpperCase() + $4457f145f4fd6a49$var$DIGIT
};
const $4457f145f4fd6a49$var$generateString = (size = 16, alphabet = $4457f145f4fd6a49$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4457f145f4fd6a49$var$isSpecCompliantForm(thing) {
    return !!(thing && $4457f145f4fd6a49$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $4457f145f4fd6a49$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($4457f145f4fd6a49$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $4457f145f4fd6a49$var$isArray(source) ? [] : {};
                $4457f145f4fd6a49$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$4457f145f4fd6a49$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $4457f145f4fd6a49$var$isAsyncFn = $4457f145f4fd6a49$var$kindOfTest("AsyncFunction");
const $4457f145f4fd6a49$var$isThenable = (thing)=>thing && ($4457f145f4fd6a49$var$isObject(thing) || $4457f145f4fd6a49$var$isFunction(thing)) && $4457f145f4fd6a49$var$isFunction(thing.then) && $4457f145f4fd6a49$var$isFunction(thing.catch);
var $4457f145f4fd6a49$export$2e2bcd8739ae039 = {
    isArray: $4457f145f4fd6a49$var$isArray,
    isArrayBuffer: $4457f145f4fd6a49$var$isArrayBuffer,
    isBuffer: $4457f145f4fd6a49$var$isBuffer,
    isFormData: $4457f145f4fd6a49$var$isFormData,
    isArrayBufferView: $4457f145f4fd6a49$var$isArrayBufferView,
    isString: $4457f145f4fd6a49$var$isString,
    isNumber: $4457f145f4fd6a49$var$isNumber,
    isBoolean: $4457f145f4fd6a49$var$isBoolean,
    isObject: $4457f145f4fd6a49$var$isObject,
    isPlainObject: $4457f145f4fd6a49$var$isPlainObject,
    isUndefined: $4457f145f4fd6a49$var$isUndefined,
    isDate: $4457f145f4fd6a49$var$isDate,
    isFile: $4457f145f4fd6a49$var$isFile,
    isBlob: $4457f145f4fd6a49$var$isBlob,
    isRegExp: $4457f145f4fd6a49$var$isRegExp,
    isFunction: $4457f145f4fd6a49$var$isFunction,
    isStream: $4457f145f4fd6a49$var$isStream,
    isURLSearchParams: $4457f145f4fd6a49$var$isURLSearchParams,
    isTypedArray: $4457f145f4fd6a49$var$isTypedArray,
    isFileList: $4457f145f4fd6a49$var$isFileList,
    forEach: $4457f145f4fd6a49$var$forEach,
    merge: $4457f145f4fd6a49$var$merge,
    extend: $4457f145f4fd6a49$var$extend,
    trim: $4457f145f4fd6a49$var$trim,
    stripBOM: $4457f145f4fd6a49$var$stripBOM,
    inherits: $4457f145f4fd6a49$var$inherits,
    toFlatObject: $4457f145f4fd6a49$var$toFlatObject,
    kindOf: $4457f145f4fd6a49$var$kindOf,
    kindOfTest: $4457f145f4fd6a49$var$kindOfTest,
    endsWith: $4457f145f4fd6a49$var$endsWith,
    toArray: $4457f145f4fd6a49$var$toArray,
    forEachEntry: $4457f145f4fd6a49$var$forEachEntry,
    matchAll: $4457f145f4fd6a49$var$matchAll,
    isHTMLForm: $4457f145f4fd6a49$var$isHTMLForm,
    hasOwnProperty: $4457f145f4fd6a49$var$hasOwnProperty,
    hasOwnProp: $4457f145f4fd6a49$var$hasOwnProperty,
    reduceDescriptors: $4457f145f4fd6a49$var$reduceDescriptors,
    freezeMethods: $4457f145f4fd6a49$var$freezeMethods,
    toObjectSet: $4457f145f4fd6a49$var$toObjectSet,
    toCamelCase: $4457f145f4fd6a49$var$toCamelCase,
    noop: $4457f145f4fd6a49$var$noop,
    toFiniteNumber: $4457f145f4fd6a49$var$toFiniteNumber,
    findKey: $4457f145f4fd6a49$var$findKey,
    global: $4457f145f4fd6a49$var$_global,
    isContextDefined: $4457f145f4fd6a49$var$isContextDefined,
    ALPHABET: $4457f145f4fd6a49$var$ALPHABET,
    generateString: $4457f145f4fd6a49$var$generateString,
    isSpecCompliantForm: $4457f145f4fd6a49$var$isSpecCompliantForm,
    toJSONObject: $4457f145f4fd6a49$var$toJSONObject,
    isAsyncFn: $4457f145f4fd6a49$var$isAsyncFn,
    isThenable: $4457f145f4fd6a49$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $ed5f7e2522a0b703$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).inherits($ed5f7e2522a0b703$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $ed5f7e2522a0b703$var$prototype = $ed5f7e2522a0b703$var$AxiosError.prototype;
const $ed5f7e2522a0b703$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $ed5f7e2522a0b703$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($ed5f7e2522a0b703$var$AxiosError, $ed5f7e2522a0b703$var$descriptors);
Object.defineProperty($ed5f7e2522a0b703$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$ed5f7e2522a0b703$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($ed5f7e2522a0b703$var$prototype);
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $ed5f7e2522a0b703$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $ed5f7e2522a0b703$export$2e2bcd8739ae039 = $ed5f7e2522a0b703$var$AxiosError;


// eslint-disable-next-line strict
var $1b5ae82d1edb0249$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c114c26e12685207$export$a143d493d941bafc;
var $c114c26e12685207$export$e4cf37d7f6fb9e0a;
var $c114c26e12685207$export$f99ded8fe4b79145;
var $c114c26e12685207$export$599f31c3813fae4d;
"use strict";
var $5a7d4ee62d502cb1$export$a48f0734ac7c2329;
var $5a7d4ee62d502cb1$export$d622b2ad8d90c771;
var $5a7d4ee62d502cb1$export$6100ba28696e12de;
"use strict";
$5a7d4ee62d502cb1$export$a48f0734ac7c2329 = $5a7d4ee62d502cb1$var$byteLength;
$5a7d4ee62d502cb1$export$d622b2ad8d90c771 = $5a7d4ee62d502cb1$var$toByteArray;
$5a7d4ee62d502cb1$export$6100ba28696e12de = $5a7d4ee62d502cb1$var$fromByteArray;
var $5a7d4ee62d502cb1$var$lookup = [];
var $5a7d4ee62d502cb1$var$revLookup = [];
var $5a7d4ee62d502cb1$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $5a7d4ee62d502cb1$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $5a7d4ee62d502cb1$var$i = 0, $5a7d4ee62d502cb1$var$len = $5a7d4ee62d502cb1$var$code.length; $5a7d4ee62d502cb1$var$i < $5a7d4ee62d502cb1$var$len; ++$5a7d4ee62d502cb1$var$i){
    $5a7d4ee62d502cb1$var$lookup[$5a7d4ee62d502cb1$var$i] = $5a7d4ee62d502cb1$var$code[$5a7d4ee62d502cb1$var$i];
    $5a7d4ee62d502cb1$var$revLookup[$5a7d4ee62d502cb1$var$code.charCodeAt($5a7d4ee62d502cb1$var$i)] = $5a7d4ee62d502cb1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a7d4ee62d502cb1$var$revLookup["-".charCodeAt(0)] = 62;
$5a7d4ee62d502cb1$var$revLookup["_".charCodeAt(0)] = 63;
function $5a7d4ee62d502cb1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a7d4ee62d502cb1$var$byteLength(b64) {
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$toByteArray(b64) {
    var tmp;
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a7d4ee62d502cb1$var$Arr($5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 18 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 2 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 10 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a7d4ee62d502cb1$var$tripletToBase64(num) {
    return $5a7d4ee62d502cb1$var$lookup[num >> 18 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 12 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 6 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num & 0x3F];
}
function $5a7d4ee62d502cb1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a7d4ee62d502cb1$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $5a7d4ee62d502cb1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a7d4ee62d502cb1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 2] + $5a7d4ee62d502cb1$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 10] + $5a7d4ee62d502cb1$var$lookup[tmp >> 4 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $47bf1c92b6d3ec4f$export$aafa59e2e03f2942;
var $47bf1c92b6d3ec4f$export$68d8715fc104d294;
$47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$47bf1c92b6d3ec4f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $c114c26e12685207$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$c114c26e12685207$export$a143d493d941bafc = $c114c26e12685207$var$Buffer;
$c114c26e12685207$export$e4cf37d7f6fb9e0a = $c114c26e12685207$var$SlowBuffer;
$c114c26e12685207$export$f99ded8fe4b79145 = 50;
const $c114c26e12685207$var$K_MAX_LENGTH = 0x7fffffff;
$c114c26e12685207$export$599f31c3813fae4d = $c114c26e12685207$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT = $c114c26e12685207$var$typedArraySupport();
if (!$c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c114c26e12685207$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c114c26e12685207$var$createBuffer(length) {
    if (length > $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c114c26e12685207$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c114c26e12685207$var$allocUnsafe(arg);
    }
    return $c114c26e12685207$var$from(arg, encodingOrOffset, length);
}
$c114c26e12685207$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c114c26e12685207$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $c114c26e12685207$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c114c26e12685207$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c114c26e12685207$var$isInstance(value, ArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, ArrayBuffer)) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($c114c26e12685207$var$isInstance(value, SharedArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, SharedArrayBuffer))) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c114c26e12685207$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $c114c26e12685207$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $c114c26e12685207$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c114c26e12685207$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c114c26e12685207$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c114c26e12685207$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c114c26e12685207$var$Buffer, Uint8Array);
function $c114c26e12685207$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c114c26e12685207$var$alloc(size, fill, encoding) {
    $c114c26e12685207$var$assertSize(size);
    if (size <= 0) return $c114c26e12685207$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $c114c26e12685207$var$createBuffer(size).fill(fill, encoding) : $c114c26e12685207$var$createBuffer(size).fill(fill);
    return $c114c26e12685207$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c114c26e12685207$var$Buffer.alloc = function(size, fill, encoding) {
    return $c114c26e12685207$var$alloc(size, fill, encoding);
};
function $c114c26e12685207$var$allocUnsafe(size) {
    $c114c26e12685207$var$assertSize(size);
    return $c114c26e12685207$var$createBuffer(size < 0 ? 0 : $c114c26e12685207$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c114c26e12685207$var$Buffer.allocUnsafe = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c114c26e12685207$var$Buffer.allocUnsafeSlow = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
function $c114c26e12685207$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $c114c26e12685207$var$byteLength(string, encoding) | 0;
    let buf = $c114c26e12685207$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c114c26e12685207$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $c114c26e12685207$var$checked(array.length) | 0;
    const buf = $c114c26e12685207$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c114c26e12685207$var$fromArrayView(arrayView) {
    if ($c114c26e12685207$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $c114c26e12685207$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c114c26e12685207$var$fromArrayLike(arrayView);
}
function $c114c26e12685207$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
function $c114c26e12685207$var$fromObject(obj) {
    if ($c114c26e12685207$var$Buffer.isBuffer(obj)) {
        const len = $c114c26e12685207$var$checked(obj.length) | 0;
        const buf = $c114c26e12685207$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $c114c26e12685207$var$numberIsNaN(obj.length)) return $c114c26e12685207$var$createBuffer(0);
        return $c114c26e12685207$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $c114c26e12685207$var$fromArrayLike(obj.data);
}
function $c114c26e12685207$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c114c26e12685207$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $c114c26e12685207$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c114c26e12685207$var$Buffer.alloc(+length);
}
$c114c26e12685207$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c114c26e12685207$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c114c26e12685207$var$Buffer.compare = function compare(a, b) {
    if ($c114c26e12685207$var$isInstance(a, Uint8Array)) a = $c114c26e12685207$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c114c26e12685207$var$isInstance(b, Uint8Array)) b = $c114c26e12685207$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(a) || !$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c114c26e12685207$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$c114c26e12685207$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c114c26e12685207$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $c114c26e12685207$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($c114c26e12685207$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) buf = $c114c26e12685207$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c114c26e12685207$var$byteLength(string, encoding) {
    if ($c114c26e12685207$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c114c26e12685207$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $c114c26e12685207$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c114c26e12685207$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c114c26e12685207$var$Buffer.byteLength = $c114c26e12685207$var$byteLength;
function $c114c26e12685207$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Slice(this, start, end);
        case "ascii":
            return $c114c26e12685207$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$latin1Slice(this, start, end);
        case "base64":
            return $c114c26e12685207$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c114c26e12685207$var$Buffer.prototype._isBuffer = true;
function $c114c26e12685207$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c114c26e12685207$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$c114c26e12685207$var$swap(this, i, i + 1);
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $c114c26e12685207$var$swap(this, i, i + 3);
        $c114c26e12685207$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $c114c26e12685207$var$swap(this, i, i + 7);
        $c114c26e12685207$var$swap(this, i + 1, i + 6);
        $c114c26e12685207$var$swap(this, i + 2, i + 5);
        $c114c26e12685207$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $c114c26e12685207$var$utf8Slice(this, 0, length);
    return $c114c26e12685207$var$slowToString.apply(this, arguments);
};
$c114c26e12685207$var$Buffer.prototype.toLocaleString = $c114c26e12685207$var$Buffer.prototype.toString;
$c114c26e12685207$var$Buffer.prototype.equals = function equals(b) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $c114c26e12685207$var$Buffer.compare(this, b) === 0;
};
$c114c26e12685207$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $c114c26e12685207$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($c114c26e12685207$var$customInspectSymbol) $c114c26e12685207$var$Buffer.prototype[$c114c26e12685207$var$customInspectSymbol] = $c114c26e12685207$var$Buffer.prototype.inspect;
$c114c26e12685207$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c114c26e12685207$var$isInstance(target, Uint8Array)) target = $c114c26e12685207$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c114c26e12685207$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c114c26e12685207$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $c114c26e12685207$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c114c26e12685207$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c114c26e12685207$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c114c26e12685207$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $c114c26e12685207$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c114c26e12685207$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c114c26e12685207$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c114c26e12685207$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c114c26e12685207$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c114c26e12685207$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c114c26e12685207$var$utf8Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c114c26e12685207$var$asciiWrite(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$asciiToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$base64Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$base64ToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$ucs2Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c114c26e12685207$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $c114c26e12685207$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c114c26e12685207$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c114c26e12685207$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5a7d4ee62d502cb1$export$6100ba28696e12de(buf);
    else return $5a7d4ee62d502cb1$export$6100ba28696e12de(buf.slice(start, end));
}
function $c114c26e12685207$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c114c26e12685207$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c114c26e12685207$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c114c26e12685207$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c114c26e12685207$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c114c26e12685207$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $c114c26e12685207$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c114c26e12685207$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c114c26e12685207$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c114c26e12685207$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c114c26e12685207$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$c114c26e12685207$var$Buffer.prototype.readUintLE = $c114c26e12685207$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUintBE = $c114c26e12685207$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUint8 = $c114c26e12685207$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c114c26e12685207$var$Buffer.prototype.readUint16LE = $c114c26e12685207$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c114c26e12685207$var$Buffer.prototype.readUint16BE = $c114c26e12685207$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c114c26e12685207$var$Buffer.prototype.readUint32LE = $c114c26e12685207$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c114c26e12685207$var$Buffer.prototype.readUint32BE = $c114c26e12685207$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c114c26e12685207$var$Buffer.prototype.readBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c114c26e12685207$var$Buffer.prototype.readBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c114c26e12685207$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c114c26e12685207$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c114c26e12685207$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c114c26e12685207$var$Buffer.prototype.readBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$c114c26e12685207$var$Buffer.prototype.readBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$c114c26e12685207$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $c114c26e12685207$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$c114c26e12685207$var$Buffer.prototype.writeUintLE = $c114c26e12685207$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUintBE = $c114c26e12685207$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUint8 = $c114c26e12685207$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16LE = $c114c26e12685207$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16BE = $c114c26e12685207$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32LE = $c114c26e12685207$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32BE = $c114c26e12685207$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c114c26e12685207$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c114c26e12685207$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $c114c26e12685207$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $c114c26e12685207$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $47bf1c92b6d3ec4f$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c114c26e12685207$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, false, noAssert);
};
function $c114c26e12685207$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $47bf1c92b6d3ec4f$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c114c26e12685207$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c114c26e12685207$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $c114c26e12685207$var$Buffer.isBuffer(val) ? val : $c114c26e12685207$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $c114c26e12685207$var$errors = {};
function $c114c26e12685207$var$E(sym, getMessage, Base) {
    $c114c26e12685207$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$c114c26e12685207$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$c114c26e12685207$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$c114c26e12685207$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c114c26e12685207$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $c114c26e12685207$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $c114c26e12685207$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $c114c26e12685207$var$checkBounds(buf, offset, byteLength) {
    $c114c26e12685207$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c114c26e12685207$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $c114c26e12685207$var$checkBounds(buf, offset, byteLength);
}
function $c114c26e12685207$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $c114c26e12685207$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $c114c26e12685207$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c114c26e12685207$var$validateNumber(value, type);
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $c114c26e12685207$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $c114c26e12685207$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c114c26e12685207$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c114c26e12685207$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $c114c26e12685207$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $c114c26e12685207$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c114c26e12685207$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c114c26e12685207$var$base64ToBytes(str) {
    return $5a7d4ee62d502cb1$export$d622b2ad8d90c771($c114c26e12685207$var$base64clean(str));
}
function $c114c26e12685207$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c114c26e12685207$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c114c26e12685207$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $c114c26e12685207$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c114c26e12685207$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $c114c26e12685207$var$BufferBigIntNotDefined : fn;
}
function $c114c26e12685207$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $5dbdf283f7ef4044$require$Buffer = $c114c26e12685207$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isVisitable(thing) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $5dbdf283f7ef4044$var$removeBrackets(key) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $5dbdf283f7ef4044$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $5dbdf283f7ef4044$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isFlatArray(arr) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(arr) && !arr.some($5dbdf283f7ef4044$var$isVisitable);
}
const $5dbdf283f7ef4044$var$predicates = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject((0, $4457f145f4fd6a49$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $5dbdf283f7ef4044$var$toFormData(obj, formData, options) {
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $1b5ae82d1edb0249$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $5dbdf283f7ef4044$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) && $5dbdf283f7ef4044$var$isFlatArray(value) || ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFileList(value) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $5dbdf283f7ef4044$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $5dbdf283f7ef4044$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($5dbdf283f7ef4044$var$isVisitable(value)) return true;
        formData.append($5dbdf283f7ef4044$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($5dbdf283f7ef4044$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $5dbdf283f7ef4044$var$isVisitable
    });
    function build(value, path) {
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $5dbdf283f7ef4044$export$2e2bcd8739ae039 = $5dbdf283f7ef4044$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $23a6a9f2f50fe381$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $23a6a9f2f50fe381$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(params, this, options);
}
const $23a6a9f2f50fe381$var$prototype = $23a6a9f2f50fe381$var$AxiosURLSearchParams.prototype;
$23a6a9f2f50fe381$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$23a6a9f2f50fe381$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $23a6a9f2f50fe381$var$encode);
    } : $23a6a9f2f50fe381$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $23a6a9f2f50fe381$export$2e2bcd8739ae039 = $23a6a9f2f50fe381$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $12c2c95c1ed3c980$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $12c2c95c1ed3c980$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $12c2c95c1ed3c980$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $23a6a9f2f50fe381$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $ca291930ae00924d$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $ca291930ae00924d$export$2e2bcd8739ae039 = $ca291930ae00924d$var$InterceptorManager;





"use strict";
var $796c18463ea25502$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};







"use strict";
var $a084e346ccf1414e$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $23a6a9f2f50fe381$export$2e2bcd8739ae039);


"use strict";
var $4d02f3c5e9d23987$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $7320e56e0494b653$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $933095d2c2007f0e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a084e346ccf1414e$export$2e2bcd8739ae039,
        FormData: $4d02f3c5e9d23987$export$2e2bcd8739ae039,
        Blob: $7320e56e0494b653$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $e7f6cfbce8ef57c2$exports = {};

$parcel$export($e7f6cfbce8ef57c2$exports, "hasBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf; });
$parcel$export($e7f6cfbce8ef57c2$exports, "hasStandardBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c0bcc9250309d66; });
$parcel$export($e7f6cfbce8ef57c2$exports, "hasStandardBrowserWebWorkerEnv", function () { return $e7f6cfbce8ef57c2$export$c81692cf5af97dac; });
const $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $e7f6cfbce8ef57c2$export$c0bcc9250309d66 = ((product)=>{
    return $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $e7f6cfbce8ef57c2$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();


var $7bb33b7264aaaf86$export$2e2bcd8739ae039 = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, $e7f6cfbce8ef57c2$exports, (0, $933095d2c2007f0e$export$2e2bcd8739ae039));


"use strict";
function $c6537084d1761b1c$export$2e2bcd8739ae039(data, options) {
    return (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(data, new (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).isNode && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a91febb88049dece$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a91febb88049dece$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a91febb88049dece$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $a91febb88049dece$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(formData) && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($a91febb88049dece$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a91febb88049dece$export$2e2bcd8739ae039 = $a91febb88049dece$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f671d6c34fc96548$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f671d6c34fc96548$var$defaults = {
    transitional: (0, $796c18463ea25502$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $a91febb88049dece$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBuffer(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isStream(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFile(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $c6537084d1761b1c$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $f671d6c34fc96548$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $f671d6c34fc96548$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).from(e, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $f671d6c34fc96548$var$defaults.headers[method] = {};
});
var $f671d6c34fc96548$export$2e2bcd8739ae039 = $f671d6c34fc96548$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $993ca9e2d6767cd4$var$ignoreDuplicateOf = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $993ca9e2d6767cd4$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $993ca9e2d6767cd4$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $97723c9940354b38$var$$internals = Symbol("internals");
function $97723c9940354b38$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $97723c9940354b38$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) ? value.map($97723c9940354b38$var$normalizeValue) : String(value);
}
function $97723c9940354b38$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $97723c9940354b38$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $97723c9940354b38$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $97723c9940354b38$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $97723c9940354b38$var$buildAccessors(obj, header) {
    const accessorName = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $97723c9940354b38$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $97723c9940354b38$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$97723c9940354b38$var$isValidHeaderName(header)) setHeaders((0, $993ca9e2d6767cd4$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $97723c9940354b38$var$parseTokens(value);
                if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $97723c9940354b38$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $97723c9940354b38$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $97723c9940354b38$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $97723c9940354b38$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $97723c9940354b38$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$97723c9940354b38$var$$internals] = this[$97723c9940354b38$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $97723c9940354b38$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$97723c9940354b38$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).reduceDescriptors($97723c9940354b38$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).freezeMethods($97723c9940354b38$var$AxiosHeaders);
var $97723c9940354b38$export$2e2bcd8739ae039 = $97723c9940354b38$var$AxiosHeaders;


"use strict";
function $2b2db412c73efddc$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $f671d6c34fc96548$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5f032fd5b915e863$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $844e24f044f60b67$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).inherits($844e24f044f60b67$var$CanceledError, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $844e24f044f60b67$export$2e2bcd8739ae039 = $844e24f044f60b67$var$CanceledError;







"use strict";
function $b1fb368c37c1823a$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




var $8292dca2fe19e2c0$export$2e2bcd8739ae039 = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $de0137e96012432b$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $4226547004fa4063$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $55a6f18683d9f888$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $de0137e96012432b$export$2e2bcd8739ae039)(requestedURL)) return (0, $4226547004fa4063$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $2d50534f56617a3d$export$2e2bcd8739ae039 = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $9a3acc13c385c3d9$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $3fe2722b85f27cc8$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $3fe2722b85f27cc8$export$2e2bcd8739ae039 = $3fe2722b85f27cc8$var$speedometer;


"use strict";
function $089238041fc30567$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $3fe2722b85f27cc8$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $089238041fc30567$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $089238041fc30567$export$2e2bcd8739ae039 = $089238041fc30567$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $55a6f18683d9f888$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $12c2c95c1ed3c980$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $b1fb368c37c1823a$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Request aborted", (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Network Error", (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $796c18463ea25502$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ETIMEDOUT : (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
            withXSRFToken && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $2d50534f56617a3d$export$2e2bcd8739ae039)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $8292dca2fe19e2c0$export$2e2bcd8739ae039).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $089238041fc30567$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $089238041fc30567$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $9a3acc13c385c3d9$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $f311d0388b14bc21$var$knownAdapters = {
    http: (0, $1b5ae82d1edb0249$export$2e2bcd8739ae039),
    xhr: (0, $089238041fc30567$export$2e2bcd8739ae039)
};
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach($f311d0388b14bc21$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $f311d0388b14bc21$var$renderReason = (reason)=>`- ${reason}`;
const $f311d0388b14bc21$var$isResolvedHandle = (adapter)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $f311d0388b14bc21$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$f311d0388b14bc21$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $f311d0388b14bc21$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($f311d0388b14bc21$var$renderReason).join("\n") : " " + $f311d0388b14bc21$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $f311d0388b14bc21$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $1ba4fe270146b4e2$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(null, config);
}
function $1ba4fe270146b4e2$export$2e2bcd8739ae039(config) {
    $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
    config.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $f311d0388b14bc21$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $f671d6c34fc96548$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5f032fd5b915e863$export$2e2bcd8739ae039)(reason)) {
            $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $142febf2fa493ec7$var$headersToObject = (thing)=>thing instanceof (0, $97723c9940354b38$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $142febf2fa493ec7$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(target) && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($142febf2fa493ec7$var$headersToObject(a), $142febf2fa493ec7$var$headersToObject(b), true)
    };
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $0c953052fb93d857$export$a4ad2735b021c132 = "1.6.3";



"use strict";
const $153d7c57f809624c$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $153d7c57f809624c$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $153d7c57f809624c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $153d7c57f809624c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $0c953052fb93d857$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$153d7c57f809624c$var$deprecatedWarnings[opt]) {
            $153d7c57f809624c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $153d7c57f809624c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("options must be an object", (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $153d7c57f809624c$export$2e2bcd8739ae039 = {
    assertOptions: $153d7c57f809624c$var$assertOptions,
    validators: $153d7c57f809624c$var$validators
};



"use strict";
const $d31ac3bc8d454bec$var$validators = (0, $153d7c57f809624c$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $d31ac3bc8d454bec$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            forcedJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            clarifyTimeoutError: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $d31ac3bc8d454bec$var$validators.function,
                serialize: $d31ac3bc8d454bec$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $1ba4fe270146b4e2$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $1ba4fe270146b4e2$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $55a6f18683d9f888$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $12c2c95c1ed3c980$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $ca291930ae00924d$export$2e2bcd8739ae039)(),
            response: new (0, $ca291930ae00924d$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $d31ac3bc8d454bec$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $d31ac3bc8d454bec$var$Axios.prototype[method] = generateHTTPMethod();
    $d31ac3bc8d454bec$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $d31ac3bc8d454bec$export$2e2bcd8739ae039 = $d31ac3bc8d454bec$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $c9dbae5aa50ec7c7$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $c9dbae5aa50ec7c7$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $c9dbae5aa50ec7c7$export$2e2bcd8739ae039 = $c9dbae5aa50ec7c7$var$CancelToken;






"use strict";
function $cbed9dfdab194748$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $48132dea419dd2c0$export$2e2bcd8739ae039(payload) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $9f6607e590634381$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($9f6607e590634381$var$HttpStatusCode).forEach(([key, value])=>{
    $9f6607e590634381$var$HttpStatusCode[value] = key;
});
var $9f6607e590634381$export$2e2bcd8739ae039 = $9f6607e590634381$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c9a85f19e57c70f8$var$createInstance(defaultConfig) {
    const context = new (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $b4293b0eb4c07151$export$2e2bcd8739ae039)((0, $d31ac3bc8d454bec$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).extend(instance, (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c9a85f19e57c70f8$var$createInstance((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $c9a85f19e57c70f8$var$axios = $c9a85f19e57c70f8$var$createInstance((0, $f671d6c34fc96548$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$c9a85f19e57c70f8$var$axios.Axios = (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$c9a85f19e57c70f8$var$axios.CanceledError = (0, $844e24f044f60b67$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.CancelToken = (0, $c9dbae5aa50ec7c7$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.isCancel = (0, $5f032fd5b915e863$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.VERSION = (0, $0c953052fb93d857$export$a4ad2735b021c132);
$c9a85f19e57c70f8$var$axios.toFormData = (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039);
// Expose AxiosError class
$c9a85f19e57c70f8$var$axios.AxiosError = (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$c9a85f19e57c70f8$var$axios.Cancel = $c9a85f19e57c70f8$var$axios.CanceledError;
// Expose all/spread
$c9a85f19e57c70f8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c9a85f19e57c70f8$var$axios.spread = (0, $cbed9dfdab194748$export$2e2bcd8739ae039);
// Expose isAxiosError
$c9a85f19e57c70f8$var$axios.isAxiosError = (0, $48132dea419dd2c0$export$2e2bcd8739ae039);
// Expose mergeConfig
$c9a85f19e57c70f8$var$axios.mergeConfig = (0, $142febf2fa493ec7$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.AxiosHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.formToJSON = (thing)=>(0, $a91febb88049dece$export$2e2bcd8739ae039)((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$c9a85f19e57c70f8$var$axios.getAdapter = (0, $f311d0388b14bc21$export$2e2bcd8739ae039).getAdapter;
$c9a85f19e57c70f8$var$axios.HttpStatusCode = (0, $9f6607e590634381$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.default = $c9a85f19e57c70f8$var$axios;
var // this module should only have a default export
$c9a85f19e57c70f8$export$2e2bcd8739ae039 = $c9a85f19e57c70f8$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $18d826a12788a23d$export$1c00760e9e5a4e95, AxiosError: $18d826a12788a23d$export$c1fbed17c2f6a328, CanceledError: $18d826a12788a23d$export$1ab0c6b20d94fa14, isCancel: $18d826a12788a23d$export$3b22524397b493c6, CancelToken: $18d826a12788a23d$export$fd08e3cb425f0d61, VERSION: $18d826a12788a23d$export$a4ad2735b021c132, all: $18d826a12788a23d$export$84bf76cd7afc7469, Cancel: $18d826a12788a23d$export$848c9b7ead0df967, isAxiosError: $18d826a12788a23d$export$fbafdbe06a5b5a9a, spread: $18d826a12788a23d$export$3ae0fd4797ed47c8, toFormData: $18d826a12788a23d$export$10ae0d317ea97f8b, AxiosHeaders: $18d826a12788a23d$export$4e7d6ff0f3e6520, HttpStatusCode: $18d826a12788a23d$export$a972f69c851492b3, formToJSON: $18d826a12788a23d$export$86d7c59254d6a2c9, getAdapter: $18d826a12788a23d$export$17ddc20a97d669e2, mergeConfig: $18d826a12788a23d$export$7ec1ebcfa9d8bd6a } = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039);



var $6cds3 = parcelRequire("6cds3");

// modules

parcelRequire("6cds3");
var $bdf0132df24026fa$exports = {};

$parcel$export($bdf0132df24026fa$exports, "format", function () { return $bdf0132df24026fa$export$d9468344d3651243; }, function (v) { return $bdf0132df24026fa$export$d9468344d3651243 = v; });
$parcel$export($bdf0132df24026fa$exports, "icon", function () { return $bdf0132df24026fa$export$1ca1ec8b29a4ce27; }, function (v) { return $bdf0132df24026fa$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($bdf0132df24026fa$exports, "link", function () { return $bdf0132df24026fa$export$9c30223ca0a664fb; }, function (v) { return $bdf0132df24026fa$export$9c30223ca0a664fb = v; });
$parcel$export($bdf0132df24026fa$exports, "text", function () { return $bdf0132df24026fa$export$6f093cfa640b7166; }, function (v) { return $bdf0132df24026fa$export$6f093cfa640b7166 = v; });
var $bdf0132df24026fa$export$d9468344d3651243;
var $bdf0132df24026fa$export$1ca1ec8b29a4ce27;
var $bdf0132df24026fa$export$9c30223ca0a664fb;
var $bdf0132df24026fa$export$6f093cfa640b7166;
$bdf0132df24026fa$export$d9468344d3651243 = `zIL5lW_format`;
$bdf0132df24026fa$export$1ca1ec8b29a4ce27 = `zIL5lW_icon`;
$bdf0132df24026fa$export$9c30223ca0a664fb = `zIL5lW_link`;
$bdf0132df24026fa$export$6f093cfa640b7166 = `zIL5lW_text`;



// to update the CV replace src/assets/cv/CV.pdf, the link picks up the new file
var $3d8caa1d1d8815b0$exports = {};

$3d8caa1d1d8815b0$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "CV.2a2dfec4.pdf";


const $d20cd8fe82accbb5$export$6aee493bb2d17b77 = new URL($3d8caa1d1d8815b0$exports).href;
const $d20cd8fe82accbb5$export$1ec3dc44021e7855 = "Vlad_Khrushchov_CV.pdf";


const $4574a52341674792$var$CvLink = (props)=>{
    const { className: className = "" } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("a", {
        href: (0, $d20cd8fe82accbb5$export$6aee493bb2d17b77),
        download: (0, $d20cd8fe82accbb5$export$1ec3dc44021e7855),
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($bdf0132df24026fa$exports))).link} ${className}`,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $048e3729530822ee$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bdf0132df24026fa$exports))).icon,
                color: "currentColor",
                width: 20,
                height: 20
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bdf0132df24026fa$exports))).text,
                children: "Download CV"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bdf0132df24026fa$exports))).format,
                children: "PDF"
            })
        ]
    });
};
var $4574a52341674792$export$2e2bcd8739ae039 = $4574a52341674792$var$CvLink;




// modules

var $6cds3 = parcelRequire("6cds3");
const $7ecf71b5cc604dc2$var$FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
const $7ecf71b5cc604dc2$export$56d2d435cafcb696 = (active, onClose, ref)=>{
    const onCloseRef = (0, $6cds3.useRef)(onClose);
    onCloseRef.current = onClose;
    (0, $6cds3.useEffect)(()=>{
        var _ref_current;
        if (!active) return;
        const { body: body, documentElement: documentElement } = document;
        const previouslyFocused = document.activeElement;
        const previousOverflow = body.style.overflow;
        const previousPadding = body.style.paddingRight;
        // keep the layout in place when the scrollbar disappears
        const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
        body.style.overflow = "hidden";
        if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
        (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus({
            preventScroll: true
        });
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") {
                onCloseRef.current();
                return;
            }
            if (event.key !== "Tab" || !ref.current) return;
            const focusable = Array.from(ref.current.querySelectorAll($7ecf71b5cc604dc2$var$FOCUSABLE)).filter((element)=>element.offsetParent !== null);
            if (!focusable.length) {
                event.preventDefault();
                return;
            }
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const current = document.activeElement;
            const isOutside = !ref.current.contains(current);
            if (event.shiftKey && (current === first || current === ref.current || isOutside)) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && (current === last || isOutside)) {
                event.preventDefault();
                first.focus();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            body.style.overflow = previousOverflow;
            body.style.paddingRight = previousPadding;
            previouslyFocused === null || previouslyFocused === void 0 ? void 0 : previouslyFocused.focus({
                preventScroll: true
            });
        };
    }, [
        active,
        ref
    ]);
};


const $df07ea70fb26ed48$var$EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $df07ea70fb26ed48$var$CONTACT_API = "/api/contact";
const $df07ea70fb26ed48$var$Modal = (props)=>{
    const { active: active, setActive: setActive } = props;
    const [messageIsSend, setMessageIsSend] = (0, $6cds3.useState)(false);
    const [sendError, setSendError] = (0, $6cds3.useState)(false);
    const [isSending, setIsSending] = (0, $6cds3.useState)(false);
    const [website, setWebsite] = (0, $6cds3.useState)("");
    const [message, setMessage] = (0, $6cds3.useState)({
        name: "",
        email: "",
        description: ""
    });
    const memoizedMessage = (0, $6cds3.useMemo)(()=>message, [
        message
    ]);
    const contentRef = (0, $6cds3.useRef)(null);
    (0, $7ecf71b5cc604dc2$export$56d2d435cafcb696)(active, ()=>setActive(false), contentRef);
    const handleInputChange = (0, $6cds3.useCallback)((field, value)=>{
        setMessage((prevMessage)=>(0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, prevMessage), {
                [field]: value
            }));
    }, []);
    const checkMessage = ()=>{
        return Object.values(memoizedMessage).some((value)=>value.trim() === "") || !$df07ea70fb26ed48$var$EMAIL_PATTERN.test(memoizedMessage.email.trim());
    };
    const resetMessage = ()=>{
        setMessage({
            name: "",
            email: "",
            description: ""
        });
    };
    const handleSendMessage = async ()=>{
        if (isSending) return;
        setSendError(false);
        setIsSending(true);
        await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post($df07ea70fb26ed48$var$CONTACT_API, (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, memoizedMessage), {
            website: website
        })).then(()=>{
            setMessageIsSend(true);
            resetMessage();
        }).catch((error)=>{
            console.log(error.message);
            setSendError(true);
        }).finally(()=>setIsSending(false));
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: active ? "modal active" : "modal",
        onClick: ()=>setActive(false),
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            ref: contentRef,
            role: "dialog",
            "aria-modal": "true",
            "aria-label": "About me and contact form",
            tabIndex: -1,
            className: active ? "modalContent active" : "modalContent",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: active && !messageIsSend ? "halfAbout active" : active && messageIsSend ? "halfAbout success" : "halfAbout",
                    children: [
                        messageIsSend && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "successContainer",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                                    children: "Your message has been sent!"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                    children: "You can close this modal"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9307550ce52715a5$export$2e2bcd8739ae039), {
                                    text: "Close",
                                    widthArrow: false,
                                    onClick: ()=>setActive(false)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: messageIsSend ? "hideContent" : "aboutContent",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                    className: "aboutMe",
                                    children: "About Me."
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                    className: "aboutDescription",
                                    children: "Full-Stack Developer \xb7 React Native / NestJS"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                    className: "mainAboutText",
                                    children: [
                                        "Hi, I'm Vlad Khrushchov, a",
                                        " ",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                            children: "Full-Stack Developer"
                                        }),
                                        " from Ukraine. I build mobile apps with ",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                            children: "React Native"
                                        }),
                                        " and backends with ",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                            children: "NestJS"
                                        }),
                                        ", from the first screen to the store release.",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                        "Recently I built ",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                            children: "IDriver"
                                        }),
                                        ", a driving-theory app live on the App Store and Google Play: the mobile app, the admin panel and the backend with payments, real-time features and security hardening. Before that I shipped",
                                        " ",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                            children: "Voice Notes"
                                        }),
                                        ", a CRM app, to the App Store as the sole developer.",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                        "I'm open to ",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                            children: "new proposals and interesting projects"
                                        }),
                                        ". Outside of work: gym, guitar and games."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "aboutIconContainer",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0c1061e411609f9e$export$2e2bcd8739ae039), {
                                            className: "reactIcon"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b072f8ca25588567$export$2e2bcd8739ae039), {
                                            className: "jsIcon"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $eb4bb93bbb19c6c9$export$2e2bcd8739ae039), {
                                            className: "cssIcon"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4f90229c6fd0f911$export$2e2bcd8739ae039), {
                                            className: "tsIcon"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "linkContainer",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4574a52341674792$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: active && !messageIsSend ? "halfContact active" : messageIsSend ? "halfContact success" : "halfContact",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: messageIsSend ? "hideContact" : "contactContainer",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "closeBtnContainer",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("button", {
                                    type: "button",
                                    "aria-label": "Close",
                                    className: "close-container",
                                    onClick: ()=>setActive(false),
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "leftright"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "rightleft"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                        className: "contactTitle",
                                        children: "Let\u2019s talk."
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "contactText",
                                        children: "New projects, freelance inquiry or even a coffee."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "inputContainer",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                        className: "inputLabel",
                                        htmlFor: "contact-name",
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "inputContent",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                                type: "text",
                                                id: "contact-name",
                                                className: "input",
                                                name: "name",
                                                value: memoizedMessage.name,
                                                onChange: (e)=>handleInputChange("name", e.target.value)
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                className: "inputCover"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                style: {
                                    marginTop: 25
                                },
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "inputContainer",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                            className: "inputLabel",
                                            htmlFor: "contact-email",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                            className: "inputContent",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                                    type: "email",
                                                    id: "contact-email",
                                                    className: "input",
                                                    name: "email",
                                                    value: memoizedMessage.email,
                                                    onChange: (e)=>handleInputChange("email", e.target.value)
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                    className: "inputCover"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                style: {
                                    marginTop: 25
                                },
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "inputContainer",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                            className: "inputLabel",
                                            htmlFor: "contact-message",
                                            children: "Message"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                            className: "inputContent",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("textarea", {
                                                    id: "contact-message",
                                                    className: "textArea",
                                                    name: "description",
                                                    value: memoizedMessage.description,
                                                    onChange: (e)=>handleInputChange("description", e.target.value)
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                    className: "textAreaCover"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                type: "text",
                                name: "website",
                                className: "honeypot",
                                tabIndex: -1,
                                autoComplete: "off",
                                "aria-hidden": true,
                                value: website,
                                onChange: (e)=>setWebsite(e.target.value)
                            }),
                            sendError && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                className: "formError",
                                role: "alert",
                                children: "The message was not sent. Please try again or email me at x.vlad2101@gmail.com"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "buttonContainer",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9307550ce52715a5$export$2e2bcd8739ae039), {
                                    text: isSending ? "Sending..." : "Send Message",
                                    widthArrow: false,
                                    disabled: isSending || checkMessage(),
                                    onClick: handleSendMessage
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $df07ea70fb26ed48$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $6cds3.memo)($df07ea70fb26ed48$var$Modal);


// modules

parcelRequire("6cds3");
var $d0e6e304306aa6d3$exports = {};

$parcel$export($d0e6e304306aa6d3$exports, "btnContainer", function () { return $d0e6e304306aa6d3$export$cb6c30b631422a13; }, function (v) { return $d0e6e304306aa6d3$export$cb6c30b631422a13 = v; });
$parcel$export($d0e6e304306aa6d3$exports, "cardLeft", function () { return $d0e6e304306aa6d3$export$5d4a0a1cf6f8dc07; }, function (v) { return $d0e6e304306aa6d3$export$5d4a0a1cf6f8dc07 = v; });
$parcel$export($d0e6e304306aa6d3$exports, "cardLink", function () { return $d0e6e304306aa6d3$export$c4387b32cb5d9d67; }, function (v) { return $d0e6e304306aa6d3$export$c4387b32cb5d9d67 = v; });
$parcel$export($d0e6e304306aa6d3$exports, "cardNumber", function () { return $d0e6e304306aa6d3$export$8c45c52c50053c36; }, function (v) { return $d0e6e304306aa6d3$export$8c45c52c50053c36 = v; });
$parcel$export($d0e6e304306aa6d3$exports, "cardRight", function () { return $d0e6e304306aa6d3$export$6d55b2b6c4c40dfe; }, function (v) { return $d0e6e304306aa6d3$export$6d55b2b6c4c40dfe = v; });
$parcel$export($d0e6e304306aa6d3$exports, "cardSlot", function () { return $d0e6e304306aa6d3$export$cc5bb08352484ec2; }, function (v) { return $d0e6e304306aa6d3$export$cc5bb08352484ec2 = v; });
$parcel$export($d0e6e304306aa6d3$exports, "cardText", function () { return $d0e6e304306aa6d3$export$69b2c67571acbe57; }, function (v) { return $d0e6e304306aa6d3$export$69b2c67571acbe57 = v; });
$parcel$export($d0e6e304306aa6d3$exports, "cardTitle", function () { return $d0e6e304306aa6d3$export$3aac624c619dfa7f; }, function (v) { return $d0e6e304306aa6d3$export$3aac624c619dfa7f = v; });
$parcel$export($d0e6e304306aa6d3$exports, "image", function () { return $d0e6e304306aa6d3$export$5c452ff88e35e47d; }, function (v) { return $d0e6e304306aa6d3$export$5c452ff88e35e47d = v; });
$parcel$export($d0e6e304306aa6d3$exports, "textLeft", function () { return $d0e6e304306aa6d3$export$354e346024ee0461; }, function (v) { return $d0e6e304306aa6d3$export$354e346024ee0461 = v; });
$parcel$export($d0e6e304306aa6d3$exports, "textRight", function () { return $d0e6e304306aa6d3$export$19e1b6471a572b37; }, function (v) { return $d0e6e304306aa6d3$export$19e1b6471a572b37 = v; });
$parcel$export($d0e6e304306aa6d3$exports, "workCard", function () { return $d0e6e304306aa6d3$export$d14e85c3159fa464; }, function (v) { return $d0e6e304306aa6d3$export$d14e85c3159fa464 = v; });
var $d0e6e304306aa6d3$export$cb6c30b631422a13;
var $d0e6e304306aa6d3$export$5d4a0a1cf6f8dc07;
var $d0e6e304306aa6d3$export$c4387b32cb5d9d67;
var $d0e6e304306aa6d3$export$8c45c52c50053c36;
var $d0e6e304306aa6d3$export$6d55b2b6c4c40dfe;
var $d0e6e304306aa6d3$export$cc5bb08352484ec2;
var $d0e6e304306aa6d3$export$69b2c67571acbe57;
var $d0e6e304306aa6d3$export$3aac624c619dfa7f;
var $d0e6e304306aa6d3$export$5c452ff88e35e47d;
var $d0e6e304306aa6d3$export$354e346024ee0461;
var $d0e6e304306aa6d3$export$19e1b6471a572b37;
var $d0e6e304306aa6d3$export$d14e85c3159fa464;
$d0e6e304306aa6d3$export$cb6c30b631422a13 = `RPbNkG_btnContainer`;
$d0e6e304306aa6d3$export$5d4a0a1cf6f8dc07 = `RPbNkG_cardLeft`;
$d0e6e304306aa6d3$export$c4387b32cb5d9d67 = `RPbNkG_cardLink`;
$d0e6e304306aa6d3$export$8c45c52c50053c36 = `RPbNkG_cardNumber`;
$d0e6e304306aa6d3$export$6d55b2b6c4c40dfe = `RPbNkG_cardRight`;
$d0e6e304306aa6d3$export$cc5bb08352484ec2 = `RPbNkG_cardSlot`;
$d0e6e304306aa6d3$export$69b2c67571acbe57 = `RPbNkG_cardText`;
$d0e6e304306aa6d3$export$3aac624c619dfa7f = `RPbNkG_cardTitle`;
$d0e6e304306aa6d3$export$5c452ff88e35e47d = `RPbNkG_image`;
$d0e6e304306aa6d3$export$354e346024ee0461 = `RPbNkG_textLeft`;
$d0e6e304306aa6d3$export$19e1b6471a572b37 = `RPbNkG_textRight`;
$d0e6e304306aa6d3$export$d14e85c3159fa464 = `RPbNkG_workCard`;



// modules




function $a59bd1c61bcc4a41$var$stopAnimation(visualElement) {
    visualElement.values.forEach((value)=>value.stop());
}
/**
 * @public
 */ function $a59bd1c61bcc4a41$export$e2858afe37bd256a() {
    /**
     * Track whether the host component has mounted.
     */ let hasMounted = false;
    /**
     * A collection of linked component animation controls.
     */ const subscribers = new Set();
    const controls = {
        subscribe (visualElement) {
            subscribers.add(visualElement);
            return ()=>void subscribers.delete(visualElement);
        },
        start (definition, transitionOverride) {
            (0, $faee95b32f04793f$export$f5708dca728d7177)(hasMounted, "controls.start() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            const animations = [];
            subscribers.forEach((visualElement)=>{
                animations.push((0, $25633fa26ef1b230$export$ff62cf473653f109)(visualElement, definition, {
                    transitionOverride: transitionOverride
                }));
            });
            return Promise.all(animations);
        },
        set (definition) {
            (0, $faee95b32f04793f$export$f5708dca728d7177)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach((visualElement)=>{
                (0, $284183dc41cada08$export$b7771d60d308862f)(visualElement, definition);
            });
        },
        stop () {
            subscribers.forEach((visualElement)=>{
                $a59bd1c61bcc4a41$var$stopAnimation(visualElement);
            });
        },
        mount () {
            hasMounted = true;
            return ()=>{
                hasMounted = false;
                controls.stop();
            };
        }
    };
    return controls;
}




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */ function $ece09ef837334a3d$export$c705d7acb130fe23() {
    const controls = (0, $491d0f9d7a26c5a8$export$fe4300aa8eebea86)((0, $a59bd1c61bcc4a41$export$e2858afe37bd256a));
    (0, $b588e509ec7465c1$export$700979bc83e7db82)(controls.mount, []);
    return controls;
}
const $ece09ef837334a3d$export$9e2608686d4ad846 = $ece09ef837334a3d$export$c705d7acb130fe23;


var $6cds3 = parcelRequire("6cds3");

function $0ec1752947769151$export$90ceba2564a894f8(elements, scope, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        let root = document;
        if (scope) {
            (0, $faee95b32f04793f$export$f5708dca728d7177)(Boolean(scope.current), "Scope provided, but no element detected.");
            root = scope.current;
        }
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = root.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = root.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}


const $f9ecdc810e5ad764$var$thresholds = {
    some: 0,
    all: 1
};
function $f9ecdc810e5ad764$export$acb1e9cb9ce4ca56(elementOrSelector, onStart, { root: root, margin: rootMargin, amount: amount = "some" } = {}) {
    const elements = (0, $0ec1752947769151$export$90ceba2564a894f8)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries)=>{
        entries.forEach((entry)=>{
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (typeof newOnEnd === "function") activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root: root,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : $f9ecdc810e5ad764$var$thresholds[amount]
    });
    elements.forEach((element)=>observer.observe(element));
    return ()=>observer.disconnect();
}


function $a4467854d8e7cfc0$export$2f62ee6831462844(ref, { root: root, margin: margin, amount: amount, once: once = false } = {}) {
    const [isInView, setInView] = (0, $6cds3.useState)(false);
    (0, $6cds3.useEffect)(()=>{
        if (!ref.current || once && isInView) return;
        const onEnter = ()=>{
            setInView(true);
            return once ? undefined : ()=>setInView(false);
        };
        const options = {
            root: root && root.current || undefined,
            margin: margin,
            amount: amount
        };
        return (0, $f9ecdc810e5ad764$export$acb1e9cb9ce4ca56)(ref.current, onEnter, options);
    }, [
        root,
        ref,
        margin,
        once
    ]);
    return isInView;
}


var $6cds3 = parcelRequire("6cds3");



/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function $5ada59f561298b56$export$6a42007cf1e7b6f8() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !(0, $3ff2c43741033fcf$export$6476d16e2fd2d0db).current && (0, $cc01182a0cb35a51$export$ca9f41fb23dded3d)();
    const [shouldReduceMotion] = (0, $6cds3.useState)((0, $3ff2c43741033fcf$export$ff7706047246b98b).current);
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}



var $6cds3 = parcelRequire("6cds3");
const $07bfed25ceaee054$var$AnimateWrapper = (props)=>{
    const { children: children, width: width = "fit-content", background: background = "rgba(40, 61, 145, 0.85)" } = props;
    const ref = (0, $6cds3.useRef)(null);
    const isInView = (0, $a4467854d8e7cfc0$export$2f62ee6831462844)(ref, {
        once: true
    });
    const reduceMotion = (0, $5ada59f561298b56$export$6a42007cf1e7b6f8)();
    const mainControl = (0, $ece09ef837334a3d$export$9e2608686d4ad846)();
    const slideControl = (0, $ece09ef837334a3d$export$9e2608686d4ad846)();
    (0, $6cds3.useEffect)(()=>{
        if (isInView) {
            mainControl.start("visible");
            slideControl.start("visible");
        }
    }, [
        isInView,
        mainControl
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        ref: ref,
        style: {
            position: "relative",
            width: width
        },
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                variants: {
                    hidden: {
                        opacity: 0,
                        y: 75
                    },
                    visible: {
                        opacity: 1,
                        y: 0
                    }
                },
                initial: "hidden",
                animate: mainControl,
                transition: {
                    duration: 0.5,
                    delay: 0.4
                },
                children: children
            }),
            !reduceMotion && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    overflow: "hidden",
                    pointerEvents: "none",
                    zIndex: 20
                },
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                    variants: {
                        hidden: {
                            left: 0
                        },
                        visible: {
                            left: "100%"
                        }
                    },
                    initial: "hidden",
                    animate: slideControl,
                    transition: {
                        duration: 0.5,
                        ease: "easeIn",
                        delay: 0.2
                    },
                    style: {
                        position: "absolute",
                        top: 4,
                        bottom: 4,
                        left: 0,
                        width: "100%",
                        background: background
                    }
                })
            })
        ]
    });
};
var $07bfed25ceaee054$export$2e2bcd8739ae039 = $07bfed25ceaee054$var$AnimateWrapper;


// modules

const $35f54a4218b84ba5$export$706ad1af8096e280 = (navigate, path)=>{
    const options = {
        duration: 200,
        smooth: true
    };
    (0, $1d42a532dd4f25d5$exports.animateScroll).scrollToTop(options);
    setTimeout(()=>navigate(path), 300);
};
const $35f54a4218b84ba5$export$13aea1a3cb5e3f1f = (event, navigate, path)=>{
    // keep "open in a new tab" working
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    $35f54a4218b84ba5$export$706ad1af8096e280(navigate, path);
};


const $4e5518ffb6e1a3df$var$WorkCards = (props)=>{
    const { item: item, index: index, navigate: navigate } = props;
    const odd = index % 2 === 0;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($d0e6e304306aa6d3$exports))).cardSlot} ${odd ? (0, (/*@__PURE__*/$parcel$interopDefault($d0e6e304306aa6d3$exports))).cardLeft : (0, (/*@__PURE__*/$parcel$interopDefault($d0e6e304306aa6d3$exports))).cardRight}`,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $07bfed25ceaee054$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                href: `/${item.path}`,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d0e6e304306aa6d3$exports))).cardLink,
                onClick: (e)=>(0, $35f54a4218b84ba5$export$13aea1a3cb5e3f1f)(e, navigate, `/${item.path}`),
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d0e6e304306aa6d3$exports))).workCard,
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d0e6e304306aa6d3$exports))).cardNumber,
                            style: odd ? {
                                right: 0
                            } : {
                                left: 0
                            },
                            children: [
                                "0",
                                index + 1
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: item.image,
                            alt: `${item.title} case study cover`,
                            loading: "lazy",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d0e6e304306aa6d3$exports))).image
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: odd ? (0, (/*@__PURE__*/$parcel$interopDefault($d0e6e304306aa6d3$exports))).textLeft : (0, (/*@__PURE__*/$parcel$interopDefault($d0e6e304306aa6d3$exports))).textRight,
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d0e6e304306aa6d3$exports))).cardTitle,
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d0e6e304306aa6d3$exports))).cardText,
                                    children: item.text
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d0e6e304306aa6d3$exports))).btnContainer,
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9307550ce52715a5$export$2e2bcd8739ae039), {
                                        text: "Case Study"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $4e5518ffb6e1a3df$export$2e2bcd8739ae039 = $4e5518ffb6e1a3df$var$WorkCards;



// modules



var $6cds3 = parcelRequire("6cds3");
const $9cb2eb5a2afb4e3f$var$defaultAnimation = {
    initial: {
        opacity: 0
    },
    visible: {
        opacity: 1
    }
};
const $9cb2eb5a2afb4e3f$var$AnimatedText = (props)=>{
    const { text: text, className: className } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).span, {
        initial: "initial",
        animate: "visible",
        transition: {
            staggerChildren: 0.07,
            delayChildren: 0.5
        },
        "aria-hidden": true,
        className: className,
        children: text.split("").map((letter, index)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).span, {
                variants: $9cb2eb5a2afb4e3f$var$defaultAnimation,
                children: letter
            }, index))
    });
};
var $9cb2eb5a2afb4e3f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $6cds3.memo)($9cb2eb5a2afb4e3f$var$AnimatedText);


// modules

parcelRequire("6cds3");


var $7d30f51b45414bd0$exports = {};

$parcel$export($7d30f51b45414bd0$exports, "contact", function () { return $7d30f51b45414bd0$export$414d047e665c7112; }, function (v) { return $7d30f51b45414bd0$export$414d047e665c7112 = v; });
$parcel$export($7d30f51b45414bd0$exports, "container", function () { return $7d30f51b45414bd0$export$34e0f9847d4c02dd; }, function (v) { return $7d30f51b45414bd0$export$34e0f9847d4c02dd = v; });
$parcel$export($7d30f51b45414bd0$exports, "contentContainer", function () { return $7d30f51b45414bd0$export$8f981dffec84ba52; }, function (v) { return $7d30f51b45414bd0$export$8f981dffec84ba52 = v; });
$parcel$export($7d30f51b45414bd0$exports, "iconLink", function () { return $7d30f51b45414bd0$export$c46d34ef8d4df28f; }, function (v) { return $7d30f51b45414bd0$export$c46d34ef8d4df28f = v; });
$parcel$export($7d30f51b45414bd0$exports, "licenceContainer", function () { return $7d30f51b45414bd0$export$33eead19c8529cd7; }, function (v) { return $7d30f51b45414bd0$export$33eead19c8529cd7 = v; });
$parcel$export($7d30f51b45414bd0$exports, "license", function () { return $7d30f51b45414bd0$export$7ff87ebdb8ccbf20; }, function (v) { return $7d30f51b45414bd0$export$7ff87ebdb8ccbf20 = v; });
$parcel$export($7d30f51b45414bd0$exports, "linkContainer", function () { return $7d30f51b45414bd0$export$51d4df9cfb8c2bf4; }, function (v) { return $7d30f51b45414bd0$export$51d4df9cfb8c2bf4 = v; });
$parcel$export($7d30f51b45414bd0$exports, "toTop", function () { return $7d30f51b45414bd0$export$dd08b95ed5ec19a6; }, function (v) { return $7d30f51b45414bd0$export$dd08b95ed5ec19a6 = v; });
var $7d30f51b45414bd0$export$414d047e665c7112;
var $7d30f51b45414bd0$export$34e0f9847d4c02dd;
var $7d30f51b45414bd0$export$8f981dffec84ba52;
var $7d30f51b45414bd0$export$c46d34ef8d4df28f;
var $7d30f51b45414bd0$export$33eead19c8529cd7;
var $7d30f51b45414bd0$export$7ff87ebdb8ccbf20;
var $7d30f51b45414bd0$export$51d4df9cfb8c2bf4;
var $7d30f51b45414bd0$export$dd08b95ed5ec19a6;
$7d30f51b45414bd0$export$414d047e665c7112 = `-4B39G_contact`;
$7d30f51b45414bd0$export$34e0f9847d4c02dd = `-4B39G_container`;
$7d30f51b45414bd0$export$8f981dffec84ba52 = `-4B39G_contentContainer`;
$7d30f51b45414bd0$export$c46d34ef8d4df28f = `-4B39G_iconLink`;
$7d30f51b45414bd0$export$33eead19c8529cd7 = `-4B39G_licenceContainer`;
$7d30f51b45414bd0$export$7ff87ebdb8ccbf20 = `-4B39G_license`;
$7d30f51b45414bd0$export$51d4df9cfb8c2bf4 = `-4B39G_linkContainer`;
$7d30f51b45414bd0$export$dd08b95ed5ec19a6 = `-4B39G_toTop`;


const $923d1205978c6ef9$export$553910ef0cc96026 = [
    {
        id: 91,
        name: "LinkedIn",
        path: "https://www.linkedin.com/in/vlad-khrushchov-59a83b380/"
    },
    {
        id: 92,
        name: "GitHub",
        path: "https://github.com/Vladoosik"
    },
    {
        id: 93,
        name: "GitLab",
        path: "https://gitlab.com/Vladoosik"
    },
    {
        id: 95,
        name: "Telegram",
        path: "https://t.me/vladoosik1"
    }
];



const $e3ea40068f29db1a$var$Footer = (props)=>{
    const { linkToTop: linkToTop = "home", onLinkPress: onLinkPress } = props;
    const year = new Date().getFullYear();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d30f51b45414bd0$exports))).container,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d30f51b45414bd0$exports))).contentContainer,
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $1d42a532dd4f25d5$exports.Link), {
                    to: linkToTop,
                    href: `#${linkToTop}`,
                    smooth: "100",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d30f51b45414bd0$exports))).iconLink,
                    onClick: onLinkPress,
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fe8768734706f750$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($7d30f51b45414bd0$exports))).toTop,
                            children: "To Top"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d30f51b45414bd0$exports))).linkContainer,
                    children: (0, $923d1205978c6ef9$export$553910ef0cc96026).map((item)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e93451a89777bdf5$export$2e2bcd8739ae039), {
                            item: item
                        }, item.id))
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7d30f51b45414bd0$exports))).licenceContainer,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7d30f51b45414bd0$exports))).license,
                        children: [
                            "\xa9 ",
                            year,
                            " Vlad Khrushchov",
                            " - ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                href: "mailto:x.vlad2101@gmail.com",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d30f51b45414bd0$exports))).contact,
                                children: "Contact"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $e3ea40068f29db1a$export$2e2bcd8739ae039 = $e3ea40068f29db1a$var$Footer;


//modules



parcelRequire("6cds3");

// src/index.ts

// src/hooks/useChain.ts








var $6cds3 = parcelRequire("6cds3");
var $10933bca3baab1c9$var$__defProp = Object.defineProperty;
var $10933bca3baab1c9$var$__export = (target, all)=>{
    for(var name in all)$10933bca3baab1c9$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $10933bca3baab1c9$export$cceeabf822b64fc0 = {};
$10933bca3baab1c9$var$__export($10933bca3baab1c9$export$cceeabf822b64fc0, {
    assign: ()=>$10933bca3baab1c9$var$assign,
    colors: ()=>$10933bca3baab1c9$var$colors,
    createStringInterpolator: ()=>$10933bca3baab1c9$var$createStringInterpolator,
    skipAnimation: ()=>$10933bca3baab1c9$var$skipAnimation,
    to: ()=>$10933bca3baab1c9$var$to,
    willAdvance: ()=>$10933bca3baab1c9$var$willAdvance
});
// ../rafz/dist/react-spring_rafz.modern.mjs
var $10933bca3baab1c9$var$updateQueue = $10933bca3baab1c9$var$makeQueue();
var $10933bca3baab1c9$export$27f233d61a9e2fa4 = (fn)=>$10933bca3baab1c9$var$schedule(fn, $10933bca3baab1c9$var$updateQueue);
var $10933bca3baab1c9$var$writeQueue = $10933bca3baab1c9$var$makeQueue();
$10933bca3baab1c9$export$27f233d61a9e2fa4.write = (fn)=>$10933bca3baab1c9$var$schedule(fn, $10933bca3baab1c9$var$writeQueue);
var $10933bca3baab1c9$var$onStartQueue = $10933bca3baab1c9$var$makeQueue();
$10933bca3baab1c9$export$27f233d61a9e2fa4.onStart = (fn)=>$10933bca3baab1c9$var$schedule(fn, $10933bca3baab1c9$var$onStartQueue);
var $10933bca3baab1c9$var$onFrameQueue = $10933bca3baab1c9$var$makeQueue();
$10933bca3baab1c9$export$27f233d61a9e2fa4.onFrame = (fn)=>$10933bca3baab1c9$var$schedule(fn, $10933bca3baab1c9$var$onFrameQueue);
var $10933bca3baab1c9$var$onFinishQueue = $10933bca3baab1c9$var$makeQueue();
$10933bca3baab1c9$export$27f233d61a9e2fa4.onFinish = (fn)=>$10933bca3baab1c9$var$schedule(fn, $10933bca3baab1c9$var$onFinishQueue);
var $10933bca3baab1c9$var$timeouts = [];
$10933bca3baab1c9$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $10933bca3baab1c9$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $10933bca3baab1c9$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $10933bca3baab1c9$var$timeouts.splice(i, 1);
        $10933bca3baab1c9$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $10933bca3baab1c9$var$timeouts.splice($10933bca3baab1c9$var$findTimeout(time), 0, timeout);
    $10933bca3baab1c9$var$pendingCount += 1;
    $10933bca3baab1c9$var$start();
    return timeout;
};
var $10933bca3baab1c9$var$findTimeout = (time)=>~(~$10933bca3baab1c9$var$timeouts.findIndex((t)=>t.time > time) || ~$10933bca3baab1c9$var$timeouts.length);
$10933bca3baab1c9$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $10933bca3baab1c9$var$onStartQueue.delete(fn);
    $10933bca3baab1c9$var$onFrameQueue.delete(fn);
    $10933bca3baab1c9$var$onFinishQueue.delete(fn);
    $10933bca3baab1c9$var$updateQueue.delete(fn);
    $10933bca3baab1c9$var$writeQueue.delete(fn);
};
$10933bca3baab1c9$export$27f233d61a9e2fa4.sync = (fn)=>{
    $10933bca3baab1c9$var$sync = true;
    $10933bca3baab1c9$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $10933bca3baab1c9$var$sync = false;
};
$10933bca3baab1c9$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $10933bca3baab1c9$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $10933bca3baab1c9$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $10933bca3baab1c9$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$10933bca3baab1c9$export$27f233d61a9e2fa4.use = (impl)=>$10933bca3baab1c9$var$nativeRaf = impl;
$10933bca3baab1c9$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$10933bca3baab1c9$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$10933bca3baab1c9$export$27f233d61a9e2fa4.catch = console.error;
$10933bca3baab1c9$export$27f233d61a9e2fa4.frameLoop = "always";
$10933bca3baab1c9$export$27f233d61a9e2fa4.advance = ()=>{
    if ($10933bca3baab1c9$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $10933bca3baab1c9$var$update();
};
var $10933bca3baab1c9$var$ts = -1;
var $10933bca3baab1c9$var$pendingCount = 0;
var $10933bca3baab1c9$var$sync = false;
function $10933bca3baab1c9$var$schedule(fn, queue) {
    if ($10933bca3baab1c9$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $10933bca3baab1c9$var$start();
    }
}
function $10933bca3baab1c9$var$start() {
    if ($10933bca3baab1c9$var$ts < 0) {
        $10933bca3baab1c9$var$ts = 0;
        if ($10933bca3baab1c9$export$27f233d61a9e2fa4.frameLoop !== "demand") $10933bca3baab1c9$var$nativeRaf($10933bca3baab1c9$var$loop);
    }
}
function $10933bca3baab1c9$var$stop() {
    $10933bca3baab1c9$var$ts = -1;
}
function $10933bca3baab1c9$var$loop() {
    if (~$10933bca3baab1c9$var$ts) {
        $10933bca3baab1c9$var$nativeRaf($10933bca3baab1c9$var$loop);
        $10933bca3baab1c9$export$27f233d61a9e2fa4.batchedUpdates($10933bca3baab1c9$var$update);
    }
}
function $10933bca3baab1c9$var$update() {
    const prevTs = $10933bca3baab1c9$var$ts;
    $10933bca3baab1c9$var$ts = $10933bca3baab1c9$export$27f233d61a9e2fa4.now();
    const count = $10933bca3baab1c9$var$findTimeout($10933bca3baab1c9$var$ts);
    if (count) {
        $10933bca3baab1c9$var$eachSafely($10933bca3baab1c9$var$timeouts.splice(0, count), (t)=>t.handler());
        $10933bca3baab1c9$var$pendingCount -= count;
    }
    if (!$10933bca3baab1c9$var$pendingCount) {
        $10933bca3baab1c9$var$stop();
        return;
    }
    $10933bca3baab1c9$var$onStartQueue.flush();
    $10933bca3baab1c9$var$updateQueue.flush(prevTs ? Math.min(64, $10933bca3baab1c9$var$ts - prevTs) : 16.667);
    $10933bca3baab1c9$var$onFrameQueue.flush();
    $10933bca3baab1c9$var$writeQueue.flush();
    $10933bca3baab1c9$var$onFinishQueue.flush();
}
function $10933bca3baab1c9$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $10933bca3baab1c9$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $10933bca3baab1c9$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $10933bca3baab1c9$var$pendingCount -= current.size;
                $10933bca3baab1c9$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $10933bca3baab1c9$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $10933bca3baab1c9$var$eachSafely(values, each2) {
    values.forEach((value)=>{
        try {
            each2(value);
        } catch (e) {
            $10933bca3baab1c9$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
// src/helpers.ts
function $10933bca3baab1c9$export$8793edee2d425525() {}
var $10933bca3baab1c9$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $10933bca3baab1c9$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $10933bca3baab1c9$export$248d38f6296296c5(a, b) {
    if ($10933bca3baab1c9$export$226b3eccf92c9ed9.arr(a)) {
        if (!$10933bca3baab1c9$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $10933bca3baab1c9$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $10933bca3baab1c9$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($10933bca3baab1c9$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $10933bca3baab1c9$export$45b10814cc054894 = (a)=>$10933bca3baab1c9$export$226b3eccf92c9ed9.und(a) ? [] : $10933bca3baab1c9$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $10933bca3baab1c9$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $10933bca3baab1c9$export$79b2f7037acddd43(items, iterator);
    }
}
var $10933bca3baab1c9$export$7ba486852759e806 = (queue, ...args)=>$10933bca3baab1c9$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $10933bca3baab1c9$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $10933bca3baab1c9$var$createStringInterpolator;
var $10933bca3baab1c9$var$to;
var $10933bca3baab1c9$var$colors = null;
var $10933bca3baab1c9$var$skipAnimation = false;
var $10933bca3baab1c9$var$willAdvance = $10933bca3baab1c9$export$8793edee2d425525;
var $10933bca3baab1c9$var$assign = (globals)=>{
    if (globals.to) $10933bca3baab1c9$var$to = globals.to;
    if (globals.now) $10933bca3baab1c9$export$27f233d61a9e2fa4.now = globals.now;
    if (globals.colors !== void 0) $10933bca3baab1c9$var$colors = globals.colors;
    if (globals.skipAnimation != null) $10933bca3baab1c9$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $10933bca3baab1c9$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) $10933bca3baab1c9$export$27f233d61a9e2fa4.use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) $10933bca3baab1c9$export$27f233d61a9e2fa4.batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $10933bca3baab1c9$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) $10933bca3baab1c9$export$27f233d61a9e2fa4.frameLoop = globals.frameLoop;
};
// src/FrameLoop.ts
var $10933bca3baab1c9$var$startQueue = /* @__PURE__ */ new Set();
var $10933bca3baab1c9$var$currentFrame = [];
var $10933bca3baab1c9$var$prevFrame = [];
var $10933bca3baab1c9$var$priority = 0;
var $10933bca3baab1c9$export$a57f5080a3bcc90a = {
    get idle () {
        return !$10933bca3baab1c9$var$startQueue.size && !$10933bca3baab1c9$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($10933bca3baab1c9$var$priority > animation.priority) {
            $10933bca3baab1c9$var$startQueue.add(animation);
            $10933bca3baab1c9$export$27f233d61a9e2fa4.onStart($10933bca3baab1c9$var$flushStartQueue);
        } else {
            $10933bca3baab1c9$var$startSafely(animation);
            $10933bca3baab1c9$export$27f233d61a9e2fa4($10933bca3baab1c9$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $10933bca3baab1c9$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($10933bca3baab1c9$var$priority) $10933bca3baab1c9$export$27f233d61a9e2fa4.onFrame(()=>$10933bca3baab1c9$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $10933bca3baab1c9$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $10933bca3baab1c9$var$currentFrame.splice(prevIndex, 1);
                $10933bca3baab1c9$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $10933bca3baab1c9$var$currentFrame = [];
        $10933bca3baab1c9$var$startQueue.clear();
    }
};
function $10933bca3baab1c9$var$flushStartQueue() {
    $10933bca3baab1c9$var$startQueue.forEach($10933bca3baab1c9$var$startSafely);
    $10933bca3baab1c9$var$startQueue.clear();
    $10933bca3baab1c9$export$27f233d61a9e2fa4($10933bca3baab1c9$var$advance);
}
function $10933bca3baab1c9$var$startSafely(animation) {
    if (!$10933bca3baab1c9$var$currentFrame.includes(animation)) $10933bca3baab1c9$var$startUnsafely(animation);
}
function $10933bca3baab1c9$var$startUnsafely(animation) {
    $10933bca3baab1c9$var$currentFrame.splice($10933bca3baab1c9$var$findIndex($10933bca3baab1c9$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $10933bca3baab1c9$var$advance(dt) {
    const nextFrame = $10933bca3baab1c9$var$prevFrame;
    for(let i = 0; i < $10933bca3baab1c9$var$currentFrame.length; i++){
        const animation = $10933bca3baab1c9$var$currentFrame[i];
        $10933bca3baab1c9$var$priority = animation.priority;
        if (!animation.idle) {
            $10933bca3baab1c9$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $10933bca3baab1c9$var$priority = 0;
    $10933bca3baab1c9$var$prevFrame = $10933bca3baab1c9$var$currentFrame;
    $10933bca3baab1c9$var$prevFrame.length = 0;
    $10933bca3baab1c9$var$currentFrame = nextFrame;
    return $10933bca3baab1c9$var$currentFrame.length > 0;
}
function $10933bca3baab1c9$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $10933bca3baab1c9$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $10933bca3baab1c9$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $10933bca3baab1c9$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $10933bca3baab1c9$var$PERCENTAGE = $10933bca3baab1c9$var$NUMBER + "%";
function $10933bca3baab1c9$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $10933bca3baab1c9$export$8972dc0e6ad9238f = new RegExp("rgb" + $10933bca3baab1c9$var$call($10933bca3baab1c9$var$NUMBER, $10933bca3baab1c9$var$NUMBER, $10933bca3baab1c9$var$NUMBER));
var $10933bca3baab1c9$export$4e46ac54fc82cf3b = new RegExp("rgba" + $10933bca3baab1c9$var$call($10933bca3baab1c9$var$NUMBER, $10933bca3baab1c9$var$NUMBER, $10933bca3baab1c9$var$NUMBER, $10933bca3baab1c9$var$NUMBER));
var $10933bca3baab1c9$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $10933bca3baab1c9$var$call($10933bca3baab1c9$var$NUMBER, $10933bca3baab1c9$var$PERCENTAGE, $10933bca3baab1c9$var$PERCENTAGE));
var $10933bca3baab1c9$export$810b04175080204c = new RegExp("hsla" + $10933bca3baab1c9$var$call($10933bca3baab1c9$var$NUMBER, $10933bca3baab1c9$var$PERCENTAGE, $10933bca3baab1c9$var$PERCENTAGE, $10933bca3baab1c9$var$NUMBER));
var $10933bca3baab1c9$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $10933bca3baab1c9$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $10933bca3baab1c9$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $10933bca3baab1c9$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $10933bca3baab1c9$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $10933bca3baab1c9$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($10933bca3baab1c9$var$colors && $10933bca3baab1c9$var$colors[color] !== void 0) return $10933bca3baab1c9$var$colors[color];
    if (match = $10933bca3baab1c9$export$8972dc0e6ad9238f.exec(color)) return ($10933bca3baab1c9$var$parse255(match[1]) << 24 | // r
    $10933bca3baab1c9$var$parse255(match[2]) << 16 | // g
    $10933bca3baab1c9$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $10933bca3baab1c9$export$4e46ac54fc82cf3b.exec(color)) return ($10933bca3baab1c9$var$parse255(match[1]) << 24 | // r
    $10933bca3baab1c9$var$parse255(match[2]) << 16 | // g
    $10933bca3baab1c9$var$parse255(match[3]) << 8 | // b
    $10933bca3baab1c9$var$parse1(match[4])) >>> // a
    0;
    if (match = $10933bca3baab1c9$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $10933bca3baab1c9$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $10933bca3baab1c9$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $10933bca3baab1c9$export$8f4a7c0bb78e6ea8.exec(color)) return ($10933bca3baab1c9$var$hslToRgb($10933bca3baab1c9$var$parse360(match[1]), // h
    $10933bca3baab1c9$var$parsePercentage(match[2]), // s
    $10933bca3baab1c9$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $10933bca3baab1c9$export$810b04175080204c.exec(color)) return ($10933bca3baab1c9$var$hslToRgb($10933bca3baab1c9$var$parse360(match[1]), // h
    $10933bca3baab1c9$var$parsePercentage(match[2]), // s
    $10933bca3baab1c9$var$parsePercentage(match[3])) | $10933bca3baab1c9$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $10933bca3baab1c9$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $10933bca3baab1c9$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $10933bca3baab1c9$var$hue2rgb(p, q, h + 1 / 3);
    const g = $10933bca3baab1c9$var$hue2rgb(p, q, h);
    const b = $10933bca3baab1c9$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $10933bca3baab1c9$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $10933bca3baab1c9$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $10933bca3baab1c9$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $10933bca3baab1c9$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $10933bca3baab1c9$export$61db176b839af1f(input) {
    let int32Color = $10933bca3baab1c9$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $10933bca3baab1c9$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($10933bca3baab1c9$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($10933bca3baab1c9$export$226b3eccf92c9ed9.arr(range)) return $10933bca3baab1c9$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($10933bca3baab1c9$export$226b3eccf92c9ed9.str(range.output[0])) return $10933bca3baab1c9$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $10933bca3baab1c9$var$findRange(input, inputRange);
        return $10933bca3baab1c9$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $10933bca3baab1c9$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $10933bca3baab1c9$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $10933bca3baab1c9$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $10933bca3baab1c9$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $10933bca3baab1c9$var$c1 = 1.70158;
var $10933bca3baab1c9$var$c2 = $10933bca3baab1c9$var$c1 * 1.525;
var $10933bca3baab1c9$var$c3 = $10933bca3baab1c9$var$c1 + 1;
var $10933bca3baab1c9$var$c4 = 2 * Math.PI / 3;
var $10933bca3baab1c9$var$c5 = 2 * Math.PI / 4.5;
var $10933bca3baab1c9$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $10933bca3baab1c9$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$10933bca3baab1c9$var$c3 * x * x * x - $10933bca3baab1c9$var$c1 * x * x,
    easeOutBack: (x)=>1 + $10933bca3baab1c9$var$c3 * Math.pow(x - 1, 3) + $10933bca3baab1c9$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($10933bca3baab1c9$var$c2 + 1) * 2 * x - $10933bca3baab1c9$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($10933bca3baab1c9$var$c2 + 1) * (x * 2 - 2) + $10933bca3baab1c9$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $10933bca3baab1c9$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $10933bca3baab1c9$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $10933bca3baab1c9$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $10933bca3baab1c9$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $10933bca3baab1c9$var$bounceOut(1 - x),
    easeOutBounce: $10933bca3baab1c9$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $10933bca3baab1c9$var$bounceOut(1 - 2 * x)) / 2 : (1 + $10933bca3baab1c9$var$bounceOut(2 * x - 1)) / 2,
    steps: $10933bca3baab1c9$var$steps
};
// src/fluids.ts
var $10933bca3baab1c9$var$$get = Symbol.for("FluidValue.get");
var $10933bca3baab1c9$var$$observers = Symbol.for("FluidValue.observers");
var $10933bca3baab1c9$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$10933bca3baab1c9$var$$get]);
var $10933bca3baab1c9$export$e37b7520edd66839 = (arg)=>arg && arg[$10933bca3baab1c9$var$$get] ? arg[$10933bca3baab1c9$var$$get]() : arg;
var $10933bca3baab1c9$export$133f54e9f7cf1796 = (target)=>target[$10933bca3baab1c9$var$$observers] || null;
function $10933bca3baab1c9$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $10933bca3baab1c9$export$31752c40a5fab62a(target, event) {
    const observers = target[$10933bca3baab1c9$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $10933bca3baab1c9$export$8cbca1207adce0c0(observer2, event);
    });
}
var $10933bca3baab1c9$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $10933bca3baab1c9$export$a3b4618659637aa3(this, get);
    }
};
$10933bca3baab1c9$var$$get, $10933bca3baab1c9$var$$observers;
var $10933bca3baab1c9$export$a3b4618659637aa3 = (target, get)=>$10933bca3baab1c9$var$setHidden(target, $10933bca3baab1c9$var$$get, get);
function $10933bca3baab1c9$export$72d604e3f8d000a5(target, observer2) {
    if (target[$10933bca3baab1c9$var$$get]) {
        let observers = target[$10933bca3baab1c9$var$$observers];
        if (!observers) $10933bca3baab1c9$var$setHidden(target, $10933bca3baab1c9$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $10933bca3baab1c9$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$10933bca3baab1c9$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$10933bca3baab1c9$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $10933bca3baab1c9$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $10933bca3baab1c9$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $10933bca3baab1c9$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $10933bca3baab1c9$var$unitRegex = new RegExp(`(${$10933bca3baab1c9$var$numberRegex.source})(%|[a-z]+)`, "i");
var $10933bca3baab1c9$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $10933bca3baab1c9$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $10933bca3baab1c9$var$variableToRgba = (input)=>{
    const [token, fallback] = $10933bca3baab1c9$var$parseCSSVariable(input);
    if (!token || $10933bca3baab1c9$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $10933bca3baab1c9$var$cssVariableRegex.test(fallback)) return $10933bca3baab1c9$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $10933bca3baab1c9$var$parseCSSVariable = (current)=>{
    const match = $10933bca3baab1c9$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $10933bca3baab1c9$var$namedColorRegex;
var $10933bca3baab1c9$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $10933bca3baab1c9$export$4759a013d387347a = (config)=>{
    if (!$10933bca3baab1c9$var$namedColorRegex) $10933bca3baab1c9$var$namedColorRegex = $10933bca3baab1c9$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($10933bca3baab1c9$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $10933bca3baab1c9$export$e37b7520edd66839(value).replace($10933bca3baab1c9$var$cssVariableRegex, $10933bca3baab1c9$var$variableToRgba).replace($10933bca3baab1c9$var$colorRegex, $10933bca3baab1c9$export$61db176b839af1f).replace($10933bca3baab1c9$var$namedColorRegex, $10933bca3baab1c9$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($10933bca3baab1c9$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$10933bca3baab1c9$export$b12af43b97697ef5((0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, config), {
            output: output2
        })));
    return (input)=>{
        var _output_find;
        const missingUnit = !$10933bca3baab1c9$var$unitRegex.test(output[0]) && ((_output_find = output.find((value)=>$10933bca3baab1c9$var$unitRegex.test(value))) === null || _output_find === void 0 ? void 0 : _output_find.replace($10933bca3baab1c9$var$numberRegex, ""));
        let i = 0;
        return output[0].replace($10933bca3baab1c9$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($10933bca3baab1c9$var$rgbaRegex, $10933bca3baab1c9$var$rgbaRound);
    };
};
// src/deprecations.ts
var $10933bca3baab1c9$export$82e9f45cca5ba907 = "react-spring: ";
var $10933bca3baab1c9$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$10933bca3baab1c9$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $10933bca3baab1c9$var$warnInterpolate = $10933bca3baab1c9$export$d2de3aaeafa91619(console.warn);
function $10933bca3baab1c9$export$2abfcde8ae218ba8() {
    $10933bca3baab1c9$var$warnInterpolate(`${$10933bca3baab1c9$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $10933bca3baab1c9$var$warnDirectCall = $10933bca3baab1c9$export$d2de3aaeafa91619(console.warn);
function $10933bca3baab1c9$export$d99d974913ad3b12() {
    $10933bca3baab1c9$var$warnDirectCall(`${$10933bca3baab1c9$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $10933bca3baab1c9$export$75bed621f62abfa9(value) {
    return $10933bca3baab1c9$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$10933bca3baab1c9$export$48d7c418edadb60c() && $10933bca3baab1c9$var$cssVariableRegex.test(value) || value in ($10933bca3baab1c9$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $10933bca3baab1c9$var$observer;
var $10933bca3baab1c9$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $10933bca3baab1c9$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        var _resizeHandlers_get;
        return (_resizeHandlers_get = $10933bca3baab1c9$var$resizeHandlers.get(target)) === null || _resizeHandlers_get === void 0 ? void 0 : _resizeHandlers_get.forEach((handler)=>handler(contentRect));
    });
function $10933bca3baab1c9$var$resizeElement(handler, target) {
    if (!$10933bca3baab1c9$var$observer) {
        if (typeof ResizeObserver !== "undefined") $10933bca3baab1c9$var$observer = new ResizeObserver($10933bca3baab1c9$var$handleObservation);
    }
    let elementHandlers = $10933bca3baab1c9$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $10933bca3baab1c9$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($10933bca3baab1c9$var$observer) $10933bca3baab1c9$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $10933bca3baab1c9$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $10933bca3baab1c9$var$observer) $10933bca3baab1c9$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $10933bca3baab1c9$var$listeners = /* @__PURE__ */ new Set();
var $10933bca3baab1c9$var$cleanupWindowResizeHandler;
var $10933bca3baab1c9$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $10933bca3baab1c9$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $10933bca3baab1c9$var$resizeWindow = (callback)=>{
    $10933bca3baab1c9$var$listeners.add(callback);
    if (!$10933bca3baab1c9$var$cleanupWindowResizeHandler) $10933bca3baab1c9$var$cleanupWindowResizeHandler = $10933bca3baab1c9$var$createResizeHandler();
    return ()=>{
        $10933bca3baab1c9$var$listeners.delete(callback);
        if (!$10933bca3baab1c9$var$listeners.size && $10933bca3baab1c9$var$cleanupWindowResizeHandler) {
            $10933bca3baab1c9$var$cleanupWindowResizeHandler();
            $10933bca3baab1c9$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $10933bca3baab1c9$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $10933bca3baab1c9$var$resizeWindow(callback);
    else return $10933bca3baab1c9$var$resizeElement(callback, container);
};
// src/progress.ts
var $10933bca3baab1c9$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $10933bca3baab1c9$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $10933bca3baab1c9$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $10933bca3baab1c9$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container["scroll" + length] - this.container["client" + length];
            axis.progress = $10933bca3baab1c9$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $10933bca3baab1c9$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $10933bca3baab1c9$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $10933bca3baab1c9$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $10933bca3baab1c9$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $10933bca3baab1c9$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $10933bca3baab1c9$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $10933bca3baab1c9$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $10933bca3baab1c9$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$10933bca3baab1c9$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers === null || containerHandlers === void 0 ? void 0 : containerHandlers.forEach((handler)=>handler.advance());
            return true;
        };
        $10933bca3baab1c9$var$scrollListeners.set(container, listener);
        const target = $10933bca3baab1c9$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $10933bca3baab1c9$var$resizeListeners.set(container, $10933bca3baab1c9$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $10933bca3baab1c9$var$scrollListeners.get(container);
    $10933bca3baab1c9$export$27f233d61a9e2fa4(animateScroll);
    return ()=>{
        $10933bca3baab1c9$export$27f233d61a9e2fa4.cancel(animateScroll);
        const containerHandlers2 = $10933bca3baab1c9$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $10933bca3baab1c9$var$scrollListeners.get(container);
        $10933bca3baab1c9$var$scrollListeners.delete(container);
        if (listener) {
            var _resizeListeners_get;
            $10933bca3baab1c9$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            (_resizeListeners_get = $10933bca3baab1c9$var$resizeListeners.get(container)) === null || _resizeListeners_get === void 0 ? void 0 : _resizeListeners_get();
        }
    };
};
function $10933bca3baab1c9$export$fe4300aa8eebea86(init) {
    const ref = (0, $6cds3.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $10933bca3baab1c9$export$700979bc83e7db82 = $10933bca3baab1c9$export$48d7c418edadb60c() ? (0, $6cds3.useEffect) : (0, $6cds3.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $10933bca3baab1c9$var$useIsMounted = ()=>{
    const isMounted = (0, $6cds3.useRef)(false);
    $10933bca3baab1c9$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $10933bca3baab1c9$export$91db9bc4f8ac944a() {
    const update2 = (0, $6cds3.useState)()[1];
    const isMounted = $10933bca3baab1c9$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update2(Math.random());
    };
}
function $10933bca3baab1c9$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $6cds3.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $6cds3.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $10933bca3baab1c9$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $6cds3.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $10933bca3baab1c9$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $10933bca3baab1c9$export$392544347a18b6ea = (effect)=>(0, $6cds3.useEffect)(effect, $10933bca3baab1c9$var$emptyDeps);
var $10933bca3baab1c9$var$emptyDeps = [];
function $10933bca3baab1c9$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $6cds3.useRef)();
    (0, $6cds3.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $10933bca3baab1c9$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $6cds3.useState)(null);
    $10933bca3baab1c9$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $10933bca3baab1c9$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        mql.addEventListener("change", handleMediaChange);
        return ()=>{
            mql.removeEventListener("change", handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $6cds3 = parcelRequire("6cds3");
// src/Animated.ts




var $6cds3 = parcelRequire("6cds3");
var $01e022ec42d981db$var$$node = Symbol.for("Animated:node");
var $01e022ec42d981db$export$3df5e165e801a70f = (value)=>!!value && value[$01e022ec42d981db$var$$node] === value;
var $01e022ec42d981db$export$6b63995194a3a9e4 = (owner)=>owner && owner[$01e022ec42d981db$var$$node];
var $01e022ec42d981db$export$b553cb5b22b81b04 = (owner, node)=>(0, $10933bca3baab1c9$export$5c74248ea0e35446)(owner, $01e022ec42d981db$var$$node, node);
var $01e022ec42d981db$export$ccab2b64c5d440 = (owner)=>owner && owner[$01e022ec42d981db$var$$node] && owner[$01e022ec42d981db$var$$node].getPayload();
var $01e022ec42d981db$export$31627395a3b18e54 = class {
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
    constructor(){
        $01e022ec42d981db$export$b553cb5b22b81b04(this, this);
    }
};
var $01e022ec42d981db$export$cb1e8f3c05d37ad5 = class extends $01e022ec42d981db$export$31627395a3b18e54 {
    /** @internal */ static create(value) {
        return new $01e022ec42d981db$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
};
var $01e022ec42d981db$export$f6c6c4cbd7fa5b93 = class extends $01e022ec42d981db$export$cb1e8f3c05d37ad5 {
    /** @internal */ static create(value) {
        return new $01e022ec42d981db$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $10933bca3baab1c9$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $10933bca3baab1c9$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
};
// src/context.ts
var $01e022ec42d981db$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $01e022ec42d981db$export$f1b0b9e366a6e2d4 = class extends $01e022ec42d981db$export$31627395a3b18e54 {
    getValue(animated) {
        const values = {};
        (0, $10933bca3baab1c9$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($01e022ec42d981db$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $10933bca3baab1c9$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $10933bca3baab1c9$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $10933bca3baab1c9$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $10933bca3baab1c9$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($01e022ec42d981db$var$TreeContext.dependencies && (0, $10933bca3baab1c9$export$57ea7e3a7f6280c7)(source)) $01e022ec42d981db$var$TreeContext.dependencies.add(source);
        const payload = $01e022ec42d981db$export$ccab2b64c5d440(source);
        if (payload) (0, $10933bca3baab1c9$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
};
// src/AnimatedArray.ts
var $01e022ec42d981db$export$ede394683406942d = class extends $01e022ec42d981db$export$f1b0b9e366a6e2d4 {
    /** @internal */ static create(source) {
        return new $01e022ec42d981db$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($01e022ec42d981db$var$makeAnimated));
        return true;
    }
    constructor(source){
        super(source);
    }
};
function $01e022ec42d981db$var$makeAnimated(value) {
    const nodeType = (0, $10933bca3baab1c9$export$75bed621f62abfa9)(value) ? $01e022ec42d981db$export$f6c6c4cbd7fa5b93 : $01e022ec42d981db$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $01e022ec42d981db$export$e6b77ddbe47b132e(value) {
    const parentNode = $01e022ec42d981db$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).arr(value) ? $01e022ec42d981db$export$ede394683406942d : (0, $10933bca3baab1c9$export$75bed621f62abfa9)(value) ? $01e022ec42d981db$export$f6c6c4cbd7fa5b93 : $01e022ec42d981db$export$cb1e8f3c05d37ad5;
}
var $01e022ec42d981db$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $6cds3.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $6cds3.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $6cds3.useCallback)((value)=>{
            instanceRef.current = $01e022ec42d981db$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $01e022ec42d981db$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $10933bca3baab1c9$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $01e022ec42d981db$var$PropsObserver(callback, deps);
        const observerRef = (0, $6cds3.useRef)();
        (0, $10933bca3baab1c9$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)(deps, (dep)=>(0, $10933bca3baab1c9$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $10933bca3baab1c9$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $10933bca3baab1c9$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $6cds3.useEffect)(callback, []);
        (0, $10933bca3baab1c9$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $10933bca3baab1c9$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $10933bca3baab1c9$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $6cds3.createElement(Component, (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, usedProps), {
            ref: ref
        }));
    });
};
var $01e022ec42d981db$var$PropsObserver = class {
    eventObserved(event) {
        if (event.type == "change") (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).write(this.update);
    }
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
};
function $01e022ec42d981db$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $01e022ec42d981db$var$TreeContext.dependencies = dependencies;
    if (props.style) props = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, props), {
        style: host.createAnimatedStyle(props.style)
    });
    props = new $01e022ec42d981db$export$f1b0b9e366a6e2d4(props);
    $01e022ec42d981db$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $01e022ec42d981db$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $01e022ec42d981db$var$cacheKey = Symbol.for("AnimatedComponent");
var $01e022ec42d981db$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $01e022ec42d981db$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $01e022ec42d981db$var$getDisplayName(Component) || "Anonymous";
        if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $01e022ec42d981db$var$withAnimated(Component, hostConfig));
        else Component = Component[$01e022ec42d981db$var$cacheKey] || (Component[$01e022ec42d981db$var$cacheKey] = $01e022ec42d981db$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $10933bca3baab1c9$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).arr(components)) key = $01e022ec42d981db$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $01e022ec42d981db$var$getDisplayName = (arg)=>(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $bb5b0e3891e79a2e$export$b24b633b1364b94b = class {
};


function $33e36a91d69b26e2$var$callProp(value, ...args) {
    return (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $33e36a91d69b26e2$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $10933bca3baab1c9$export$45b10814cc054894)(value).includes(key)));
var $33e36a91d69b26e2$var$resolveProp = (prop, key)=>(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $33e36a91d69b26e2$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $33e36a91d69b26e2$var$noopTransform = (value)=>value;
var $33e36a91d69b26e2$var$getDefaultProps = (props, transform = $33e36a91d69b26e2$var$noopTransform)=>{
    let keys = $33e36a91d69b26e2$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $33e36a91d69b26e2$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $33e36a91d69b26e2$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $33e36a91d69b26e2$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $10933bca3baab1c9$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$33e36a91d69b26e2$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $33e36a91d69b26e2$export$b971039a739bf227(props) {
    const to2 = $33e36a91d69b26e2$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $10933bca3baab1c9$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, props);
}
function $33e36a91d69b26e2$var$computeGoal(value) {
    value = (0, $10933bca3baab1c9$export$e37b7520edd66839)(value);
    return (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).arr(value) ? value.map($33e36a91d69b26e2$var$computeGoal) : (0, $10933bca3baab1c9$export$75bed621f62abfa9)(value) ? (0, $10933bca3baab1c9$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $33e36a91d69b26e2$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $33e36a91d69b26e2$var$isAsyncTo(to2) {
    return (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(to2) || (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).arr(to2) && (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $33e36a91d69b26e2$var$detachRefs(ctrl, ref) {
    var _ctrl_ref;
    (_ctrl_ref = ctrl.ref) === null || _ctrl_ref === void 0 ? void 0 : _ctrl_ref.delete(ctrl);
    ref === null || ref === void 0 ? void 0 : ref.delete(ctrl);
}
function $33e36a91d69b26e2$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        var _ctrl_ref;
        (_ctrl_ref = ctrl.ref) === null || _ctrl_ref === void 0 ? void 0 : _ctrl_ref.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $33e36a91d69b26e2$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $10933bca3baab1c9$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $10933bca3baab1c9$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $33e36a91d69b26e2$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $10933bca3baab1c9$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $33e36a91d69b26e2$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $33e36a91d69b26e2$var$defaults = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, $33e36a91d69b26e2$export$e506a1d27d1eaa20.default), {
    mass: 1,
    damping: 1,
    easing: (0, $10933bca3baab1c9$export$15a0bf1b4bbacad8).linear,
    clamp: false
});
var $33e36a91d69b26e2$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $33e36a91d69b26e2$var$defaults);
    }
};
function $33e36a91d69b26e2$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, defaultConfig);
        $33e36a91d69b26e2$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, defaultConfig, newConfig);
    }
    $33e36a91d69b26e2$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $33e36a91d69b26e2$var$defaults)if (config2[key] == null) config2[key] = $33e36a91d69b26e2$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $33e36a91d69b26e2$var$sanitizeConfig(config2, props) {
    if (!(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props.tension) || !(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props.damping) || !(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $33e36a91d69b26e2$var$emptyArray = [];
var $33e36a91d69b26e2$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $33e36a91d69b26e2$var$emptyArray;
        this.toValues = null;
        this.fromValues = $33e36a91d69b26e2$var$emptyArray;
        this.config = new $33e36a91d69b26e2$var$AnimationConfig();
        this.immediate = false;
    }
};
function $33e36a91d69b26e2$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        var _props_cancel;
        let cancel = $33e36a91d69b26e2$var$matchProp((_props_cancel = props.cancel) !== null && _props_cancel !== void 0 ? _props_cancel : defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $33e36a91d69b26e2$var$matchProp(props.pause, key);
            let pause = defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.pause;
            if (pause !== true) pause = state.paused || $33e36a91d69b26e2$var$matchProp(pause, key);
            delay = $33e36a91d69b26e2$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $10933bca3baab1c9$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start((0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, props), {
                    callId: callId,
                    cancel: cancel
                }), resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $33e36a91d69b26e2$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $33e36a91d69b26e2$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $33e36a91d69b26e2$var$getNoopResult(target.get()) : $33e36a91d69b26e2$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $33e36a91d69b26e2$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $33e36a91d69b26e2$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $33e36a91d69b26e2$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $33e36a91d69b26e2$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $33e36a91d69b26e2$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $33e36a91d69b26e2$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $33e36a91d69b26e2$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $33e36a91d69b26e2$export$d362d093fa99dc7();
            const skipAnimationSignal = new $33e36a91d69b26e2$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $10933bca3baab1c9$export$cceeabf822b64fc0).skipAnimation) {
                    $33e36a91d69b26e2$var$stopAsync(state);
                    skipAnimationSignal.result = $33e36a91d69b26e2$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).obj(arg1) ? (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, arg1) : (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, arg2), {
                    to: arg1
                });
                props2.parentId = callId;
                (0, $10933bca3baab1c9$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $10933bca3baab1c9$export$cceeabf822b64fc0).skipAnimation) {
            $33e36a91d69b26e2$var$stopAsync(state);
            return $33e36a91d69b26e2$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $33e36a91d69b26e2$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $33e36a91d69b26e2$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $33e36a91d69b26e2$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(onRest)) (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $33e36a91d69b26e2$var$stopAsync(state, cancelId) {
    (0, $10933bca3baab1c9$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $33e36a91d69b26e2$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $33e36a91d69b26e2$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $33e36a91d69b26e2$var$isFrameValue = (value)=>value instanceof $33e36a91d69b26e2$export$8229896f80e2495e;
var $33e36a91d69b26e2$var$nextId = 1;
var $33e36a91d69b26e2$export$8229896f80e2495e = class extends (0, $10933bca3baab1c9$export$aff8e1ac1a016a2) {
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $01e022ec42d981db$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $10933bca3baab1c9$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $10933bca3baab1c9$export$2abfcde8ae218ba8)();
        return (0, $10933bca3baab1c9$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $10933bca3baab1c9$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $10933bca3baab1c9$export$a57f5080a3bcc90a).sort(this);
        (0, $10933bca3baab1c9$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
    constructor(){
        super(...arguments);
        this.id = $33e36a91d69b26e2$var$nextId++;
        this._priority = 0;
    }
};
// src/SpringPhase.ts
var $33e36a91d69b26e2$var$$P = Symbol.for("SpringPhase");
var $33e36a91d69b26e2$var$HAS_ANIMATED = 1;
var $33e36a91d69b26e2$var$IS_ANIMATING = 2;
var $33e36a91d69b26e2$var$IS_PAUSED = 4;
var $33e36a91d69b26e2$var$hasAnimated = (target)=>(target[$33e36a91d69b26e2$var$$P] & $33e36a91d69b26e2$var$HAS_ANIMATED) > 0;
var $33e36a91d69b26e2$var$isAnimating = (target)=>(target[$33e36a91d69b26e2$var$$P] & $33e36a91d69b26e2$var$IS_ANIMATING) > 0;
var $33e36a91d69b26e2$var$isPaused = (target)=>(target[$33e36a91d69b26e2$var$$P] & $33e36a91d69b26e2$var$IS_PAUSED) > 0;
var $33e36a91d69b26e2$var$setActiveBit = (target, active)=>active ? target[$33e36a91d69b26e2$var$$P] |= $33e36a91d69b26e2$var$IS_ANIMATING | $33e36a91d69b26e2$var$HAS_ANIMATED : target[$33e36a91d69b26e2$var$$P] &= ~$33e36a91d69b26e2$var$IS_ANIMATING;
var $33e36a91d69b26e2$var$setPausedBit = (target, paused)=>paused ? target[$33e36a91d69b26e2$var$$P] |= $33e36a91d69b26e2$var$IS_PAUSED : target[$33e36a91d69b26e2$var$$P] &= ~$33e36a91d69b26e2$var$IS_PAUSED;
// src/SpringValue.ts
var $33e36a91d69b26e2$export$5854d13427d5a954 = class extends $33e36a91d69b26e2$export$8229896f80e2495e {
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($33e36a91d69b26e2$var$isAnimating(this) || this._state.asyncTo) || $33e36a91d69b26e2$var$isPaused(this);
    }
    get goal() {
        return (0, $10933bca3baab1c9$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $01e022ec42d981db$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $01e022ec42d981db$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $33e36a91d69b26e2$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $33e36a91d69b26e2$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $33e36a91d69b26e2$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $01e022ec42d981db$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $10933bca3baab1c9$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $10933bca3baab1c9$export$45b10814cc054894)((0, $10933bca3baab1c9$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $01e022ec42d981db$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $01e022ec42d981db$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $10933bca3baab1c9$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($33e36a91d69b26e2$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).obj(to2) ? to2 : (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, arg2), {
                to: to2
            })
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$33e36a91d69b26e2$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $33e36a91d69b26e2$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $33e36a91d69b26e2$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$33e36a91d69b26e2$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $10933bca3baab1c9$export$e37b7520edd66839)(from);
            if (!(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $01e022ec42d981db$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update(_param, isLoop) {
        var props = (0, $877ef6de280e80e7$export$c90d7ca213038c72)({}, (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(_param));
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $33e36a91d69b26e2$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $33e36a91d69b26e2$var$resolveProp(value, key) : value));
        $33e36a91d69b26e2$var$mergeActiveFn(this, props, "onProps");
        $33e36a91d69b26e2$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $33e36a91d69b26e2$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$33e36a91d69b26e2$var$isPaused(this)) {
                        $33e36a91d69b26e2$var$setPausedBit(this, true);
                        (0, $10933bca3baab1c9$export$7ba486852759e806)(state.pauseQueue);
                        $33e36a91d69b26e2$var$sendEvent(this, "onPause", $33e36a91d69b26e2$var$getFinishedResult(this, $33e36a91d69b26e2$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($33e36a91d69b26e2$var$isPaused(this)) {
                        $33e36a91d69b26e2$var$setPausedBit(this, false);
                        if ($33e36a91d69b26e2$var$isAnimating(this)) this._resume();
                        (0, $10933bca3baab1c9$export$7ba486852759e806)(state.resumeQueue);
                        $33e36a91d69b26e2$var$sendEvent(this, "onResume", $33e36a91d69b26e2$var$getFinishedResult(this, $33e36a91d69b26e2$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $33e36a91d69b26e2$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($33e36a91d69b26e2$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($33e36a91d69b26e2$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $10933bca3baab1c9$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $10933bca3baab1c9$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $10933bca3baab1c9$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $33e36a91d69b26e2$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $33e36a91d69b26e2$var$mergeConfig(config2, $33e36a91d69b26e2$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $33e36a91d69b26e2$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $01e022ec42d981db$export$6b63995194a3a9e4)(this);
        if (!node || (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(to2)) return resolve($33e36a91d69b26e2$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(from) && $33e36a91d69b26e2$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $33e36a91d69b26e2$var$computeGoal(to2);
        const isAnimatable = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).num(goal) || (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).arr(goal) || (0, $10933bca3baab1c9$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $33e36a91d69b26e2$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $01e022ec42d981db$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $10933bca3baab1c9$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$33e36a91d69b26e2$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $10933bca3baab1c9$export$248d38f6296296c5)($33e36a91d69b26e2$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $10933bca3baab1c9$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $10933bca3baab1c9$export$248d38f6296296c5)(config2.decay, decay) || !(0, $10933bca3baab1c9$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $33e36a91d69b26e2$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $10933bca3baab1c9$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $10933bca3baab1c9$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $01e022ec42d981db$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $10933bca3baab1c9$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $10933bca3baab1c9$export$79b2f7037acddd43)($33e36a91d69b26e2$var$ACTIVE_EVENTS, (type)=>$33e36a91d69b26e2$var$mergeActiveFn(this, props, type));
                const result = $33e36a91d69b26e2$var$getFinishedResult(this, $33e36a91d69b26e2$var$checkFinished(this, prevTo));
                (0, $10933bca3baab1c9$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    var _anim_onStart;
                    anim.changed = !reset;
                    onRest === null || onRest === void 0 ? void 0 : onRest(result, this);
                    if (reset) $33e36a91d69b26e2$var$callProp(defaultProps.onRest, result);
                    else (_anim_onStart = anim.onStart) === null || _anim_onStart === void 0 ? void 0 : _anim_onStart.call(anim, result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($33e36a91d69b26e2$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($33e36a91d69b26e2$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($33e36a91d69b26e2$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $10933bca3baab1c9$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $10933bca3baab1c9$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $10933bca3baab1c9$export$57ea7e3a7f6280c7)(to2)) {
            (0, $10933bca3baab1c9$export$72d604e3f8d000a5)(to2, this);
            if ($33e36a91d69b26e2$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $10933bca3baab1c9$export$57ea7e3a7f6280c7)(to2)) (0, $10933bca3baab1c9$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $10933bca3baab1c9$export$e37b7520edd66839)(arg);
        if (!(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $01e022ec42d981db$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $10933bca3baab1c9$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $01e022ec42d981db$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $01e022ec42d981db$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $01e022ec42d981db$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $33e36a91d69b26e2$var$sendEvent(this, "onStart", $33e36a91d69b26e2$var$getFinishedResult(this, $33e36a91d69b26e2$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $33e36a91d69b26e2$var$callProp(this.animation.onChange, value, this);
        }
        $33e36a91d69b26e2$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $01e022ec42d981db$export$6b63995194a3a9e4)(this).reset((0, $10933bca3baab1c9$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$33e36a91d69b26e2$var$isAnimating(this)) {
            $33e36a91d69b26e2$var$setActiveBit(this, true);
            if (!$33e36a91d69b26e2$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $10933bca3baab1c9$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $10933bca3baab1c9$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($33e36a91d69b26e2$var$isAnimating(this)) {
            $33e36a91d69b26e2$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $10933bca3baab1c9$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $33e36a91d69b26e2$var$getCancelledResult(this.get()) : $33e36a91d69b26e2$var$getFinishedResult(this.get(), $33e36a91d69b26e2$var$checkFinished(this, goal !== null && goal !== void 0 ? goal : anim.to));
            (0, $10933bca3baab1c9$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $33e36a91d69b26e2$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $33e36a91d69b26e2$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(arg1) || !(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).obj(arg1) ? (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, arg1) : (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, arg2), {
                from: arg1
            });
            if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
};
function $33e36a91d69b26e2$var$checkFinished(target, to2) {
    const goal = $33e36a91d69b26e2$var$computeGoal(to2);
    const value = $33e36a91d69b26e2$var$computeGoal(target.get());
    return (0, $10933bca3baab1c9$export$248d38f6296296c5)(value, goal);
}
function $33e36a91d69b26e2$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $33e36a91d69b26e2$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $33e36a91d69b26e2$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $33e36a91d69b26e2$var$createUpdate((0, $66a5668b38a29be4$export$581ff339ea0ba762)((0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, props), {
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $33e36a91d69b26e2$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset
        }), overrides));
    }
}
function $33e36a91d69b26e2$var$createUpdate(props) {
    const { to: to2, from: from } = props = $33e36a91d69b26e2$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).obj(to2)) $33e36a91d69b26e2$var$findDefined(to2, keys);
    if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).obj(from)) $33e36a91d69b26e2$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $33e36a91d69b26e2$var$declareUpdate(props) {
    const update2 = $33e36a91d69b26e2$var$createUpdate(props);
    if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $33e36a91d69b26e2$var$getDefaultProps(update2);
    return update2;
}
function $33e36a91d69b26e2$var$findDefined(values, keys) {
    (0, $10933bca3baab1c9$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $33e36a91d69b26e2$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $33e36a91d69b26e2$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $33e36a91d69b26e2$var$getDefaultProp(props, type) ? $33e36a91d69b26e2$var$resolveProp(props[type], target.key) : void 0;
}
function $33e36a91d69b26e2$var$sendEvent(target, type, ...args) {
    var _target_animation_type, _target_animation, _target_defaultProps_type, _target_defaultProps;
    (_target_animation_type = (_target_animation = target.animation)[type]) === null || _target_animation_type === void 0 ? void 0 : _target_animation_type.call(_target_animation, ...args);
    (_target_defaultProps_type = (_target_defaultProps = target.defaultProps)[type]) === null || _target_defaultProps_type === void 0 ? void 0 : _target_defaultProps_type.call(_target_defaultProps, ...args);
}
var $33e36a91d69b26e2$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $33e36a91d69b26e2$var$nextId2 = 1;
var $33e36a91d69b26e2$export$bd0bf19f25da8474 = class {
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($33e36a91d69b26e2$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $10933bca3baab1c9$export$45b10814cc054894)(props).map($33e36a91d69b26e2$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $33e36a91d69b26e2$var$prepareKeys(this, queue);
        return $33e36a91d69b26e2$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)((0, $10933bca3baab1c9$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $33e36a91d69b26e2$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)((0, $10933bca3baab1c9$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)((0, $10933bca3baab1c9$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $10933bca3baab1c9$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $10933bca3baab1c9$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $10933bca3baab1c9$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $10933bca3baab1c9$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
    constructor(props, flush3){
        this.id = $33e36a91d69b26e2$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start((0, $66a5668b38a29be4$export$581ff339ea0ba762)({
            default: true
        }, props));
    }
};
function $33e36a91d69b26e2$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$33e36a91d69b26e2$var$flushUpdate(ctrl, props))).then((results)=>$33e36a91d69b26e2$var$getCombinedResult(ctrl, results));
}
async function $33e36a91d69b26e2$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).arr(to2) || (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $10933bca3baab1c9$export$79b2f7037acddd43)($33e36a91d69b26e2$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $10933bca3baab1c9$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $33e36a91d69b26e2$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($33e36a91d69b26e2$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $10933bca3baab1c9$export$8793edee2d425525),
            resume: (0, $10933bca3baab1c9$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $33e36a91d69b26e2$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($33e36a91d69b26e2$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($33e36a91d69b26e2$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $33e36a91d69b26e2$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $33e36a91d69b26e2$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $33e36a91d69b26e2$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $33e36a91d69b26e2$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $33e36a91d69b26e2$var$getSprings(ctrl, props) {
    const springs = (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, ctrl.springs);
    if (props) (0, $10933bca3baab1c9$export$79b2f7037acddd43)((0, $10933bca3baab1c9$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $33e36a91d69b26e2$var$createUpdate(props2);
        if (!(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).obj(props2.to)) props2 = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, props2), {
            to: void 0
        });
        $33e36a91d69b26e2$var$prepareSprings(springs, props2, (key)=>{
            return $33e36a91d69b26e2$var$createSpring(key);
        });
    });
    $33e36a91d69b26e2$var$setSprings(ctrl, springs);
    return springs;
}
function $33e36a91d69b26e2$var$setSprings(ctrl, springs) {
    (0, $10933bca3baab1c9$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $10933bca3baab1c9$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $33e36a91d69b26e2$var$createSpring(key, observer) {
    const spring = new $33e36a91d69b26e2$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $10933bca3baab1c9$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $33e36a91d69b26e2$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $10933bca3baab1c9$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $33e36a91d69b26e2$var$prepareKeys(ctrl, queue) {
    (0, $10933bca3baab1c9$export$79b2f7037acddd43)(queue, (props)=>{
        $33e36a91d69b26e2$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $33e36a91d69b26e2$var$createSpring(key, ctrl);
        });
    });
}
var $33e36a91d69b26e2$export$f12a216ec50d2cf1 = (_param)=>{
    var { children: children } = _param, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "children"
    ]);
    const inherited = (0, $6cds3.useContext)($33e36a91d69b26e2$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $10933bca3baab1c9$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $33e36a91d69b26e2$var$ctx;
    return /* @__PURE__ */ $6cds3.createElement(Provider, {
        value: props
    }, children);
};
var $33e36a91d69b26e2$var$ctx = $33e36a91d69b26e2$var$makeContext($33e36a91d69b26e2$export$f12a216ec50d2cf1, {});
$33e36a91d69b26e2$export$f12a216ec50d2cf1.Provider = $33e36a91d69b26e2$var$ctx.Provider;
$33e36a91d69b26e2$export$f12a216ec50d2cf1.Consumer = $33e36a91d69b26e2$var$ctx.Consumer;
function $33e36a91d69b26e2$var$makeContext(target, init) {
    Object.assign(target, $6cds3.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $33e36a91d69b26e2$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $10933bca3baab1c9$export$d99d974913ad3b12)();
        const results = [];
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $33e36a91d69b26e2$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $6cds3.useMemo)(()=>propsFn || arguments.length == 3 ? $33e36a91d69b26e2$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $6cds3.useRef)(0);
    const forceUpdate = (0, $10933bca3baab1c9$export$91db9bc4f8ac944a)();
    const state = (0, $6cds3.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $33e36a91d69b26e2$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $33e36a91d69b26e2$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $33e36a91d69b26e2$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($33e36a91d69b26e2$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $6cds3.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $10933bca3baab1c9$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $6cds3.useMemo)(()=>{
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $33e36a91d69b26e2$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $6cds3.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $33e36a91d69b26e2$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $33e36a91d69b26e2$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$33e36a91d69b26e2$var$getSprings(ctrl, updates[i]));
    const context = (0, $6cds3.useContext)($33e36a91d69b26e2$export$f12a216ec50d2cf1);
    const prevContext = (0, $10933bca3baab1c9$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $33e36a91d69b26e2$var$hasProps(context);
    (0, $10933bca3baab1c9$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref === null || ref === void 0 ? void 0 : ref.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $33e36a91d69b26e2$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $10933bca3baab1c9$export$392544347a18b6ea)(()=>()=>{
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>(0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, x));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $33e36a91d69b26e2$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $33e36a91d69b26e2$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $33e36a91d69b26e2$var$initSpringRef = ()=>$33e36a91d69b26e2$export$2471ae76e2946684();
var $33e36a91d69b26e2$export$564bff9c23cad2ca = ()=>(0, $6cds3.useState)($33e36a91d69b26e2$var$initSpringRef)[0];
var $33e36a91d69b26e2$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $10933bca3baab1c9$export$fe4300aa8eebea86)(()=>new $33e36a91d69b26e2$export$5854d13427d5a954(initial, props));
    (0, $10933bca3baab1c9$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $33e36a91d69b26e2$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $33e36a91d69b26e2$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $10933bca3baab1c9$export$700979bc83e7db82)(()=>{
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $33e36a91d69b26e2$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef !== null && passedRef !== void 0 ? passedRef : result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $33e36a91d69b26e2$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $6cds3.useMemo)(()=>propsFn || arguments.length == 3 ? $33e36a91d69b26e2$export$2471ae76e2946684() : void 0, []);
    const items = (0, $10933bca3baab1c9$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $6cds3.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $10933bca3baab1c9$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $10933bca3baab1c9$export$392544347a18b6ea)(()=>{
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(transitions, (t)=>{
            ref === null || ref === void 0 ? void 0 : ref.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $33e36a91d69b26e2$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $33e36a91d69b26e2$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $10933bca3baab1c9$export$700979bc83e7db82)(()=>(0, $10933bca3baab1c9$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $33e36a91d69b26e2$var$detachRefs(ctrl, ref);
            $33e36a91d69b26e2$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $10933bca3baab1c9$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $10933bca3baab1c9$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $33e36a91d69b26e2$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, t), {
                    item: items[keyIndex]
                });
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $10933bca3baab1c9$export$91db9bc4f8ac944a)();
    const defaultProps = $33e36a91d69b26e2$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $6cds3.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $6cds3.useRef)(false);
    (0, $10933bca3baab1c9$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $33e36a91d69b26e2$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $33e36a91d69b26e2$var$callProp(to2, t.item, i);
        to2 = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).obj(to2) ? $33e36a91d69b26e2$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $33e36a91d69b26e2$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = (0, $66a5668b38a29be4$export$581ff339ea0ba762)((0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, defaultProps), {
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false
        }), to2);
        if (phase == "enter" /* ENTER */  && (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $33e36a91d69b26e2$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $33e36a91d69b26e2$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $33e36a91d69b26e2$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $33e36a91d69b26e2$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $6cds3.useContext)($33e36a91d69b26e2$export$f12a216ec50d2cf1);
    const prevContext = (0, $10933bca3baab1c9$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $33e36a91d69b26e2$var$hasProps(context);
    (0, $10933bca3baab1c9$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $10933bca3baab1c9$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $10933bca3baab1c9$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $10933bca3baab1c9$export$700979bc83e7db82)(()=>{
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref === null || ref === void 0 ? void 0 : ref.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $33e36a91d69b26e2$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $6cds3.createElement($6cds3.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, springs), t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $6cds3.createElement(elem.type, (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, elem.props), {
                key: (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).str(t.key) || (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            })) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $33e36a91d69b26e2$var$nextKey = 1;
function $33e36a91d69b26e2$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $33e36a91d69b26e2$var$nextKey++;
        });
    }
    return (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(keys) ? items : (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $10933bca3baab1c9$export$45b10814cc054894)(keys);
}
var $33e36a91d69b26e2$export$d928051c8cd740b = (_param = {})=>{
    var { container: container } = _param, springOptions = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "container"
    ]);
    const [scrollValues, api] = $33e36a91d69b26e2$export$c4af9125706c4d30(()=>(0, $66a5668b38a29be4$export$581ff339ea0ba762)({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0
        }, springOptions), []);
    (0, $10933bca3baab1c9$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $10933bca3baab1c9$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: (container === null || container === void 0 ? void 0 : container.current) || void 0
        });
        return ()=>{
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $33e36a91d69b26e2$export$e8b771555dc4a003 = (_param)=>{
    var { container: container } = _param, springOptions = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "container"
    ]);
    const [sizeValues, api] = $33e36a91d69b26e2$export$c4af9125706c4d30(()=>(0, $66a5668b38a29be4$export$581ff339ea0ba762)({
            width: 0,
            height: 0
        }, springOptions), []);
    (0, $10933bca3baab1c9$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $10933bca3baab1c9$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: (container === null || container === void 0 ? void 0 : container.current) || void 0
        });
        return ()=>{
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $33e36a91d69b26e2$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $33e36a91d69b26e2$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $6cds3.useState)(false);
    const ref = (0, $6cds3.useRef)();
    const propsFn = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {} } = springsProps, restSpringProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(springsProps, [
        "to",
        "from"
    ]);
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $33e36a91d69b26e2$export$c4af9125706c4d30(()=>(0, $66a5668b38a29be4$export$581ff339ea0ba762)({
            from: from
        }, restSpringProps), []);
    (0, $10933bca3baab1c9$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const _ref = intersectionArguments !== null && intersectionArguments !== void 0 ? intersectionArguments : {}, { root: root, once: once, amount: amount = "any" } = _ref, restArgs = (0, $c4006311849aa271$export$69fdd232f62cde60)(_ref, [
            "root",
            "once",
            "amount"
        ]);
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, (0, $66a5668b38a29be4$export$581ff339ea0ba762)({
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $33e36a91d69b26e2$var$defaultThresholdOptions[amount]
        }, restArgs));
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $33e36a91d69b26e2$export$a500e5b516cedfc(_param) {
    var { children: children } = _param, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "children"
    ]);
    return children($33e36a91d69b26e2$export$c4af9125706c4d30(props));
}
function $33e36a91d69b26e2$export$3b8b9d47fbf8fd2b(_param) {
    var { items: items, children: children } = _param, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "items",
        "children"
    ]);
    const trails = $33e36a91d69b26e2$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $33e36a91d69b26e2$export$be58926105124dd4(_param) {
    var { items: items, children: children } = _param, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "items",
        "children"
    ]);
    return $33e36a91d69b26e2$export$7b286972b8d8ccbf(items, props)(children);
}
var $33e36a91d69b26e2$export$b0cc4f9860136880 = class extends $33e36a91d69b26e2$export$8229896f80e2495e {
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $10933bca3baab1c9$export$248d38f6296296c5)(value, oldValue)) {
            (0, $01e022ec42d981db$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $33e36a91d69b26e2$var$checkIdle(this._active)) $33e36a91d69b26e2$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $10933bca3baab1c9$export$e37b7520edd66839)) : (0, $10933bca3baab1c9$export$45b10814cc054894)((0, $10933bca3baab1c9$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$33e36a91d69b26e2$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $10933bca3baab1c9$export$79b2f7037acddd43)((0, $01e022ec42d981db$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $10933bca3baab1c9$export$cceeabf822b64fc0).skipAnimation) {
                (0, $10933bca3baab1c9$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $33e36a91d69b26e2$var$becomeIdle(this);
            } else (0, $10933bca3baab1c9$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)((0, $10933bca3baab1c9$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $10933bca3baab1c9$export$57ea7e3a7f6280c7)(source)) (0, $10933bca3baab1c9$export$72d604e3f8d000a5)(source, this);
            if ($33e36a91d69b26e2$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)((0, $10933bca3baab1c9$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $10933bca3baab1c9$export$57ea7e3a7f6280c7)(source)) (0, $10933bca3baab1c9$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $33e36a91d69b26e2$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $10933bca3baab1c9$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($33e36a91d69b26e2$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $10933bca3baab1c9$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $01e022ec42d981db$export$e6b77ddbe47b132e)(value);
        (0, $01e022ec42d981db$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
};
function $33e36a91d69b26e2$var$isIdle(source) {
    return source.idle !== false;
}
function $33e36a91d69b26e2$var$checkIdle(active) {
    return !active.size || Array.from(active).every($33e36a91d69b26e2$var$isIdle);
}
function $33e36a91d69b26e2$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)((0, $01e022ec42d981db$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $10933bca3baab1c9$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $33e36a91d69b26e2$export$2c618a4308a30424 = (source, ...args)=>new $33e36a91d69b26e2$export$b0cc4f9860136880(source, args);
var $33e36a91d69b26e2$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $10933bca3baab1c9$export$2abfcde8ae218ba8)(), new $33e36a91d69b26e2$export$b0cc4f9860136880(source, args));
(0, $10933bca3baab1c9$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $10933bca3baab1c9$export$4759a013d387347a,
    to: (source, args)=>new $33e36a91d69b26e2$export$b0cc4f9860136880(source, args)
});
var $33e36a91d69b26e2$export$722fbec263ad908a = (0, $10933bca3baab1c9$export$a57f5080a3bcc90a).advance;





// src/applyAnimatedValues.ts
var $49e594efc80f35bf$var$isCustomPropRE = /^--/;
function $49e594efc80f35bf$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$49e594efc80f35bf$var$isCustomPropRE.test(name) && !($49e594efc80f35bf$var$isUnitlessNumber.hasOwnProperty(name) && $49e594efc80f35bf$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $49e594efc80f35bf$var$attributeCache = {};
function $49e594efc80f35bf$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox } = props, attributes = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "style",
        "children",
        "scrollTop",
        "scrollLeft",
        "viewBox"
    ]);
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $49e594efc80f35bf$var$attributeCache[name] || ($49e594efc80f35bf$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $49e594efc80f35bf$var$dangerousStyleValue(name, style[name]);
        if ($49e594efc80f35bf$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $49e594efc80f35bf$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $49e594efc80f35bf$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $49e594efc80f35bf$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$49e594efc80f35bf$var$isUnitlessNumber = Object.keys($49e594efc80f35bf$var$isUnitlessNumber).reduce((acc, prop)=>{
    $49e594efc80f35bf$var$prefixes.forEach((prefix)=>acc[$49e594efc80f35bf$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $49e594efc80f35bf$var$isUnitlessNumber);
var $49e594efc80f35bf$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $49e594efc80f35bf$var$pxTransforms = /^(translate)/;
var $49e594efc80f35bf$var$degTransforms = /^(rotate|skew)/;
var $49e594efc80f35bf$var$addUnit = (value, unit)=>(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $49e594efc80f35bf$var$isValueIdentity = (value, id)=>(0, $10933bca3baab1c9$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$49e594efc80f35bf$var$isValueIdentity(v, id)) : (0, $10933bca3baab1c9$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $49e594efc80f35bf$var$AnimatedStyle = class extends (0, $01e022ec42d981db$export$f1b0b9e366a6e2d4) {
    constructor(_param){
        var { x: x, y: y, z: z } = _param, style = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
            "x",
            "y",
            "z"
        ]);
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$49e594efc80f35bf$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $49e594efc80f35bf$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $10933bca3baab1c9$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($49e594efc80f35bf$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $49e594efc80f35bf$var$pxTransforms.test(key) ? "px" : $49e594efc80f35bf$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $10933bca3baab1c9$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$49e594efc80f35bf$var$addUnit(deg, unit)})`,
                        $49e594efc80f35bf$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$49e594efc80f35bf$var$addUnit(v, unit)).join(",")})`,
                        $49e594efc80f35bf$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $49e594efc80f35bf$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $49e594efc80f35bf$var$FluidTransform = class extends (0, $10933bca3baab1c9$export$aff8e1ac1a016a2) {
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $10933bca3baab1c9$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $10933bca3baab1c9$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $10933bca3baab1c9$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $10933bca3baab1c9$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $10933bca3baab1c9$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $10933bca3baab1c9$export$79b2f7037acddd43)(input, (value)=>(0, $10933bca3baab1c9$export$57ea7e3a7f6280c7)(value) && (0, $10933bca3baab1c9$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $10933bca3baab1c9$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $10933bca3baab1c9$export$79b2f7037acddd43)(input, (value)=>(0, $10933bca3baab1c9$export$57ea7e3a7f6280c7)(value) && (0, $10933bca3baab1c9$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $10933bca3baab1c9$export$31752c40a5fab62a)(this, event);
    }
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
};
// src/primitives.ts
var $49e594efc80f35bf$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $10933bca3baab1c9$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $6d4849ee44552f5f$exports.unstable_batchedUpdates),
    createStringInterpolator: $10933bca3baab1c9$export$4759a013d387347a,
    colors: $10933bca3baab1c9$export$8f45430ccf837300
});
var $49e594efc80f35bf$var$host = (0, $01e022ec42d981db$export$4ee5c78f6dcbcef)($49e594efc80f35bf$var$primitives, {
    applyAnimatedValues: $49e594efc80f35bf$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $49e594efc80f35bf$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: (_param)=>{
        var { scrollTop: scrollTop, scrollLeft: scrollLeft } = _param, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
            "scrollTop",
            "scrollLeft"
        ]);
        return props;
    }
});
var $49e594efc80f35bf$export$407448d2b89b1813 = $49e594efc80f35bf$var$host.animated;


var $69a1b302c8bc319f$exports = {};

$parcel$export($69a1b302c8bc319f$exports, "circle", function () { return $69a1b302c8bc319f$export$e1d786d2f707b414; }, function (v) { return $69a1b302c8bc319f$export$e1d786d2f707b414 = v; });
$parcel$export($69a1b302c8bc319f$exports, "circleContainer", function () { return $69a1b302c8bc319f$export$58293416dd28ec6d; }, function (v) { return $69a1b302c8bc319f$export$58293416dd28ec6d = v; });
$parcel$export($69a1b302c8bc319f$exports, "reorderItem", function () { return $69a1b302c8bc319f$export$cafede516b0605c1; }, function (v) { return $69a1b302c8bc319f$export$cafede516b0605c1 = v; });
$parcel$export($69a1b302c8bc319f$exports, "reorderRow", function () { return $69a1b302c8bc319f$export$4ed6b9877c64f320; }, function (v) { return $69a1b302c8bc319f$export$4ed6b9877c64f320 = v; });
var $69a1b302c8bc319f$export$e1d786d2f707b414;
var $69a1b302c8bc319f$export$58293416dd28ec6d;
var $69a1b302c8bc319f$export$cafede516b0605c1;
var $69a1b302c8bc319f$export$4ed6b9877c64f320;
$69a1b302c8bc319f$export$e1d786d2f707b414 = `kwOFOq_circle`;
$69a1b302c8bc319f$export$58293416dd28ec6d = `kwOFOq_circleContainer`;
$69a1b302c8bc319f$export$cafede516b0605c1 = `kwOFOq_reorderItem`;
$69a1b302c8bc319f$export$4ed6b9877c64f320 = `kwOFOq_reorderRow`;


const $b422146aa2f42e82$var$ColorCircle = (props)=>{
    const { item: item } = props;
    const [{ x: x }, api] = (0, $33e36a91d69b26e2$export$c4af9125706c4d30)(()=>({
            x: 0
        }));
    const bind = (0, $160140048d0d318d$export$7941f8aafa4b6021)(({ down: down, movement: [mx] })=>api.start({
            x: down ? mx : 0
        }));
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $49e594efc80f35bf$export$407448d2b89b1813).div, (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($69a1b302c8bc319f$exports))).circleContainer
    }, bind()), {
        style: {
            x: x
        },
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($69a1b302c8bc319f$exports))).circle,
                style: {
                    backgroundColor: item.color
                }
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                children: item === null || item === void 0 ? void 0 : item.name
            })
        ]
    }));
};
var $b422146aa2f42e82$export$2e2bcd8739ae039 = $b422146aa2f42e82$var$ColorCircle;


// modules

parcelRequire("6cds3");
var $de9762a54593ecb7$exports = {};

$parcel$export($de9762a54593ecb7$exports, "arrow", function () { return $de9762a54593ecb7$export$f2120bbfa5450bd2; }, function (v) { return $de9762a54593ecb7$export$f2120bbfa5450bd2 = v; });
$parcel$export($de9762a54593ecb7$exports, "container", function () { return $de9762a54593ecb7$export$34e0f9847d4c02dd; }, function (v) { return $de9762a54593ecb7$export$34e0f9847d4c02dd = v; });
$parcel$export($de9762a54593ecb7$exports, "contentContainer", function () { return $de9762a54593ecb7$export$8f981dffec84ba52; }, function (v) { return $de9762a54593ecb7$export$8f981dffec84ba52 = v; });
$parcel$export($de9762a54593ecb7$exports, "description", function () { return $de9762a54593ecb7$export$6d59db4903f20f7d; }, function (v) { return $de9762a54593ecb7$export$6d59db4903f20f7d = v; });
$parcel$export($de9762a54593ecb7$exports, "nextWorkText", function () { return $de9762a54593ecb7$export$9436ada51d33876d; }, function (v) { return $de9762a54593ecb7$export$9436ada51d33876d = v; });
$parcel$export($de9762a54593ecb7$exports, "overlay", function () { return $de9762a54593ecb7$export$29dd17c7f3c81c36; }, function (v) { return $de9762a54593ecb7$export$29dd17c7f3c81c36 = v; });
var $de9762a54593ecb7$export$f2120bbfa5450bd2;
var $de9762a54593ecb7$export$34e0f9847d4c02dd;
var $de9762a54593ecb7$export$8f981dffec84ba52;
var $de9762a54593ecb7$export$6d59db4903f20f7d;
var $de9762a54593ecb7$export$9436ada51d33876d;
var $de9762a54593ecb7$export$29dd17c7f3c81c36;
$de9762a54593ecb7$export$f2120bbfa5450bd2 = `_7F8zEq_arrow`;
$de9762a54593ecb7$export$34e0f9847d4c02dd = `_7F8zEq_container`;
$de9762a54593ecb7$export$8f981dffec84ba52 = `_7F8zEq_contentContainer`;
$de9762a54593ecb7$export$6d59db4903f20f7d = `_7F8zEq_description`;
$de9762a54593ecb7$export$9436ada51d33876d = `_7F8zEq_nextWorkText`;
$de9762a54593ecb7$export$29dd17c7f3c81c36 = `_7F8zEq_overlay`;



const $9ca92ffcb8ea5b15$var$WorkNavigator = (props)=>{
    const { nextProjectName: nextProjectName, href: href, onClick: onClick, overlayColor: overlayColor = "#f06449", backgroundColor: backgroundColor } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("a", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($de9762a54593ecb7$exports))).container,
        style: {
            backgroundColor: backgroundColor
        },
        href: href,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($de9762a54593ecb7$exports))).description,
                children: "Next work"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($de9762a54593ecb7$exports))).contentContainer,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($de9762a54593ecb7$exports))).nextWorkText,
                        children: nextProjectName
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d7df85b6397975d1$export$2e2bcd8739ae039), {
                        color: "black",
                        width: 60,
                        height: 60,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($de9762a54593ecb7$exports))).arrow
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($de9762a54593ecb7$exports))).overlay,
                style: {
                    backgroundColor: overlayColor
                }
            })
        ]
    });
};
var $9ca92ffcb8ea5b15$export$2e2bcd8739ae039 = $9ca92ffcb8ea5b15$var$WorkNavigator;


// modules

parcelRequire("6cds3");
var $53c04ada6f6b5394$exports = {};

$parcel$export($53c04ada6f6b5394$exports, "aboutContainer", function () { return $53c04ada6f6b5394$export$a5cf4b156cb0a00f; }, function (v) { return $53c04ada6f6b5394$export$a5cf4b156cb0a00f = v; });
var $53c04ada6f6b5394$export$a5cf4b156cb0a00f;
$53c04ada6f6b5394$export$a5cf4b156cb0a00f = `G7fsrW_aboutContainer`;


const $0b62aa8cd3e21a28$var$WorkDescription = (props)=>{
    const { role: role, period: period, context: context, titleColor: titleColor = "#f06449", style: style } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($53c04ada6f6b5394$exports))).aboutContainer,
        style: style,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                            style: {
                                color: titleColor
                            },
                            children: "Role"
                        }),
                        role
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                            style: {
                                color: titleColor
                            },
                            children: "Context"
                        }),
                        context
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                            style: {
                                color: titleColor
                            },
                            children: "Period"
                        }),
                        period
                    ]
                })
            })
        ]
    });
};
var $0b62aa8cd3e21a28$export$2e2bcd8739ae039 = $0b62aa8cd3e21a28$var$WorkDescription;


// modules


var $6cds3 = parcelRequire("6cds3");





const $e39d7a1997c3ede8$var$AllWorkModal = (props)=>{
    const { data: data, active: active, setActive: setActive } = props;
    const navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    const modalRef = (0, $6cds3.useRef)(null);
    (0, $7ecf71b5cc604dc2$export$56d2d435cafcb696)(active, ()=>setActive(false), modalRef);
    const handleModalClick = (e)=>{
        e.stopPropagation();
    };
    const modalVariants = {
        hidden: {
            opacity: 0
        },
        visible: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    };
    const transition = {
        duration: 0.3,
        ease: "easeInOut"
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $35bf9e9aed03b88e$export$3ae376d12526dd6f), {
        children: active && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
            ref: modalRef,
            role: "dialog",
            "aria-modal": "true",
            "aria-label": "All works",
            tabIndex: -1,
            className: "modalWork active",
            initial: "hidden",
            animate: "visible",
            exit: "exit",
            variants: modalVariants,
            transition: transition,
            onClick: ()=>setActive(false),
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "buttonBox",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9307550ce52715a5$export$2e2bcd8739ae039), {
                        text: "X Close",
                        onClick: ()=>setActive(false),
                        widthArrow: false,
                        className: "buttonModal"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                    className: "cardModalContainer",
                    onClick: handleModalClick,
                    initial: "hidden",
                    animate: "visible",
                    exit: "exit",
                    variants: modalVariants,
                    transition: transition,
                    children: data === null || data === void 0 ? void 0 : data.map((item, index)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $73096be23d597aa3$export$2e2bcd8739ae039), {
                            currentPath: location.pathname,
                            navigate: navigate,
                            item: item,
                            index: index
                        }, item.id))
                })
            ]
        })
    });
};
var $e39d7a1997c3ede8$export$2e2bcd8739ae039 = $e39d7a1997c3ede8$var$AllWorkModal;


// modules

parcelRequire("6cds3");
var $8d2d205a69901a39$exports = {};

$parcel$export($8d2d205a69901a39$exports, "button", function () { return $8d2d205a69901a39$export$2ba01fb71ed41cb6; }, function (v) { return $8d2d205a69901a39$export$2ba01fb71ed41cb6 = v; });
$parcel$export($8d2d205a69901a39$exports, "coverText", function () { return $8d2d205a69901a39$export$dcb80bb663fb7300; }, function (v) { return $8d2d205a69901a39$export$dcb80bb663fb7300 = v; });
$parcel$export($8d2d205a69901a39$exports, "projectText", function () { return $8d2d205a69901a39$export$3e33b13bb2ee446e; }, function (v) { return $8d2d205a69901a39$export$3e33b13bb2ee446e = v; });
$parcel$export($8d2d205a69901a39$exports, "projectTitle", function () { return $8d2d205a69901a39$export$d98ff0eab640b056; }, function (v) { return $8d2d205a69901a39$export$d98ff0eab640b056 = v; });
$parcel$export($8d2d205a69901a39$exports, "theProjectContainer", function () { return $8d2d205a69901a39$export$68781f0fa0b9b6a5; }, function (v) { return $8d2d205a69901a39$export$68781f0fa0b9b6a5 = v; });
var $8d2d205a69901a39$export$2ba01fb71ed41cb6;
var $8d2d205a69901a39$export$dcb80bb663fb7300;
var $8d2d205a69901a39$export$3e33b13bb2ee446e;
var $8d2d205a69901a39$export$d98ff0eab640b056;
var $8d2d205a69901a39$export$68781f0fa0b9b6a5;
$8d2d205a69901a39$export$2ba01fb71ed41cb6 = `_1ORX_q_button`;
$8d2d205a69901a39$export$dcb80bb663fb7300 = `_1ORX_q_coverText`;
$8d2d205a69901a39$export$3e33b13bb2ee446e = `_1ORX_q_projectText`;
$8d2d205a69901a39$export$d98ff0eab640b056 = `_1ORX_q_projectTitle`;
$8d2d205a69901a39$export$68781f0fa0b9b6a5 = `_1ORX_q_theProjectContainer`;


const $097e928218dfebc5$var$Introduction = (props)=>{
    const { title: title, description: description, link: link, linkText: linkText = "Visit Website", workLogo: workLogo } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8d2d205a69901a39$exports))).theProjectContainer,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8d2d205a69901a39$exports))).projectTitle,
                children: title
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8d2d205a69901a39$exports))).projectText,
                children: description
            }),
            link && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8d2d205a69901a39$exports))).button,
                href: link,
                target: "_blank",
                rel: "noopener noreferrer",
                children: linkText
            }),
            workLogo && workLogo
        ]
    });
};
var $097e928218dfebc5$export$2e2bcd8739ae039 = $097e928218dfebc5$var$Introduction;


// modules

parcelRequire("6cds3");
var $aa7022b61633d91e$exports = {};

$parcel$export($aa7022b61633d91e$exports, "cardContainer", function () { return $aa7022b61633d91e$export$6b2d426110a11d7a; }, function (v) { return $aa7022b61633d91e$export$6b2d426110a11d7a = v; });
$parcel$export($aa7022b61633d91e$exports, "cardTitle", function () { return $aa7022b61633d91e$export$3aac624c619dfa7f; }, function (v) { return $aa7022b61633d91e$export$3aac624c619dfa7f = v; });
$parcel$export($aa7022b61633d91e$exports, "circleContainer", function () { return $aa7022b61633d91e$export$58293416dd28ec6d; }, function (v) { return $aa7022b61633d91e$export$58293416dd28ec6d = v; });
$parcel$export($aa7022b61633d91e$exports, "line", function () { return $aa7022b61633d91e$export$53f1d5ea8de3d7c; }, function (v) { return $aa7022b61633d91e$export$53f1d5ea8de3d7c = v; });
$parcel$export($aa7022b61633d91e$exports, "paletteTitle", function () { return $aa7022b61633d91e$export$bc63144ec964c7a; }, function (v) { return $aa7022b61633d91e$export$bc63144ec964c7a = v; });
$parcel$export($aa7022b61633d91e$exports, "phoneCard", function () { return $aa7022b61633d91e$export$21fd950930b595bd; }, function (v) { return $aa7022b61633d91e$export$21fd950930b595bd = v; });
$parcel$export($aa7022b61633d91e$exports, "phoneContainer", function () { return $aa7022b61633d91e$export$bcbc0114e9f3ac1c; }, function (v) { return $aa7022b61633d91e$export$bcbc0114e9f3ac1c = v; });
$parcel$export($aa7022b61633d91e$exports, "phoneContainerMob", function () { return $aa7022b61633d91e$export$185925cd520010e2; }, function (v) { return $aa7022b61633d91e$export$185925cd520010e2 = v; });
$parcel$export($aa7022b61633d91e$exports, "workCard", function () { return $aa7022b61633d91e$export$d14e85c3159fa464; }, function (v) { return $aa7022b61633d91e$export$d14e85c3159fa464 = v; });
$parcel$export($aa7022b61633d91e$exports, "workDescription", function () { return $aa7022b61633d91e$export$128b5cd702dd1d8f; }, function (v) { return $aa7022b61633d91e$export$128b5cd702dd1d8f = v; });
$parcel$export($aa7022b61633d91e$exports, "workText", function () { return $aa7022b61633d91e$export$bd3558835fd89b8a; }, function (v) { return $aa7022b61633d91e$export$bd3558835fd89b8a = v; });
$parcel$export($aa7022b61633d91e$exports, "workTitle", function () { return $aa7022b61633d91e$export$3acfc26975580309; }, function (v) { return $aa7022b61633d91e$export$3acfc26975580309 = v; });
var $aa7022b61633d91e$export$6b2d426110a11d7a;
var $aa7022b61633d91e$export$3aac624c619dfa7f;
var $aa7022b61633d91e$export$58293416dd28ec6d;
var $aa7022b61633d91e$export$53f1d5ea8de3d7c;
var $aa7022b61633d91e$export$bc63144ec964c7a;
var $aa7022b61633d91e$export$21fd950930b595bd;
var $aa7022b61633d91e$export$bcbc0114e9f3ac1c;
var $aa7022b61633d91e$export$185925cd520010e2;
var $aa7022b61633d91e$export$d14e85c3159fa464;
var $aa7022b61633d91e$export$128b5cd702dd1d8f;
var $aa7022b61633d91e$export$bd3558835fd89b8a;
var $aa7022b61633d91e$export$3acfc26975580309;
$aa7022b61633d91e$export$6b2d426110a11d7a = `o6drmq_cardContainer`;
$aa7022b61633d91e$export$3aac624c619dfa7f = `o6drmq_cardTitle`;
$aa7022b61633d91e$export$58293416dd28ec6d = `o6drmq_circleContainer`;
$aa7022b61633d91e$export$53f1d5ea8de3d7c = `o6drmq_line`;
$aa7022b61633d91e$export$bc63144ec964c7a = `o6drmq_paletteTitle`;
$aa7022b61633d91e$export$21fd950930b595bd = `o6drmq_phoneCard`;
$aa7022b61633d91e$export$bcbc0114e9f3ac1c = `o6drmq_phoneContainer`;
$aa7022b61633d91e$export$185925cd520010e2 = `o6drmq_phoneContainerMob`;
$aa7022b61633d91e$export$d14e85c3159fa464 = `o6drmq_workCard`;
$aa7022b61633d91e$export$128b5cd702dd1d8f = `o6drmq_workDescription`;
$aa7022b61633d91e$export$bd3558835fd89b8a = `o6drmq_workText`;
$aa7022b61633d91e$export$3acfc26975580309 = `o6drmq_workTitle`;


// modules




var $6cds3 = parcelRequire("6cds3");



// circle (160px) + gap (50px) — horizontal pitch of one item
const $cde20023a56df241$var$MAX_ITEM = 210;
// side padding kept around the row on narrow screens
const $cde20023a56df241$var$ROW_GUTTER = 32;
// pitch of one item that lets the whole row fit into the viewport
const $cde20023a56df241$var$getItemSize = (count)=>Math.min($cde20023a56df241$var$MAX_ITEM, Math.floor((window.innerWidth - $cde20023a56df241$var$ROW_GUTTER) / count));
const $cde20023a56df241$var$clamp = (n, min, max)=>Math.max(min, Math.min(n, max));
// immutably move an element from one index to another
const $cde20023a56df241$var$move = (arr, from, to)=>{
    const next = arr.slice();
    const [picked] = next.splice(from, 1);
    next.splice(to, 0, picked);
    return next;
};
// spring values for every item given the current order
const $cde20023a56df241$var$fn = (order, item, active = false, originalIndex = 0, curIndex = 0, x = 0)=>(index)=>active && index === originalIndex ? {
            x: curIndex * item + x,
            scale: 1.1,
            zIndex: 10,
            immediate: (key)=>key === "x" || key === "zIndex"
        } : {
            x: order.indexOf(index) * item,
            scale: 1,
            zIndex: 0,
            immediate: false
        };
const $cde20023a56df241$var$ColorCircleList = ({ data: data })=>{
    const order = (0, $6cds3.useRef)(data.map((_, i)=>i));
    const [item, setItem] = (0, $6cds3.useState)(()=>$cde20023a56df241$var$getItemSize(data.length));
    const [springs, api] = (0, $33e36a91d69b26e2$export$15786d483ab9f469)(data.length, $cde20023a56df241$var$fn(order.current, item));
    (0, $6cds3.useEffect)(()=>{
        const handleResize = ()=>setItem($cde20023a56df241$var$getItemSize(data.length));
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        data.length
    ]);
    (0, $6cds3.useEffect)(()=>{
        api.start($cde20023a56df241$var$fn(order.current, item));
    }, [
        api,
        item
    ]);
    const bind = (0, $160140048d0d318d$export$7941f8aafa4b6021)(({ args: [originalIndex], active: active, movement: [mx] })=>{
        const curIndex = order.current.indexOf(originalIndex);
        const curCol = $cde20023a56df241$var$clamp(Math.round((curIndex * item + mx) / item), 0, data.length - 1);
        const newOrder = $cde20023a56df241$var$move(order.current, curIndex, curCol);
        api.start($cde20023a56df241$var$fn(newOrder, item, active, originalIndex, curIndex, mx));
        // commit the new order only once the drag is released
        if (!active) order.current = newOrder;
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($69a1b302c8bc319f$exports))).reorderRow,
        style: {
            width: data.length * item,
            "--item": `${item}px`
        },
        children: springs.map(({ zIndex: zIndex, x: x }, i)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $49e594efc80f35bf$export$407448d2b89b1813).div, (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({
                className: (0, (/*@__PURE__*/$parcel$interopDefault($69a1b302c8bc319f$exports))).reorderItem
            }, bind(i)), {
                style: {
                    zIndex: zIndex,
                    x: x,
                    width: item
                },
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($69a1b302c8bc319f$exports))).circle,
                        style: {
                            backgroundColor: data[i].color
                        }
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                        children: data[i].name
                    })
                ]
            }), i))
    });
};
var $cde20023a56df241$export$2e2bcd8739ae039 = $cde20023a56df241$var$ColorCircleList;


var $8a086d95af0c9c00$exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
    $8a086d95af0c9c00$exports = factory((parcelRequire("6cds3")));
})($8a086d95af0c9c00$exports, (__WEBPACK_EXTERNAL_MODULE_react__)=>{
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ "./node_modules/css-mediaquery/index.js": /*!**********************************************!*\
  !*** ./node_modules/css-mediaquery/index.js ***!
  \**********************************************/ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ exports.match = matchQuery;
                exports.parse = parseQuery;
                // -----------------------------------------------------------------------------
                var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
                function matchQuery(mediaQuery, values) {
                    return parseQuery(mediaQuery).some(function(query) {
                        var inverse = query.inverse;
                        // Either the parsed or specified `type` is "all", or the types must be
                        // equal for a match.
                        var typeMatch = query.type === "all" || values.type === query.type;
                        // Quit early when `type` doesn't match, but take "not" into account.
                        if (typeMatch && inverse || !(typeMatch || inverse)) return false;
                        var expressionsMatch = query.expressions.every(function(expression) {
                            var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
                            // Missing or falsy values don't match.
                            if (!value) return false;
                            switch(feature){
                                case "orientation":
                                case "scan":
                                    return value.toLowerCase() === expValue.toLowerCase();
                                case "width":
                                case "height":
                                case "device-width":
                                case "device-height":
                                    expValue = toPx(expValue);
                                    value = toPx(value);
                                    break;
                                case "resolution":
                                    expValue = toDpi(expValue);
                                    value = toDpi(value);
                                    break;
                                case "aspect-ratio":
                                case "device-aspect-ratio":
                                case /* Deprecated */ "device-pixel-ratio":
                                    expValue = toDecimal(expValue);
                                    value = toDecimal(value);
                                    break;
                                case "grid":
                                case "color":
                                case "color-index":
                                case "monochrome":
                                    expValue = parseInt(expValue, 10) || 1;
                                    value = parseInt(value, 10) || 0;
                                    break;
                            }
                            switch(modifier){
                                case "min":
                                    return value >= expValue;
                                case "max":
                                    return value <= expValue;
                                default:
                                    return value === expValue;
                            }
                        });
                        return expressionsMatch && !inverse || !expressionsMatch && inverse;
                    });
                }
                function parseQuery(mediaQuery) {
                    return mediaQuery.split(",").map(function(query) {
                        query = query.trim();
                        var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
                        parsed.inverse = !!modifier && modifier.toLowerCase() === "not";
                        parsed.type = type ? type.toLowerCase() : "all";
                        // Split expressions into a list.
                        expressions = expressions.match(/\([^\)]+\)/g) || [];
                        parsed.expressions = expressions.map(function(expression) {
                            var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
                            return {
                                modifier: feature[1],
                                feature: feature[2],
                                value: captures[2]
                            };
                        });
                        return parsed;
                    });
                }
                // -- Utilities ----------------------------------------------------------------
                function toDecimal(ratio) {
                    var decimal = Number(ratio), numbers;
                    if (!decimal) {
                        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
                        decimal = numbers[1] / numbers[2];
                    }
                    return decimal;
                }
                function toDpi(resolution) {
                    var value = parseFloat(resolution), units = String(resolution).match(RE_RESOLUTION_UNIT)[1];
                    switch(units){
                        case "dpcm":
                            return value / 2.54;
                        case "dppx":
                            return value * 96;
                        default:
                            return value;
                    }
                }
                function toPx(length) {
                    var value = parseFloat(length), units = String(length).match(RE_LENGTH_UNIT)[1];
                    switch(units){
                        case "em":
                            return value * 16;
                        case "rem":
                            return value * 16;
                        case "cm":
                            return value * 96 / 2.54;
                        case "mm":
                            return value * 96 / 2.54 / 10;
                        case "in":
                            return value * 96;
                        case "pt":
                            return value * 72;
                        case "pc":
                            return value * 72 / 12;
                        default:
                            return value;
                    }
                }
            /***/ },
            /***/ "./node_modules/hyphenate-style-name/index.js": /*!****************************************************!*\
  !*** ./node_modules/hyphenate-style-name/index.js ***!
  \****************************************************/ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": ()=>__WEBPACK_DEFAULT_EXPORT__
                });
                /* eslint-disable no-var, prefer-template */ var uppercasePattern = /[A-Z]/g;
                var msPattern = /^ms-/;
                var cache = {};
                function toHyphenLower(match) {
                    return "-" + match.toLowerCase();
                }
                function hyphenateStyleName(name) {
                    if (cache.hasOwnProperty(name)) return cache[name];
                    var hName = name.replace(uppercasePattern, toHyphenLower);
                    return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
                }
                /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = hyphenateStyleName;
            /***/ },
            /***/ "./node_modules/matchmediaquery/index.js": /*!***********************************************!*\
  !*** ./node_modules/matchmediaquery/index.js ***!
  \***********************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var staticMatch = __webpack_require__(/*! css-mediaquery */ "./node_modules/css-mediaquery/index.js").match;
                var dynamicMatch = typeof window !== "undefined" ? window.matchMedia : null;
                // our fake MediaQueryList
                function Mql(query, values, forceStatic) {
                    var self = this;
                    if (dynamicMatch && !forceStatic) {
                        var mql = dynamicMatch.call(window, query);
                        this.matches = mql.matches;
                        this.media = mql.media;
                        // TODO: is there a time it makes sense to remove this listener?
                        mql.addListener(update);
                    } else {
                        this.matches = staticMatch(query, values);
                        this.media = query;
                    }
                    this.addListener = addListener;
                    this.removeListener = removeListener;
                    this.dispose = dispose;
                    function addListener(listener) {
                        if (mql) mql.addListener(listener);
                    }
                    function removeListener(listener) {
                        if (mql) mql.removeListener(listener);
                    }
                    // update ourselves!
                    function update(evt) {
                        self.matches = evt.matches;
                        self.media = evt.media;
                    }
                    function dispose() {
                        if (mql) mql.removeListener(update);
                    }
                }
                function matchMedia(query, values, forceStatic) {
                    return new Mql(query, values, forceStatic);
                }
                module1.exports = matchMedia;
            /***/ },
            /***/ "./node_modules/object-assign/index.js": /*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/ /***/ (module1)=>{
                "use strict";
                /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;
                function toObject(val) {
                    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(val);
                }
                function shouldUseNative() {
                    try {
                        if (!Object.assign) return false;
                        // Detect buggy property enumeration order in older V8 versions.
                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
                        test1[5] = "de";
                        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
                        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                            return test2[n];
                        });
                        if (order2.join("") !== "0123456789") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                            test3[letter] = letter;
                        });
                        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
                        return true;
                    } catch (err) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }
                module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
                    var from;
                    var to = toObject(target);
                    var symbols;
                    for(var s = 1; s < arguments.length; s++){
                        from = Object(arguments[s]);
                        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                        if (getOwnPropertySymbols) {
                            symbols = getOwnPropertySymbols(from);
                            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                        }
                    }
                    return to;
                };
            /***/ },
            /***/ "./node_modules/prop-types/checkPropTypes.js": /*!***************************************************!*\
  !*** ./node_modules/prop-types/checkPropTypes.js ***!
  \***************************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var printWarning = function() {};
                var ReactPropTypesSecret = __webpack_require__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");
                var loggedTypeFailures = {};
                var has = __webpack_require__(/*! ./lib/has */ "./node_modules/prop-types/lib/has.js");
                printWarning = function(text) {
                    var message = "Warning: " + text;
                    if (typeof console !== "undefined") console.error(message);
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) {}
                };
                /**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
                    for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
                        var error;
                        // Prop type validation may throw. In case they do, we don't want to
                        // fail the render phase where it didn't fail before. So we log it.
                        // After these have been cleaned up, we'll let them throw.
                        try {
                            // This is intentionally an invariant that gets caught. It's the same
                            // behavior as without this statement except with a better message.
                            if (typeof typeSpecs[typeSpecName] !== "function") {
                                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                                err.name = "Invariant Violation";
                                throw err;
                            }
                            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                        } catch (ex) {
                            error = ex;
                        }
                        if (error && !(error instanceof Error)) printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
                        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                            // Only monitor this failure once because there tends to be a lot of the
                            // same error.
                            loggedTypeFailures[error.message] = true;
                            var stack = getStack ? getStack() : "";
                            printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
                        }
                    }
                }
                /**
 * Resets warning cache when testing.
 *
 * @private
 */ checkPropTypes.resetWarningCache = function() {
                    loggedTypeFailures = {};
                };
                module1.exports = checkPropTypes;
            /***/ },
            /***/ "./node_modules/prop-types/factoryWithTypeCheckers.js": /*!************************************************************!*\
  !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
  \************************************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs = __webpack_require__(/*! react-is */ "./node_modules/react-is/index.js");
                var assign = __webpack_require__(/*! object-assign */ "./node_modules/object-assign/index.js");
                var ReactPropTypesSecret = __webpack_require__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");
                var has = __webpack_require__(/*! ./lib/has */ "./node_modules/prop-types/lib/has.js");
                var checkPropTypes = __webpack_require__(/*! ./checkPropTypes */ "./node_modules/prop-types/checkPropTypes.js");
                var printWarning = function() {};
                printWarning = function(text) {
                    var message = "Warning: " + text;
                    if (typeof console !== "undefined") console.error(message);
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) {}
                };
                function emptyFunctionThatReturnsNull() {
                    return null;
                }
                module1.exports = function(isValidElement, throwOnDirectAccess) {
                    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
                    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
                    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
                        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                        if (typeof iteratorFn === "function") return iteratorFn;
                    }
                    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
                    // Important!
                    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
                    var ReactPropTypes = {
                        array: createPrimitiveTypeChecker("array"),
                        bigint: createPrimitiveTypeChecker("bigint"),
                        bool: createPrimitiveTypeChecker("boolean"),
                        func: createPrimitiveTypeChecker("function"),
                        number: createPrimitiveTypeChecker("number"),
                        object: createPrimitiveTypeChecker("object"),
                        string: createPrimitiveTypeChecker("string"),
                        symbol: createPrimitiveTypeChecker("symbol"),
                        any: createAnyTypeChecker(),
                        arrayOf: createArrayOfTypeChecker,
                        element: createElementTypeChecker(),
                        elementType: createElementTypeTypeChecker(),
                        instanceOf: createInstanceTypeChecker,
                        node: createNodeChecker(),
                        objectOf: createObjectOfTypeChecker,
                        oneOf: createEnumTypeChecker,
                        oneOfType: createUnionTypeChecker,
                        shape: createShapeTypeChecker,
                        exact: createStrictShapeTypeChecker
                    };
                    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
                        // SameValue algorithm
                        if (x === y) // Steps 1-5, 7-10
                        // Steps 6.b-6.e: +0 != -0
                        return x !== 0 || 1 / x === 1 / y;
                        else // Step 6.a: NaN == NaN
                        return x !== x && y !== y;
                    }
                    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
                        this.message = message;
                        this.data = data && typeof data === "object" ? data : {};
                        this.stack = "";
                    }
                    // Make `instanceof Error` still work for returned errors.
                    PropTypeError.prototype = Error.prototype;
                    function createChainableTypeChecker(validate) {
                        var manualPropTypeCallCache = {};
                        var manualPropTypeWarningCount = 0;
                        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                            componentName = componentName || ANONYMOUS;
                            propFullName = propFullName || propName;
                            if (secret !== ReactPropTypesSecret) {
                                if (throwOnDirectAccess) {
                                    // New behavior only for users of `prop-types` package
                                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                                    err.name = "Invariant Violation";
                                    throw err;
                                } else if (typeof console !== "undefined") {
                                    // Old behavior for people using React.PropTypes
                                    var cacheKey = componentName + ":" + propName;
                                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                                    manualPropTypeWarningCount < 3) {
                                        printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                                        manualPropTypeCallCache[cacheKey] = true;
                                        manualPropTypeWarningCount++;
                                    }
                                }
                            }
                            if (props[propName] == null) {
                                if (isRequired) {
                                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                                }
                                return null;
                            } else return validate(props, propName, componentName, location, propFullName);
                        }
                        var chainedCheckType = checkType.bind(null, false);
                        chainedCheckType.isRequired = checkType.bind(null, true);
                        return chainedCheckType;
                    }
                    function createPrimitiveTypeChecker(expectedType) {
                        function validate(props, propName, componentName, location, propFullName, secret) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== expectedType) {
                                // `propValue` being instance of, say, date/regexp, pass the 'object'
                                // check, but we can offer a more precise error message here rather than
                                // 'of type `object`'.
                                var preciseType = getPreciseType(propValue);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                                    expectedType: expectedType
                                });
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createAnyTypeChecker() {
                        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                    }
                    function createArrayOfTypeChecker(typeChecker) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                            var propValue = props[propName];
                            if (!Array.isArray(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
                            }
                            for(var i = 0; i < propValue.length; i++){
                                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                                if (error instanceof Error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createElementTypeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            if (!isValidElement(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createElementTypeTypeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            if (!ReactIs.isValidElementType(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createInstanceTypeChecker(expectedClass) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (!(props[propName] instanceof expectedClass)) {
                                var expectedClassName = expectedClass.name || ANONYMOUS;
                                var actualClassName = getClassName(props[propName]);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createEnumTypeChecker(expectedValues) {
                        if (!Array.isArray(expectedValues)) {
                            {
                                if (arguments.length > 1) printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                                else printWarning("Invalid argument supplied to oneOf, expected an array.");
                            }
                            return emptyFunctionThatReturnsNull;
                        }
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            for(var i = 0; i < expectedValues.length; i++){
                                if (is(propValue, expectedValues[i])) return null;
                            }
                            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                                var type = getPreciseType(value);
                                if (type === "symbol") return String(value);
                                return value;
                            });
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createObjectOfTypeChecker(typeChecker) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
                            for(var key in propValue)if (has(propValue, key)) {
                                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                if (error instanceof Error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createUnionTypeChecker(arrayOfTypeCheckers) {
                        if (!Array.isArray(arrayOfTypeCheckers)) {
                            printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
                            return emptyFunctionThatReturnsNull;
                        }
                        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                            var checker = arrayOfTypeCheckers[i];
                            if (typeof checker !== "function") {
                                printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                                return emptyFunctionThatReturnsNull;
                            }
                        }
                        function validate(props, propName, componentName, location, propFullName) {
                            var expectedTypes = [];
                            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                                var checker = arrayOfTypeCheckers[i];
                                var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                                if (checkerResult == null) return null;
                                if (checkerResult.data && has(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
                            }
                            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createNodeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function invalidValidatorError(componentName, location, propFullName, key, type) {
                        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
                    }
                    function createShapeTypeChecker(shapeTypes) {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                            for(var key in shapeTypes){
                                var checker = shapeTypes[key];
                                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                if (error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createStrictShapeTypeChecker(shapeTypes) {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                            // We need to check all keys in case some are required but missing from props.
                            var allKeys = assign({}, props[propName], shapeTypes);
                            for(var key in allKeys){
                                var checker = shapeTypes[key];
                                if (has(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                if (error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function isNode(propValue) {
                        switch(typeof propValue){
                            case "number":
                            case "string":
                            case "undefined":
                                return true;
                            case "boolean":
                                return !propValue;
                            case "object":
                                if (Array.isArray(propValue)) return propValue.every(isNode);
                                if (propValue === null || isValidElement(propValue)) return true;
                                var iteratorFn = getIteratorFn(propValue);
                                if (iteratorFn) {
                                    var iterator = iteratorFn.call(propValue);
                                    var step;
                                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                                        if (!isNode(step.value)) return false;
                                    }
                                    else // Iterator will provide entry [k,v] tuples rather than values.
                                    while(!(step = iterator.next()).done){
                                        var entry = step.value;
                                        if (entry) {
                                            if (!isNode(entry[1])) return false;
                                        }
                                    }
                                } else return false;
                                return true;
                            default:
                                return false;
                        }
                    }
                    function isSymbol(propType, propValue) {
                        // Native Symbol.
                        if (propType === "symbol") return true;
                        // falsy value can't be a Symbol
                        if (!propValue) return false;
                        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
                        if (propValue["@@toStringTag"] === "Symbol") return true;
                        // Fallback for non-spec compliant Symbols which are polyfilled.
                        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
                        return false;
                    }
                    // Equivalent of `typeof` but with special handling for array and regexp.
                    function getPropType(propValue) {
                        var propType = typeof propValue;
                        if (Array.isArray(propValue)) return "array";
                        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
                        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
                        // passes PropTypes.object.
                        return "object";
                        if (isSymbol(propType, propValue)) return "symbol";
                        return propType;
                    }
                    // This handles more types than `getPropType`. Only used for error messages.
                    // See `createPrimitiveTypeChecker`.
                    function getPreciseType(propValue) {
                        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
                        var propType = getPropType(propValue);
                        if (propType === "object") {
                            if (propValue instanceof Date) return "date";
                            else if (propValue instanceof RegExp) return "regexp";
                        }
                        return propType;
                    }
                    // Returns a string that is postfixed to a warning about an invalid type.
                    // For example, "undefined" or "of type array"
                    function getPostfixForTypeWarning(value) {
                        var type = getPreciseType(value);
                        switch(type){
                            case "array":
                            case "object":
                                return "an " + type;
                            case "boolean":
                            case "date":
                            case "regexp":
                                return "a " + type;
                            default:
                                return type;
                        }
                    }
                    // Returns class name of the object, if any.
                    function getClassName(propValue) {
                        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
                        return propValue.constructor.name;
                    }
                    ReactPropTypes.checkPropTypes = checkPropTypes;
                    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
                    ReactPropTypes.PropTypes = ReactPropTypes;
                    return ReactPropTypes;
                };
            /***/ },
            /***/ "./node_modules/prop-types/index.js": /*!******************************************!*\
  !*** ./node_modules/prop-types/index.js ***!
  \******************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var ReactIs = __webpack_require__(/*! react-is */ "./node_modules/react-is/index.js");
                // By explicitly using `prop-types` you are opting into new development behavior.
                // http://fb.me/prop-types-in-prod
                var throwOnDirectAccess = true;
                module1.exports = __webpack_require__(/*! ./factoryWithTypeCheckers */ "./node_modules/prop-types/factoryWithTypeCheckers.js")(ReactIs.isElement, throwOnDirectAccess);
            /***/ },
            /***/ "./node_modules/prop-types/lib/ReactPropTypesSecret.js": /*!*************************************************************!*\
  !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
  \*************************************************************/ /***/ (module1)=>{
                "use strict";
                /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
                module1.exports = ReactPropTypesSecret;
            /***/ },
            /***/ "./node_modules/prop-types/lib/has.js": /*!********************************************!*\
  !*** ./node_modules/prop-types/lib/has.js ***!
  \********************************************/ /***/ (module1)=>{
                module1.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            /***/ },
            /***/ "./node_modules/react-is/cjs/react-is.development.js": /*!***********************************************************!*\
  !*** ./node_modules/react-is/cjs/react-is.development.js ***!
  \***********************************************************/ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                (function() {
                    "use strict";
                    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
                    // nor polyfill, then a plain number is used for performance.
                    var hasSymbol = typeof Symbol === "function" && Symbol.for;
                    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
                    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
                    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
                    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
                    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
                    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
                    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
                    // (unstable) APIs that have been removed. Can we remove the symbols?
                    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
                    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
                    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
                    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
                    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
                    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
                    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
                    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
                    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
                    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
                    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
                    function isValidElementType(type) {
                        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
                    }
                    function typeOf(object) {
                        if (typeof object === "object" && object !== null) {
                            var $$typeof = object.$$typeof;
                            switch($$typeof){
                                case REACT_ELEMENT_TYPE:
                                    var type = object.type;
                                    switch(type){
                                        case REACT_ASYNC_MODE_TYPE:
                                        case REACT_CONCURRENT_MODE_TYPE:
                                        case REACT_FRAGMENT_TYPE:
                                        case REACT_PROFILER_TYPE:
                                        case REACT_STRICT_MODE_TYPE:
                                        case REACT_SUSPENSE_TYPE:
                                            return type;
                                        default:
                                            var $$typeofType = type && type.$$typeof;
                                            switch($$typeofType){
                                                case REACT_CONTEXT_TYPE:
                                                case REACT_FORWARD_REF_TYPE:
                                                case REACT_LAZY_TYPE:
                                                case REACT_MEMO_TYPE:
                                                case REACT_PROVIDER_TYPE:
                                                    return $$typeofType;
                                                default:
                                                    return $$typeof;
                                            }
                                    }
                                case REACT_PORTAL_TYPE:
                                    return $$typeof;
                            }
                        }
                        return undefined;
                    } // AsyncMode is deprecated along with isAsyncMode
                    var AsyncMode = REACT_ASYNC_MODE_TYPE;
                    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
                    var ContextConsumer = REACT_CONTEXT_TYPE;
                    var ContextProvider = REACT_PROVIDER_TYPE;
                    var Element = REACT_ELEMENT_TYPE;
                    var ForwardRef = REACT_FORWARD_REF_TYPE;
                    var Fragment = REACT_FRAGMENT_TYPE;
                    var Lazy = REACT_LAZY_TYPE;
                    var Memo = REACT_MEMO_TYPE;
                    var Portal = REACT_PORTAL_TYPE;
                    var Profiler = REACT_PROFILER_TYPE;
                    var StrictMode = REACT_STRICT_MODE_TYPE;
                    var Suspense = REACT_SUSPENSE_TYPE;
                    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
                    function isAsyncMode(object) {
                        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
                            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
                        }
                        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
                    }
                    function isConcurrentMode(object) {
                        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
                    }
                    function isContextConsumer(object) {
                        return typeOf(object) === REACT_CONTEXT_TYPE;
                    }
                    function isContextProvider(object) {
                        return typeOf(object) === REACT_PROVIDER_TYPE;
                    }
                    function isElement(object) {
                        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
                    }
                    function isForwardRef(object) {
                        return typeOf(object) === REACT_FORWARD_REF_TYPE;
                    }
                    function isFragment(object) {
                        return typeOf(object) === REACT_FRAGMENT_TYPE;
                    }
                    function isLazy(object) {
                        return typeOf(object) === REACT_LAZY_TYPE;
                    }
                    function isMemo(object) {
                        return typeOf(object) === REACT_MEMO_TYPE;
                    }
                    function isPortal(object) {
                        return typeOf(object) === REACT_PORTAL_TYPE;
                    }
                    function isProfiler(object) {
                        return typeOf(object) === REACT_PROFILER_TYPE;
                    }
                    function isStrictMode(object) {
                        return typeOf(object) === REACT_STRICT_MODE_TYPE;
                    }
                    function isSuspense(object) {
                        return typeOf(object) === REACT_SUSPENSE_TYPE;
                    }
                    exports.AsyncMode = AsyncMode;
                    exports.ConcurrentMode = ConcurrentMode;
                    exports.ContextConsumer = ContextConsumer;
                    exports.ContextProvider = ContextProvider;
                    exports.Element = Element;
                    exports.ForwardRef = ForwardRef;
                    exports.Fragment = Fragment;
                    exports.Lazy = Lazy;
                    exports.Memo = Memo;
                    exports.Portal = Portal;
                    exports.Profiler = Profiler;
                    exports.StrictMode = StrictMode;
                    exports.Suspense = Suspense;
                    exports.isAsyncMode = isAsyncMode;
                    exports.isConcurrentMode = isConcurrentMode;
                    exports.isContextConsumer = isContextConsumer;
                    exports.isContextProvider = isContextProvider;
                    exports.isElement = isElement;
                    exports.isForwardRef = isForwardRef;
                    exports.isFragment = isFragment;
                    exports.isLazy = isLazy;
                    exports.isMemo = isMemo;
                    exports.isPortal = isPortal;
                    exports.isProfiler = isProfiler;
                    exports.isStrictMode = isStrictMode;
                    exports.isSuspense = isSuspense;
                    exports.isValidElementType = isValidElementType;
                    exports.typeOf = typeOf;
                })();
            /***/ },
            /***/ "./node_modules/react-is/index.js": /*!****************************************!*\
  !*** ./node_modules/react-is/index.js ***!
  \****************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                module1.exports = __webpack_require__(/*! ./cjs/react-is.development.js */ "./node_modules/react-is/cjs/react-is.development.js");
            /***/ },
            /***/ "./node_modules/shallow-equal/dist/index.esm.js": /*!******************************************************!*\
  !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
  \******************************************************/ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "shallowEqualArrays": ()=>/* binding */ shallowEqualArrays,
                    /* harmony export */ "shallowEqualObjects": ()=>/* binding */ shallowEqualObjects
                });
                function shallowEqualObjects(objA, objB) {
                    if (objA === objB) return true;
                    if (!objA || !objB) return false;
                    var aKeys = Object.keys(objA);
                    var bKeys = Object.keys(objB);
                    var len = aKeys.length;
                    if (bKeys.length !== len) return false;
                    for(var i = 0; i < len; i++){
                        var key = aKeys[i];
                        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
                    }
                    return true;
                }
                function shallowEqualArrays(arrA, arrB) {
                    if (arrA === arrB) return true;
                    if (!arrA || !arrB) return false;
                    var len = arrA.length;
                    if (arrB.length !== len) return false;
                    for(var i = 0; i < len; i++){
                        if (arrA[i] !== arrB[i]) return false;
                    }
                    return true;
                }
            /***/ },
            /***/ "./src/Component.ts": /*!**************************!*\
  !*** ./src/Component.ts ***!
  \**************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __rest = this && this.__rest || function(s, e) {
                    var t = {};
                    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                    }
                    return t;
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var useMediaQuery_1 = __importDefault(__webpack_require__(/*! ./useMediaQuery */ "./src/useMediaQuery.ts"));
                // ReactNode and ReactElement typings are a little funky for functional components, so the ReactElement cast is needed on the return
                var MediaQuery = function(_a) {
                    var children = _a.children, device = _a.device, onChange = _a.onChange, settings = __rest(_a, [
                        "children",
                        "device",
                        "onChange"
                    ]);
                    var matches = (0, useMediaQuery_1.default)(settings, device, onChange);
                    if (typeof children === "function") return children(matches);
                    return matches ? children : null;
                };
                exports["default"] = MediaQuery;
            /***/ },
            /***/ "./src/Context.ts": /*!************************!*\
  !*** ./src/Context.ts ***!
  \************************/ /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var react_1 = __webpack_require__(/*! react */ "react");
                var Context = (0, react_1.createContext)(undefined);
                exports["default"] = Context;
            /***/ },
            /***/ "./src/index.ts": /*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Context = exports.toQuery = exports.useMediaQuery = exports["default"] = void 0;
                var useMediaQuery_1 = __importDefault(__webpack_require__(/*! ./useMediaQuery */ "./src/useMediaQuery.ts"));
                exports.useMediaQuery = useMediaQuery_1.default;
                var Component_1 = __importDefault(__webpack_require__(/*! ./Component */ "./src/Component.ts"));
                exports["default"] = Component_1.default;
                var toQuery_1 = __importDefault(__webpack_require__(/*! ./toQuery */ "./src/toQuery.ts"));
                exports.toQuery = toQuery_1.default;
                var Context_1 = __importDefault(__webpack_require__(/*! ./Context */ "./src/Context.ts"));
                exports.Context = Context_1.default;
            /***/ },
            /***/ "./src/mediaQuery.ts": /*!***************************!*\
  !*** ./src/mediaQuery.ts ***!
  \***************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __assign = this && this.__assign || function() {
                    __assign = Object.assign || function(t) {
                        for(var s, i = 1, n = arguments.length; i < n; i++){
                            s = arguments[i];
                            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                        }
                        return t;
                    };
                    return __assign.apply(this, arguments);
                };
                var __rest = this && this.__rest || function(s, e) {
                    var t = {};
                    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                    }
                    return t;
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var prop_types_1 = __importDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));
                var stringOrNumber = prop_types_1.default.oneOfType([
                    prop_types_1.default.string,
                    prop_types_1.default.number
                ]);
                // media types
                var types = {
                    all: prop_types_1.default.bool,
                    grid: prop_types_1.default.bool,
                    aural: prop_types_1.default.bool,
                    braille: prop_types_1.default.bool,
                    handheld: prop_types_1.default.bool,
                    print: prop_types_1.default.bool,
                    projection: prop_types_1.default.bool,
                    screen: prop_types_1.default.bool,
                    tty: prop_types_1.default.bool,
                    tv: prop_types_1.default.bool,
                    embossed: prop_types_1.default.bool
                };
                // properties that match media queries
                var matchers = {
                    orientation: prop_types_1.default.oneOf([
                        "portrait",
                        "landscape"
                    ]),
                    scan: prop_types_1.default.oneOf([
                        "progressive",
                        "interlace"
                    ]),
                    aspectRatio: prop_types_1.default.string,
                    deviceAspectRatio: prop_types_1.default.string,
                    height: stringOrNumber,
                    deviceHeight: stringOrNumber,
                    width: stringOrNumber,
                    deviceWidth: stringOrNumber,
                    color: prop_types_1.default.bool,
                    colorIndex: prop_types_1.default.bool,
                    monochrome: prop_types_1.default.bool,
                    resolution: stringOrNumber,
                    type: Object.keys(types)
                };
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                var type = matchers.type, featureMatchers = __rest(matchers, [
                    "type"
                ]);
                // media features
                var features = __assign({
                    minAspectRatio: prop_types_1.default.string,
                    maxAspectRatio: prop_types_1.default.string,
                    minDeviceAspectRatio: prop_types_1.default.string,
                    maxDeviceAspectRatio: prop_types_1.default.string,
                    minHeight: stringOrNumber,
                    maxHeight: stringOrNumber,
                    minDeviceHeight: stringOrNumber,
                    maxDeviceHeight: stringOrNumber,
                    minWidth: stringOrNumber,
                    maxWidth: stringOrNumber,
                    minDeviceWidth: stringOrNumber,
                    maxDeviceWidth: stringOrNumber,
                    minColor: prop_types_1.default.number,
                    maxColor: prop_types_1.default.number,
                    minColorIndex: prop_types_1.default.number,
                    maxColorIndex: prop_types_1.default.number,
                    minMonochrome: prop_types_1.default.number,
                    maxMonochrome: prop_types_1.default.number,
                    minResolution: stringOrNumber,
                    maxResolution: stringOrNumber
                }, featureMatchers);
                var all = __assign(__assign({}, types), features);
                exports["default"] = {
                    all: all,
                    types: types,
                    matchers: matchers,
                    features: features
                };
            /***/ },
            /***/ "./src/toQuery.ts": /*!************************!*\
  !*** ./src/toQuery.ts ***!
  \************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var hyphenate_style_name_1 = __importDefault(__webpack_require__(/*! hyphenate-style-name */ "./node_modules/hyphenate-style-name/index.js"));
                var mediaQuery_1 = __importDefault(__webpack_require__(/*! ./mediaQuery */ "./src/mediaQuery.ts"));
                var negate = function(cond) {
                    return "not ".concat(cond);
                };
                var keyVal = function(k, v) {
                    var realKey = (0, hyphenate_style_name_1.default)(k);
                    // px shorthand
                    if (typeof v === "number") v = "".concat(v, "px");
                    if (v === true) return realKey;
                    if (v === false) return negate(realKey);
                    return "(".concat(realKey, ": ").concat(v, ")");
                };
                var join = function(conds) {
                    return conds.join(" and ");
                };
                var toQuery = function(obj) {
                    var rules = [];
                    Object.keys(mediaQuery_1.default.all).forEach(function(k) {
                        var v = obj[k];
                        if (v != null) rules.push(keyVal(k, v));
                    });
                    return join(rules);
                };
                exports["default"] = toQuery;
            /***/ },
            /***/ "./src/useMediaQuery.ts": /*!******************************!*\
  !*** ./src/useMediaQuery.ts ***!
  \******************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var react_1 = __webpack_require__(/*! react */ "react");
                var matchmediaquery_1 = __importDefault(__webpack_require__(/*! matchmediaquery */ "./node_modules/matchmediaquery/index.js"));
                var hyphenate_style_name_1 = __importDefault(__webpack_require__(/*! hyphenate-style-name */ "./node_modules/hyphenate-style-name/index.js"));
                var shallow_equal_1 = __webpack_require__(/*! shallow-equal */ "./node_modules/shallow-equal/dist/index.esm.js");
                var toQuery_1 = __importDefault(__webpack_require__(/*! ./toQuery */ "./src/toQuery.ts"));
                var Context_1 = __importDefault(__webpack_require__(/*! ./Context */ "./src/Context.ts"));
                var makeQuery = function(settings) {
                    return settings.query || (0, toQuery_1.default)(settings);
                };
                var hyphenateKeys = function(obj) {
                    if (!obj) return undefined;
                    var keys = Object.keys(obj);
                    return keys.reduce(function(result, key) {
                        result[(0, hyphenate_style_name_1.default)(key)] = obj[key];
                        return result;
                    }, {});
                };
                var useIsUpdate = function() {
                    var ref = (0, react_1.useRef)(false);
                    (0, react_1.useEffect)(function() {
                        ref.current = true;
                    }, []);
                    return ref.current;
                };
                var useDevice = function(deviceFromProps) {
                    var deviceFromContext = (0, react_1.useContext)(Context_1.default);
                    var getDevice = function() {
                        return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
                    };
                    var _a = (0, react_1.useState)(getDevice), device = _a[0], setDevice = _a[1];
                    (0, react_1.useEffect)(function() {
                        var newDevice = getDevice();
                        if (!(0, shallow_equal_1.shallowEqualObjects)(device, newDevice)) setDevice(newDevice);
                    }, [
                        deviceFromProps,
                        deviceFromContext
                    ]);
                    return device;
                };
                var useQuery = function(settings) {
                    var getQuery = function() {
                        return makeQuery(settings);
                    };
                    var _a = (0, react_1.useState)(getQuery), query = _a[0], setQuery = _a[1];
                    (0, react_1.useEffect)(function() {
                        var newQuery = getQuery();
                        if (query !== newQuery) setQuery(newQuery);
                    }, [
                        settings
                    ]);
                    return query;
                };
                var useMatchMedia = function(query, device) {
                    var getMatchMedia = function() {
                        return (0, matchmediaquery_1.default)(query, device || {}, !!device);
                    };
                    var _a = (0, react_1.useState)(getMatchMedia), mq = _a[0], setMq = _a[1];
                    var isUpdate = useIsUpdate();
                    (0, react_1.useEffect)(function() {
                        if (isUpdate) {
                            // skip on mounting, it has already been set
                            var newMq_1 = getMatchMedia();
                            setMq(newMq_1);
                            return function() {
                                if (newMq_1) newMq_1.dispose();
                            };
                        }
                    }, [
                        query,
                        device
                    ]);
                    return mq;
                };
                var useMatches = function(mediaQuery) {
                    var _a = (0, react_1.useState)(mediaQuery.matches), matches = _a[0], setMatches = _a[1];
                    (0, react_1.useEffect)(function() {
                        var updateMatches = function(ev) {
                            setMatches(ev.matches);
                        };
                        mediaQuery.addListener(updateMatches);
                        setMatches(mediaQuery.matches);
                        return function() {
                            mediaQuery.removeListener(updateMatches);
                        };
                    }, [
                        mediaQuery
                    ]);
                    return matches;
                };
                var useMediaQuery = function(settings, device, onChange) {
                    var deviceSettings = useDevice(device);
                    var query = useQuery(settings);
                    if (!query) throw new Error("Invalid or missing MediaQuery!");
                    var mq = useMatchMedia(query, deviceSettings);
                    var matches = useMatches(mq);
                    var isUpdate = useIsUpdate();
                    (0, react_1.useEffect)(function() {
                        if (isUpdate && onChange) onChange(matches);
                    }, [
                        matches
                    ]);
                    (0, react_1.useEffect)(function() {
                        return function() {
                            if (mq) mq.dispose();
                        };
                    }, []);
                    return matches;
                };
                exports["default"] = useMediaQuery;
            /***/ },
            /***/ "react": /*!**************************************************************************************!*\
  !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
  \**************************************************************************************/ /***/ (module1)=>{
                "use strict";
                module1.exports = __WEBPACK_EXTERNAL_MODULE_react__;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__("./src/index.ts");
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});


var $c809127cd3a70564$exports = {};

$c809127cd3a70564$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "phone.c997cc2e.png";


const $2473041a92174530$var$AboutProject = (props)=>{
    const { title: title, data: data, description: description, photoSource: photoSource = $c809127cd3a70564$exports, imageStyle: imageStyle, visual: visual, background: background } = props;
    const isMobile = (0, $8a086d95af0c9c00$exports.useMediaQuery)({
        query: "(max-width: 1000px)"
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aa7022b61633d91e$exports))).cardContainer,
        style: background ? {
            background: background
        } : undefined,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa7022b61633d91e$exports))).workTitle,
                children: "ANALYSIS & PREPARATION"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa7022b61633d91e$exports))).workText,
                children: "Responsibilities"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa7022b61633d91e$exports))).workCard,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa7022b61633d91e$exports))).cardTitle,
                                children: title
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa7022b61633d91e$exports))).line
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa7022b61633d91e$exports))).workDescription,
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($aa7022b61633d91e$exports))).phoneContainerMob : (0, (/*@__PURE__*/$parcel$interopDefault($aa7022b61633d91e$exports))).phoneContainer,
                        children: visual ? visual : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($aa7022b61633d91e$exports))).phoneCard,
                            style: imageStyle,
                            src: photoSource,
                            alt: "App screen mockup"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa7022b61633d91e$exports))).paletteTitle,
                children: "Design system \xb7 project palette"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa7022b61633d91e$exports))).circleContainer,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $cde20023a56df241$export$2e2bcd8739ae039), {
                    data: data
                })
            })
        ]
    });
};
var $2473041a92174530$export$2e2bcd8739ae039 = $2473041a92174530$var$AboutProject;


// modules


parcelRequire("6cds3");


const $73096be23d597aa3$var$CardModal = (props)=>{
    const { item: item, index: index, navigate: navigate, currentPath: currentPath } = props;
    const odd = index % 2 === 0;
    const imageVariants = {
        hidden: {
            x: odd ? -100 : 100,
            opacity: 0
        },
        visible: {
            x: 0,
            opacity: 1
        },
        exit: {
            x: odd ? -100 : 100,
            opacity: 0
        }
    };
    const textVariants = {
        hidden: {
            x: odd ? 150 : -150,
            opacity: 0
        },
        visible: {
            x: 0,
            opacity: 1
        },
        exit: {
            x: odd ? 150 : -150,
            opacity: 0
        }
    };
    const transition = {
        duration: 0.4,
        ease: "easeInOut",
        delay: odd ? 0 : 0.3
    };
    const Image = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).img, {
            src: item.image,
            alt: `${item.title} cover`,
            className: "img",
            style: {
                order: !odd ? 1 : 0
            },
            initial: "hidden",
            animate: "visible",
            variants: imageVariants,
            transition: transition
        });
    const DescriptionText = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
            style: {
                order: !odd ? 0 : 1
            },
            className: "textContainer",
            initial: "hidden",
            animate: "visible",
            variants: textVariants,
            transition: transition,
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "title",
                            children: item.title
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            className: "modalSubtitle",
                            children: [
                                item.role,
                                " - ",
                                item.period
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "modalDescription",
                            children: item.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "modalButtonBox",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9307550ce52715a5$export$2e2bcd8739ae039), {
                        text: "Case study",
                        widthArrow: false,
                        disabled: currentPath === `/${item.path}`,
                        onClick: ()=>navigate(`/${item.path}`)
                    })
                })
            ]
        });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "modalCard",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Image, {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(DescriptionText, {})
        ]
    });
};
var $73096be23d597aa3$export$2e2bcd8739ae039 = $73096be23d597aa3$var$CardModal;








const $d1852bbe54d44f24$var$Home = ()=>{
    const [modalActive, setModalActive] = (0, $6cds3.useState)(false);
    const [isHovered, setIsHovered] = (0, $6cds3.useState)(false);
    const bind = (0, $160140048d0d318d$export$ae780daf29e6d456)((state)=>{
        setIsHovered(state.hovering);
    });
    const cursorPositionRef = (0, $6cds3.useRef)({
        x: 0,
        y: 0
    });
    (0, $6cds3.useEffect)(()=>{
        const handleMouseMove = (event)=>{
            cursorPositionRef.current = {
                x: event.clientX,
                y: event.clientY
            };
        };
        window.addEventListener("mousemove", handleMouseMove);
        return ()=>{
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, [
        isHovered
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).container,
            id: "home"
        }, bind()), {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: modalActive ? (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).hiddenHeader : (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).headerContainer,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4eb7dc37af125249$export$2e2bcd8739ae039), {
                        setModal: setModalActive
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).contentContainer,
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).nameContainer,
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).textBlock,
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).name,
                                            children: "Vlad Khrushchov"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9cb2eb5a2afb4e3f$export$2e2bcd8739ae039), {
                                            text: "Full-Stack Developer \xb7 React Native / NestJS",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).description
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).buttonContainer,
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9307550ce52715a5$export$2e2bcd8739ae039), {
                                                    text: "About Me",
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).aboutButton,
                                                    onClick: ()=>setModalActive(true)
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4574a52341674792$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).cvLink
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).logoContainer,
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26f2e3d8304fc83$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            className: modalActive ? (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).hiddenElement : (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).iconContainer,
                            children: (0, $659a992bfe06fd0d$export$78a7c3e6a26a06a6).map((item)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                    href: item.link,
                                    "aria-label": item.name,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).socialLink,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: item.icon
                                }, item.id))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).decorIcons,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $6e1f125894bc562c$export$2e2bcd8739ae039), {
                        cursorPosition: cursorPositionRef
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $df07ea70fb26ed48$export$2e2bcd8739ae039), {
                    active: modalActive,
                    setActive: setModalActive
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).worksContainer,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1d42a532dd4f25d5$exports.Link), {
                        to: "work",
                        href: "#work",
                        smooth: true,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d85277821bd819c$exports))).works,
                            children: "Works"
                        })
                    })
                })
            ]
        }))
    });
};
var $d1852bbe54d44f24$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $6cds3.memo)($d1852bbe54d44f24$var$Home);


// modules


parcelRequire("6cds3");


var $7c5f30e918dc6214$exports = {};

$parcel$export($7c5f30e918dc6214$exports, "cardContainer", function () { return $7c5f30e918dc6214$export$6b2d426110a11d7a; }, function (v) { return $7c5f30e918dc6214$export$6b2d426110a11d7a = v; });
$parcel$export($7c5f30e918dc6214$exports, "iconsContainer", function () { return $7c5f30e918dc6214$export$94cec53e3205acbe; }, function (v) { return $7c5f30e918dc6214$export$94cec53e3205acbe = v; });
$parcel$export($7c5f30e918dc6214$exports, "workText", function () { return $7c5f30e918dc6214$export$bd3558835fd89b8a; }, function (v) { return $7c5f30e918dc6214$export$bd3558835fd89b8a = v; });
$parcel$export($7c5f30e918dc6214$exports, "workTitle", function () { return $7c5f30e918dc6214$export$3acfc26975580309; }, function (v) { return $7c5f30e918dc6214$export$3acfc26975580309 = v; });
var $7c5f30e918dc6214$export$6b2d426110a11d7a;
var $7c5f30e918dc6214$export$94cec53e3205acbe;
var $7c5f30e918dc6214$export$bd3558835fd89b8a;
var $7c5f30e918dc6214$export$3acfc26975580309;
$7c5f30e918dc6214$export$6b2d426110a11d7a = `nF2IMG_cardContainer`;
$7c5f30e918dc6214$export$94cec53e3205acbe = `nF2IMG_iconsContainer`;
$7c5f30e918dc6214$export$bd3558835fd89b8a = `nF2IMG_workText`;
$7c5f30e918dc6214$export$3acfc26975580309 = `nF2IMG_workTitle`;



// types



const $e620f929d587f27c$export$cf42e9e39aa444e0 = [
    {
        id: 15,
        path: "idriver",
        title: "IDriver",
        role: "Full-Stack Developer",
        period: "April 2026 - Present",
        image: (parcelRequire("f288Y")),
        description: "A mobile app for learning Ukrainian traffic rules (\u041F\u0414\u0420). As the lead full-stack developer I built both the React Native app and the NestJS / TypeORM backend \u2014 including payments, real-time features and application security. The app is live on the App Store and Google Play."
    },
    {
        id: 12,
        path: "voiceNotes",
        title: "Voice Notes",
        role: "React-Native Developer",
        period: "July 2025 - Present",
        image: (parcelRequire("90B6E")),
        description: "An internal CRM system for managing client records and session notes. Built from scratch with React Native CLI, Firebase, TypeScript and Zustand, and released on the App Store as a co-founder and sole developer."
    },
    {
        id: 14,
        path: "kloki",
        title: "Kloki Planner",
        role: "React-Native Developer",
        period: "January 2024 - Present",
        image: (parcelRequire("dTXXY")),
        description: "The project created in React Native is a planner that allows you to add, delete plans, daily habits, monitor your progress, and also receive notifications from the application about upcoming plans"
    }
];



const $e620f929d587f27c$export$6b09d51c38a097d9 = [
    {
        id: 15,
        title: "IDriver",
        text: "Ukrainian driving app \xb7 Full-Stack",
        image: (parcelRequire("f288Y")),
        path: "idriver"
    },
    {
        id: 12,
        title: "VoiceNotes",
        text: "CRM for small business",
        image: (parcelRequire("90B6E")),
        path: "voiceNotes"
    },
    {
        id: 14,
        title: "Kloki Planner",
        text: "Planner app on React Native",
        image: (parcelRequire("dTXXY")),
        path: "kloki"
    }
];



const $fc8192a66e628ce6$var$Works = ()=>{
    const isBigScreen = (0, $8a086d95af0c9c00$exports.useMediaQuery)({
        query: "(min-width: 2193px)"
    });
    const navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        id: "work",
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7c5f30e918dc6214$exports))).workTitle,
                children: "CASE STUDIES"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7c5f30e918dc6214$exports))).workText,
                children: "Latest Works"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7c5f30e918dc6214$exports))).cardContainer,
                children: (0, $e620f929d587f27c$export$6b09d51c38a097d9).map((item, index)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4e5518ffb6e1a3df$export$2e2bcd8739ae039), {
                        navigate: navigate,
                        item: item,
                        index: index
                    }, item.id))
            }),
            isBigScreen && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7c5f30e918dc6214$exports))).iconsContainer,
                children: (0, $659a992bfe06fd0d$export$5acc3e0471c10a8c).map((item)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        style: (0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, item.style),
                        children: item.icon
                    }, item.id))
            })
        ]
    });
};
var $fc8192a66e628ce6$export$2e2bcd8739ae039 = $fc8192a66e628ce6$var$Works;


// modules

parcelRequire("6cds3");
var $405cd1e8d4fca9e5$exports = {};

$parcel$export($405cd1e8d4fca9e5$exports, "cardText", function () { return $405cd1e8d4fca9e5$export$69b2c67571acbe57; }, function (v) { return $405cd1e8d4fca9e5$export$69b2c67571acbe57 = v; });
$parcel$export($405cd1e8d4fca9e5$exports, "cardTextBox", function () { return $405cd1e8d4fca9e5$export$ed9bf2440f2ce05d; }, function (v) { return $405cd1e8d4fca9e5$export$ed9bf2440f2ce05d = v; });
$parcel$export($405cd1e8d4fca9e5$exports, "cardTitle", function () { return $405cd1e8d4fca9e5$export$3aac624c619dfa7f; }, function (v) { return $405cd1e8d4fca9e5$export$3aac624c619dfa7f = v; });
$parcel$export($405cd1e8d4fca9e5$exports, "container", function () { return $405cd1e8d4fca9e5$export$34e0f9847d4c02dd; }, function (v) { return $405cd1e8d4fca9e5$export$34e0f9847d4c02dd = v; });
$parcel$export($405cd1e8d4fca9e5$exports, "numberCard", function () { return $405cd1e8d4fca9e5$export$d8996cc984233f3; }, function (v) { return $405cd1e8d4fca9e5$export$d8996cc984233f3 = v; });
$parcel$export($405cd1e8d4fca9e5$exports, "numberCardContainer", function () { return $405cd1e8d4fca9e5$export$ce34592cdb313f76; }, function (v) { return $405cd1e8d4fca9e5$export$ce34592cdb313f76 = v; });
$parcel$export($405cd1e8d4fca9e5$exports, "projectCard", function () { return $405cd1e8d4fca9e5$export$7ffb29c470bbe0c1; }, function (v) { return $405cd1e8d4fca9e5$export$7ffb29c470bbe0c1 = v; });
$parcel$export($405cd1e8d4fca9e5$exports, "projectContainer", function () { return $405cd1e8d4fca9e5$export$6e4e136db2811e9e; }, function (v) { return $405cd1e8d4fca9e5$export$6e4e136db2811e9e = v; });
$parcel$export($405cd1e8d4fca9e5$exports, "projectImage", function () { return $405cd1e8d4fca9e5$export$fe7c67492ddcd5ff; }, function (v) { return $405cd1e8d4fca9e5$export$fe7c67492ddcd5ff = v; });
$parcel$export($405cd1e8d4fca9e5$exports, "text", function () { return $405cd1e8d4fca9e5$export$6f093cfa640b7166; }, function (v) { return $405cd1e8d4fca9e5$export$6f093cfa640b7166 = v; });
$parcel$export($405cd1e8d4fca9e5$exports, "title", function () { return $405cd1e8d4fca9e5$export$fb184b623420d9be; }, function (v) { return $405cd1e8d4fca9e5$export$fb184b623420d9be = v; });
$parcel$export($405cd1e8d4fca9e5$exports, "verticalLine", function () { return $405cd1e8d4fca9e5$export$65259e741b4c5370; }, function (v) { return $405cd1e8d4fca9e5$export$65259e741b4c5370 = v; });
var $405cd1e8d4fca9e5$export$69b2c67571acbe57;
var $405cd1e8d4fca9e5$export$ed9bf2440f2ce05d;
var $405cd1e8d4fca9e5$export$3aac624c619dfa7f;
var $405cd1e8d4fca9e5$export$34e0f9847d4c02dd;
var $405cd1e8d4fca9e5$export$d8996cc984233f3;
var $405cd1e8d4fca9e5$export$ce34592cdb313f76;
var $405cd1e8d4fca9e5$export$7ffb29c470bbe0c1;
var $405cd1e8d4fca9e5$export$6e4e136db2811e9e;
var $405cd1e8d4fca9e5$export$fe7c67492ddcd5ff;
var $405cd1e8d4fca9e5$export$6f093cfa640b7166;
var $405cd1e8d4fca9e5$export$fb184b623420d9be;
var $405cd1e8d4fca9e5$export$65259e741b4c5370;
$405cd1e8d4fca9e5$export$69b2c67571acbe57 = `mxE6Gq_cardText`;
$405cd1e8d4fca9e5$export$ed9bf2440f2ce05d = `mxE6Gq_cardTextBox`;
$405cd1e8d4fca9e5$export$3aac624c619dfa7f = `mxE6Gq_cardTitle`;
$405cd1e8d4fca9e5$export$34e0f9847d4c02dd = `mxE6Gq_container`;
$405cd1e8d4fca9e5$export$d8996cc984233f3 = `mxE6Gq_numberCard`;
$405cd1e8d4fca9e5$export$ce34592cdb313f76 = `mxE6Gq_numberCardContainer`;
$405cd1e8d4fca9e5$export$7ffb29c470bbe0c1 = `mxE6Gq_projectCard`;
$405cd1e8d4fca9e5$export$6e4e136db2811e9e = `mxE6Gq_projectContainer`;
$405cd1e8d4fca9e5$export$fe7c67492ddcd5ff = `mxE6Gq_projectImage`;
$405cd1e8d4fca9e5$export$6f093cfa640b7166 = `mxE6Gq_text`;
$405cd1e8d4fca9e5$export$fb184b623420d9be = `mxE6Gq_title`;
$405cd1e8d4fca9e5$export$65259e741b4c5370 = `mxE6Gq_verticalLine`;







const $9a7060677ec4f9a5$export$db29154b08c82b55 = [
    {
        id: 21,
        title: "Cryptomania",
        description: "project with firebase (auth, storage, deploy), mobX, typescript",
        image: (parcelRequire("eu0M3")),
        link: "https://cryptomania-d5f1c.web.app/"
    },
    {
        id: 22,
        title: "StarWars Project",
        description: "One of the first project on React. React-router-dom, Api Star-wars",
        image: (parcelRequire("eUqt2")),
        link: "https://github.com/Vladoosik/React-Cource/tree/master/starwars"
    },
    {
        id: 23,
        title: "Loader",
        description: "some loader on CodePen",
        image: (parcelRequire("d5NXK")),
        link: "https://codepen.io/Vladoosik/pen/vYbLrKN"
    },
    {
        id: 24,
        title: "Swapi Mobile",
        description: "Project with MobX, Typescript, React-Native, React Navigation",
        image: (parcelRequire("aR5as")),
        link: "https://github.com/Vladoosik/swapiMobile"
    }
];


const $8442607dbd2ccb09$var$PetProjects = ()=>{
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($405cd1e8d4fca9e5$exports))).container,
        id: "petProject",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($405cd1e8d4fca9e5$exports))).title,
                children: "EXPERIMENTS & OPEN SOURCE"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($405cd1e8d4fca9e5$exports))).text,
                children: "Web is fun."
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $07bfed25ceaee054$export$2e2bcd8739ae039), {
                width: "100%",
                background: "rgba(97, 218, 251, 0.5)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($405cd1e8d4fca9e5$exports))).projectContainer,
                    children: (0, $9a7060677ec4f9a5$export$db29154b08c82b55).map((item, index)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("a", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($405cd1e8d4fca9e5$exports))).projectCard,
                            href: item.link,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($405cd1e8d4fca9e5$exports))).projectImage,
                                    src: item.image,
                                    alt: `${item.title} project preview`,
                                    loading: "lazy"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($405cd1e8d4fca9e5$exports))).cardTextBox,
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($405cd1e8d4fca9e5$exports))).cardTitle,
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($405cd1e8d4fca9e5$exports))).cardText,
                                            children: item.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($405cd1e8d4fca9e5$exports))).numberCardContainer,
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($405cd1e8d4fca9e5$exports))).numberCard,
                                            children: [
                                                "0",
                                                index + 1
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($405cd1e8d4fca9e5$exports))).verticalLine
                                        })
                                    ]
                                })
                            ]
                        }, item.id))
                })
            })
        ]
    });
};
var $8442607dbd2ccb09$export$2e2bcd8739ae039 = $8442607dbd2ccb09$var$PetProjects;


// modules

parcelRequire("6cds3");


// modules



var $6cds3 = parcelRequire("6cds3");

const $e2d127ce7abdc63d$var$transitionPages = (Component, transitionColor = "#03aaf1")=>{
    const Page = ()=>{
        // false while the page is leaving, this is when the "slide-in" cover closes the screen
        const isPresent = (0, $35c3ca91a4fc3062$export$8249053f690ea39a)();
        const [entered, setEntered] = (0, $6cds3.useState)(false);
        // A cover is rendered only while it moves: Safari tints its top and bottom
        // bars with the color of fixed elements that stay at the screen edges.
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {}),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                    className: "slide-in",
                    style: {
                        display: isPresent ? "none" : "block"
                    },
                    initial: {
                        scaleY: 0,
                        background: transitionColor
                    },
                    animate: {
                        scaleY: 0
                    },
                    exit: {
                        scaleY: 1
                    },
                    transition: {
                        duration: 1,
                        ease: [
                            0.22,
                            1,
                            0.35,
                            1
                        ]
                    }
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                    className: "slide-out",
                    style: {
                        display: entered ? "none" : "block"
                    },
                    initial: {
                        scaleY: 1,
                        background: transitionColor
                    },
                    animate: {
                        scaleY: 0
                    },
                    exit: {
                        scaleY: 0
                    },
                    transition: {
                        duration: 1,
                        ease: [
                            0.22,
                            1,
                            0.35,
                            1
                        ]
                    },
                    onAnimationComplete: ()=>setEntered(true)
                })
            ]
        });
    };
    return Page;
};
var $e2d127ce7abdc63d$export$2e2bcd8739ae039 = $e2d127ce7abdc63d$var$transitionPages;


// modules

var $6cds3 = parcelRequire("6cds3");
const $41071ce0bf3fff43$export$c2c6cc04189e2ea6 = (title, description)=>{
    (0, $6cds3.useEffect)(()=>{
        var _document_querySelector;
        document.title = title;
        (_document_querySelector = document.querySelector('meta[name="description"]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.setAttribute("content", description);
    }, [
        title,
        description
    ]);
};


const $c1b4d20b5a3b9149$var$MainScreen = ()=>{
    (0, $41071ce0bf3fff43$export$c2c6cc04189e2ea6)("Vlad Khrushchov \u2014 Full-Stack Developer", "Vlad Khrushchov \u2014 Full-Stack Developer (React Native, NestJS). Mobile apps, admin panels, backend.");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d1852bbe54d44f24$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fc8192a66e628ce6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8442607dbd2ccb09$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e3ea40068f29db1a$export$2e2bcd8739ae039), {})
        ]
    });
};
var $c1b4d20b5a3b9149$export$2e2bcd8739ae039 = (0, $e2d127ce7abdc63d$export$2e2bcd8739ae039)($c1b4d20b5a3b9149$var$MainScreen);


// modules


var $6cds3 = parcelRequire("6cds3");







var $ce07876e980830cc$exports = {};

$parcel$export($ce07876e980830cc$exports, "aboutGlow", function () { return $ce07876e980830cc$export$c4ab985f35c8fb92; }, function (v) { return $ce07876e980830cc$export$c4ab985f35c8fb92 = v; });
$parcel$export($ce07876e980830cc$exports, "aboutNotch", function () { return $ce07876e980830cc$export$af24eced8c29b1e1; }, function (v) { return $ce07876e980830cc$export$af24eced8c29b1e1 = v; });
$parcel$export($ce07876e980830cc$exports, "aboutPhone", function () { return $ce07876e980830cc$export$f2612e3e51238ec0; }, function (v) { return $ce07876e980830cc$export$f2612e3e51238ec0 = v; });
$parcel$export($ce07876e980830cc$exports, "aboutScreen", function () { return $ce07876e980830cc$export$805539a8f9c62752; }, function (v) { return $ce07876e980830cc$export$805539a8f9c62752 = v; });
$parcel$export($ce07876e980830cc$exports, "aboutStage", function () { return $ce07876e980830cc$export$807f98b30b38f59a; }, function (v) { return $ce07876e980830cc$export$807f98b30b38f59a = v; });
$parcel$export($ce07876e980830cc$exports, "aboutTag", function () { return $ce07876e980830cc$export$c115485119910444; }, function (v) { return $ce07876e980830cc$export$c115485119910444 = v; });
$parcel$export($ce07876e980830cc$exports, "aboutTag1", function () { return $ce07876e980830cc$export$e1b57b9301200117; }, function (v) { return $ce07876e980830cc$export$e1b57b9301200117 = v; });
$parcel$export($ce07876e980830cc$exports, "aboutTag2", function () { return $ce07876e980830cc$export$9ff3bb7da8d51471; }, function (v) { return $ce07876e980830cc$export$9ff3bb7da8d51471 = v; });
$parcel$export($ce07876e980830cc$exports, "aboutTag3", function () { return $ce07876e980830cc$export$31cf8c2b5fa85333; }, function (v) { return $ce07876e980830cc$export$31cf8c2b5fa85333 = v; });
$parcel$export($ce07876e980830cc$exports, "container", function () { return $ce07876e980830cc$export$34e0f9847d4c02dd; }, function (v) { return $ce07876e980830cc$export$34e0f9847d4c02dd = v; });
$parcel$export($ce07876e980830cc$exports, "description", function () { return $ce07876e980830cc$export$6d59db4903f20f7d; }, function (v) { return $ce07876e980830cc$export$6d59db4903f20f7d = v; });
$parcel$export($ce07876e980830cc$exports, "heroBg", function () { return $ce07876e980830cc$export$513ddc224ccfb871; }, function (v) { return $ce07876e980830cc$export$513ddc224ccfb871 = v; });
$parcel$export($ce07876e980830cc$exports, "heroChip", function () { return $ce07876e980830cc$export$d2986c5ff6581bb2; }, function (v) { return $ce07876e980830cc$export$d2986c5ff6581bb2 = v; });
$parcel$export($ce07876e980830cc$exports, "heroFade", function () { return $ce07876e980830cc$export$18d46c9843cd5809; }, function (v) { return $ce07876e980830cc$export$18d46c9843cd5809 = v; });
$parcel$export($ce07876e980830cc$exports, "heroNotch", function () { return $ce07876e980830cc$export$6c2ff4ccc5bc5a49; }, function (v) { return $ce07876e980830cc$export$6c2ff4ccc5bc5a49 = v; });
$parcel$export($ce07876e980830cc$exports, "heroPhone", function () { return $ce07876e980830cc$export$152c94fb6e056f3b; }, function (v) { return $ce07876e980830cc$export$152c94fb6e056f3b = v; });
$parcel$export($ce07876e980830cc$exports, "heroPhoneGlow", function () { return $ce07876e980830cc$export$e1500f2d017a84bf; }, function (v) { return $ce07876e980830cc$export$e1500f2d017a84bf = v; });
$parcel$export($ce07876e980830cc$exports, "heroPhoneMob", function () { return $ce07876e980830cc$export$1530f4665174f6ef; }, function (v) { return $ce07876e980830cc$export$1530f4665174f6ef = v; });
$parcel$export($ce07876e980830cc$exports, "heroScreen", function () { return $ce07876e980830cc$export$2adaa127afadd617; }, function (v) { return $ce07876e980830cc$export$2adaa127afadd617 = v; });
$parcel$export($ce07876e980830cc$exports, "heroSvg", function () { return $ce07876e980830cc$export$87fa8c1411fa2c3f; }, function (v) { return $ce07876e980830cc$export$87fa8c1411fa2c3f = v; });
$parcel$export($ce07876e980830cc$exports, "title", function () { return $ce07876e980830cc$export$fb184b623420d9be; }, function (v) { return $ce07876e980830cc$export$fb184b623420d9be = v; });
$parcel$export($ce07876e980830cc$exports, "titleContainer", function () { return $ce07876e980830cc$export$12948adc4d562794; }, function (v) { return $ce07876e980830cc$export$12948adc4d562794 = v; });
$parcel$export($ce07876e980830cc$exports, "titleContainerMob", function () { return $ce07876e980830cc$export$585ecab085bb38c4; }, function (v) { return $ce07876e980830cc$export$585ecab085bb38c4 = v; });
$parcel$export($ce07876e980830cc$exports, "titleContent", function () { return $ce07876e980830cc$export$ba223a368a14c1f2; }, function (v) { return $ce07876e980830cc$export$ba223a368a14c1f2 = v; });
$parcel$export($ce07876e980830cc$exports, "titleContentMob", function () { return $ce07876e980830cc$export$69a1cb60fd2c48d1; }, function (v) { return $ce07876e980830cc$export$69a1cb60fd2c48d1 = v; });
$parcel$export($ce07876e980830cc$exports, "workDescription", function () { return $ce07876e980830cc$export$128b5cd702dd1d8f; }, function (v) { return $ce07876e980830cc$export$128b5cd702dd1d8f = v; });
$parcel$export($ce07876e980830cc$exports, "workDescriptionBox", function () { return $ce07876e980830cc$export$f7d6624d2b150835; }, function (v) { return $ce07876e980830cc$export$f7d6624d2b150835 = v; });
var $ce07876e980830cc$export$c4ab985f35c8fb92;
var $ce07876e980830cc$export$af24eced8c29b1e1;
var $ce07876e980830cc$export$f2612e3e51238ec0;
var $ce07876e980830cc$export$805539a8f9c62752;
var $ce07876e980830cc$export$807f98b30b38f59a;
var $ce07876e980830cc$export$c115485119910444;
var $ce07876e980830cc$export$e1b57b9301200117;
var $ce07876e980830cc$export$9ff3bb7da8d51471;
var $ce07876e980830cc$export$31cf8c2b5fa85333;
var $ce07876e980830cc$export$34e0f9847d4c02dd;
var $ce07876e980830cc$export$6d59db4903f20f7d;
var $ce07876e980830cc$export$513ddc224ccfb871;
var $ce07876e980830cc$export$d2986c5ff6581bb2;
var $ce07876e980830cc$export$18d46c9843cd5809;
var $ce07876e980830cc$export$6c2ff4ccc5bc5a49;
var $ce07876e980830cc$export$152c94fb6e056f3b;
var $ce07876e980830cc$export$e1500f2d017a84bf;
var $ce07876e980830cc$export$1530f4665174f6ef;
var $ce07876e980830cc$export$2adaa127afadd617;
var $ce07876e980830cc$export$87fa8c1411fa2c3f;
var $ce07876e980830cc$export$fb184b623420d9be;
var $ce07876e980830cc$export$12948adc4d562794;
var $ce07876e980830cc$export$585ecab085bb38c4;
var $ce07876e980830cc$export$ba223a368a14c1f2;
var $ce07876e980830cc$export$69a1cb60fd2c48d1;
var $ce07876e980830cc$export$128b5cd702dd1d8f;
var $ce07876e980830cc$export$f7d6624d2b150835;
$ce07876e980830cc$export$c4ab985f35c8fb92 = `r4hfga_aboutGlow`;
$ce07876e980830cc$export$af24eced8c29b1e1 = `r4hfga_aboutNotch`;
$ce07876e980830cc$export$f2612e3e51238ec0 = `r4hfga_aboutPhone`;
$ce07876e980830cc$export$805539a8f9c62752 = `r4hfga_aboutScreen`;
$ce07876e980830cc$export$807f98b30b38f59a = `r4hfga_aboutStage`;
$ce07876e980830cc$export$c115485119910444 = `r4hfga_aboutTag`;
$ce07876e980830cc$export$e1b57b9301200117 = `r4hfga_aboutTag1`;
$ce07876e980830cc$export$9ff3bb7da8d51471 = `r4hfga_aboutTag2`;
$ce07876e980830cc$export$31cf8c2b5fa85333 = `r4hfga_aboutTag3`;
$ce07876e980830cc$export$34e0f9847d4c02dd = `r4hfga_container`;
$ce07876e980830cc$export$6d59db4903f20f7d = `r4hfga_description`;
$ce07876e980830cc$export$513ddc224ccfb871 = `r4hfga_heroBg`;
$ce07876e980830cc$export$d2986c5ff6581bb2 = `r4hfga_heroChip`;
$ce07876e980830cc$export$18d46c9843cd5809 = `r4hfga_heroFade`;
$ce07876e980830cc$export$6c2ff4ccc5bc5a49 = `r4hfga_heroNotch`;
$ce07876e980830cc$export$152c94fb6e056f3b = `r4hfga_heroPhone`;
$ce07876e980830cc$export$e1500f2d017a84bf = `r4hfga_heroPhoneGlow`;
$ce07876e980830cc$export$1530f4665174f6ef = `r4hfga_heroPhoneMob`;
$ce07876e980830cc$export$2adaa127afadd617 = `r4hfga_heroScreen`;
$ce07876e980830cc$export$87fa8c1411fa2c3f = `r4hfga_heroSvg`;
$ce07876e980830cc$export$fb184b623420d9be = `r4hfga_title`;
$ce07876e980830cc$export$12948adc4d562794 = `r4hfga_titleContainer`;
$ce07876e980830cc$export$585ecab085bb38c4 = `r4hfga_titleContainerMob`;
$ce07876e980830cc$export$ba223a368a14c1f2 = `r4hfga_titleContent`;
$ce07876e980830cc$export$69a1cb60fd2c48d1 = `r4hfga_titleContentMob`;
$ce07876e980830cc$export$128b5cd702dd1d8f = `r4hfga_workDescription`;
$ce07876e980830cc$export$f7d6624d2b150835 = `r4hfga_workDescriptionBox`;



parcelRequire("6cds3");

const $0d55b7f57b49e4c1$var$L = "#cdeb00";
const $0d55b7f57b49e4c1$var$W = "#ffffff";
const $0d55b7f57b49e4c1$var$streaks = [
    [
        -300,
        70,
        300,
        7,
        $0d55b7f57b49e4c1$var$L,
        0.9
    ],
    [
        120,
        70,
        150,
        4,
        $0d55b7f57b49e4c1$var$W,
        0.5
    ],
    [
        560,
        66,
        430,
        9,
        $0d55b7f57b49e4c1$var$L,
        0.5
    ],
    [
        1060,
        72,
        240,
        3,
        $0d55b7f57b49e4c1$var$W,
        0.25
    ],
    [
        -160,
        150,
        200,
        4,
        $0d55b7f57b49e4c1$var$W,
        0.3
    ],
    [
        260,
        146,
        560,
        9,
        $0d55b7f57b49e4c1$var$L,
        0.95
    ],
    [
        900,
        150,
        180,
        5,
        $0d55b7f57b49e4c1$var$W,
        0.55
    ],
    [
        -260,
        250,
        360,
        5,
        $0d55b7f57b49e4c1$var$L,
        0.35
    ],
    [
        430,
        248,
        150,
        4,
        $0d55b7f57b49e4c1$var$W,
        0.4
    ],
    [
        760,
        246,
        520,
        8,
        $0d55b7f57b49e4c1$var$L,
        0.6
    ],
    [
        60,
        330,
        240,
        4,
        $0d55b7f57b49e4c1$var$W,
        0.28
    ],
    [
        470,
        326,
        430,
        8,
        $0d55b7f57b49e4c1$var$L,
        0.85
    ],
    [
        1000,
        330,
        220,
        3,
        $0d55b7f57b49e4c1$var$W,
        0.22
    ],
    [
        -200,
        430,
        330,
        6,
        $0d55b7f57b49e4c1$var$L,
        0.5
    ],
    [
        300,
        432,
        180,
        4,
        $0d55b7f57b49e4c1$var$W,
        0.35
    ],
    [
        720,
        428,
        360,
        6,
        $0d55b7f57b49e4c1$var$L,
        0.7
    ],
    [
        120,
        520,
        480,
        8,
        $0d55b7f57b49e4c1$var$L,
        0.9
    ],
    [
        760,
        524,
        200,
        4,
        $0d55b7f57b49e4c1$var$W,
        0.4
    ],
    [
        -120,
        600,
        300,
        5,
        $0d55b7f57b49e4c1$var$L,
        0.4
    ],
    [
        420,
        606,
        260,
        5,
        $0d55b7f57b49e4c1$var$W,
        0.28
    ]
];
const $0d55b7f57b49e4c1$var$HeroBackground = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).heroBg,
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).heroSvg,
                viewBox: "0 0 1280 720",
                preserveAspectRatio: "xMidYMid slice",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("radialGradient", {
                            id: "idGlow",
                            cx: "50%",
                            cy: "50%",
                            r: "50%",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                    offset: "0",
                                    stopColor: "#cdeb00",
                                    stopOpacity: "0.4"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#cdeb00",
                                    stopOpacity: "0"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                        cx: "960",
                        cy: "250",
                        r: "320",
                        fill: "url(#idGlow)"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                        cx: "220",
                        cy: "560",
                        r: "240",
                        fill: "url(#idGlow)"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                        transform: "rotate(-29 640 360)",
                        children: $0d55b7f57b49e4c1$var$streaks.map(([x, y, w, h, fill, opacity], i)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                                x: x,
                                y: y,
                                width: w,
                                height: h,
                                rx: h / 2,
                                fill: fill,
                                opacity: opacity
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).heroFade
            })
        ]
    });
var $0d55b7f57b49e4c1$export$2e2bcd8739ae039 = $0d55b7f57b49e4c1$var$HeroBackground;



parcelRequire("6cds3");

const $da84bf9eb001f7c3$var$BookIcon = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "none",
        stroke: "#5b7a00",
        strokeWidth: "1.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M4 4h9a3 3 0 0 1 3 3v13a2 2 0 0 0-2-2H4z"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M20 4h-3a3 3 0 0 0-3 3v13a2 2 0 0 1 2-2h4z"
            })
        ]
    });
const $da84bf9eb001f7c3$var$CheckIcon = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "none",
        stroke: "#5b7a00",
        strokeWidth: "1.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M9 11l3 3L22 4"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
            })
        ]
    });
const $da84bf9eb001f7c3$var$BoltIcon = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "none",
        stroke: "#5b7a00",
        strokeWidth: "1.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M13 2 3 14h7l-1 8 10-12h-7z"
        })
    });

const $da84bf9eb001f7c3$var$AboutVisual = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).aboutStage,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).aboutGlow
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).aboutPhone,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).aboutScreen,
                    src: (parcelRequire("hAyS5")),
                    alt: "IDriver home screen"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).aboutTag} ${(0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).aboutTag1}`,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($da84bf9eb001f7c3$var$BookIcon, {}),
                    "Theory + practice"
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).aboutTag} ${(0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).aboutTag2}`,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($da84bf9eb001f7c3$var$CheckIcon, {}),
                    "PDR mock tests"
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).aboutTag} ${(0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).aboutTag3}`,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($da84bf9eb001f7c3$var$BoltIcon, {}),
                    "Daily plan"
                ]
            })
        ]
    });
var $da84bf9eb001f7c3$export$2e2bcd8739ae039 = $da84bf9eb001f7c3$var$AboutVisual;



// types
const $83979233edb6f6de$export$607df5adff94a460 = [
    {
        id: 12,
        color: "#0179CF",
        name: "blue1"
    },
    {
        id: 32,
        color: "#200CBE",
        name: "blue2"
    },
    {
        id: 2,
        color: "#90D1FF",
        name: "blue_light"
    },
    {
        id: 92,
        color: "#ACAAA9",
        name: "gray1_40"
    },
    {
        id: 82,
        color: "#94C3E4",
        name: "blue1_40"
    }
];
const $83979233edb6f6de$export$df2742d523d96e2a = [
    {
        id: 12,
        color: "#030D22",
        name: "dark"
    },
    {
        id: 32,
        color: "#1F2AD1",
        name: "blue1"
    },
    {
        id: 2,
        color: "#560DAA",
        name: "purple"
    },
    {
        id: 92,
        color: "#1E34E1",
        name: "blue2"
    },
    {
        id: 82,
        color: "#E545B2",
        name: "pink"
    }
];
const $83979233edb6f6de$export$13a18bddafdb12e9 = [
    {
        id: 12,
        color: "#CDEB00",
        name: "Lime"
    },
    {
        id: 32,
        color: "#0E0F12",
        name: "Black"
    },
    {
        id: 2,
        color: "#20222A",
        name: "Graphite"
    },
    {
        id: 92,
        color: "#94AF00",
        name: "Deep lime"
    },
    {
        id: 82,
        color: "#EDEDED",
        name: "White"
    }
];
const $83979233edb6f6de$export$5c1840a3692fb7f0 = [
    {
        id: 12,
        color: "#4C6EF5",
        name: "Blue"
    },
    {
        id: 32,
        color: "#2B3F9E",
        name: "Deep blue"
    },
    {
        id: 2,
        color: "#8AA4FF",
        name: "Light blue"
    },
    {
        id: 92,
        color: "#0E111A",
        name: "Dark"
    },
    {
        id: 82,
        color: "#C7D2F5",
        name: "Pale blue"
    }
];
const $83979233edb6f6de$export$fd07a6ae12df212a = [
    {
        id: 12,
        color: "#B88AFE",
        name: "Purple"
    },
    {
        id: 32,
        color: "#7D40DB",
        name: "Deep purple"
    },
    {
        id: 2,
        color: "#FE8A96",
        name: "Red"
    },
    {
        id: 92,
        color: "#94DF21",
        name: "Green"
    },
    {
        id: 82,
        color: "#322F35",
        name: "Gray"
    }
];




const $15119af130913117$var$IDriverCase = ()=>{
    const [active, setActive] = (0, $6cds3.useState)(false);
    const [workModal, setWorkModal] = (0, $6cds3.useState)(false);
    const navigation = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const isMobile = (0, $8a086d95af0c9c00$exports.useMediaQuery)({
        query: "(max-width: 1200px)"
    });
    const scrollToTop = ()=>{
        (0, $1d42a532dd4f25d5$exports.animateScroll).scrollToTop();
    };
    (0, $41071ce0bf3fff43$export$c2c6cc04189e2ea6)("IDriver case study \u2014 Vlad Khrushchov", "IDriver (\u042F\u0412\u043E\u0434\u0456\u0439): a React Native app and NestJS backend for learning Ukrainian traffic rules. Payments, real-time features and security.");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).container,
                id: "#idriver",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4eb7dc37af125249$export$2e2bcd8739ae039), {
                        setModal: setActive,
                        setWorkModal: setWorkModal,
                        alternative: true,
                        data: (0, $b5d47c2f6a1fbb71$export$1c6d320eca5f475),
                        navigation: navigation
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).titleContainerMob : (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).titleContainer,
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0d55b7f57b49e4c1$export$2e2bcd8739ae039), {}),
                            !isMobile && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).heroPhoneGlow
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).titleContentMob : (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).titleContent,
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).title,
                                        children: "IDriver"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9cb2eb5a2afb4e3f$export$2e2bcd8739ae039), {
                                        text: "\u042F\u0412\u043E\u0434\u0456\u0439 \xb7 learn Ukrainian traffic rules",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).description
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).heroChip,
                                        children: "React Native \xb7 NestJS \xb7 Full-Stack"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).heroPhoneMob : (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).heroPhone,
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).heroScreen,
                                    src: (parcelRequire("69Rxo")),
                                    alt: "IDriver welcome screen"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).workDescriptionBox,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0b62aa8cd3e21a28$export$2e2bcd8739ae039), {
                            context: "Driving-theory app",
                            role: "Full-Stack Developer",
                            period: "April 2026 - Present",
                            titleColor: "#cdeb00"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $097e928218dfebc5$export$2e2bcd8739ae039), {
                        title: "Introduction",
                        description: "Lead Full-Stack developer of IDriver (\u042F\u0412\u043E\u0434\u0456\u0439), a mobile app for learning Ukrainian traffic rules (\u041F\u0414\u0420).\nBuilt both the React Native app and the NestJS / TypeORM backend \u2014 including payments (RevenueCat), real-time features (WebSocket) and application security.\nThe app is already live on the App Store and Google Play.",
                        link: "https://idriver.ai"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2473041a92174530$export$2e2bcd8739ae039), {
                        title: "Mobile app, admin panel and backend.",
                        visual: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $da84bf9eb001f7c3$export$2e2bcd8739ae039), {}),
                        data: (0, $83979233edb6f6de$export$13a18bddafdb12e9),
                        background: "#f4f5f3",
                        description: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ce07876e980830cc$exports))).workDescription,
                            children: [
                                "Served as the ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "lead Full-Stack developer"
                                }),
                                ". For about a month I worked as part of a two-person team, after which I became the ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "sole developer"
                                }),
                                ". I developed both the",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "frontend"
                                }),
                                " (admin panel and React Native app) and the",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "backend"
                                }),
                                " (NestJS and TypeORM).",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                "Developed a ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "card game from scratch"
                                }),
                                ", integrated",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "Cloudflare"
                                }),
                                ", secured the payment process, implemented",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "rate limiting"
                                }),
                                ", and enhanced the application's overall",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "security"
                                }),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $df07ea70fb26ed48$export$2e2bcd8739ae039), {
                        active: active,
                        setActive: setActive
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9ca92ffcb8ea5b15$export$2e2bcd8739ae039), {
                nextProjectName: "Voice Notes",
                href: "/voiceNotes",
                onClick: (e)=>(0, $35f54a4218b84ba5$export$13aea1a3cb5e3f1f)(e, navigation, "/voiceNotes"),
                overlayColor: "#cdeb00"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e39d7a1997c3ede8$export$2e2bcd8739ae039), {
                data: (0, $e620f929d587f27c$export$cf42e9e39aa444e0),
                active: workModal,
                setActive: setWorkModal
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e3ea40068f29db1a$export$2e2bcd8739ae039), {
                onLinkPress: scrollToTop
            })
        ]
    });
};
var $15119af130913117$export$2e2bcd8739ae039 = (0, $e2d127ce7abdc63d$export$2e2bcd8739ae039)($15119af130913117$var$IDriverCase);


// modules


var $6cds3 = parcelRequire("6cds3");




var $d855b660acf84bf8$exports = {};

$parcel$export($d855b660acf84bf8$exports, "aboutGlow", function () { return $d855b660acf84bf8$export$c4ab985f35c8fb92; }, function (v) { return $d855b660acf84bf8$export$c4ab985f35c8fb92 = v; });
$parcel$export($d855b660acf84bf8$exports, "aboutNotch", function () { return $d855b660acf84bf8$export$af24eced8c29b1e1; }, function (v) { return $d855b660acf84bf8$export$af24eced8c29b1e1 = v; });
$parcel$export($d855b660acf84bf8$exports, "aboutPhone", function () { return $d855b660acf84bf8$export$f2612e3e51238ec0; }, function (v) { return $d855b660acf84bf8$export$f2612e3e51238ec0 = v; });
$parcel$export($d855b660acf84bf8$exports, "aboutScreen", function () { return $d855b660acf84bf8$export$805539a8f9c62752; }, function (v) { return $d855b660acf84bf8$export$805539a8f9c62752 = v; });
$parcel$export($d855b660acf84bf8$exports, "aboutStage", function () { return $d855b660acf84bf8$export$807f98b30b38f59a; }, function (v) { return $d855b660acf84bf8$export$807f98b30b38f59a = v; });
$parcel$export($d855b660acf84bf8$exports, "aboutTag", function () { return $d855b660acf84bf8$export$c115485119910444; }, function (v) { return $d855b660acf84bf8$export$c115485119910444 = v; });
$parcel$export($d855b660acf84bf8$exports, "aboutTag1", function () { return $d855b660acf84bf8$export$e1b57b9301200117; }, function (v) { return $d855b660acf84bf8$export$e1b57b9301200117 = v; });
$parcel$export($d855b660acf84bf8$exports, "aboutTag2", function () { return $d855b660acf84bf8$export$9ff3bb7da8d51471; }, function (v) { return $d855b660acf84bf8$export$9ff3bb7da8d51471 = v; });
$parcel$export($d855b660acf84bf8$exports, "aboutTag3", function () { return $d855b660acf84bf8$export$31cf8c2b5fa85333; }, function (v) { return $d855b660acf84bf8$export$31cf8c2b5fa85333 = v; });
$parcel$export($d855b660acf84bf8$exports, "container", function () { return $d855b660acf84bf8$export$34e0f9847d4c02dd; }, function (v) { return $d855b660acf84bf8$export$34e0f9847d4c02dd = v; });
$parcel$export($d855b660acf84bf8$exports, "description", function () { return $d855b660acf84bf8$export$6d59db4903f20f7d; }, function (v) { return $d855b660acf84bf8$export$6d59db4903f20f7d = v; });
$parcel$export($d855b660acf84bf8$exports, "glassChart", function () { return $d855b660acf84bf8$export$3b2ef425b6f7ba18; }, function (v) { return $d855b660acf84bf8$export$3b2ef425b6f7ba18 = v; });
$parcel$export($d855b660acf84bf8$exports, "glassChat", function () { return $d855b660acf84bf8$export$3de16cf8cb2594f2; }, function (v) { return $d855b660acf84bf8$export$3de16cf8cb2594f2 = v; });
$parcel$export($d855b660acf84bf8$exports, "glassIcon", function () { return $d855b660acf84bf8$export$76bded260fedda; }, function (v) { return $d855b660acf84bf8$export$76bded260fedda = v; });
$parcel$export($d855b660acf84bf8$exports, "glassLock", function () { return $d855b660acf84bf8$export$370c32389ac6f902; }, function (v) { return $d855b660acf84bf8$export$370c32389ac6f902 = v; });
$parcel$export($d855b660acf84bf8$exports, "glassMic", function () { return $d855b660acf84bf8$export$7684f14e32906118; }, function (v) { return $d855b660acf84bf8$export$7684f14e32906118 = v; });
$parcel$export($d855b660acf84bf8$exports, "glassUser", function () { return $d855b660acf84bf8$export$870aadea09e8563b; }, function (v) { return $d855b660acf84bf8$export$870aadea09e8563b = v; });
$parcel$export($d855b660acf84bf8$exports, "heroAsset", function () { return $d855b660acf84bf8$export$515749fdd80c7146; }, function (v) { return $d855b660acf84bf8$export$515749fdd80c7146 = v; });
$parcel$export($d855b660acf84bf8$exports, "heroAssetBoxMob", function () { return $d855b660acf84bf8$export$423e5d56bc27b9c3; }, function (v) { return $d855b660acf84bf8$export$423e5d56bc27b9c3 = v; });
$parcel$export($d855b660acf84bf8$exports, "heroAssetMob", function () { return $d855b660acf84bf8$export$dcd4d109e5264640; }, function (v) { return $d855b660acf84bf8$export$dcd4d109e5264640 = v; });
$parcel$export($d855b660acf84bf8$exports, "heroBg", function () { return $d855b660acf84bf8$export$513ddc224ccfb871; }, function (v) { return $d855b660acf84bf8$export$513ddc224ccfb871 = v; });
$parcel$export($d855b660acf84bf8$exports, "heroFade", function () { return $d855b660acf84bf8$export$18d46c9843cd5809; }, function (v) { return $d855b660acf84bf8$export$18d46c9843cd5809 = v; });
$parcel$export($d855b660acf84bf8$exports, "heroSvg", function () { return $d855b660acf84bf8$export$87fa8c1411fa2c3f; }, function (v) { return $d855b660acf84bf8$export$87fa8c1411fa2c3f = v; });
$parcel$export($d855b660acf84bf8$exports, "macImg", function () { return $d855b660acf84bf8$export$6a5f6378c1bdc357; }, function (v) { return $d855b660acf84bf8$export$6a5f6378c1bdc357 = v; });
$parcel$export($d855b660acf84bf8$exports, "title", function () { return $d855b660acf84bf8$export$fb184b623420d9be; }, function (v) { return $d855b660acf84bf8$export$fb184b623420d9be = v; });
$parcel$export($d855b660acf84bf8$exports, "titleContainer", function () { return $d855b660acf84bf8$export$12948adc4d562794; }, function (v) { return $d855b660acf84bf8$export$12948adc4d562794 = v; });
$parcel$export($d855b660acf84bf8$exports, "titleContainerMob", function () { return $d855b660acf84bf8$export$585ecab085bb38c4; }, function (v) { return $d855b660acf84bf8$export$585ecab085bb38c4 = v; });
$parcel$export($d855b660acf84bf8$exports, "titleContent", function () { return $d855b660acf84bf8$export$ba223a368a14c1f2; }, function (v) { return $d855b660acf84bf8$export$ba223a368a14c1f2 = v; });
$parcel$export($d855b660acf84bf8$exports, "titleContentMob", function () { return $d855b660acf84bf8$export$69a1cb60fd2c48d1; }, function (v) { return $d855b660acf84bf8$export$69a1cb60fd2c48d1 = v; });
$parcel$export($d855b660acf84bf8$exports, "workDescription", function () { return $d855b660acf84bf8$export$128b5cd702dd1d8f; }, function (v) { return $d855b660acf84bf8$export$128b5cd702dd1d8f = v; });
$parcel$export($d855b660acf84bf8$exports, "workDescriptionBox", function () { return $d855b660acf84bf8$export$f7d6624d2b150835; }, function (v) { return $d855b660acf84bf8$export$f7d6624d2b150835 = v; });
var $d855b660acf84bf8$export$c4ab985f35c8fb92;
var $d855b660acf84bf8$export$af24eced8c29b1e1;
var $d855b660acf84bf8$export$f2612e3e51238ec0;
var $d855b660acf84bf8$export$805539a8f9c62752;
var $d855b660acf84bf8$export$807f98b30b38f59a;
var $d855b660acf84bf8$export$c115485119910444;
var $d855b660acf84bf8$export$e1b57b9301200117;
var $d855b660acf84bf8$export$9ff3bb7da8d51471;
var $d855b660acf84bf8$export$31cf8c2b5fa85333;
var $d855b660acf84bf8$export$34e0f9847d4c02dd;
var $d855b660acf84bf8$export$6d59db4903f20f7d;
var $d855b660acf84bf8$export$3b2ef425b6f7ba18;
var $d855b660acf84bf8$export$3de16cf8cb2594f2;
var $d855b660acf84bf8$export$76bded260fedda;
var $d855b660acf84bf8$export$370c32389ac6f902;
var $d855b660acf84bf8$export$7684f14e32906118;
var $d855b660acf84bf8$export$870aadea09e8563b;
var $d855b660acf84bf8$export$515749fdd80c7146;
var $d855b660acf84bf8$export$423e5d56bc27b9c3;
var $d855b660acf84bf8$export$dcd4d109e5264640;
var $d855b660acf84bf8$export$513ddc224ccfb871;
var $d855b660acf84bf8$export$18d46c9843cd5809;
var $d855b660acf84bf8$export$87fa8c1411fa2c3f;
var $d855b660acf84bf8$export$6a5f6378c1bdc357;
var $d855b660acf84bf8$export$fb184b623420d9be;
var $d855b660acf84bf8$export$12948adc4d562794;
var $d855b660acf84bf8$export$585ecab085bb38c4;
var $d855b660acf84bf8$export$ba223a368a14c1f2;
var $d855b660acf84bf8$export$69a1cb60fd2c48d1;
var $d855b660acf84bf8$export$128b5cd702dd1d8f;
var $d855b660acf84bf8$export$f7d6624d2b150835;
$d855b660acf84bf8$export$c4ab985f35c8fb92 = `jfrBrW_aboutGlow`;
$d855b660acf84bf8$export$af24eced8c29b1e1 = `jfrBrW_aboutNotch`;
$d855b660acf84bf8$export$f2612e3e51238ec0 = `jfrBrW_aboutPhone`;
$d855b660acf84bf8$export$805539a8f9c62752 = `jfrBrW_aboutScreen`;
$d855b660acf84bf8$export$807f98b30b38f59a = `jfrBrW_aboutStage`;
$d855b660acf84bf8$export$c115485119910444 = `jfrBrW_aboutTag`;
$d855b660acf84bf8$export$e1b57b9301200117 = `jfrBrW_aboutTag1`;
$d855b660acf84bf8$export$9ff3bb7da8d51471 = `jfrBrW_aboutTag2`;
$d855b660acf84bf8$export$31cf8c2b5fa85333 = `jfrBrW_aboutTag3`;
$d855b660acf84bf8$export$34e0f9847d4c02dd = `jfrBrW_container`;
$d855b660acf84bf8$export$6d59db4903f20f7d = `jfrBrW_description`;
$d855b660acf84bf8$export$3b2ef425b6f7ba18 = `jfrBrW_glassChart`;
$d855b660acf84bf8$export$3de16cf8cb2594f2 = `jfrBrW_glassChat`;
$d855b660acf84bf8$export$76bded260fedda = `jfrBrW_glassIcon`;
$d855b660acf84bf8$export$370c32389ac6f902 = `jfrBrW_glassLock`;
$d855b660acf84bf8$export$7684f14e32906118 = `jfrBrW_glassMic`;
$d855b660acf84bf8$export$870aadea09e8563b = `jfrBrW_glassUser`;
$d855b660acf84bf8$export$515749fdd80c7146 = `jfrBrW_heroAsset`;
$d855b660acf84bf8$export$423e5d56bc27b9c3 = `jfrBrW_heroAssetBoxMob`;
$d855b660acf84bf8$export$dcd4d109e5264640 = `jfrBrW_heroAssetMob`;
$d855b660acf84bf8$export$513ddc224ccfb871 = `jfrBrW_heroBg`;
$d855b660acf84bf8$export$18d46c9843cd5809 = `jfrBrW_heroFade`;
$d855b660acf84bf8$export$87fa8c1411fa2c3f = `jfrBrW_heroSvg`;
$d855b660acf84bf8$export$6a5f6378c1bdc357 = `jfrBrW_macImg`;
$d855b660acf84bf8$export$fb184b623420d9be = `jfrBrW_title`;
$d855b660acf84bf8$export$12948adc4d562794 = `jfrBrW_titleContainer`;
$d855b660acf84bf8$export$585ecab085bb38c4 = `jfrBrW_titleContainerMob`;
$d855b660acf84bf8$export$ba223a368a14c1f2 = `jfrBrW_titleContent`;
$d855b660acf84bf8$export$69a1cb60fd2c48d1 = `jfrBrW_titleContentMob`;
$d855b660acf84bf8$export$128b5cd702dd1d8f = `jfrBrW_workDescription`;
$d855b660acf84bf8$export$f7d6624d2b150835 = `jfrBrW_workDescriptionBox`;



parcelRequire("6cds3");

const $bf763455d001a7fc$var$HeroBackground = ({ floating: floating = true })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).heroBg,
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).heroSvg,
                viewBox: "0 0 1280 720",
                preserveAspectRatio: "xMidYMid slice",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("linearGradient", {
                                id: "vnRibbon",
                                x1: "0",
                                y1: "0",
                                x2: "1",
                                y2: "1",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                        offset: "0",
                                        stopColor: "#3f5fe6"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                        offset: "0.55",
                                        stopColor: "#5b7cf5"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#8aa4ff"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("radialGradient", {
                                id: "vnGlow",
                                cx: "50%",
                                cy: "50%",
                                r: "50%",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                        offset: "0",
                                        stopColor: "#4c6ef5",
                                        stopOpacity: "0.3"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#4c6ef5",
                                        stopOpacity: "0"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                        cx: "300",
                        cy: "520",
                        r: "380",
                        fill: "url(#vnGlow)"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                        cx: "1120",
                        cy: "150",
                        r: "360",
                        fill: "url(#vnGlow)"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                        d: "M-40 300 C 220 160, 340 520, 620 430 S 980 210, 1340 360",
                        fill: "none",
                        stroke: "url(#vnRibbon)",
                        strokeWidth: "34",
                        strokeLinecap: "round",
                        opacity: "0.9"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                        d: "M-40 420 C 260 300, 420 620, 700 500 S 1040 320, 1340 470",
                        fill: "none",
                        stroke: "url(#vnRibbon)",
                        strokeWidth: "14",
                        strokeLinecap: "round",
                        opacity: "0.5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).heroFade
            }),
            floating && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($bf763455d001a7fc$export$34ea0b1adc0a5a7c, {})
        ]
    });
const $bf763455d001a7fc$export$34ea0b1adc0a5a7c = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).glassIcon} ${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).glassChat}`,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
                    viewBox: "0 0 24 24",
                    width: "26",
                    height: "26",
                    fill: "none",
                    stroke: "#dfe6ff",
                    strokeWidth: "1.8",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                        d: "M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).glassIcon} ${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).glassMic}`,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    width: "30",
                    height: "30",
                    fill: "none",
                    stroke: "#dfe6ff",
                    strokeWidth: "1.8",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "9",
                            y: "2",
                            width: "6",
                            height: "12",
                            rx: "3"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            d: "M5 10a7 7 0 0 0 14 0M12 17v4"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).glassIcon} ${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).glassLock}`,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    width: "26",
                    height: "26",
                    fill: "none",
                    stroke: "#dfe6ff",
                    strokeWidth: "1.8",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "4",
                            y: "11",
                            width: "16",
                            height: "10",
                            rx: "2"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            d: "M8 11V7a4 4 0 0 1 8 0v4"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).glassIcon} ${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).glassUser}`,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    width: "26",
                    height: "26",
                    fill: "none",
                    stroke: "#dfe6ff",
                    strokeWidth: "1.8",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                            cx: "12",
                            cy: "8",
                            r: "4"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            d: "M4 21a8 8 0 0 1 16 0"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).glassIcon} ${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).glassChart}`,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    width: "26",
                    height: "26",
                    fill: "none",
                    stroke: "#dfe6ff",
                    strokeWidth: "1.8",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            d: "M4 20h16"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            d: "M7 20v-6M12 20V6M17 20v-9"
                        })
                    ]
                })
            })
        ]
    });
var $bf763455d001a7fc$export$2e2bcd8739ae039 = $bf763455d001a7fc$var$HeroBackground;



parcelRequire("6cds3");

const $a4e40c63cbbc8cd3$var$UserIcon = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "none",
        stroke: "#4c6ef5",
        strokeWidth: "1.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "12",
                cy: "8",
                r: "4"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M4 21a8 8 0 0 1 16 0"
            })
        ]
    });
const $a4e40c63cbbc8cd3$var$ChatIcon = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "none",
        stroke: "#4c6ef5",
        strokeWidth: "1.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
        })
    });
const $a4e40c63cbbc8cd3$var$LockIcon = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "none",
        stroke: "#4c6ef5",
        strokeWidth: "1.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "4",
                y: "11",
                width: "16",
                height: "10",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M8 11V7a4 4 0 0 1 8 0v4"
            })
        ]
    });

const $a4e40c63cbbc8cd3$var$AboutVisual = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).aboutStage,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).aboutGlow
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).aboutPhone,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).aboutNotch
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).aboutScreen,
                        src: (parcelRequire("j46sV")),
                        alt: "Voice Notes clients screen"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).aboutTag} ${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).aboutTag1}`,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a4e40c63cbbc8cd3$var$UserIcon, {}),
                    "Client \xb7 Maria"
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).aboutTag} ${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).aboutTag2}`,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a4e40c63cbbc8cd3$var$ChatIcon, {}),
                    "Session note"
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).aboutTag} ${(0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).aboutTag3}`,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a4e40c63cbbc8cd3$var$LockIcon, {}),
                    "Encrypted"
                ]
            })
        ]
    });
var $a4e40c63cbbc8cd3$export$2e2bcd8739ae039 = $a4e40c63cbbc8cd3$var$AboutVisual;









const $45667d844aa0bce5$var$VoiceNotesCase = ()=>{
    const [active, setActive] = (0, $6cds3.useState)(false);
    const [workModal, setWorkModal] = (0, $6cds3.useState)(false);
    const navigation = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const isMobile = (0, $8a086d95af0c9c00$exports.useMediaQuery)({
        query: "(max-width: 1200px)"
    });
    const scrollToTop = ()=>{
        (0, $1d42a532dd4f25d5$exports.animateScroll).scrollToTop();
    };
    (0, $41071ce0bf3fff43$export$c2c6cc04189e2ea6)("Voice Notes case study \u2014 Vlad Khrushchov", "Voice Notes: a CRM app for client records and session notes, built from scratch with React Native CLI and Firebase and released on the App Store.");
    const heroAsset = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
        className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).heroAssetMob : (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).heroAsset,
        src: (parcelRequire("7cPtD")),
        alt: "Voice Notes app"
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).container,
                id: "#voiceNotes",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4eb7dc37af125249$export$2e2bcd8739ae039), {
                        setModal: setActive,
                        setWorkModal: setWorkModal,
                        alternative: true,
                        data: (0, $b5d47c2f6a1fbb71$export$1c6d320eca5f475),
                        navigation: navigation
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).titleContainerMob : (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).titleContainer,
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bf763455d001a7fc$export$2e2bcd8739ae039), {
                                floating: !isMobile
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).titleContentMob : (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).titleContent,
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).title,
                                        children: "Voice Notes"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9cb2eb5a2afb4e3f$export$2e2bcd8739ae039), {
                                        text: "CRM System for small business",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).description
                                    })
                                ]
                            }),
                            isMobile ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).heroAssetBoxMob,
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bf763455d001a7fc$export$34ea0b1adc0a5a7c), {}),
                                    heroAsset
                                ]
                            }) : heroAsset
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).workDescriptionBox,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0b62aa8cd3e21a28$export$2e2bcd8739ae039), {
                            context: "CRM System",
                            role: "React-Native Developer",
                            period: "July 2025 - Present",
                            titleColor: "#00c8e7"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $097e928218dfebc5$export$2e2bcd8739ae039), {
                        title: "Introduction",
                        description: "Co-founder and sole developer of Voice Notes, a CRM system designed for managing client records and session notes.\nBuilt the entire application from scratch using React Native CLI, Firebase, TypeScript, and Zustand.\nSuccessfully launched the first version on the App Store within a short timeframe.",
                        link: "https://apps.apple.com/ua/app/voice-notes-crm-%D0%BF%D1%81%D0%B8%D1%85%D0%BE%D0%BB%D0%BE%D0%B3%D0%B0/id6749210527?l=ru",
                        linkText: "View on the App Store"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2473041a92174530$export$2e2bcd8739ae039), {
                        title: "From first commit to App Store release.",
                        visual: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a4e40c63cbbc8cd3$export$2e2bcd8739ae039), {}),
                        data: (0, $83979233edb6f6de$export$5c1840a3692fb7f0),
                        description: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d855b660acf84bf8$exports))).workDescription,
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "Voice Notes"
                                }),
                                " is an internal CRM system designed to help professionals organize client information and track session notes efficiently.",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "As a co-founder and the sole developer"
                                }),
                                ", I was responsible for implementing the full functionality of the app \u2014 from architecture and development to testing and App Store release.",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                "The project is built with",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "React Native CLI, Firebase Firestore, OneSignal, TypeScript, and Zustand."
                                }),
                                " ",
                                "Our small team consisted of two co-founders and a designer. The initial version was released quickly and is already available on the ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "App Store"
                                }),
                                ", with plans to evolve into a subscription-based product."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $df07ea70fb26ed48$export$2e2bcd8739ae039), {
                        active: active,
                        setActive: setActive
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9ca92ffcb8ea5b15$export$2e2bcd8739ae039), {
                nextProjectName: "Kloki Planner",
                href: "/kloki",
                onClick: (e)=>(0, $35f54a4218b84ba5$export$13aea1a3cb5e3f1f)(e, navigation, "/kloki"),
                overlayColor: "#00c8e7"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e39d7a1997c3ede8$export$2e2bcd8739ae039), {
                data: (0, $e620f929d587f27c$export$cf42e9e39aa444e0),
                active: workModal,
                setActive: setWorkModal
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e3ea40068f29db1a$export$2e2bcd8739ae039), {
                onLinkPress: scrollToTop
            })
        ]
    });
};
var $45667d844aa0bce5$export$2e2bcd8739ae039 = (0, $e2d127ce7abdc63d$export$2e2bcd8739ae039)($45667d844aa0bce5$var$VoiceNotesCase);


// modules


var $6cds3 = parcelRequire("6cds3");










var $bea9cd0eebebb17e$exports = {};

$parcel$export($bea9cd0eebebb17e$exports, "aboutGlow", function () { return $bea9cd0eebebb17e$export$c4ab985f35c8fb92; }, function (v) { return $bea9cd0eebebb17e$export$c4ab985f35c8fb92 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "aboutPhone", function () { return $bea9cd0eebebb17e$export$f2612e3e51238ec0; }, function (v) { return $bea9cd0eebebb17e$export$f2612e3e51238ec0 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "aboutScreen", function () { return $bea9cd0eebebb17e$export$805539a8f9c62752; }, function (v) { return $bea9cd0eebebb17e$export$805539a8f9c62752 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "aboutStage", function () { return $bea9cd0eebebb17e$export$807f98b30b38f59a; }, function (v) { return $bea9cd0eebebb17e$export$807f98b30b38f59a = v; });
$parcel$export($bea9cd0eebebb17e$exports, "aboutTag", function () { return $bea9cd0eebebb17e$export$c115485119910444; }, function (v) { return $bea9cd0eebebb17e$export$c115485119910444 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "aboutTag1", function () { return $bea9cd0eebebb17e$export$e1b57b9301200117; }, function (v) { return $bea9cd0eebebb17e$export$e1b57b9301200117 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "aboutTag2", function () { return $bea9cd0eebebb17e$export$9ff3bb7da8d51471; }, function (v) { return $bea9cd0eebebb17e$export$9ff3bb7da8d51471 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "aboutTag3", function () { return $bea9cd0eebebb17e$export$31cf8c2b5fa85333; }, function (v) { return $bea9cd0eebebb17e$export$31cf8c2b5fa85333 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "checkEmpty", function () { return $bea9cd0eebebb17e$export$356714a797753c3a; }, function (v) { return $bea9cd0eebebb17e$export$356714a797753c3a = v; });
$parcel$export($bea9cd0eebebb17e$exports, "checkGreen", function () { return $bea9cd0eebebb17e$export$94140423b4806d03; }, function (v) { return $bea9cd0eebebb17e$export$94140423b4806d03 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "checkPurple", function () { return $bea9cd0eebebb17e$export$604d776a0af1c0eb; }, function (v) { return $bea9cd0eebebb17e$export$604d776a0af1c0eb = v; });
$parcel$export($bea9cd0eebebb17e$exports, "container", function () { return $bea9cd0eebebb17e$export$34e0f9847d4c02dd; }, function (v) { return $bea9cd0eebebb17e$export$34e0f9847d4c02dd = v; });
$parcel$export($bea9cd0eebebb17e$exports, "description", function () { return $bea9cd0eebebb17e$export$6d59db4903f20f7d; }, function (v) { return $bea9cd0eebebb17e$export$6d59db4903f20f7d = v; });
$parcel$export($bea9cd0eebebb17e$exports, "heroBg", function () { return $bea9cd0eebebb17e$export$513ddc224ccfb871; }, function (v) { return $bea9cd0eebebb17e$export$513ddc224ccfb871 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "heroChip", function () { return $bea9cd0eebebb17e$export$d2986c5ff6581bb2; }, function (v) { return $bea9cd0eebebb17e$export$d2986c5ff6581bb2 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "heroFade", function () { return $bea9cd0eebebb17e$export$18d46c9843cd5809; }, function (v) { return $bea9cd0eebebb17e$export$18d46c9843cd5809 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "heroPhone", function () { return $bea9cd0eebebb17e$export$152c94fb6e056f3b; }, function (v) { return $bea9cd0eebebb17e$export$152c94fb6e056f3b = v; });
$parcel$export($bea9cd0eebebb17e$exports, "heroPhoneBoxMob", function () { return $bea9cd0eebebb17e$export$5601c7c0bf5e624f; }, function (v) { return $bea9cd0eebebb17e$export$5601c7c0bf5e624f = v; });
$parcel$export($bea9cd0eebebb17e$exports, "heroPhoneGlow", function () { return $bea9cd0eebebb17e$export$e1500f2d017a84bf; }, function (v) { return $bea9cd0eebebb17e$export$e1500f2d017a84bf = v; });
$parcel$export($bea9cd0eebebb17e$exports, "heroPhoneMob", function () { return $bea9cd0eebebb17e$export$1530f4665174f6ef; }, function (v) { return $bea9cd0eebebb17e$export$1530f4665174f6ef = v; });
$parcel$export($bea9cd0eebebb17e$exports, "heroScreen", function () { return $bea9cd0eebebb17e$export$2adaa127afadd617; }, function (v) { return $bea9cd0eebebb17e$export$2adaa127afadd617 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "heroSvg", function () { return $bea9cd0eebebb17e$export$87fa8c1411fa2c3f; }, function (v) { return $bea9cd0eebebb17e$export$87fa8c1411fa2c3f = v; });
$parcel$export($bea9cd0eebebb17e$exports, "title", function () { return $bea9cd0eebebb17e$export$fb184b623420d9be; }, function (v) { return $bea9cd0eebebb17e$export$fb184b623420d9be = v; });
$parcel$export($bea9cd0eebebb17e$exports, "titleContainer", function () { return $bea9cd0eebebb17e$export$12948adc4d562794; }, function (v) { return $bea9cd0eebebb17e$export$12948adc4d562794 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "titleContainerMob", function () { return $bea9cd0eebebb17e$export$585ecab085bb38c4; }, function (v) { return $bea9cd0eebebb17e$export$585ecab085bb38c4 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "titleContent", function () { return $bea9cd0eebebb17e$export$ba223a368a14c1f2; }, function (v) { return $bea9cd0eebebb17e$export$ba223a368a14c1f2 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "titleContentMob", function () { return $bea9cd0eebebb17e$export$69a1cb60fd2c48d1; }, function (v) { return $bea9cd0eebebb17e$export$69a1cb60fd2c48d1 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "todo1", function () { return $bea9cd0eebebb17e$export$dd9e13c5d56e1fd3; }, function (v) { return $bea9cd0eebebb17e$export$dd9e13c5d56e1fd3 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "todo2", function () { return $bea9cd0eebebb17e$export$a92f3551f2a686cf; }, function (v) { return $bea9cd0eebebb17e$export$a92f3551f2a686cf = v; });
$parcel$export($bea9cd0eebebb17e$exports, "todo3", function () { return $bea9cd0eebebb17e$export$fe95fc036bfa2e28; }, function (v) { return $bea9cd0eebebb17e$export$fe95fc036bfa2e28 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "todo4", function () { return $bea9cd0eebebb17e$export$a160deeb1de1992; }, function (v) { return $bea9cd0eebebb17e$export$a160deeb1de1992 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "todoCard", function () { return $bea9cd0eebebb17e$export$9feab614391b3884; }, function (v) { return $bea9cd0eebebb17e$export$9feab614391b3884 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "todoCheck", function () { return $bea9cd0eebebb17e$export$fe485f7a1c03bd6f; }, function (v) { return $bea9cd0eebebb17e$export$fe485f7a1c03bd6f = v; });
$parcel$export($bea9cd0eebebb17e$exports, "todoDone", function () { return $bea9cd0eebebb17e$export$b6957c91014a2e57; }, function (v) { return $bea9cd0eebebb17e$export$b6957c91014a2e57 = v; });
$parcel$export($bea9cd0eebebb17e$exports, "todoSub", function () { return $bea9cd0eebebb17e$export$49e8e74be8f9560c; }, function (v) { return $bea9cd0eebebb17e$export$49e8e74be8f9560c = v; });
$parcel$export($bea9cd0eebebb17e$exports, "todoText", function () { return $bea9cd0eebebb17e$export$10ca57db9a6777ce; }, function (v) { return $bea9cd0eebebb17e$export$10ca57db9a6777ce = v; });
$parcel$export($bea9cd0eebebb17e$exports, "workDescription", function () { return $bea9cd0eebebb17e$export$128b5cd702dd1d8f; }, function (v) { return $bea9cd0eebebb17e$export$128b5cd702dd1d8f = v; });
$parcel$export($bea9cd0eebebb17e$exports, "workDescriptionBox", function () { return $bea9cd0eebebb17e$export$f7d6624d2b150835; }, function (v) { return $bea9cd0eebebb17e$export$f7d6624d2b150835 = v; });
var $bea9cd0eebebb17e$export$c4ab985f35c8fb92;
var $bea9cd0eebebb17e$export$f2612e3e51238ec0;
var $bea9cd0eebebb17e$export$805539a8f9c62752;
var $bea9cd0eebebb17e$export$807f98b30b38f59a;
var $bea9cd0eebebb17e$export$c115485119910444;
var $bea9cd0eebebb17e$export$e1b57b9301200117;
var $bea9cd0eebebb17e$export$9ff3bb7da8d51471;
var $bea9cd0eebebb17e$export$31cf8c2b5fa85333;
var $bea9cd0eebebb17e$export$356714a797753c3a;
var $bea9cd0eebebb17e$export$94140423b4806d03;
var $bea9cd0eebebb17e$export$604d776a0af1c0eb;
var $bea9cd0eebebb17e$export$34e0f9847d4c02dd;
var $bea9cd0eebebb17e$export$6d59db4903f20f7d;
var $bea9cd0eebebb17e$export$513ddc224ccfb871;
var $bea9cd0eebebb17e$export$d2986c5ff6581bb2;
var $bea9cd0eebebb17e$export$18d46c9843cd5809;
var $bea9cd0eebebb17e$export$152c94fb6e056f3b;
var $bea9cd0eebebb17e$export$5601c7c0bf5e624f;
var $bea9cd0eebebb17e$export$e1500f2d017a84bf;
var $bea9cd0eebebb17e$export$1530f4665174f6ef;
var $bea9cd0eebebb17e$export$2adaa127afadd617;
var $bea9cd0eebebb17e$export$87fa8c1411fa2c3f;
var $bea9cd0eebebb17e$export$fb184b623420d9be;
var $bea9cd0eebebb17e$export$12948adc4d562794;
var $bea9cd0eebebb17e$export$585ecab085bb38c4;
var $bea9cd0eebebb17e$export$ba223a368a14c1f2;
var $bea9cd0eebebb17e$export$69a1cb60fd2c48d1;
var $bea9cd0eebebb17e$export$dd9e13c5d56e1fd3;
var $bea9cd0eebebb17e$export$a92f3551f2a686cf;
var $bea9cd0eebebb17e$export$fe95fc036bfa2e28;
var $bea9cd0eebebb17e$export$a160deeb1de1992;
var $bea9cd0eebebb17e$export$9feab614391b3884;
var $bea9cd0eebebb17e$export$fe485f7a1c03bd6f;
var $bea9cd0eebebb17e$export$b6957c91014a2e57;
var $bea9cd0eebebb17e$export$49e8e74be8f9560c;
var $bea9cd0eebebb17e$export$10ca57db9a6777ce;
var $bea9cd0eebebb17e$export$128b5cd702dd1d8f;
var $bea9cd0eebebb17e$export$f7d6624d2b150835;
$bea9cd0eebebb17e$export$c4ab985f35c8fb92 = `DydckW_aboutGlow`;
$bea9cd0eebebb17e$export$f2612e3e51238ec0 = `DydckW_aboutPhone`;
$bea9cd0eebebb17e$export$805539a8f9c62752 = `DydckW_aboutScreen`;
$bea9cd0eebebb17e$export$807f98b30b38f59a = `DydckW_aboutStage`;
$bea9cd0eebebb17e$export$c115485119910444 = `DydckW_aboutTag`;
$bea9cd0eebebb17e$export$e1b57b9301200117 = `DydckW_aboutTag1`;
$bea9cd0eebebb17e$export$9ff3bb7da8d51471 = `DydckW_aboutTag2`;
$bea9cd0eebebb17e$export$31cf8c2b5fa85333 = `DydckW_aboutTag3`;
$bea9cd0eebebb17e$export$356714a797753c3a = `DydckW_checkEmpty`;
$bea9cd0eebebb17e$export$94140423b4806d03 = `DydckW_checkGreen`;
$bea9cd0eebebb17e$export$604d776a0af1c0eb = `DydckW_checkPurple`;
$bea9cd0eebebb17e$export$34e0f9847d4c02dd = `DydckW_container`;
$bea9cd0eebebb17e$export$6d59db4903f20f7d = `DydckW_description`;
$bea9cd0eebebb17e$export$513ddc224ccfb871 = `DydckW_heroBg`;
$bea9cd0eebebb17e$export$d2986c5ff6581bb2 = `DydckW_heroChip`;
$bea9cd0eebebb17e$export$18d46c9843cd5809 = `DydckW_heroFade`;
$bea9cd0eebebb17e$export$152c94fb6e056f3b = `DydckW_heroPhone`;
$bea9cd0eebebb17e$export$5601c7c0bf5e624f = `DydckW_heroPhoneBoxMob`;
$bea9cd0eebebb17e$export$e1500f2d017a84bf = `DydckW_heroPhoneGlow`;
$bea9cd0eebebb17e$export$1530f4665174f6ef = `DydckW_heroPhoneMob`;
$bea9cd0eebebb17e$export$2adaa127afadd617 = `DydckW_heroScreen`;
$bea9cd0eebebb17e$export$87fa8c1411fa2c3f = `DydckW_heroSvg`;
$bea9cd0eebebb17e$export$fb184b623420d9be = `DydckW_title`;
$bea9cd0eebebb17e$export$12948adc4d562794 = `DydckW_titleContainer`;
$bea9cd0eebebb17e$export$585ecab085bb38c4 = `DydckW_titleContainerMob`;
$bea9cd0eebebb17e$export$ba223a368a14c1f2 = `DydckW_titleContent`;
$bea9cd0eebebb17e$export$69a1cb60fd2c48d1 = `DydckW_titleContentMob`;
$bea9cd0eebebb17e$export$dd9e13c5d56e1fd3 = `DydckW_todo1`;
$bea9cd0eebebb17e$export$a92f3551f2a686cf = `DydckW_todo2`;
$bea9cd0eebebb17e$export$fe95fc036bfa2e28 = `DydckW_todo3`;
$bea9cd0eebebb17e$export$a160deeb1de1992 = `DydckW_todo4`;
$bea9cd0eebebb17e$export$9feab614391b3884 = `DydckW_todoCard`;
$bea9cd0eebebb17e$export$fe485f7a1c03bd6f = `DydckW_todoCheck`;
$bea9cd0eebebb17e$export$b6957c91014a2e57 = `DydckW_todoDone`;
$bea9cd0eebebb17e$export$49e8e74be8f9560c = `DydckW_todoSub`;
$bea9cd0eebebb17e$export$10ca57db9a6777ce = `DydckW_todoText`;
$bea9cd0eebebb17e$export$128b5cd702dd1d8f = `DydckW_workDescription`;
$bea9cd0eebebb17e$export$f7d6624d2b150835 = `DydckW_workDescriptionBox`;



parcelRequire("6cds3");

const $a6165195039ace52$var$Check = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "none",
        stroke: "#160f1f",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M20 6 9 17l-5-5"
        })
    });
const $a6165195039ace52$var$habits = [
    {
        text: "Drink 2L of water",
        sub: "12-day streak",
        state: "green",
        cls: "todo1"
    },
    {
        text: "Morning run",
        sub: "8:00 \xb7 Mn\u2013Fr",
        state: "purple",
        cls: "todo2"
    },
    {
        text: "Read 20 minutes",
        sub: "today",
        state: "empty",
        cls: "todo3"
    },
    {
        text: "Meditate",
        sub: "",
        state: "green",
        cls: "todo4"
    }
];
const $a6165195039ace52$export$59876d53903d5c7b = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: $a6165195039ace52$var$habits.map((h)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).todoCard} ${(0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports)))[h.cls]}`,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).todoCheck} ${h.state === "green" ? (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).checkGreen : h.state === "purple" ? (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).checkPurple : (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).checkEmpty}`,
                        children: h.state !== "empty" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a6165195039ace52$var$Check, {})
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).todoText} ${h.state !== "empty" ? (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).todoDone : ""}`,
                                children: h.text
                            }),
                            h.sub && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).todoSub,
                                children: h.sub
                            })
                        ]
                    })
                ]
            }, h.cls))
    });
const $a6165195039ace52$var$HeroBackground = ({ floating: floating = true })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).heroBg,
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).heroSvg,
                viewBox: "0 0 1280 720",
                preserveAspectRatio: "xMidYMid slice",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("radialGradient", {
                            id: "klGlow",
                            cx: "50%",
                            cy: "50%",
                            r: "50%",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                    offset: "0",
                                    stopColor: "#a855f7",
                                    stopOpacity: "0.42"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#a855f7",
                                    stopOpacity: "0"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                        cx: "940",
                        cy: "230",
                        r: "330",
                        fill: "url(#klGlow)"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                        cx: "230",
                        cy: "560",
                        r: "250",
                        fill: "url(#klGlow)"
                    })
                ]
            }),
            floating && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a6165195039ace52$export$59876d53903d5c7b, {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).heroFade
            })
        ]
    });
var $a6165195039ace52$export$2e2bcd8739ae039 = $a6165195039ace52$var$HeroBackground;



parcelRequire("6cds3");

const $bdc41f61d67a0f7b$var$RepeatIcon = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "none",
        stroke: "#7c3aed",
        strokeWidth: "1.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M17 2l4 4-4 4"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M3 11V9a4 4 0 0 1 4-4h14"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M7 22l-4-4 4-4"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M21 13v2a4 4 0 0 1-4 4H3"
            })
        ]
    });
const $bdc41f61d67a0f7b$var$CalendarIcon = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "none",
        stroke: "#7c3aed",
        strokeWidth: "1.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "3",
                y: "4",
                width: "18",
                height: "18",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M16 2v4M8 2v4M3 10h18"
            })
        ]
    });
const $bdc41f61d67a0f7b$var$ChartIcon = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "none",
        stroke: "#7c3aed",
        strokeWidth: "1.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M4 20h16"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M7 20v-6M12 20V6M17 20v-9"
            })
        ]
    });

const $bdc41f61d67a0f7b$var$AboutVisual = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).aboutStage,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).aboutGlow
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).aboutPhone,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).aboutScreen,
                    src: (parcelRequire("7iqCP")),
                    alt: "Kloki charts screen"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).aboutTag} ${(0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).aboutTag1}`,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($bdc41f61d67a0f7b$var$RepeatIcon, {}),
                    "Habits"
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).aboutTag} ${(0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).aboutTag2}`,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($bdc41f61d67a0f7b$var$CalendarIcon, {}),
                    "Daily plan"
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).aboutTag} ${(0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).aboutTag3}`,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($bdc41f61d67a0f7b$var$ChartIcon, {}),
                    "Progress"
                ]
            })
        ]
    });
var $bdc41f61d67a0f7b$export$2e2bcd8739ae039 = $bdc41f61d67a0f7b$var$AboutVisual;



const $d8c019f665db1a3a$var$PlannerCase = ()=>{
    const [active, setActive] = (0, $6cds3.useState)(false);
    const [workModal, setWorkModal] = (0, $6cds3.useState)(false);
    const navigation = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const isMobile = (0, $8a086d95af0c9c00$exports.useMediaQuery)({
        query: "(max-width: 1200px)"
    });
    const scrollToTop = ()=>{
        (0, $1d42a532dd4f25d5$exports.animateScroll).scrollToTop();
    };
    (0, $41071ce0bf3fff43$export$c2c6cc04189e2ea6)("Kloki Planner case study \u2014 Vlad Khrushchov", "Kloki: a React Native planner with plans, daily habits, progress tracking and notifications, available on the App Store.");
    const heroPhone = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).heroPhoneMob : (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).heroPhone,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).heroScreen,
            src: (parcelRequire("1IavV")),
            alt: "Kloki habits screen"
        })
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).container,
                id: "#kloki",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4eb7dc37af125249$export$2e2bcd8739ae039), {
                        setWorkModal: setWorkModal,
                        alternative: true,
                        data: (0, $b5d47c2f6a1fbb71$export$1c6d320eca5f475),
                        setModal: setActive,
                        navigation: navigation
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).titleContainerMob : (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).titleContainer,
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a6165195039ace52$export$2e2bcd8739ae039), {
                                floating: !isMobile
                            }),
                            !isMobile && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).heroPhoneGlow
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).titleContentMob : (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).titleContent,
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).title,
                                        children: "Kloki"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9cb2eb5a2afb4e3f$export$2e2bcd8739ae039), {
                                        text: "all your plans in one app",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).description
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).heroChip,
                                        children: "React Native \xb7 Redux \xb7 Firebase"
                                    })
                                ]
                            }),
                            isMobile ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).heroPhoneBoxMob,
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a6165195039ace52$export$59876d53903d5c7b), {}),
                                    heroPhone
                                ]
                            }) : heroPhone
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).workDescriptionBox,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0b62aa8cd3e21a28$export$2e2bcd8739ae039), {
                            role: "React-Native Developer",
                            context: "Mobile Planner",
                            period: "January 2024 - Present",
                            titleColor: "#a855f7"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $097e928218dfebc5$export$2e2bcd8739ae039), {
                        title: "About Project",
                        description: "The project created in React Native is a planner that allows you to add, delete plans, daily habits, monitor your progress, and also receive notifications from the application about upcoming plans",
                        link: "https://apps.apple.com/us/app/kloki-planner/id6746350225",
                        linkText: "View on the App Store"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2473041a92174530$export$2e2bcd8739ae039), {
                        title: "Core features, built together with the designer.",
                        visual: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bdc41f61d67a0f7b$export$2e2bcd8739ae039), {}),
                        data: (0, $83979233edb6f6de$export$fd07a6ae12df212a),
                        background: "#f3f0f7",
                        description: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($bea9cd0eebebb17e$exports))).workDescription,
                            children: [
                                "My work on this project was to",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "interact with the designer"
                                }),
                                ", add new features together, and also create the main functionality of the application using various tools, for example",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "Redux Toolkit"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                "as the main state manager. ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "MMKV"
                                }),
                                " for storage, React Navigation for navigation, ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "Typescript"
                                }),
                                " for typing components and more convenient work with properties, and",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "Firebase"
                                }),
                                " as authorization, server storage and database"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $df07ea70fb26ed48$export$2e2bcd8739ae039), {
                        active: active,
                        setActive: setActive
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9ca92ffcb8ea5b15$export$2e2bcd8739ae039), {
                nextProjectName: "IDriver",
                href: "/idriver",
                onClick: (e)=>(0, $35f54a4218b84ba5$export$13aea1a3cb5e3f1f)(e, navigation, "/idriver"),
                overlayColor: "#a855f7"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e39d7a1997c3ede8$export$2e2bcd8739ae039), {
                data: (0, $e620f929d587f27c$export$cf42e9e39aa444e0),
                active: workModal,
                setActive: setWorkModal
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e3ea40068f29db1a$export$2e2bcd8739ae039), {
                onLinkPress: scrollToTop
            })
        ]
    });
};
var $d8c019f665db1a3a$export$2e2bcd8739ae039 = (0, $e2d127ce7abdc63d$export$2e2bcd8739ae039)($d8c019f665db1a3a$var$PlannerCase);




function $18cb66d1e7a58135$var$App() {
    const location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $97523485216ee353$export$caa69d61d2de10d9), {
        reducedMotion: "user",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $35bf9e9aed03b88e$export$3ae376d12526dd6f), {
            mode: "wait",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $4a3e215446c0ed92$export$3565eb3d00ca5a74), {
                location: location,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                        index: true,
                        path: "/",
                        element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c1b4d20b5a3b9149$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                        path: "/idriver",
                        element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $15119af130913117$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                        path: "/voiceNotes",
                        element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $45667d844aa0bce5$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                        path: "/kloki",
                        element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d8c019f665db1a3a$export$2e2bcd8739ae039), {})
                    })
                ]
            }, location.pathname)
        })
    });
}
var $18cb66d1e7a58135$export$2e2bcd8739ae039 = $18cb66d1e7a58135$var$App;


const $7dfc410149830cad$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($64d0b1ebdd6bcffe$exports))).createRoot(document.getElementById("root"));
$7dfc410149830cad$var$root.render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).StrictMode, {
    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $18cb66d1e7a58135$export$2e2bcd8739ae039), {})
    })
}));

})();
//# sourceMappingURL=index.ec7e77e6.js.map
